

// ////////////////////////////////////////////////////////////////////////////////////

import exportDoc from "./exportUtil";
import {
  Document,
  Header,
  Paragraph,
  TextRun,
  AlignmentType,
  Table,
  TableRow,
  TableCell,
  WidthType,
  Footer,
  ImageRun,
  PageNumber,
} from "docx";
// Updated code: added tacNumberLampList, possibleDateLampList, copCertLampList, validityLampList, and MakeList,
// because lamps should be separated to ensure clear categorization and organization of data for each lamp type.ffgfgf
let docSealImage;
// let twoWheeler;
let twoWheeler = false;
let firstValue;
// let Vehicle_category;
const mainData = function () {
  const suppNameList = [];
  const suppNameLampList = [];
  const tacNumberList = [];
  const possibleDateList = [];
  const copCertList = [];
  const vehType = [];
  const validityList = [];
  const tacNumberLampList = [];
  const possibleDateLampList = [];
  const copCertLampList = [];
  const validityLampList = [];
  const MakeList = [];
  const MakeLampList = [];
  return {
    suppNameList,
    suppNameLampList,
    tacNumberList,
    possibleDateList,
    copCertList,
    vehType,
    validityList,
    tacNumberLampList,
    possibleDateLampList,
    copCertLampList,
    MakeList,
    validityLampList,
    MakeLampList,
  };
};

async function fetchAndProcessImage(footerData) {
  const dataOfFooterr = footerData.footerData.SealSign.properties;
  const fileName = dataOfFooterr.Upload_Seal.file_name;
 const imageUrl = `https://auto-canon.in/api/files/downloads/${fileName}`; 
// const imageUrl = `http://localhost:3007/api/files/downloads/${fileName}`;
  //   const imageUrl = `http://localhost:3007/api/files/downloads/${fileName}`;
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    // Convert the blob to Base64
    const base64Data = await new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result); // Resolve with the Base64 string
      };

      reader.onerror = reject; // Reject on error

      reader.readAsDataURL(blob);
    });

    // Create an ImageRun object with the Base64 data
    const docSealImage = new ImageRun({
      data: base64Data, // Use the Base64 data here
      transformation: {
        width: 90,
        height: 50,
      },
    });

    console.log("ImageRun instance created:", docSealImage);

    return docSealImage; // Return the docSealImage after it's ready
  } catch (error) {
    console.error("Error loading or converting image:", error);
    throw error; // If the image fails to load, throw an error
  }
}

// // Universal function inside the same file
// function parseAndCheckTACValidity(tacValueRaw) {
//     const result = {
//         raw: tacValueRaw || "",
//         dateStr: "NA",
//         hasDate: false,
//         expired: false
//     };

//     if (!tacValueRaw) return result;

//     const tacParts = tacValueRaw.split(/and|&/i);
//     if (tacParts.length < 2) return result;

//     const datePart = tacParts[1].trim();
//     result.dateStr = datePart;

//     const [day, month, year] = datePart.split("/").map(Number);
//     if (!day || !month || !year) return result;

//     const tacDate = new Date(year, month - 1, day);
//     const today = new Date();

//     result.hasDate = true;
//     result.expired = tacDate < today;

//     return result;
// }

// function parseAndCheckTACValidity(validityDateStr) {
//     if (!validityDateStr || typeof validityDateStr !== 'string') {
//         return { expired: true, hasDate: false };
//     }

//     let parsedDate = new Date(validityDateStr);

//     if (isNaN(parsedDate.getTime())) {
//         // Try to extract using regex (handles formats like DD-MM-YYYY or DD/MM/YYYY)
//         const parts = validityDateStr.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
//         if (parts) {
//             const [ , day, month, year ] = parts;
//             parsedDate = new Date(`${year}-${month}-${day}`);
//         }
//     }

//     if (isNaN(parsedDate.getTime())) {
//         return { expired: true, hasDate: false }; // Still invalid
//     }

//     return {
//         expired: parsedDate < new Date(),
//         hasDate: true
//     };
// }

// function parseAndCheckTACValidity(validityDateStr) {
//   if (!validityDateStr || typeof validityDateStr !== "string") {
//     return { expired: true, hasDate: false };
//   }

//   // Try parsing directly as ISO date (YYYY-MM-DD)
//   const isoDate = new Date(validityDateStr);
//   if (!isNaN(isoDate.getTime())) {
//     return {
//       expired: isoDate < new Date(),
//       hasDate: true,
//     };
//   }

//   // If not a valid ISO date, try regex for DD/MM/YYYY or DD-MM-YYYY
//   const dateRegex = /(\d{1,2})[-/](\d{1,2})[-/](\d{4})/g;
//   let matches = [...validityDateStr.matchAll(dateRegex)];

//   if (matches.length === 0) {
//     return { expired: true, hasDate: false }; // No valid date found
//   }

//   // Take the last matched date
//   const lastMatch = matches[matches.length - 1];
//   const day = lastMatch[1];
//   const month = lastMatch[2];
//   const year = lastMatch[3];

//   const parsedDate = new Date(
//     `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
//   );
//   if (isNaN(parsedDate.getTime())) {
//     return { expired: true, hasDate: false };
//   }

//   return {
//     expired: parsedDate < new Date(),
//     hasDate: true,
//   };
// }



function parseAndCheckTACValidity(validityDateStr) {
    if (!validityDateStr || typeof validityDateStr !== "string") {
      return { expired: true, hasDate: false };
    }
  
    // Try parsing directly as ISO date (YYYY-MM-DD)
    const isoDate = new Date(validityDateStr);
    if (!isNaN(isoDate.getTime())) {
      return {
        expired: isoDate < new Date(),
        hasDate: true,
      };
    }
  
    // Regex for DD/MM/YYYY or DD-MM-YYYY
    const ddmmyyyyRegex = /(\d{1,2})[-/](\d{1,2})[-/](\d{4})/g;
    let matches = [...validityDateStr.matchAll(ddmmyyyyRegex)];
  
    if (matches.length > 0) {
      const lastMatch = matches[matches.length - 1];
      const day = lastMatch[1];
      const month = lastMatch[2];
      const year = lastMatch[3];
  
      const parsedDate = new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);
      if (!isNaN(parsedDate.getTime())) {
        return {
          expired: parsedDate < new Date(),
          hasDate: true,
        };
      }
    }
  
    // Regex for MM/DD/YY (2-digit year)
    const mmddyyRegex = /(\d{1,2})[-/](\d{1,2})[-/](\d{2})/g;
    matches = [...validityDateStr.matchAll(mmddyyRegex)];
  
    if (matches.length > 0) {
      const lastMatch = matches[matches.length - 1];
      const month = lastMatch[1];
      const day = lastMatch[2];
      let year = parseInt(lastMatch[3], 10);
  
      // Convert 2-digit year to 4-digit (assume 2000–2099)
      year += year < 50 ? 2000 : 1900;
  
      const parsedDate = new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);
      if (!isNaN(parsedDate.getTime())) {
        return {
          expired: parsedDate < new Date(),
          hasDate: true,
        };
      }
    }
  
    // No valid date found
    return { expired: true, hasDate: false };
  }
  

// // ✅ Helper regexes & utility functions
// const validDateRegex =
//   /\b(\d{4}[-/.]\d{1,2}[-/.]\d{1,2}|\d{1,2}[-/.]\d{1,2}[-/.]\d{4})\b/;
// const isNonEmpty = (s) =>
//   typeof s === "string" && s.trim() !== "" && s.trim().toUpperCase() !== "NA";
// const containsValidDate = (s) => isNonEmpty(s) && validDateRegex.test(s);
// const isTACorBISNumber = (s) => isNonEmpty(s) && /^[A-Z0-9]{2}\d{4,5}/i.test(s); // First 2 alphanum chars + 4-5 digits
// const isCOPNumber = (s) => isNonEmpty(s) && /^[A-Z0-9\-\/]+$/i.test(s);

// function getTACorBISHeader(list) {
//   if (!Array.isArray(list)) return "";
//   const validItems = list.filter(isTACorBISNumber);
//   if (validItems.length === 0) return "";
//   return list.some(containsValidDate)
//     ? "TAC/BIS No and Validity"
//     : "TAC/BIS No";
// }
const validDateRegex =
  /\b(\d{4}[-/.]\d{1,2}[-/.]\d{1,2}|\d{1,2}[-/.]\d{1,2}[-/.]\d{4})\b/;

const isNonEmpty = (s) =>
  typeof s === "string" && s.trim() !== "" && s.trim().toUpperCase() !== "NA";

const containsValidDate = (s) =>
  isNonEmpty(s) && validDateRegex.test(s);

// count alphanumeric characters (letters + digits)
const countAlphaNum = (s) => (s.match(/[A-Za-z0-9]/g) || []).length;
const countDigits = (s) => (s.match(/[0-9]/g) || []).length;
const countAlphaNumSlashDash = (s) => (s.match(/[A-Za-z0-9\/\-]/g) || []).length;
const isCOPNumber = (s) => isNonEmpty(s) && /^[A-Z0-9\-\/]+$/i.test(s);
function getTACorBISLabel(s) {
  if (!isNonEmpty(s)) return "";

  // 1) detect if there’s a date at all
  const hasDate = containsValidDate(s);

  // 2) strip off the date and everything after it
  const dateMatch = s.match(validDateRegex);
  const preDate = dateMatch
    ? s.slice(0, dateMatch.index)
    : s;

  // 3) trim and collapse whitespace, then count all alphanumerics
  const alphaNumCount = countAlphaNum(preDate);
  const digitCount = countDigits(preDate);
  const alphaNumCount1 = countAlphaNumSlashDash(preDate);

  // 4) apply your 6‐vs‐7 logic
  if (alphaNumCount === 6) {
    return hasDate ? "TAC No and Validity" : "TAC No";
  }
  // BIS No (only digits, length 7–10)
  if (digitCount >= 7 && digitCount <= 10 && digitCount === alphaNumCount) {
    return hasDate ? "BIS No and Validity" : "BIS No";
  }

  if (alphaNumCount1 > 7 && alphaNumCount1 < 40) {
    return hasDate ? "Test Report No and Validity" : "Test Report No";
  }
  return "";
}

function getTACorBISHeader(list) {
  if (!Array.isArray(list)) return "";

  for (const item of list) {
    const label = getTACorBISLabel(item);
    if (label) return label;
  }
  return "";
}



const makePrefix = (make) => {
    if (!make) return "";
  
    const lowerMake = make.toLowerCase();
    if (lowerMake === "na") return make;
  
    if (make.startsWith("M/s.")) return make;
    if (make.startsWith("M/")) return `M/s. ${make.slice(2)}`;
  
    return `M/s. ${make}`;
  };
  

// function getCOPHeader(list) {
//   if (!Array.isArray(list)) return "";
//   const validItems = list.filter(isCOPNumber);
//   if (validItems.length === 0) return "";
//   return list.some(containsValidDate) ? "COP No and Validity" : "COP No";
// }

// function getCOPHeader(list) {
//     if (!Array.isArray(list)) return "";
  
//     // Filter valid COP numbers
//     const validItems = list.filter(isCOPNumber);
//     if (validItems.length === 0) return "";
  
//     // Check if any item contains a valid date
//     const hasValidDate = list.some(containsValidDate);
  
//     return hasValidDate ? "COP No and Validity Date" : "COP No";
//   }
  

function getCOPHeader(list) {
    if (!Array.isArray(list)) return "";
  
    const validItems = list.filter((item) => {
      if (!isNonEmpty(item)) return false;
  
      const dateMatch = item.match(validDateRegex);
      const preDate = dateMatch ? item.slice(0, dateMatch.index).trim() : item.trim();
  
      return isCOPNumber(preDate);
    });
  
    if (validItems.length === 0) return "";
  
    const hasValidDate = list.some(containsValidDate);
  
    return hasValidDate ? "COP No and Validity Date" : "COP No";
  }

function getPossibleDateHeader(list) {
  if (!Array.isArray(list)) return "";
  const validDates = list.filter(containsValidDate);
  if (validDates.length === 0) return "";
  return validDates.length === 1 ? "Possible Date" : "Possible Dates";
}

// function TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw) {
//   const tacCheck = parseAndCheckTACValidity(tacValueRaw);
//   const result = { cop: "", possible: "" };

//   if (tacCheck.hasDate) {
//     if (tacCheck.expired) {
//       result.cop = "NA";
//       result.possible = possibleDateRaw || "NA";
//     } else {
//       result.cop = "NA";
//       result.possible = "NA";
//     }
//   } else {
//     const isCopBlank = !copCertRaw.trim();
//     const isTacBlank = !tacValueRaw.trim();
//     result.cop = isCopBlank ? "" : copCertRaw;
//     result.possible = isTacBlank && isCopBlank ? "" : "NA";
//   }

//   return result;
// }

// function TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw) {
//     const tacCheck = parseAndCheckTACValidity(tacValueRaw);
//     const result = { cop: "", possible: "" };

//     const isTacBlank = !tacValueRaw.trim();
//     const isCopPresent = !!copCertRaw.trim();
//     const isCopBlank = !isCopPresent;

//     if (!isTacBlank && tacCheck.hasDate) {
//         if (tacCheck.expired) {
//             // ✅ Condition 1: TAC given & expired
//             result.cop = "NA";
//             result.possible = possibleDateRaw || "NA";
//         } else {
//             // ✅ Condition 2: TAC given & valid
//             result.cop = "NA";
//             result.possible = "NA";
//         }
//     } else if (isTacBlank && isCopPresent) {
//         // ✅ Condition 3 / 5: TAC missing, CoP present
//         result.cop = copCertRaw;
//         result.possible = "NA";
//     } else if (isTacBlank && isCopBlank && !possibleDateRaw) {
//         // ✅ Condition 4: All missing
//         result.cop = "";
//         result.possible = "";
//     } else {
//         // 🔁 Fallback for edge cases
//         result.cop = isCopBlank ? "" : copCertRaw;
//         result.possible = "NA";
//     }

//     return result;
// }

function TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw) {
  const tacCheck = parseAndCheckTACValidity(tacValueRaw);
  const result = { cop: "", possible: "" };

  const isTacBlank = !tacValueRaw.trim();
  const isPossiblePresent = !!possibleDateRaw?.trim();
  const isPossibleBlank = !isPossiblePresent;

  if (!isTacBlank && tacCheck.hasDate) {
    if (tacCheck.expired) {
      // ✅ Condition 1: TAC given & expired
      // result.cop = "NA";
      // result.possible = possibleDateRaw || "NA";
      result.possible = "NA";
      result.cop = copCertRaw || "NA";
    } else {
      // ✅ Condition 2: TAC given & valid
      result.cop = "NA";
      result.possible = "NA";
    }
    // } else if (isTacBlank && isCopPresent) {
  } else if (isTacBlank && isPossiblePresent) {
    // ✅ Condition 3 / 5: TAC missing, CoP present
    // result.cop = copCertRaw;
    // result.possible = "NA";
    result.possible = possibleDateRaw;
    result.cop = "NA";
    // } else if (isTacBlank && isCopBlank && !possibleDateRaw) {
  } else if (isTacBlank && isPossibleBlank && !copCertRaw) {
    // ✅ Condition 4: All missing
    result.cop = "";
    result.possible = "";
  } else {
    // 🔁 Fallback for edge cases
    result.possible = isPossibleBlank ? "" : possibleDateRaw;
    result.cop = "NA";
  }

  return result;
}

async function generateForm8(form8Data, footerData) {
  const docSealImage = await fetchAndProcessImage(footerData);
  console.log("form8Data:", form8Data);
  const dataOfFooter = footerData.footerData.footer.properties;
  const dataOfFooterr = footerData.footerData.SealSign.properties;

  let homologation_Engg_Name = dataOfFooter.Homologation_Engineer_Name.value;

  // Capitalize first letter and prepend "Mr/Mrs"
  if (
    typeof homologation_Engg_Name === "string" &&
    homologation_Engg_Name.trim().length > 0
  ) {
    let trimmedName = homologation_Engg_Name.trim();
    homologation_Engg_Name = `Mr/Mrs. ${trimmedName[0].toUpperCase()}${trimmedName.slice(
      1
    )}`;
  }
  // Manufacturer Name
  let manufacturer_Name = dataOfFooter.Manufacture_Name.value;
  if (
    typeof manufacturer_Name === "string" &&
    manufacturer_Name.trim().length > 0
  ) {
    let trimmedManu = manufacturer_Name.trim();
    manufacturer_Name = `M/s. ${trimmedManu[0].toUpperCase()}${trimmedManu.slice(
      1
    )}`;
  }

  // const HandleLockList = form8Data?.Handle_Lock?.HandleLock || [];
  // let HandleLockDataList = mainData();

  // // Ensure lists are initialized
  // HandleLockDataList.suppNameList = HandleLockDataList.suppNameList || [];
  // HandleLockDataList.MakeList = HandleLockDataList.MakeList || [];
  // HandleLockDataList.tacNumberList = HandleLockDataList.tacNumberList || [];
  // HandleLockDataList.possibleDateList = HandleLockDataList.possibleDateList || [];
  // HandleLockDataList.copCertList = HandleLockDataList.copCertList || [];

  // HandleLockList.map(vehHandleLock => {
  //     const Vehicle_category = vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Vehicle_category?.value;
  //     console.log('Vehicle category:', Vehicle_category);

  //     twoWheeler = Vehicle_category === "L1" || Vehicle_category === "L2";

  //     if (twoWheeler && vehHandleLock?.supplier?.active === true) {
  //         let supplierName = vehHandleLock?.supplier?.nameOfSupplier || "NA";
  //         let makeValue = vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Make?.value || "NA";

  //         if (supplierName !== "NA" && !supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         if (makeValue !== "NA" && !makeValue.startsWith("M/")) {
  //             makeValue = `M/s. ${makeValue}`;
  //         }

  //         HandleLockDataList.suppNameList.push(supplierName);
  //         HandleLockDataList.MakeList.push(makeValue);
  //         HandleLockDataList.tacNumberList.push(vehHandleLock?.Protective_Device_Handle_Lock?.properties?.TAC_Number?.value || "NA");
  //         HandleLockDataList.possibleDateList.push(vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //         HandleLockDataList.copCertList.push(vehHandleLock?.Protective_Device_Handle_Lock?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");

  //     } else {
  //         // If not L1/L2 or supplier inactive, push NA
  //         HandleLockDataList.suppNameList.push("NA");
  //         HandleLockDataList.MakeList.push("NA");
  //         HandleLockDataList.tacNumberList.push("NA");
  //         HandleLockDataList.possibleDateList.push("NA");
  //         HandleLockDataList.copCertList.push("NA");
  //     }
  // });

  // Assuming parseAndCheckTACValidity function is defined somewhere accessible

  const HandleLockList = form8Data?.Handle_Lock?.HandleLock || [];
  let HandleLockDataList = mainData();

  // Ensure lists are initialized as arrays
  HandleLockDataList.suppNameList = Array.isArray(
    HandleLockDataList.suppNameList
  )
    ? HandleLockDataList.suppNameList
    : [];
  HandleLockDataList.MakeList = Array.isArray(HandleLockDataList.MakeList)
    ? HandleLockDataList.MakeList
    : [];
  HandleLockDataList.tacNumberList = Array.isArray(
    HandleLockDataList.tacNumberList
  )
    ? HandleLockDataList.tacNumberList
    : [];
  HandleLockDataList.possibleDateList = Array.isArray(
    HandleLockDataList.possibleDateList
  )
    ? HandleLockDataList.possibleDateList
    : [];
  HandleLockDataList.copCertList = Array.isArray(HandleLockDataList.copCertList)
    ? HandleLockDataList.copCertList
    : [];

  HandleLockList.forEach((vehHandleLock) => {
    const Vehicle_category =
      vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Vehicle_category
        ?.value;
    console.log("Vehicle category:", Vehicle_category);

    twoWheeler = Vehicle_category === "L1" || Vehicle_category === "L2";

    if (twoWheeler && vehHandleLock?.supplier?.active === true) {
      let supplierName = vehHandleLock?.supplier?.nameOfSupplier || "NA";
      let makeValue =
        vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Make?.value ||
        "NA";

    //   if (supplierName !== "NA" && !supplierName.startsWith("M/")) {
    //     supplierName = `M/s. ${supplierName}`;
    //   }

    //   if (makeValue !== "NA" && !makeValue.startsWith("M/")) {
    //     makeValue = `M/s. ${makeValue}`;
    //   }

    supplierName = makePrefix(supplierName);
makeValue = makePrefix(makeValue);
      const tacRaw =
        vehHandleLock?.Protective_Device_Handle_Lock?.properties?.TAC_Number
          ?.value || "";
      const tacCheck = parseAndCheckTACValidity(tacRaw);

      HandleLockDataList.tacNumberList.push(tacRaw || "NA");
      HandleLockDataList.MakeList.push(makeValue);

      const copCert =
        vehHandleLock?.Protective_Device_Handle_Lock?.properties
          ?.CoP_Cert_No_with_validity_date?.value || "NA";
      const possibleDate =
        vehHandleLock?.Protective_Device_Handle_Lock?.properties
          ?.Possible_date_of_submission_of_required_approval?.value || "NA";

      if (tacCheck.hasDate) {
        if (tacCheck.expired) {
          HandleLockDataList.suppNameList.push(supplierName);
          HandleLockDataList.copCertList.push(copCert);
          HandleLockDataList.possibleDateList.push(possibleDate);
        } else {
          HandleLockDataList.suppNameList.push(supplierName);
          HandleLockDataList.copCertList.push("NA");
          HandleLockDataList.possibleDateList.push("NA");
        }
      } else {
        HandleLockDataList.suppNameList.push(supplierName);
        HandleLockDataList.copCertList.push(copCert);
        HandleLockDataList.possibleDateList.push(possibleDate);
      }
    } else {
      // If not L1/L2 or supplier inactive, push "NA"
      HandleLockDataList.suppNameList.push("NA");
      HandleLockDataList.MakeList.push("NA");
      HandleLockDataList.tacNumberList.push("NA");
      HandleLockDataList.possibleDateList.push("NA");
      HandleLockDataList.copCertList.push("NA");
    }
  });

  console.log("handledatalist.suppNameList", HandleLockDataList.suppNameList);
  console.log("handledatalist.MakeList", HandleLockDataList.MakeList);
  console.log("handledatalist.tacNumberList", HandleLockDataList.tacNumberList);
  console.log(
    "handledatalist.possibleDateList",
    HandleLockDataList.possibleDateList
  );
  console.log("handledatalist.copCertList", HandleLockDataList.copCertList);

  // const reflectorsList = form8Data.Retro_Reflectors.RetroReflectors;

  // let reflDataList = {
  //     suppNameList: [] = [],
  //     frontWhiteList: mainData(),
  //     rearRedList: mainData(),
  //     sideAmberList: mainData()
  // };
  // reflectorsList.map(vehRefl => {
  //     if (vehRefl.supplier.active === true) {

  //         let supplierName = vehRefl.supplier.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;

  //         }

  //         // reflDataList.suppNameList.push(supplierName);

  //         // // reflDataList.suppNameList.push(vehRefl.supplier.nameOfSupplier);
  //         // reflDataList.frontWhiteList.tacNumberList.push(vehRefl?.Front_White_Reflector?.properties?.TAC_Number?.value);
  //         // Get the TAC Number value for Front White Reflector
  //         const frontWhiteTACValue = vehRefl?.Front_White_Reflector?.properties?.TAC_Number?.value;

  //         // Push the TAC value to reflDataList
  //         reflDataList.frontWhiteList.tacNumberList.push(frontWhiteTACValue);

  //         // Check if TAC value is present
  //         // reflDataList.suppNameList.push(frontWhiteTACValue ? supplierName : "");
  //         // reflDataList.suppNameList.push(frontWhiteTACValue === "NA" ? "" : supplierName);
  //         if (frontWhiteTACValue && frontWhiteTACValue.trim() !== "NA") {
  //             reflDataList.suppNameList.push(supplierName);
  //         }

  //         let makeValue = vehRefl?.Front_White_Reflector?.properties?.Make?.value;

  //         if (makeValue && !makeValue.startsWith("M/")) {
  //             makeValue = `M/s. ${makeValue}`;
  //         }

  //         reflDataList.frontWhiteList.MakeList.push(makeValue);

  //         reflDataList.frontWhiteList.possibleDateList.push(vehRefl?.Front_White_Reflector?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         reflDataList.frontWhiteList.copCertList.push(vehRefl?.Front_White_Reflector?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         reflDataList.frontWhiteList.validityList.push(vehRefl?.Front_White_Reflector?.properties?.TAC_Validity?.value);

  //         let rearMakeValue = vehRefl?.Rear_Red_Reflector?.properties?.Make?.value;

  //         if (rearMakeValue && !rearMakeValue.startsWith("M/")) {
  //             rearMakeValue = `M/s. ${rearMakeValue}`;
  //         }

  //         reflDataList.rearRedList.MakeList.push(rearMakeValue);

  //         reflDataList.rearRedList.tacNumberList.push(vehRefl?.Rear_Red_Reflector?.properties?.TAC_Number?.value);
  //         reflDataList.rearRedList.possibleDateList.push(vehRefl?.Rear_Red_Reflector?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         reflDataList.rearRedList.copCertList.push(vehRefl?.Rear_Red_Reflector?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         reflDataList.rearRedList.validityList.push(vehRefl?.Rear_Red_Reflector?.properties?.TAC_Validity?.value);

  //         let sideAmberMakeValue = vehRefl?.Side_Amber_Reflector?.properties?.Make?.value;

  //         if (sideAmberMakeValue && !sideAmberMakeValue.startsWith("M/")) {
  //             sideAmberMakeValue = `M/s. ${sideAmberMakeValue}`;
  //         }

  //         reflDataList.sideAmberList.MakeList.push(sideAmberMakeValue);

  //         reflDataList.sideAmberList.tacNumberList.push(vehRefl?.Side_Amber_Reflector?.properties?.TAC_Number?.value);
  //         reflDataList.sideAmberList.possibleDateList.push(vehRefl?.Side_Amber_Reflector?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         reflDataList.sideAmberList.copCertList.push(vehRefl?.Side_Amber_Reflector?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         reflDataList.sideAmberList.validityList.push(vehRefl?.Side_Amber_Reflector?.properties?.TAC_Validity?.value);

  //         console.log("Front White Reflector:");
  //         console.log("  suppNameList:", reflDataList.frontWhiteList.suppNameList);
  //         console.log("  possibleDateList:", reflDataList.frontWhiteList.possibleDateList);
  //         console.log("  copCertList:", reflDataList.frontWhiteList.copCertList);
  //         console.log("  validityList:", reflDataList.frontWhiteList.validityList);

  //         console.log("Rear Red Reflector:");
  //         console.log("  suppNameList:", reflDataList.rearRedList.suppNameList);
  //         console.log("  possibleDateList:", reflDataList.rearRedList.possibleDateList);
  //         console.log("  copCertList:", reflDataList.rearRedList.copCertList);
  //         console.log("  validityList:", reflDataList.rearRedList.validityList);

  //         console.log("Side Amber Reflector:");
  //         console.log("  suppNameList:", reflDataList.sideAmberList.suppNameList);
  //         console.log("  possibleDateList:", reflDataList.sideAmberList.possibleDateList);
  //         console.log("  copCertList:", reflDataList.sideAmberList.copCertList);
  //         console.log("  validityList:", reflDataList.sideAmberList.validityList);

  //     }
  // });

  // const reflectorsList = form8Data.Retro_Reflectors.RetroReflectors;

  // let reflDataList = {
  //     suppNameList: [],
  //     frontWhiteList: mainData(),
  //     rearRedList: mainData(),
  //     sideAmberList: mainData()
  // };

  // reflectorsList.map((vehRefl) => {
  //     if (vehRefl?.supplier?.active === true) {
  //         let supplierName = vehRefl?.supplier?.nameOfSupplier || "";
  //         if (supplierName && !supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // --- FRONT WHITE ---
  //         const frontWhite = vehRefl?.Front_White_Reflector?.properties || {};
  //         const fwMakeRaw = frontWhite?.Make?.value || "";
  //         const fwMake = fwMakeRaw && !fwMakeRaw.startsWith("M/") ? `M/s. ${fwMakeRaw}` : fwMakeRaw;
  //         const fwTAC = frontWhite?.TAC_Validity?.value || "";
  //         const fwCheck = parseAndCheckTACValidity(fwTAC);

  //         reflDataList.frontWhiteList.MakeList.push(fwMake);
  //         reflDataList.frontWhiteList.validityList.push(fwTAC);

  //         const fwCop = frontWhite?.CoP_Cert_No_with_validity_date?.value || "NA";
  //         const fwDate = frontWhite?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //         reflDataList.suppNameList.push(fwMake);
  //         if (fwCheck.hasDate) {
  //             reflDataList.frontWhiteList.copCertList.push(fwCheck.expired ? fwCop : "NA");
  //             reflDataList.frontWhiteList.possibleDateList.push(fwCheck.expired ? fwDate : "NA");
  //         } else {
  //             reflDataList.frontWhiteList.copCertList.push(fwCop);
  //             reflDataList.frontWhiteList.possibleDateList.push(fwDate);
  //         }

  //         // --- REAR RED ---
  //         const rearRed = vehRefl?.Rear_Red_Reflector?.properties || {};
  //         const rrMakeRaw = rearRed?.Make?.value || "";
  //         const rrMake = rrMakeRaw && !rrMakeRaw.startsWith("M/") ? `M/s. ${rrMakeRaw}` : rrMakeRaw;
  //         const rrTAC = rearRed?.TAC_Validity?.value || "";
  //         const rrCheck = parseAndCheckTACValidity(rrTAC);

  //         reflDataList.rearRedList.MakeList.push(rrMake);
  //         reflDataList.rearRedList.validityList.push(rrTAC);

  //         const rrCop = rearRed?.CoP_Cert_No_with_validity_date?.value || "NA";
  //         const rrDate = rearRed?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //         reflDataList.suppNameList.push(rrMake);
  //         if (rrCheck.hasDate) {
  //             reflDataList.rearRedList.copCertList.push(rrCheck.expired ? rrCop : "NA");
  //             reflDataList.rearRedList.possibleDateList.push(rrCheck.expired ? rrDate : "NA");
  //         } else {
  //             reflDataList.rearRedList.copCertList.push(rrCop);
  //             reflDataList.rearRedList.possibleDateList.push(rrDate);
  //         }

  //         // --- SIDE AMBER ---
  //         const sideAmber = vehRefl?.Side_Amber_Reflector?.properties || {};
  //         const saMakeRaw = sideAmber?.Make?.value || "";
  //         const saMake = saMakeRaw && !saMakeRaw.startsWith("M/") ? `M/s. ${saMakeRaw}` : saMakeRaw;
  //         const saTAC = sideAmber?.TAC_Validity?.value || "";
  //         const saCheck = parseAndCheckTACValidity(saTAC);

  //         reflDataList.sideAmberList.MakeList.push(saMake);
  //         reflDataList.sideAmberList.validityList.push(saTAC);

  //         const saCop = sideAmber?.CoP_Cert_No_with_validity_date?.value || "NA";
  //         const saDate = sideAmber?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //         reflDataList.suppNameList.push(saMake);
  //         if (saCheck.hasDate) {
  //             reflDataList.sideAmberList.copCertList.push(saCheck.expired ? saCop : "NA");
  //             reflDataList.sideAmberList.possibleDateList.push(saCheck.expired ? saDate : "NA");
  //         } else {
  //             reflDataList.sideAmberList.copCertList.push(saCop);
  //             reflDataList.sideAmberList.possibleDateList.push(saDate);
  //         }
  //     }
  // });

  // const reflectorsList = form8Data?.Retro_Reflectors?.RetroReflectors;

  // let reflDataList = {
  //     suppNameList: [],
  //     frontWhiteList: mainData(),
  //     rearRedList: mainData(),
  //     sideAmberList: mainData()
  // };

  // const getCoPValue = (check, cop) => (!check.hasDate ? "NA" : (check.expired ? cop : "NA"));
  // const getDateValue = (check, date) => (!check.hasDate ? "NA" : (check.expired ? date : "NA"));

  // reflectorsList.forEach((vehRefl) => {
  //     if (!vehRefl?.supplier?.active) return;
  //     const addPrefix = (make) => {
  //         if (make && !make.startsWith("M/")) {
  //             return `M/s. ${make}`;
  //         }
  //         return make || "";
  //     };
  //     // --- FRONT WHITE REFLECTOR ---
  //     const frontWhiteProps = vehRefl?.Front_White_Reflector?.properties || {};
  //     const fwMake = addPrefix(frontWhiteProps?.Make?.value);
  //     const fwTAC = frontWhiteProps?.TAC_Validity?.value || "";
  //     const fwCheck = parseAndCheckTACValidity(fwTAC);
  //     const fwTacNumber = frontWhiteProps?.TAC_Number?.value || "";
  //     const fwCop = frontWhiteProps?.CoP_Cert_No_with_validity_date?.value || "NA";
  //     const fwDate = frontWhiteProps?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //     reflDataList.frontWhiteList.MakeList.push(fwMake);
  //     reflDataList.frontWhiteList.validityList.push(fwTAC);
  //     reflDataList.frontWhiteList.tacNumberList.push(fwTacNumber);
  //     reflDataList.frontWhiteList.copCertList.push(getCoPValue(fwCheck, fwCop));
  //     reflDataList.frontWhiteList.possibleDateList.push(getDateValue(fwCheck, fwDate));
  //     reflDataList.suppNameList.push(fwMake);

  //     // --- REAR RED REFLECTOR ---
  //     const rearRedProps = vehRefl?.Rear_Red_Reflector?.properties || {};
  //     const rrMake = addPrefix(rearRedProps?.Make?.value);
  //     const rrTAC = rearRedProps?.TAC_Validity?.value || "";
  //     const rrCheck = parseAndCheckTACValidity(rrTAC);
  //     const rrTacNumber = rearRedProps?.TAC_Number?.value || "";
  //     const rrCop = rearRedProps?.CoP_Cert_No_with_validity_date?.value || "NA";
  //     const rrDate = rearRedProps?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //     reflDataList.rearRedList.MakeList.push(rrMake);
  //     reflDataList.rearRedList.validityList.push(rrTAC);
  //     reflDataList.rearRedList.tacNumberList.push(rrTacNumber);
  //     reflDataList.rearRedList.copCertList.push(getCoPValue(rrCheck, rrCop));
  //     reflDataList.rearRedList.possibleDateList.push(getDateValue(rrCheck, rrDate));
  //     reflDataList.suppNameList.push(rrMake);

  //     // --- SIDE AMBER REFLECTOR ---
  //     const sideAmberProps = vehRefl?.Side_Amber_Reflector?.properties || {};
  //     const saMake = addPrefix(sideAmberProps?.Make?.value);
  //     const saTAC = sideAmberProps?.TAC_Validity?.value || "";
  //     const saCheck = parseAndCheckTACValidity(saTAC);
  //     const saTacNumber = sideAmberProps?.TAC_Number?.value || "";
  //     const saCop = sideAmberProps?.CoP_Cert_No_with_validity_date?.value || "NA";
  //     const saDate = sideAmberProps?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //     reflDataList.sideAmberList.MakeList.push(saMake);
  //     reflDataList.sideAmberList.validityList.push(saTAC);
  //     reflDataList.sideAmberList.tacNumberList.push(saTacNumber);
  //     reflDataList.sideAmberList.copCertList.push(getCoPValue(saCheck, saCop));
  //     reflDataList.sideAmberList.possibleDateList.push(getDateValue(saCheck, saDate));
  //     reflDataList.suppNameList.push(saMake);
  // });

  //   const reflectorsList = form8Data?.Retro_Reflectors?.RetroReflectors;

  //   let reflDataList = {
  //     suppNameList: [],
  //     frontWhiteList: mainData(),
  //     rearRedList: mainData(),
  //     sideAmberList: mainData(),
  //   };

  //   reflectorsList.forEach((vehRefl) => {
  //     if (!vehRefl?.supplier?.active) return;

  //     const makePrefix = (make) => {
  //       if (make && !make.startsWith("M/")) return `M/s. ${make}`;
  //       return make || "";
  //     };

  //     // --- FRONT WHITE REFLECTOR ---
  //     const frontWhiteProps = vehRefl?.Front_White_Reflector?.properties || {};
  //     const fwMake = makePrefix(frontWhiteProps?.Make?.value);
  //     const fwTacValidity = frontWhiteProps?.TAC_Validity?.value || "";
  //     const fwTacNumber = frontWhiteProps?.TAC_Number?.value || "";
  //     const fwCop = frontWhiteProps?.CoP_Cert_No_with_validity_date?.value || "";
  //     const fwDate =
  //       frontWhiteProps?.Possible_date_of_submission_of_required_approval
  //         ?.value || "";

  //     reflDataList.frontWhiteList.MakeList.push(fwMake);
  //     reflDataList.frontWhiteList.validityList.push(fwTacValidity);
  //     reflDataList.frontWhiteList.tacNumberList.push(fwTacNumber);
  //     reflDataList.suppNameList.push(fwMake);

  //     const { cop: fwCopFinal, possible: fwPossible } = TACvalidationcheck(
  //       fwTacValidity,
  //       fwCop,
  //       fwDate
  //     );
  //     reflDataList.frontWhiteList.copCertList.push(fwCopFinal);
  //     reflDataList.frontWhiteList.possibleDateList.push(fwPossible);

  //     // --- REAR RED REFLECTOR ---
  //     const rearRedProps = vehRefl?.Rear_Red_Reflector?.properties || {};
  //     const rrMake = makePrefix(rearRedProps?.Make?.value);
  //     const rrTacValidity = rearRedProps?.TAC_Validity?.value || "";
  //     const rrTacNumber = rearRedProps?.TAC_Number?.value || "";
  //     const rrCop = rearRedProps?.CoP_Cert_No_with_validity_date?.value || "";
  //     const rrDate =
  //       rearRedProps?.Possible_date_of_submission_of_required_approval?.value ||
  //       "";

  //     reflDataList.rearRedList.MakeList.push(rrMake);
  //     reflDataList.rearRedList.validityList.push(rrTacValidity);
  //     reflDataList.rearRedList.tacNumberList.push(rrTacNumber);
  //     reflDataList.suppNameList.push(rrMake);

  //     const { cop: rrCopFinal, possible: rrPossible } = TACvalidationcheck(
  //       rrTacValidity,
  //       rrCop,
  //       rrDate
  //     );
  //     reflDataList.rearRedList.copCertList.push(rrCopFinal);
  //     reflDataList.rearRedList.possibleDateList.push(rrPossible);

  //     // --- SIDE AMBER REFLECTOR ---
  //     const sideAmberProps = vehRefl?.Side_Amber_Reflector?.properties || {};
  //     const saMake = makePrefix(sideAmberProps?.Make?.value);
  //     const saTacValidity = sideAmberProps?.TAC_Validity?.value || "";
  //     const saTacNumber = sideAmberProps?.TAC_Number?.value || "";
  //     const saCop = sideAmberProps?.CoP_Cert_No_with_validity_date?.value || "";
  //     const saDate =
  //       sideAmberProps?.Possible_date_of_submission_of_required_approval?.value ||
  //       "";

  //     reflDataList.sideAmberList.MakeList.push(saMake);
  //     reflDataList.sideAmberList.validityList.push(saTacValidity);
  //     reflDataList.sideAmberList.tacNumberList.push(saTacNumber);
  //     reflDataList.suppNameList.push(saMake);

  //     const { cop: saCopFinal, possible: saPossible } = TACvalidationcheck(
  //       saTacValidity,
  //       saCop,
  //       saDate
  //     );
  //     reflDataList.sideAmberList.copCertList.push(saCopFinal);
  //     reflDataList.sideAmberList.possibleDateList.push(saPossible);
  //   });

  //   console.log("----- Reflector Data Lists -----");

  //   // Supplier Name List
  //   console.log("Supplier Name List:", reflDataList.suppNameList);

  //   // FRONT WHITE
  //   console.log("\n--- Front White Reflector ---");
  //   console.log("Make List:", reflDataList.frontWhiteList.MakeList);
  //   console.log("TAC Validity List:", reflDataList.frontWhiteList.validityList);
  //   console.log("CoP Cert List:", reflDataList.frontWhiteList.copCertList);
  //   console.log(
  //     "Possible Date List:",
  //     reflDataList.frontWhiteList.possibleDateList
  //   );

  //   // REAR RED
  //   console.log("\n--- Rear Red Reflector ---");
  //   console.log("Make List:", reflDataList.rearRedList.MakeList);
  //   console.log("TAC Validity List:", reflDataList.rearRedList.validityList);
  //   console.log("CoP Cert List:", reflDataList.rearRedList.copCertList);
  //   console.log("Possible Date List:", reflDataList.rearRedList.possibleDateList);

  //   // SIDE AMBER
  //   console.log("\n--- Side Amber Reflector ---");
  //   console.log("Make List:", reflDataList.sideAmberList.MakeList);
  //   console.log("TAC Validity List:", reflDataList.sideAmberList.validityList);
  //   console.log("CoP Cert List:", reflDataList.sideAmberList.copCertList);
  //   console.log(
  //     "Possible Date List:",
  //     reflDataList.sideAmberList.possibleDateList
  //   );

  const reflectorsList = form8Data?.Retro_Reflectors?.RetroReflectors;

  let reflDataList = {
    suppNameList: [],
    frontWhiteList: mainData(),
    rearRedList: mainData(),
    sideAmberList: mainData(),
    frontWhiteListt: mainData(),
    rearRedListt: mainData(),
    sideAmberListt: mainData(),
  };

  reflectorsList.forEach((vehRefl) => {
    if (!vehRefl?.supplier?.active) return;

 
    // --- FRONT WHITE REFLECTOR ---
    const frontWhiteProps = vehRefl?.Front_White_Reflector?.properties || {};
    const fwMake = makePrefix(frontWhiteProps?.Make?.value);


    const fwTacValidityRaw = frontWhiteProps?.TAC_Validity?.value || "";
    const fwTacNumber = frontWhiteProps?.TAC_Number?.value || "";
    const fwCopRaw =
      frontWhiteProps?.CoP_Cert_No_with_validity_date?.value || "";
    const fwDate =
      frontWhiteProps?.Possible_date_of_submission_of_required_approval
        ?.value || "";

    // Logic for handling TAC when only CoP is present
    const isTacMissingFW = fwTacValidityRaw.trim() === "";
    const isfwDate = fwDate.trim() !== "";

    let finalFwTacValidity = fwTacValidityRaw;
    if (isTacMissingFW && isfwDate) {
      finalFwTacValidity = "NA"; // Your Condition 3 & 5
    }

    // FRONT WHITE REFLECTOR
    reflDataList.frontWhiteList.MakeList.push(fwMake);
    // if (finalFwTacValidity !== "NA") {
    //   reflDataList.frontWhiteList.validityList.push(fwTacValidityRaw);
    // } else {
    //   reflDataList.frontWhiteList.validityList.push("");
    // }

    //   reflDataList.frontWhiteList.MakeList.push(fwMake);
    //   reflDataList.frontWhiteList.validityList.push(finalFwTacValidity);

    // Push validity
reflDataList.frontWhiteList.validityList.push(finalFwTacValidity);

// Conditionally push TAC number
if (finalFwTacValidity === "NA") {
  reflDataList.frontWhiteList.tacNumberList.push("");
} else {
  reflDataList.frontWhiteList.tacNumberList.push(fwTacNumber);
}

    // reflDataList.frontWhiteList.validityList.push(finalFwTacValidity);
    // reflDataList.frontWhiteList.tacNumberList.push(fwTacNumber);
    reflDataList.suppNameList.push(fwMake);

    const { cop: fwCopFinal, possible: fwPossible } = TACvalidationcheck(
      fwTacValidityRaw,
      fwCopRaw,
      fwDate
    );
    reflDataList.frontWhiteList.copCertList.push(fwCopFinal);
    reflDataList.frontWhiteList.possibleDateList.push(fwPossible);

    // --- REAR RED REFLECTOR ---
    const rearRedProps = vehRefl?.Rear_Red_Reflector?.properties || {};
    const rrMake = makePrefix(rearRedProps?.Make?.value);

    const rrTacValidityRaw = rearRedProps?.TAC_Validity?.value || "";
    const rrTacNumber = rearRedProps?.TAC_Number?.value || "";
    const rrCopRaw = rearRedProps?.CoP_Cert_No_with_validity_date?.value || "";
    const rrDate =
      rearRedProps?.Possible_date_of_submission_of_required_approval?.value ||
      "";

    // Logic for handling TAC when only CoP is present
    const isTacMissingRR = rrTacValidityRaw.trim() === "";
    const isrrDate = rrDate.trim() !== "";

    let finalRrTacValidity = rrTacValidityRaw;
    if (isTacMissingRR && isrrDate) {
      finalRrTacValidity = "NA"; // Your Condition 3 & 5
    }

    // REAR RED REFLECTOR
    reflDataList.rearRedList.MakeList.push(rrMake);
    // if (finalRrTacValidity !== "NA") {
    //   reflDataList.rearRedList.validityList.push(rrTacValidityRaw);
    // } else {
    //   reflDataList.rearRedList.validityList.push("");
    // }

    //   reflDataList.rearRedList.MakeList.push(rrMake);
    //   reflDataList.rearRedList.validityList.push(finalRrTacValidity);
    // Push validity
reflDataList.rearRedList.validityList.push(finalRrTacValidity);

// Conditionally push TAC number
if (finalRrTacValidity === "NA") {
  reflDataList.rearRedList.tacNumberList.push("");
} else {
  reflDataList.rearRedList.tacNumberList.push(rrTacNumber);
}

    // reflDataList.rearRedList.validityList.push(finalRrTacValidity);
    // reflDataList.rearRedList.tacNumberList.push(rrTacNumber);
    reflDataList.suppNameList.push(rrMake);

    const { cop: rrCopFinal, possible: rrPossible } = TACvalidationcheck(
      rrTacValidityRaw,
      rrCopRaw,
      rrDate
    );
    reflDataList.rearRedList.copCertList.push(rrCopFinal);
    reflDataList.rearRedList.possibleDateList.push(rrPossible);

    // --- SIDE AMBER REFLECTOR ---
    const sideAmberProps = vehRefl?.Side_Amber_Reflector?.properties || {};
    const saMake = makePrefix(sideAmberProps?.Make?.value);

    const saTacValidityRaw = sideAmberProps?.TAC_Validity?.value || "";
    const saTacNumber = sideAmberProps?.TAC_Number?.value || "";
    const saCopRaw =
      sideAmberProps?.CoP_Cert_No_with_validity_date?.value || "";
    const saDate =
      sideAmberProps?.Possible_date_of_submission_of_required_approval?.value ||
      "";

    // Logic for handling TAC when only CoP is present
    const isTacMissingSA = saTacValidityRaw.trim() === "";
    const issaDate = saDate.trim() !== "";

    let finalSaTacValidity = saTacValidityRaw;
    if (isTacMissingSA && issaDate) {
      finalSaTacValidity = "NA"; // Your Condition 3 & 5
    }
    // SIDE AMBER REFLECTOR
    reflDataList.sideAmberList.MakeList.push(saMake);
    // if (finalSaTacValidity !== "NA") {
    //   reflDataList.sideAmberList.validityList.push(saTacValidityRaw);
    // } else {
    //   reflDataList.sideAmberList.validityList.push("");
    // }

    //   reflDataList.sideAmberList.MakeList.push(saMake);
    //   reflDataList.sideAmberList.validityList.push(finalSaTacValidity);
    // Push validity
reflDataList.sideAmberList.validityList.push(finalSaTacValidity);

// Conditionally push TAC number
if (finalSaTacValidity === "NA") {
  reflDataList.sideAmberList.tacNumberList.push("");
} else {
  reflDataList.sideAmberList.tacNumberList.push(saTacNumber);
}

    // reflDataList.sideAmberList.validityList.push(finalSaTacValidity);
    // reflDataList.sideAmberList.tacNumberList.push(saTacNumber);
    reflDataList.suppNameList.push(saMake);

    const { cop: saCopFinal, possible: saPossible } = TACvalidationcheck(
      saTacValidityRaw,
      saCopRaw,
      saDate
    );
    reflDataList.sideAmberList.copCertList.push(saCopFinal);
    reflDataList.sideAmberList.possibleDateList.push(saPossible);

    // --- FRONT WHITE Reflective ---
    const frontWhiteProperties =
      vehRefl?.Front_Reflective_Tape?.properties || {};
    const frontWhiteMake = makePrefix(frontWhiteProperties?.Make?.value);

    const frontWhiteTacValidityRaw =
      frontWhiteProperties?.TAC_Validity?.value || "";
    const frontWhiteTacNumber = frontWhiteProperties?.TAC_Number?.value || "";
    const frontWhiteCopCertRaw =
      frontWhiteProperties?.CoP_Cert_No_with_validity_date?.value || "";
    const frontWhitePossibleDateOfSubmission =
      frontWhiteProperties?.Possible_date_of_submission_of_required_approval
        ?.value || "";

    // Logic for handling TAC when only CoP is present
    const isFrontWhiteTacMissing = frontWhiteTacValidityRaw.trim() === "";
    const hasFrontWhiteSubmissionDate =
      frontWhitePossibleDateOfSubmission.trim() !== "";

    let finalFrontWhiteTacValidity = frontWhiteTacValidityRaw;
    if (isFrontWhiteTacMissing && hasFrontWhiteSubmissionDate) {
      finalFrontWhiteTacValidity = "NA"; // Your Condition 3 & 5
    }

    // FRONT WHITE REFLECTOR
    reflDataList.frontWhiteListt.MakeList.push(frontWhiteMake);
    // if (finalFrontWhiteTacValidity !== "NA") {
    //   reflDataList.frontWhiteListt.validityList.push(frontWhiteTacValidityRaw);
    // } else {
    //   reflDataList.frontWhiteListt.validityList.push("");
    // }

    if (finalFrontWhiteTacValidity === "NA") {
        reflDataList.frontWhiteListt.tacNumberList.push("");
      } else {
        reflDataList.frontWhiteListt.tacNumberList.push(frontWhiteTacNumber);
      }
    reflDataList.frontWhiteListt.validityList.push(finalFrontWhiteTacValidity);
    // reflDataList.frontWhiteListt.tacNumberList.push(frontWhiteTacNumber);
    reflDataList.suppNameList.push(frontWhiteMake);

    const {
      cop: frontWhiteCopCertFinal,
      possible: frontWhitePossibleDateFinal,
    } = TACvalidationcheck(
      frontWhiteTacValidityRaw,
      frontWhiteCopCertRaw,
      frontWhitePossibleDateOfSubmission
    );

    reflDataList.frontWhiteListt.copCertList.push(frontWhiteCopCertFinal);
    reflDataList.frontWhiteListt.possibleDateList.push(
      frontWhitePossibleDateFinal
    );

    // --- REAR RED Reflective Tape ---
    const rearRedProperties = vehRefl?.Rear_Reflective_Tape?.properties || {};
    const rearRedMake = makePrefix(rearRedProperties?.Make?.value);

    const rearRedTacValidityRaw = rearRedProperties?.TAC_Validity?.value || "";
    const rearRedTacNumber = rearRedProperties?.TAC_Number?.value || "";
    const rearRedCopCertRaw =
      rearRedProperties?.CoP_Cert_No_with_validity_date?.value || "";
    const rearRedPossibleDateOfSubmission =
      rearRedProperties?.Possible_date_of_submission_of_required_approval
        ?.value || "";

    // Logic for handling TAC when only CoP is present
    const isRearRedTacMissing = rearRedTacValidityRaw.trim() === "";
    const hasRearRedSubmissionDate =
      rearRedPossibleDateOfSubmission.trim() !== "";

    let finalRearRedTacValidity = rearRedTacValidityRaw;
    if (isRearRedTacMissing && hasRearRedSubmissionDate) {
      finalRearRedTacValidity = "NA"; // Your Condition 3 & 5
    }

    // REAR RED Reflective Tape
    reflDataList.rearRedListt.MakeList.push(rearRedMake);
    // if (finalRearRedTacValidity !== "NA") {
    //   reflDataList.rearRedListt.validityList.push(rearRedTacValidityRaw);
    // } else {
    //   reflDataList.rearRedListt.validityList.push("");
    // }

    // Push validity
reflDataList.rearRedListt.validityList.push(finalRearRedTacValidity);

// Conditionally push TAC number
if (finalRearRedTacValidity === "NA") {
  reflDataList.rearRedListt.tacNumberList.push("");
} else {
  reflDataList.rearRedListt.tacNumberList.push(rearRedTacNumber);
}

    // reflDataList.rearRedListt.validityList.push(finalRearRedTacValidity);
    // reflDataList.rearRedListt.tacNumberList.push(rearRedTacNumber);
    reflDataList.suppNameList.push(rearRedMake);

    // Keep this line unchanged
    const { cop: rearRedCopCertFinal, possible: rearRedPossibleDateFinal } =
      TACvalidationcheck(
        rearRedTacValidityRaw,
        rearRedCopCertRaw,
        rearRedPossibleDateOfSubmission
      );

    reflDataList.rearRedListt.copCertList.push(rearRedCopCertFinal);
    reflDataList.rearRedListt.possibleDateList.push(rearRedPossibleDateFinal);

    // --- SIDE AMBER Reflective Tape ---
    const sideAmberProperties = vehRefl?.Side_Reflective_Tape?.properties || {};
    const sideAmberMake = makePrefix(sideAmberProperties?.Make?.value);

    const sideAmberTacValidityRaw =
      sideAmberProperties?.TAC_Validity?.value || "";
    const sideAmberTacNumber = sideAmberProperties?.TAC_Number?.value || "";
    const sideAmberCopCertRaw =
      sideAmberProperties?.CoP_Cert_No_with_validity_date?.value || "";
    const sideAmberPossibleDateOfSubmission =
      sideAmberProperties?.Possible_date_of_submission_of_required_approval
        ?.value || "";

    // Logic for handling TAC when only CoP is present
    const isSideAmberTacMissing = sideAmberTacValidityRaw.trim() === "";
    const hasSideAmberSubmissionDate =
      sideAmberPossibleDateOfSubmission.trim() !== "";

    let finalSideAmberTacValidity = sideAmberTacValidityRaw;
    if (isSideAmberTacMissing && hasSideAmberSubmissionDate) {
      finalSideAmberTacValidity = "NA"; // Your Condition 3 & 5
    }

    // SIDE AMBER Reflective Tape
    reflDataList.sideAmberListt.MakeList.push(sideAmberMake);
    // if (finalSideAmberTacValidity !== "NA") {
    //   reflDataList.sideAmberListt.validityList.push(sideAmberTacValidityRaw);
    // } else {
    //   reflDataList.sideAmberListt.validityList.push("");
    // }


    // Conditionally push tac number
if (finalSideAmberTacValidity === "NA") {
    reflDataList.sideAmberListt.tacNumberList.push("");
  } else {
    reflDataList.sideAmberListt.tacNumberList.push(sideAmberTacNumber);
  }
    reflDataList.sideAmberListt.validityList.push(finalSideAmberTacValidity);
    // reflDataList.sideAmberListt.tacNumberList.push(sideAmberTacNumber);
    reflDataList.suppNameList.push(sideAmberMake);

    // Keep this line unchanged
    const { cop: sideAmberCopCertFinal, possible: sideAmberPossibleDateFinal } =
      TACvalidationcheck(
        sideAmberTacValidityRaw,
        sideAmberCopCertRaw,
        sideAmberPossibleDateOfSubmission
      );

    reflDataList.sideAmberListt.copCertList.push(sideAmberCopCertFinal);
    reflDataList.sideAmberListt.possibleDateList.push(
      sideAmberPossibleDateFinal
    );
  });

  console.log("----- Reflector Data Lists -----");

  console.log("Supplier Name List:", reflDataList.suppNameList);

  // FRONT WHITE
  console.log("\n--- Front White Reflector ---");
  console.log("Make List:", reflDataList.frontWhiteList.MakeList);
  console.log("TAC Validity List:", reflDataList.frontWhiteList.tacNumberList);
  console.log("TAC Validity List:", reflDataList.frontWhiteList.validityList);
  console.log("CoP Cert List:", reflDataList.frontWhiteList.copCertList);
  console.log(
    "Possible Date List:",
    reflDataList.frontWhiteList.possibleDateList
  );

  // REAR RED
  console.log("\n--- Rear Red Reflector ---");
  console.log("Make List:", reflDataList.rearRedList.MakeList);
  console.log("TAC Validity List:", reflDataList.rearRedList.validityList);
  console.log("TAC Validity List:", reflDataList.rearRedList.tacNumberList);
  console.log("CoP Cert List:", reflDataList.rearRedList.copCertList);
  console.log("Possible Date List:", reflDataList.rearRedList.possibleDateList);

  // SIDE AMBER
  console.log("\n--- Side Amber Reflector ---");
  console.log("Make List:", reflDataList.sideAmberList.MakeList);
  console.log("TAC Validity List:", reflDataList.sideAmberList.tacNumberList);
  console.log("TAC Validity List:", reflDataList.sideAmberList.validityList);
  console.log("CoP Cert List:", reflDataList.sideAmberList.copCertList);
  console.log(
    "Possible Date List:",
    reflDataList.sideAmberList.possibleDateList
  );

  // const hornList = form8Data?.Horn?.Horn;
  // let hornDataList = mainData();
  // hornList.map(vehHorn => {
  //     if (vehHorn.supplier.active === true) {

  //         let supplierName = vehHorn?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // hornDataList.suppNameList.push(supplierName);
  //         // // hornDataList.suppNameList.push(vehHorn?.supplier?.nameOfSupplier);
  //         // hornDataList.validityList.push(vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value);
  //         // Get the TAC Number validity value for Horn
  //         const hornTACValue = vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value;

  //         // Push the TAC value to hornDataList
  //         hornDataList.validityList.push(hornTACValue);

  //         // Check if TAC value is present
  //         // hornDataList.suppNameList.push(hornTACValue ? supplierName : "");
  //         if (hornTACValue && hornTACValue.trim() !== "") {
  //             hornDataList.suppNameList.push(supplierName);
  //         }

  //         hornDataList.MakeList.push(vehHorn?.Horn?.properties?.Make?.value);
  //         hornDataList.possibleDateList.push(vehHorn?.Horn?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         hornDataList.copCertList.push(vehHorn?.Horn?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  /////////////////
  // const hornList = form8Data?.Horn?.Horn;
  // let hornDataList = mainData();

  // hornList.map(vehHorn => {
  //     if (vehHorn?.supplier?.active === true) {
  //         // Get and process Make
  //         let make = vehHorn?.Horn?.properties?.Make?.value || "";

  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         // TAC value
  //         const hornTACValue = vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value;
  //         hornDataList.validityList.push(hornTACValue);

  //         // Add Make to suppNameList only if TAC value is present
  //         if (hornTACValue && hornTACValue.trim() !== "") {
  //             hornDataList.suppNameList.push(make);
  //         }

  //         hornDataList.MakeList.push(make);

  //         const possibleDate = (make.includes("NA"))
  //             ? "NA"
  //             : vehHorn?.Horn?.properties?.Possible_date_of_submission_of_required_approval?.value;
  //         hornDataList.possibleDateList.push(possibleDate);

  //         hornDataList.copCertList.push(vehHorn?.Horn?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const hornList = form8Data?.Horn?.Horn;
  // let hornDataList = mainData();
  // const today = new Date();

  // hornList.map((vehHorn) => {
  //     if (vehHorn?.supplier?.active === true) {
  //         let make = vehHorn?.Horn?.properties?.Make?.value || "";
  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         const tacValueRaw = vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value || "";
  //         const tacParts = tacValueRaw.split(/and|&/); // supports both 'and' and '&'
  //         const tacDateStr = tacParts.length > 1 ? tacParts[1].trim() : "";

  //         let tacDate;
  //         let isTACExpired = false;

  //         if (tacDateStr) {
  //             const [day, month, year] = tacDateStr.split("/").map(Number);
  //             if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
  //                 tacDate = new Date(year, month - 1, day);
  //                 isTACExpired = tacDate < today;
  //             }
  //         }

  //         hornDataList.validityList.push(tacValueRaw);
  //         hornDataList.MakeList.push(make);

  //         const copCert = vehHorn?.Horn?.properties?.CoP_Cert_No_with_validity_date?.value || "NA";
  //         const possibleDate = vehHorn?.Horn?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //         // Apply condition
  //         if (tacDateStr) {
  //             if (isTACExpired) {
  //                 hornDataList.suppNameList.push(make);
  //                 hornDataList.copCertList.push(copCert);
  //                 hornDataList.possibleDateList.push(possibleDate);
  //             } else {
  //                 hornDataList.suppNameList.push(make);
  //                 hornDataList.copCertList.push("NA");
  //                 hornDataList.possibleDateList.push("NA");
  //             }
  //         } else {
  //             hornDataList.suppNameList.push(make);
  //             hornDataList.copCertList.push(copCert);
  //             hornDataList.possibleDateList.push(possibleDate);
  //         }
  //     }
  // });

  // Example usage in your existing code
  // const hornList = form8Data?.Horn?.Horn;
  // let hornDataList = mainData();
  // const today = new Date();

  // hornList.map((vehHorn) => {
  //     if (vehHorn?.supplier?.active === true) {
  //         let make = vehHorn?.Horn?.properties?.Make?.value || "";
  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         const tacValueRaw = vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value || "";
  //         const tacCheck = parseAndCheckTACValidity(tacValueRaw);

  //         hornDataList.validityList.push(tacValueRaw);
  //         hornDataList.MakeList.push(make);

  //         const copCert = vehHorn?.Horn?.properties?.CoP_Cert_No_with_validity_date?.value || "NA";
  //         const possibleDate = vehHorn?.Horn?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //         if (tacCheck.hasDate) {
  //             if (tacCheck.expired) {
  //                 hornDataList.suppNameList.push(make);
  //                 hornDataList.copCertList.push(copCert);
  //                 hornDataList.possibleDateList.push(possibleDate);
  //             } else {
  //                 hornDataList.suppNameList.push(make);
  //                 hornDataList.copCertList.push("NA");
  //                 hornDataList.possibleDateList.push("NA");
  //             }
  //         } else {
  //             hornDataList.suppNameList.push(make);
  //             hornDataList.copCertList.push(copCert);
  //             hornDataList.possibleDateList.push(possibleDate);
  //         }
  //     }
  // });

  //     const hornList = form8Data?.Horn?.Horn;
  // let hornDataList = mainData();
  // const today = new Date();

  // hornList.map((vehHorn) => {
  //     if (vehHorn?.supplier?.active === true) {
  //         let make = vehHorn?.Horn?.properties?.Make?.value || "";
  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         const tacValueRaw = vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value || "";
  //         const tacCheck = parseAndCheckTACValidity(tacValueRaw);

  //         const copCertRaw = vehHorn?.Horn?.properties?.CoP_Cert_No_with_validity_date?.value || "";
  //         const possibleDateRaw = vehHorn?.Horn?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //         hornDataList.validityList.push(tacValueRaw);
  //         hornDataList.MakeList.push(make);
  // hornDataList.suppNameList.push(make);
  //         if (tacCheck.hasDate) {
  //             if (tacCheck.expired) {

  //                 hornDataList.copCertList.push("NA");
  //                 hornDataList.possibleDateList.push(possibleDateRaw || "NA");
  //             } else {

  //                 hornDataList.copCertList.push("NA");
  //                 hornDataList.possibleDateList.push("NA");
  //             }
  //         } else {

  //             const isCopBlank = !copCertRaw.trim();
  //             const isTacBlank = !tacValueRaw.trim();
  //             const possibleDateFinal = (isTacBlank && isCopBlank) ? "" : "NA";

  //             hornDataList.copCertList.push(isCopBlank ? "" : copCertRaw);
  //             hornDataList.possibleDateList.push(possibleDateFinal);
  //         }
  //     }
  // });

  //   const hornList = form8Data?.Horn?.Horn;
  //   let hornDataList = mainData();

  //   hornList.map((vehHorn) => {
  //     if (vehHorn?.supplier?.active === true) {
  //       let make = vehHorn?.Horn?.properties?.Make?.value || "";
  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       const tacValueRaw =
  //         vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value || "";
  //       const copCertRaw =
  //         vehHorn?.Horn?.properties?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw =
  //         vehHorn?.Horn?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";

  //       hornDataList.validityList.push(tacValueRaw);
  //       hornDataList.MakeList.push(make);
  //       hornDataList.suppNameList.push(make);

  //       // ✅ Modular & correct usage
  //       const { cop, possible } = TACvalidationcheck(
  //         tacValueRaw,
  //         copCertRaw,
  //         possibleDateRaw
  //       );
  //       hornDataList.copCertList.push(cop);
  //       hornDataList.possibleDateList.push(possible);
  //     }
  //   });

  const hornList = form8Data?.Horn?.Horn;
  let hornDataList = mainData();

  hornList.map((vehHorn) => {
    if (vehHorn?.supplier?.active === true) {
    //   let make = vehHorn?.Horn?.properties?.Make?.value || "";
    //   if (make && make.toLowerCase() !== "na" && !make.startsWith("M/")) {
    //     make = `M/s. ${make}`;
    //   }
    let make = makePrefix(vehHorn?.Horn?.properties?.Make?.value);

      const tacValueRaw =
        vehHorn?.Horn?.properties?.TAC_Number_Its_Validity?.value?.trim() || "";
      const copCertRaw =
        vehHorn?.Horn?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() ||
        "";
      const possibleDateRaw =
        vehHorn?.Horn?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      // // Logic for handling TAC when only CoP is present
      // const isTacMissing = tacValueRaw === "";
      // const isPossibleDatePresent = possibleDateRaw !== "";

      // let finalTAC = tacValueRaw;
      // if (isTacMissing && isPossibleDatePresent) {
      //     finalTAC = "NA"; // ✅ Your Condition 5 / 3
      // }

      // Updated logic: check if TAC is missing and Possible Date is present
      const isTacMissing = tacValueRaw === "";
      const isPossibleDatePresent = possibleDateRaw !== "";

      let finalTAC = tacValueRaw;
      if (isTacMissing && isPossibleDatePresent) {
        finalTAC = "NA"; // ✅ Updated Condition 5 / 3
      }

      hornDataList.validityList.push(finalTAC);
      hornDataList.MakeList.push(make);
      hornDataList.suppNameList.push(make);

      // Handle CoP & Possible Date via helper
      const { cop, possible } = TACvalidationcheck(
        tacValueRaw,
        copCertRaw,
        possibleDateRaw
      );
      hornDataList.copCertList.push(cop);
      hornDataList.possibleDateList.push(possible);
    }
  });

  console.log(" Horn suppNameList:", hornDataList.suppNameList);
  console.log("possibleDateList:", hornDataList.possibleDateList);
  console.log("copCertList:", hornDataList.copCertList);
  console.log("validityList:", hornDataList.validityList);

  const tyreList = form8Data?.Tyres?.TyresData;

  // let ftyreDataList = mainData();
  // let rtyreDataList = mainData();
  // let atyreDataList = mainData();
  // tyreList.map(vehTyre => {
  //     if (vehTyre.supplier.active === true) {
  //         // ftyreDataList.suppNameList.push(vehTyre?.supplier?.nameOfSupplier);
  //         let frontTyreMakeValue = vehTyre?.Front_tyre?.properties?.Make?.value;

  //         if (frontTyreMakeValue && !frontTyreMakeValue.startsWith("M/")) {
  //             frontTyreMakeValue = `M/s. ${frontTyreMakeValue}`;
  //         }

  //         ftyreDataList.MakeList.push(frontTyreMakeValue);

  //         ftyreDataList.validityList.push(vehTyre?.Front_tyre?.properties?.TAC_Number_Its_Validity?.value);
  //         ftyreDataList.possibleDateList.push(vehTyre?.Front_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         ftyreDataList.copCertList.push(vehTyre?.Front_tyre?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         ftyreDataList.vehType.push(vehTyre?.Front_tyre?.properties?.tyre_vehicle_type?.value);
  //         let rearTyreMakeValue = vehTyre?.Rear_tyre?.properties?.Make?.value;

  //         if (rearTyreMakeValue && !rearTyreMakeValue.startsWith("M/")) {
  //             rearTyreMakeValue = `M/s. ${rearTyreMakeValue}`;
  //         }

  //         rtyreDataList.MakeList.push(rearTyreMakeValue);

  //         rtyreDataList.validityList.push(vehTyre?.Rear_tyre?.properties?.TAC_Number_Its_Validity?.value);
  //         rtyreDataList.possibleDateList.push(vehTyre?.Rear_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rtyreDataList.copCertList.push(vehTyre?.Rear_tyre?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         const tacValidity = vehTyre?.Any_other_Tyre?.properties?.TAC_Number_Its_Validity?.value;
  //         atyreDataList.validityList.push(tacValidity);
  //         // if (tacValidity && tacValidity.trim() !== "NA") {
  //         //     atyreDataList.suppNameList.push(vehTyre?.supplier?.nameOfSupplier);
  //         // } else {
  //         //     atyreDataList.suppNameList.push(""); // If TAC validity is "NA" or not present, push an empty string
  //         // }
  //         let anyOtherTyreMakeValue = vehTyre?.Any_other_Tyre?.properties?.Make?.value;

  //         if (anyOtherTyreMakeValue && !anyOtherTyreMakeValue.startsWith("M/")) {
  //             anyOtherTyreMakeValue = `M/s. ${anyOtherTyreMakeValue}`;
  //         }

  //         atyreDataList.MakeList.push(anyOtherTyreMakeValue);

  //         atyreDataList.possibleDateList.push(vehTyre?.Any_other_Tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         atyreDataList.copCertList.push(vehTyre?.Any_other_Tyre?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         console.log("Front Tyre Make (raw):", vehTyre?.Front_tyre?.properties?.Make?.value);
  //         console.log("Formatted Front Tyre Make:", frontTyreMakeValue);
  //         console.log("Front Tyre TAC Validity:", vehTyre?.Front_tyre?.properties?.TAC_Number_Its_Validity?.value);
  //         console.log("Front Tyre Possible Submission Date:", vehTyre?.Front_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         console.log("Front Tyre CoP Cert No:", vehTyre?.Front_tyre?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         console.log("Front Tyre Vehicle Type:", vehTyre?.Front_tyre?.properties?.tyre_vehicle_type?.value);

  //         console.log("Rear Tyre Make (raw):", vehTyre?.Rear_tyre?.properties?.Make?.value);
  //         console.log("Formatted Rear Tyre Make:", rearTyreMakeValue);
  //         console.log("Rear Tyre TAC Validity:", vehTyre?.Rear_tyre?.properties?.TAC_Number_Its_Validity?.value);
  //         console.log("Rear Tyre Possible Submission Date:", vehTyre?.Rear_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         console.log("Rear Tyre CoP Cert No:", vehTyre?.Rear_tyre?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         console.log("Any Other Tyre TAC Validity:", tacValidity);
  //         console.log("Any Other Tyre Make (raw):", vehTyre?.Any_other_Tyre?.properties?.Make?.value);
  //         console.log("Formatted Any Other Tyre Make:", anyOtherTyreMakeValue);
  //         console.log("Any Other Tyre Possible Submission Date:", vehTyre?.Any_other_Tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         console.log("Any Other Tyre CoP Cert No:", vehTyre?.Any_other_Tyre?.properties?.CoP_Cert_No_with_validity_date?.value);

  //     }
  // });

  // let ftyreDataList = mainData();
  // let rtyreDataList = mainData();
  // let atyreDataList = mainData();

  // tyreList.map(vehTyre => {
  //     if (vehTyre.supplier.active === true) {
  //         // FRONT TYRE
  //         let frontTyreMakeValue = vehTyre?.Front_tyre?.properties?.Make?.value || "";
  //         if (frontTyreMakeValue && !frontTyreMakeValue.startsWith("M/")) {
  //             frontTyreMakeValue = `M/s. ${frontTyreMakeValue}`;
  //         }

  //         const frontTyreTAC = vehTyre?.Front_tyre?.properties?.TAC_Number_Its_Validity?.value;
  //         const tacCheckFront = parseAndCheckTACValidity(frontTyreTAC);

  //         ftyreDataList.MakeList.push(frontTyreMakeValue);
  //         ftyreDataList.validityList.push(frontTyreTAC);

  //         if (frontTyreTAC && frontTyreTAC.trim() !== "") {
  //             if (tacCheckFront.hasDate) {
  //                 if (tacCheckFront.expired) {
  //                     ftyreDataList.copCertList.push(vehTyre?.Front_tyre?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                     ftyreDataList.possibleDateList.push(vehTyre?.Front_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //                 } else {
  //                     ftyreDataList.copCertList.push("NA");
  //                     ftyreDataList.possibleDateList.push("NA");
  //                 }
  //             } else {
  //                 ftyreDataList.copCertList.push(vehTyre?.Front_tyre?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                 ftyreDataList.possibleDateList.push(vehTyre?.Front_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //             }
  //         } else {
  //             ftyreDataList.copCertList.push("NA");
  //             ftyreDataList.possibleDateList.push("NA");
  //         }

  //         ftyreDataList.vehType.push(vehTyre?.Front_tyre?.properties?.tyre_vehicle_type?.value);

  //         // REAR TYRE
  //         let rearTyreMakeValue = vehTyre?.Rear_tyre?.properties?.Make?.value || "";
  //         if (rearTyreMakeValue && !rearTyreMakeValue.startsWith("M/")) {
  //             rearTyreMakeValue = `M/s. ${rearTyreMakeValue}`;
  //         }

  //         const rearTyreTAC = vehTyre?.Rear_tyre?.properties?.TAC_Number_Its_Validity?.value;
  //         const tacCheckRear = parseAndCheckTACValidity(rearTyreTAC);

  //         rtyreDataList.MakeList.push(rearTyreMakeValue);
  //         rtyreDataList.validityList.push(rearTyreTAC);

  //         if (rearTyreTAC && rearTyreTAC.trim() !== "") {
  //             if (tacCheckRear.hasDate) {
  //                 if (tacCheckRear.expired) {
  //                     rtyreDataList.copCertList.push(vehTyre?.Rear_tyre?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                     rtyreDataList.possibleDateList.push(vehTyre?.Rear_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //                 } else {
  //                     rtyreDataList.copCertList.push("NA");
  //                     rtyreDataList.possibleDateList.push("NA");
  //                 }
  //             } else {
  //                 rtyreDataList.copCertList.push(vehTyre?.Rear_tyre?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                 rtyreDataList.possibleDateList.push(vehTyre?.Rear_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //             }
  //         } else {
  //             rtyreDataList.copCertList.push("NA");
  //             rtyreDataList.possibleDateList.push("NA");
  //         }

  //         // ANY OTHER TYRE
  //         let anyOtherTyreMakeValue = vehTyre?.Any_other_Tyre?.properties?.Make?.value || "";
  //         if (anyOtherTyreMakeValue && !anyOtherTyreMakeValue.startsWith("M/")) {
  //             anyOtherTyreMakeValue = `M/s. ${anyOtherTyreMakeValue}`;
  //         }

  //         const anyOtherTyreTAC = vehTyre?.Any_other_Tyre?.properties?.TAC_Number_Its_Validity?.value;
  //         const tacCheckAnyOther = parseAndCheckTACValidity(anyOtherTyreTAC);

  //         atyreDataList.MakeList.push(anyOtherTyreMakeValue);
  //         atyreDataList.validityList.push(anyOtherTyreTAC);

  //         if (anyOtherTyreTAC && anyOtherTyreTAC.trim() !== "") {
  //             if (tacCheckAnyOther.hasDate) {
  //                 if (tacCheckAnyOther.expired) {
  //                     atyreDataList.copCertList.push(vehTyre?.Any_other_Tyre?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                     atyreDataList.possibleDateList.push(vehTyre?.Any_other_Tyre?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //                 } else {
  //                     atyreDataList.copCertList.push("NA");
  //                     atyreDataList.possibleDateList.push("NA");
  //                 }
  //             } else {
  //                 atyreDataList.copCertList.push(vehTyre?.Any_other_Tyre?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                 atyreDataList.possibleDateList.push(vehTyre?.Any_other_Tyre?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //             }
  //         } else {
  //             atyreDataList.copCertList.push("NA");
  //             atyreDataList.possibleDateList.push("NA");
  //         }

  //         // Debug logs (optional)
  //         console.log("Front Tyre Make (raw):", vehTyre?.Front_tyre?.properties?.Make?.value);
  //         console.log("Formatted Front Tyre Make:", frontTyreMakeValue);
  //         console.log("Front Tyre TAC Validity:", frontTyreTAC);
  //         console.log("Front Tyre Possible Submission Date:", vehTyre?.Front_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         console.log("Front Tyre CoP Cert No:", vehTyre?.Front_tyre?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         console.log("Front Tyre Vehicle Type:", vehTyre?.Front_tyre?.properties?.tyre_vehicle_type?.value);

  //         console.log("Rear Tyre Make (raw):", vehTyre?.Rear_tyre?.properties?.Make?.value);
  //         console.log("Formatted Rear Tyre Make:", rearTyreMakeValue);
  //         console.log("Rear Tyre TAC Validity:", rearTyreTAC);
  //         console.log("Rear Tyre Possible Submission Date:", vehTyre?.Rear_tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         console.log("Rear Tyre CoP Cert No:", vehTyre?.Rear_tyre?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         console.log("Any Other Tyre TAC Validity:", anyOtherTyreTAC);
  //         console.log("Any Other Tyre Make (raw):", vehTyre?.Any_other_Tyre?.properties?.Make?.value);
  //         console.log("Formatted Any Other Tyre Make:", anyOtherTyreMakeValue);
  //         console.log("Any Other Tyre Possible Submission Date:", vehTyre?.Any_other_Tyre?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         console.log("Any Other Tyre CoP Cert No:", vehTyre?.Any_other_Tyre?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  //   let ftyreDataList = mainData();
  //   let rtyreDataList = mainData();
  //   let atyreDataList = mainData();

  //   tyreList.map((vehTyre) => {
  //     if (vehTyre?.supplier?.active === true) {
  //       // ---------- FRONT TYRE ----------
  //       const frontProps = vehTyre?.Front_tyre?.properties || {};
  //       let frontTyreMake = frontProps?.Make?.value || "";
  //       if (frontTyreMake && !frontTyreMake.startsWith("M/")) {
  //         frontTyreMake = `M/s. ${frontTyreMake}`;
  //       }

  //       const frontTAC = frontProps?.TAC_Number_Its_Validity?.value || "";
  //       const frontCoP = frontProps?.CoP_Cert_No_with_validity_date?.value || "";
  //       const frontPossible =
  //         frontProps?.Possible_date_of_submission_of_required_approval?.value ||
  //         "";

  //       const { cop: frontCop, possible: frontPossibleDate } = TACvalidationcheck(
  //         frontTAC,
  //         frontCoP,
  //         frontPossible
  //       );

  //       ftyreDataList.MakeList.push(frontTyreMake);
  //       ftyreDataList.validityList.push(frontTAC);
  //       ftyreDataList.copCertList.push(frontCop);
  //       ftyreDataList.possibleDateList.push(frontPossibleDate);
  //       ftyreDataList.vehType.push(frontProps?.tyre_vehicle_type?.value);

  //       // ---------- REAR TYRE ----------
  //       const rearProps = vehTyre?.Rear_tyre?.properties || {};
  //       let rearTyreMake = rearProps?.Make?.value || "";
  //       if (rearTyreMake && !rearTyreMake.startsWith("M/")) {
  //         rearTyreMake = `M/s. ${rearTyreMake}`;
  //       }

  //       const rearTAC = rearProps?.TAC_Number_Its_Validity?.value || "";
  //       const rearCoP = rearProps?.CoP_Cert_No_with_validity_date?.value || "";
  //       const rearPossible =
  //         rearProps?.Possible_date_of_submission_of_required_approval?.value ||
  //         "";

  //       const { cop: rearCop, possible: rearPossibleDate } = TACvalidationcheck(
  //         rearTAC,
  //         rearCoP,
  //         rearPossible
  //       );

  //       rtyreDataList.MakeList.push(rearTyreMake);
  //       rtyreDataList.validityList.push(rearTAC);
  //       rtyreDataList.copCertList.push(rearCop);
  //       rtyreDataList.possibleDateList.push(rearPossibleDate);

  //       // ---------- ANY OTHER TYRE ----------
  //       const otherProps = vehTyre?.Any_other_Tyre?.properties || {};
  //       let otherTyreMake = otherProps?.Make?.value || "";
  //       if (otherTyreMake && !otherTyreMake.startsWith("M/")) {
  //         otherTyreMake = `M/s. ${otherTyreMake}`;
  //       }

  //       const otherTAC = otherProps?.TAC_Number_Its_Validity?.value || "";
  //       const otherCoP = otherProps?.CoP_Cert_No_with_validity_date?.value || "";
  //       const otherPossible =
  //         otherProps?.Possible_date_of_submission_of_required_approval?.value ||
  //         "";

  //       const { cop: otherCop, possible: otherPossibleDate } = TACvalidationcheck(
  //         otherTAC,
  //         otherCoP,
  //         otherPossible
  //       );

  //       atyreDataList.MakeList.push(otherTyreMake);
  //       atyreDataList.validityList.push(otherTAC);
  //       atyreDataList.copCertList.push(otherCop);
  //       atyreDataList.possibleDateList.push(otherPossibleDate);
  //     }
  //   });

  let ftyreDataList = mainData();
  let rtyreDataList = mainData();
  let atyreDataList = mainData();

  tyreList.map((vehTyre) => {
    if (vehTyre?.supplier?.active === true) {
      // ---------- FRONT TYRE ----------
      const frontProps = vehTyre?.Front_tyre?.properties || {};
    //   let frontTyreMake = frontProps?.Make?.value || "";
    //   if (frontTyreMake && !frontTyreMake.startsWith("M/")) {
    //     frontTyreMake = `M/s. ${frontTyreMake}`;
    //   }
    let frontTyreMake = makePrefix(frontProps?.Make?.value);

      const frontTacRaw = frontProps?.TAC_Number_Its_Validity?.value || "";
      const frontCopRaw =
        frontProps?.CoP_Cert_No_with_validity_date?.value || "";
      const frontPossibleRaw =
        frontProps?.Possible_date_of_submission_of_required_approval?.value ||
        "";

      // Logic for handling TAC when only CoP is present
      const isTacMissingFront = frontTacRaw.trim() === "";
      const isFrontPossibleRaw = frontPossibleRaw.trim() !== "";

      let finalFrontTac = frontTacRaw;
      if (isTacMissingFront && isFrontPossibleRaw) {
        finalFrontTac = "NA";
      }

      const { cop: frontCop, possible: frontPossibleDate } = TACvalidationcheck(
        frontTacRaw,
        frontCopRaw,
        frontPossibleRaw
      );

      ftyreDataList.MakeList.push(frontTyreMake);
      ftyreDataList.validityList.push(finalFrontTac);
      ftyreDataList.copCertList.push(frontCop);
      ftyreDataList.possibleDateList.push(frontPossibleDate);
      ftyreDataList.vehType.push(frontProps?.tyre_vehicle_type?.value);

      // ---------- REAR TYRE ----------
      const rearProps = vehTyre?.Rear_tyre?.properties || {};
    //   let rearTyreMake = rearProps?.Make?.value || "";
    //   if (rearTyreMake && !rearTyreMake.startsWith("M/")) {
    //     rearTyreMake = `M/s. ${rearTyreMake}`;
    //   }
    let rearTyreMake = makePrefix(rearProps?.Make?.value);

      const rearTacRaw = rearProps?.TAC_Number_Its_Validity?.value || "";
      const rearCopRaw = rearProps?.CoP_Cert_No_with_validity_date?.value || "";
      const rearPossibleRaw =
        rearProps?.Possible_date_of_submission_of_required_approval?.value ||
        "";

      // Logic for handling TAC when only CoP is present
      const isTacMissingRear = rearTacRaw.trim() === "";
      const isrearPossibleRaw = rearPossibleRaw.trim() !== "";

      let finalRearTac = rearTacRaw;
      if (isTacMissingRear && isrearPossibleRaw) {
        finalRearTac = "NA";
      }

      const { cop: rearCop, possible: rearPossibleDate } = TACvalidationcheck(
        rearTacRaw,
        rearCopRaw,
        rearPossibleRaw
      );

      rtyreDataList.MakeList.push(rearTyreMake);
      rtyreDataList.validityList.push(finalRearTac);
      rtyreDataList.copCertList.push(rearCop);
      rtyreDataList.possibleDateList.push(rearPossibleDate);

      // ---------- ANY OTHER TYRE ----------
      const otherProps = vehTyre?.Any_other_Tyre?.properties || {};
    //   let otherTyreMake = otherProps?.Make?.value || "";
    //   if (otherTyreMake && !otherTyreMake.startsWith("M/")) {
    //     otherTyreMake = `M/s. ${otherTyreMake}`;
    //   }
    let otherTyreMake = makePrefix(otherProps?.Make?.value);

      const otherTacRaw = otherProps?.TAC_Number_Its_Validity?.value || "";
      const otherCopRaw =
        otherProps?.CoP_Cert_No_with_validity_date?.value || "";
      const otherPossibleRaw =
        otherProps?.Possible_date_of_submission_of_required_approval?.value ||
        "";

      // Logic for handling TAC when only CoP is present
      const isTacMissingOther = otherTacRaw.trim() === "";
      const isotherPossibleRaw = otherPossibleRaw.trim() !== "";

      let finalOtherTac = otherTacRaw;
      if (isTacMissingOther && isotherPossibleRaw) {
        finalOtherTac = "NA";
      }

      const { cop: otherCop, possible: otherPossibleDate } = TACvalidationcheck(
        otherTacRaw,
        otherCopRaw,
        otherPossibleRaw
      );

      atyreDataList.MakeList.push(otherTyreMake);
      atyreDataList.validityList.push(finalOtherTac);
      atyreDataList.copCertList.push(otherCop);
      atyreDataList.possibleDateList.push(otherPossibleDate);
    }
  });

  // const firstValue = ftyreDataList?.vehType?.[0] || '';
  // if (firstValue === "2-Wheeler") {
  //     twoWheeler = true;
  //     console.log('true');
  // }

  // const headLampList = form8Data?.Head_Lamp?.HeadLamp;
  // let hlMainBeamDataList = mainData();
  // let hlDipBeamDataList = mainData();
  // headLampList.map(vehHeadLamp => {
  //     if (vehHeadLamp.supplier.active === true) {

  //         let supplierName = vehHeadLamp?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // hlMainBeamDataList.suppNameList.push(supplierName);

  //         // // hlMainBeamDataList.suppNameList.push(vehHeadLamp?.supplier?.nameOfSupplier);
  //         hlMainBeamDataList.validityList.push(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Main Beam Head Lamp
  //         const hlMainBeamTACValue = vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to hlMainBeamDataList
  //         hlMainBeamDataList.tacNumberList.push(hlMainBeamTACValue);

  //         // // Check if TAC value is present
  //         // hlMainBeamDataList.suppNameList.push(hlMainBeamTACValue ? supplierName : "");
  //         // If hlMainBeamTACValue is "NA", push an empty string; otherwise, push supplierName
  //         // hlMainBeamDataList.suppNameList.push(hlMainBeamTACValue === "NA" ? "" : supplierName);

  //         // hlMainBeamDataList.suppNameList.push(hlMainBeamTACValue?.trim() === "NA" ? "" : supplierName);
  //         if (hlMainBeamTACValue && hlMainBeamTACValue.trim() !== "NA") {
  //             hlMainBeamDataList.suppNameList.push(supplierName);
  //         }

  //         hlMainBeamDataList.possibleDateList.push(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.Possible_date_of_submission_of_required_approval?.value)
  //         hlMainBeamDataList.copCertList.push(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.CoP_Cert_No_with_validity_date?.value)
  //         // hlMainBeamDataList.tacNumberList.push(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.TAC_Number?.value)
  //         // hlDipBeamDataList.suppNameList.push(vehHeadLamp?.supplier?.nameOfSupplier);
  //         // hlDipBeamDataList.suppNameList.push(supplierName);
  //         hlDipBeamDataList.validityList.push(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Dipped Beam Headlamp
  //         const hlDipBeamTACValue = vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to hlDipBeamDataList
  //         hlDipBeamDataList.tacNumberList.push(hlDipBeamTACValue);

  //         // // Check if TAC value is present
  //         // hlDipBeamDataList.suppNameList.push(hlDipBeamTACValue ? supplierName : "");
  //         // hlDipBeamDataList.suppNameList.push(hlDipBeamTACValue === "NA" ? "" : supplierName);
  //         if (hlDipBeamTACValue && hlDipBeamTACValue.trim() !== "NA") {
  //             hlDipBeamDataList.suppNameList.push(supplierName);
  //         }

  //         hlDipBeamDataList.possibleDateList.push(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value)
  //         hlDipBeamDataList.copCertList.push(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value)
  //         // hlDipBeamDataList.tacNumberList.push(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.TAC_Number?.value)

  //         hlMainBeamDataList.validityLampList.push(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.TAC_Validity?.value)
  //         const hlMainBeamTAcValue = vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to hlMainBeamDataList
  //         hlMainBeamDataList.tacNumberLampList.push(hlMainBeamTAcValue);

  //         // Check if TAC value is present
  //         // hlMainBeamDataList.suppNameLampList.push(hlMainBeamTAcValue ? supplierName : "");
  //         // hlMainBeamDataList.suppNameLampList.push(hlMainBeamTAcValue === "NA" ? "" : supplierName);
  //         if (hlMainBeamTAcValue && hlMainBeamTAcValue.trim() !== "NA") {
  //             hlMainBeamDataList.suppNameLampList.push(supplierName);
  //         }

  //         hlMainBeamDataList.possibleDateLampList.push(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.Possible_date_of_submission_of_required_approval?.value)
  //         hlMainBeamDataList.copCertLampList.push(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.CoP_Cert_No_with_validity_date?.value)
  //         // hlMainBeamDataList.tacNumberLampList.push(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.TAC_Number?.value)

  //         // hlDipBeamDataList.validityLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.TAC_Validity?.value)
  //         const hlDipBeamFilamentTACValue = vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to hlDipBeamDataList
  //         hlDipBeamDataList.tacNumberLampList.push(hlDipBeamFilamentTACValue);

  //         // Check if TAC value is present
  //         // hlDipBeamDataList.suppNameLampList.push(hlDipBeamFilamentTACValue ? supplierName : "");
  //         // hlDipBeamDataList.suppNameLampList.push(hlDipBeamFilamentTACValue === "NA" ? "" : supplierName);
  //         if (hlDipBeamFilamentTACValue && hlDipBeamFilamentTACValue.trim() !== "NA") {
  //             hlDipBeamDataList.suppNameLampList.push(supplierName);
  //         }

  //         hlDipBeamDataList.possibleDateLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.Possible_date_of_submission_of_required_approval?.value)
  //         hlDipBeamDataList.copCertLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.CoP_Cert_No_with_validity_date?.value)
  //         // hlDipBeamDataList.tacNumberLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.TAC_Number?.value)
  //         hlDipBeamDataList.validityLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.TAC_Validity?.value)

  //     }
  // });

  // const headLampList = form8Data?.Head_Lamp?.HeadLamp;
  // let hlMainBeamDataList = mainData();
  // let hlDipBeamDataList = mainData();

  // headLampList.map(vehHeadLamp => {
  //     if (vehHeadLamp.supplier.active === true) {

  //         // Function to add prefix 'M/s.' if missing
  //         const addPrefix = (make) => {
  //             if (make && !make.startsWith("M/")) {
  //                 return `M/s. ${make}`;
  //             }
  //             return make || "";
  //         };

  //         // Main Beam LED Make
  //         let mainBeamMake = addPrefix(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.Main_Beam_Head_Lamp_make?.value);

  //         // Dip Beam LED Make
  //         let dipBeamMake = addPrefix(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.Make?.value);

  //         // Main Beam Filament Make
  //         let mainBeamFilamentMake = addPrefix(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.Make?.value);

  //         // Dip Beam Filament Make
  //         let dipBeamFilamentMake = addPrefix(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.Make?.value);

  //         // Main Beam LED TAC and lists
  //         const hlMainBeamTACValue = vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.TAC_Number?.value;
  //         hlMainBeamDataList.validityList.push(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.TAC_Validity?.value);
  //         hlMainBeamDataList.tacNumberList.push(hlMainBeamTACValue);
  //         if (hlMainBeamTACValue && hlMainBeamTACValue.trim() !== "NA") {
  //             hlMainBeamDataList.suppNameList.push(mainBeamMake);
  //         }
  //         hlMainBeamDataList.possibleDateList.push(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         hlMainBeamDataList.copCertList.push(vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         // Dip Beam LED TAC and lists
  //         const hlDipBeamTACValue = vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.TAC_Number?.value;
  //         hlDipBeamDataList.validityList.push(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.TAC_Validity?.value);
  //         hlDipBeamDataList.tacNumberList.push(hlDipBeamTACValue);
  //         if (hlDipBeamTACValue && hlDipBeamTACValue.trim() !== "NA") {
  //             hlDipBeamDataList.suppNameList.push(dipBeamMake);
  //         }
  //         hlDipBeamDataList.possibleDateList.push(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         hlDipBeamDataList.copCertList.push(vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         hlDipBeamDataList.MakeList.push(dipBeamMake);

  //         // Main Beam Filament TAC and lists
  //         const hlMainBeamTAcValue = vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.TAC_Number?.value;
  //         hlMainBeamDataList.validityLampList.push(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.TAC_Validity?.value);
  //         hlMainBeamDataList.tacNumberLampList.push(hlMainBeamTAcValue);
  //         if (hlMainBeamTAcValue && hlMainBeamTAcValue.trim() !== "NA") {
  //             hlMainBeamDataList.suppNameLampList.push(mainBeamFilamentMake);
  //         }
  //         hlMainBeamDataList.possibleDateLampList.push(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         hlMainBeamDataList.copCertLampList.push(vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         hlMainBeamDataList.MakeLampList.push(mainBeamFilamentMake);

  //         // Dip Beam Filament TAC and lists
  //         const hlDipBeamFilamentTACValue = vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.TAC_Number?.value;
  //         hlDipBeamDataList.validityLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.TAC_Validity?.value);
  //         hlDipBeamDataList.tacNumberLampList.push(hlDipBeamFilamentTACValue);
  //         if (hlDipBeamFilamentTACValue && hlDipBeamFilamentTACValue.trim() !== "NA") {
  //             hlDipBeamDataList.suppNameLampList.push(dipBeamFilamentMake);
  //         }
  //         hlDipBeamDataList.possibleDateLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         hlDipBeamDataList.copCertLampList.push(vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         hlDipBeamDataList.MakeLampList.push(dipBeamFilamentMake);
  //     }
  // });

  //   const headLampList = form8Data?.Head_Lamp?.HeadLamp;
  //   let hlMainBeamDataList = mainData();
  //   let hlDipBeamDataList = mainData();

  //   // Add M/s. if needed
  //   const addPrefix = (make) => {
  //     return make && !make.startsWith("M/") ? `M/s. ${make}` : make || "";
  //   };

  //   headLampList?.map((vehHeadLamp) => {
  //     if (vehHeadLamp?.supplier?.active) {
  //       // --- MAIN BEAM LED ---
  //       const mainLED =
  //         vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties || {};
  //       const mainLEDMk = addPrefix(mainLED?.Main_Beam_Head_Lamp_make?.value);
  //       const mainLEDValidity = mainLED?.TAC_Validity?.value || "";
  //       const mainLEDCop = mainLED?.CoP_Cert_No_with_validity_date?.value || "";
  //       const mainLEDPossible =
  //         mainLED?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const { cop: copMainLED, possible: possibleMainLED } = TACvalidationcheck(
  //         mainLEDValidity,
  //         mainLEDCop,
  //         mainLEDPossible
  //       );

  //       hlMainBeamDataList.MakeList.push(mainLEDMk);
  //       hlMainBeamDataList.validityList.push(mainLEDValidity);
  //       hlMainBeamDataList.tacNumberList.push(mainLED?.TAC_Number?.value || "");
  //       hlMainBeamDataList.suppNameList.push(mainLEDMk);
  //       hlMainBeamDataList.copCertList.push(copMainLED);
  //       hlMainBeamDataList.possibleDateList.push(possibleMainLED);

  //       // --- DIPPED BEAM LED ---
  //       const dipLED =
  //         vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties || {};
  //       const dipLEDMk = addPrefix(dipLED?.Make?.value);
  //       const dipLEDValidity = dipLED?.TAC_Validity?.value || "";
  //       const dipLEDCop = dipLED?.CoP_Cert_No_with_validity_date?.value || "";
  //       const dipLEDPossible =
  //         dipLED?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const { cop: copDipLED, possible: possibleDipLED } = TACvalidationcheck(
  //         dipLEDValidity,
  //         dipLEDCop,
  //         dipLEDPossible
  //       );

  //       hlDipBeamDataList.MakeList.push(dipLEDMk);
  //       hlDipBeamDataList.validityList.push(dipLEDValidity);
  //       hlDipBeamDataList.tacNumberList.push(dipLED?.TAC_Number?.value || "");
  //       hlDipBeamDataList.suppNameList.push(dipLEDMk);
  //       hlDipBeamDataList.copCertList.push(copDipLED);
  //       hlDipBeamDataList.possibleDateList.push(possibleDipLED);

  //       // --- MAIN BEAM FILAMENT ---
  //       const mainFil =
  //         vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties || {};
  //       const mainFilMk = addPrefix(mainFil?.Make?.value);
  //       const mainFilValidity = mainFil?.TAC_Validity?.value || "";
  //       const mainFilCop = mainFil?.CoP_Cert_No_with_validity_date?.value || "";
  //       const mainFilPossible =
  //         mainFil?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const { cop: copMainFil, possible: possibleMainFil } = TACvalidationcheck(
  //         mainFilValidity,
  //         mainFilCop,
  //         mainFilPossible
  //       );

  //       hlMainBeamDataList.MakeLampList.push(mainFilMk);
  //       hlMainBeamDataList.validityLampList.push(mainFilValidity);
  //       hlMainBeamDataList.tacNumberLampList.push(
  //         mainFil?.TAC_Number?.value || ""
  //       );
  //       hlMainBeamDataList.suppNameLampList.push(mainFilMk);
  //       hlMainBeamDataList.copCertLampList.push(copMainFil);
  //       hlMainBeamDataList.possibleDateLampList.push(possibleMainFil);

  //       // --- DIPPED BEAM FILAMENT ---
  //       const dipFil =
  //         vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties || {};
  //       const dipFilMk = addPrefix(dipFil?.Make?.value);
  //       const dipFilValidity = dipFil?.TAC_Validity?.value || "";
  //       const dipFilCop = dipFil?.CoP_Cert_No_with_validity_date?.value || "";
  //       const dipFilPossible =
  //         dipFil?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const { cop: copDipFil, possible: possibleDipFil } = TACvalidationcheck(
  //         dipFilValidity,
  //         dipFilCop,
  //         dipFilPossible
  //       );

  //       hlDipBeamDataList.MakeLampList.push(dipFilMk);
  //       hlDipBeamDataList.validityLampList.push(dipFilValidity);
  //       hlDipBeamDataList.tacNumberLampList.push(dipFil?.TAC_Number?.value || "");
  //       hlDipBeamDataList.suppNameLampList.push(dipFilMk);
  //       hlDipBeamDataList.copCertLampList.push(copDipFil);
  //       hlDipBeamDataList.possibleDateLampList.push(possibleDipFil);
  //     }
  //   });

  const headLampList = form8Data?.Head_Lamp?.HeadLamp;
  let hlMainBeamDataList = mainData();
  let hlDipBeamDataList = mainData();

  // Add M/s. if needed
//   const addPrefix = (make) => {
//     return make && !make.startsWith("M/") ? `M/s. ${make}` : make || "";
//   };

  headLampList?.map((vehHeadLamp) => {
    if (vehHeadLamp?.supplier?.active) {
      // --- MAIN BEAM LED ---
      const mainLED =
        vehHeadLamp?.Main_Beam_Head_Lamp_LED_type?.properties || {};
      const mainLEDMk = makePrefix(mainLED?.Main_Beam_Head_Lamp_make?.value);

      const mainTacRaw = mainLED?.TAC_Validity?.value || "";
      const mainCopRaw = mainLED?.CoP_Cert_No_with_validity_date?.value || "";
      const mainPossibleRaw =
        mainLED?.Possible_date_of_submission_of_required_approval?.value || "";

      // Logic for TAC = "NA" when TAC missing and CoP present
      const isTacMissingMain = mainTacRaw.trim() === "";
      const isPossibleRawPresentMain = mainPossibleRaw.trim() !== "";

      let finalMainTac = mainTacRaw;
      if (isTacMissingMain && isPossibleRawPresentMain) {
        finalMainTac = "NA";
      }
      // --- MAIN BEAM LED ---
      hlMainBeamDataList.MakeList.push(mainLEDMk);
    //   if (finalMainTac !== "NA") {
    //     hlMainBeamDataList.validityList.push(mainTacRaw);
    //   } else {
    //     hlMainBeamDataList.validityList.push("");
    //   }

    if (finalMainTac !== "NA") {
        hlMainBeamDataList.validityList.push(mainTacRaw);
        hlMainBeamDataList.tacNumberList.push(mainLED?.TAC_Number?.value || "");
      } else {
        hlMainBeamDataList.validityList.push("NA");
        hlMainBeamDataList.tacNumberList.push("");
      }

      const { cop: copMainLED, possible: possibleMainLED } = TACvalidationcheck(
        mainTacRaw,
        mainCopRaw,
        mainPossibleRaw
      );

      hlMainBeamDataList.MakeList.push(mainLEDMk);
      // hlMainBeamDataList.validityList.push(finalMainTac);
    //   hlMainBeamDataList.tacNumberList.push(mainLED?.TAC_Number?.value || "");
      hlMainBeamDataList.suppNameList.push(mainLEDMk);
      hlMainBeamDataList.copCertList.push(copMainLED);
      hlMainBeamDataList.possibleDateList.push(possibleMainLED);

      // --- DIPPED BEAM LED ---
      const dipLED =
        vehHeadLamp?.Dipped_Beam_Headlamp_LED_Type?.properties || {};
      const dipLEDMk = makePrefix(dipLED?.Make?.value);

      const dipTacRaw = dipLED?.TAC_Validity?.value || "";
      const dipCopRaw = dipLED?.CoP_Cert_No_with_validity_date?.value || "";
      const dipPossibleRaw =
        dipLED?.Possible_date_of_submission_of_required_approval?.value || "";

      // Logic for TAC = "NA" when TAC missing and CoP present
      const isTacMissingDip = dipTacRaw.trim() === "";
      const isdipPossibleRawPresentDip = dipPossibleRaw.trim() !== "";

      let finalDipTac = dipTacRaw;
      if (isTacMissingDip && isdipPossibleRawPresentDip) {
        finalDipTac = "NA";
      }

      // --- DIPPED BEAM LED ---
      hlDipBeamDataList.MakeList.push(dipLEDMk);
    //   if (finalDipTac !== "NA") {
    //     hlDipBeamDataList.validityList.push(dipTacRaw);
    //   } else {
    //     hlDipBeamDataList.validityList.push("");
    //   }

    if (finalDipTac !== "NA") {
        hlDipBeamDataList.validityList.push(dipTacRaw);
        hlDipBeamDataList.tacNumberList.push(dipLED?.TAC_Number?.value || "");
      } else {
        hlDipBeamDataList.validityList.push("NA");
        hlDipBeamDataList.tacNumberList.push("");
      }
      const { cop: copDipLED, possible: possibleDipLED } = TACvalidationcheck(
        dipTacRaw,
        dipCopRaw,
        dipPossibleRaw
      );

      hlDipBeamDataList.MakeList.push(dipLEDMk);
      // hlDipBeamDataList.validityList.push(finalDipTac);
    //   hlDipBeamDataList.tacNumberList.push(dipLED?.TAC_Number?.value || "");
      hlDipBeamDataList.suppNameList.push(dipLEDMk);
      hlDipBeamDataList.copCertList.push(copDipLED);
      hlDipBeamDataList.possibleDateList.push(possibleDipLED);

      // --- MAIN BEAM FILAMENT ---
      const mainFil =
        vehHeadLamp?.Main_Beam_Headlamp_Filament_Type?.properties || {};
      const mainFilMk = makePrefix(mainFil?.Make?.value);

      const mainFilTacRaw = mainFil?.TAC_Validity?.value || "";
      const mainFilCopRaw =
        mainFil?.CoP_Cert_No_with_validity_date?.value || "";
      const mainFilPossibleRaw =
        mainFil?.Possible_date_of_submission_of_required_approval?.value || "";

      // Logic for TAC = "NA" when TAC missing and CoP present
      const isTacMissingMainFil = mainFilTacRaw.trim() === "";
      const ismainFilPossibleRawMainFil = mainFilPossibleRaw.trim() !== "";

      let finalMainFilTac = mainFilTacRaw;
      if (isTacMissingMainFil && ismainFilPossibleRawMainFil) {
        finalMainFilTac = "NA";
      }

      hlMainBeamDataList.MakeLampList.push(mainFilMk);
    //   if (finalMainFilTac !== "NA") {
    //     hlMainBeamDataList.validityLampList.push(mainFilTacRaw);
    //   } else {
    //     hlMainBeamDataList.validityLampList.push("");
    //   }

    if (finalMainFilTac !== "NA") {
        hlMainBeamDataList.validityLampList.push(mainFilTacRaw);
        hlMainBeamDataList.tacNumberLampList.push(mainFil?.TAC_Number?.value || "");
      } else {
        hlMainBeamDataList.validityLampList.push("NA");
        hlMainBeamDataList.tacNumberLampList.push("");
      }

      const { cop: copMainFil, possible: possibleMainFil } = TACvalidationcheck(
        mainFilTacRaw,
        mainFilCopRaw,
        mainFilPossibleRaw
      );

      hlMainBeamDataList.MakeLampList.push(mainFilMk);
      // hlMainBeamDataList.validityLampList.push(finalMainFilTac);
    //   hlMainBeamDataList.tacNumberLampList.push(
    //     mainFil?.TAC_Number?.value || ""
    //   );
      hlMainBeamDataList.suppNameLampList.push(mainFilMk);
      hlMainBeamDataList.copCertLampList.push(copMainFil);
      hlMainBeamDataList.possibleDateLampList.push(possibleMainFil);

      // --- DIPPED BEAM FILAMENT ---
      const dipFil =
        vehHeadLamp?.Dipped_Beam_Headlamp_Filament_Type?.properties || {};
      const dipFilMk = makePrefix(dipFil?.Make?.value);

      const dipFilTacRaw = dipFil?.TAC_Validity?.value || "";
      const dipFilCopRaw = dipFil?.CoP_Cert_No_with_validity_date?.value || "";
      const dipFilPossibleRaw =
        dipFil?.Possible_date_of_submission_of_required_approval?.value || "";

      // Logic for TAC = "NA" when TAC missing and CoP present
      const isTacMissingDipFil = dipFilTacRaw.trim() === "";
      const isdipFilPossibleRawPresentDipFil = dipFilPossibleRaw.trim() !== "";

      let finalDipFilTac = dipFilTacRaw;
      if (isTacMissingDipFil && isdipFilPossibleRawPresentDipFil) {
        finalDipFilTac = "NA";
      }

      hlDipBeamDataList.MakeLampList.push(dipFilMk);
    //   if (finalDipFilTac !== "NA") {
    //     hlDipBeamDataList.validityLampList.push(dipFilTacRaw);
    //   } else {
    //     hlDipBeamDataList.validityLampList.push("");
    //   }

    if (finalDipFilTac !== "NA") {
        hlDipBeamDataList.validityLampList.push(dipFilTacRaw);
        hlDipBeamDataList.tacNumberLampList.push(dipFil?.TAC_Number?.value || "");
      } else {
        hlDipBeamDataList.validityLampList.push("NA");
        hlDipBeamDataList.tacNumberLampList.push("");
      }

      const { cop: copDipFil, possible: possibleDipFil } = TACvalidationcheck(
        dipFilTacRaw,
        dipFilCopRaw,
        dipFilPossibleRaw
      );

      hlDipBeamDataList.MakeLampList.push(dipFilMk);
      // hlDipBeamDataList.validityLampList.push(finalDipFilTac);
    //   hlDipBeamDataList.tacNumberLampList.push(dipFil?.TAC_Number?.value || "");
      hlDipBeamDataList.suppNameLampList.push(dipFilMk);
      hlDipBeamDataList.copCertLampList.push(copDipFil);
      hlDipBeamDataList.possibleDateLampList.push(possibleDipFil);
    }
  });

  // Main Beam LED
  console.log("Main Beam LED - suppNameList:", hlMainBeamDataList.suppNameList);
  console.log(
    "Main Beam LED - tacNumberList:",
    hlMainBeamDataList.tacNumberList
  );
  console.log("Main Beam LED - validityList:", hlMainBeamDataList.validityList);
  console.log(
    "Main Beam LED - possibleDateList:",
    hlMainBeamDataList.possibleDateList
  );
  console.log("Main Beam LED - copCertList:", hlMainBeamDataList.copCertList);

  // Dip Beam LED
  console.log("Dip Beam LED - suppNameList:", hlDipBeamDataList.suppNameList);
  console.log("Dip Beam LED - tacNumberList:", hlDipBeamDataList.tacNumberList);
  console.log("Dip Beam LED - validityList:", hlDipBeamDataList.validityList);
  console.log(
    "Dip Beam LED - possibleDateList:",
    hlDipBeamDataList.possibleDateList
  );
  console.log("Dip Beam LED - copCertList:", hlDipBeamDataList.copCertList);

  // Main Beam Filament
  console.log(
    "Main Beam Filament - suppNameLampList:",
    hlMainBeamDataList.suppNameLampList
  );
  console.log(
    "Main Beam Filament - tacNumberLampList:",
    hlMainBeamDataList.tacNumberLampList
  );
  console.log(
    "Main Beam Filament - validityLampList:",
    hlMainBeamDataList.validityLampList
  );
  console.log(
    "Main Beam Filament - possibleDateLampList:",
    hlMainBeamDataList.possibleDateLampList
  );
  console.log(
    "Main Beam Filament - copCertLampList:",
    hlMainBeamDataList.copCertLampList
  );

  // Dip Beam Filament
  console.log(
    "Dip Beam Filament - suppNameLampList:",
    hlDipBeamDataList.suppNameLampList
  );
  console.log(
    "Dip Beam Filament - tacNumberLampList:",
    hlDipBeamDataList.tacNumberLampList
  );
  console.log(
    "Dip Beam Filament - validityLampList:",
    hlDipBeamDataList.validityLampList
  );
  console.log(
    "Dip Beam Filament - possibleDateLampList:",
    hlDipBeamDataList.possibleDateLampList
  );
  console.log(
    "Dip Beam Filament - copCertLampList:",
    hlDipBeamDataList.copCertLampList
  );

  // const dtRunnLampList = form8Data?.Daytime_Running_Lamp?.DaytimeRunningLamp;
  // let dtRunnLampDataList = mainData();
  // dtRunnLampList.map(vehRunnLamp => {
  //     if (vehRunnLamp.supplier.active === true) {

  //         let supplierName = vehRunnLamp?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // dtRunnLampDataList.suppNameList.push(supplierName);
  //         // // dtRunnLampDataList.suppNameList.push(vehRunnLamp?.supplier?.nameOfSupplier);
  //         // dtRunnLampDataList.validityList.push(vehRunnLamp?.Daytime_Running_Lamp?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Daytime Running Lamp
  //         const dtRunnLampTACValue = vehRunnLamp?.Daytime_Running_Lamp?.properties?.CoP_Cert_No_with_validity_date?.value;

  //         // Push the TAC value to dtRunnLampDataList
  //         dtRunnLampDataList.copCertList.push(dtRunnLampTACValue);

  //         // Check if TAC value is present
  //         // dtRunnLampDataList.suppNameList.push(dtRunnLampTACValue ? supplierName : "");
  //         // dtRunnLampDataList.suppNameList.push(dtRunnLampTACValue === "NA" ? "" : supplierName);
  //         if (dtRunnLampTACValue && dtRunnLampTACValue.trim() !== "NA") {
  //             dtRunnLampDataList.suppNameList.push(supplierName);
  //         }
  //         dtRunnLampDataList.MakeList.push(vehRunnLamp?.Daytime_Running_Lamp.properties?.Make?.value);
  //         dtRunnLampDataList.possibleDateList.push(vehRunnLamp?.Daytime_Running_Lamp.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         dtRunnLampDataList.validityList.push(vehRunnLamp?.Daytime_Running_Lamp?.properties?.TAC_Validity?.value);
  //         // dtRunnLampDataList.copCertList.push(vehRunnLamp?.Daytime_Running_Lamp?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const dtRunnLampList = form8Data?.Daytime_Running_Lamp?.DaytimeRunningLamp;
  // let dtRunnLampDataList = mainData();

  // dtRunnLampList.map(vehRunnLamp => {
  //     if (vehRunnLamp.supplier.active === true) {

  //         // Get Make from properties
  //         let make = vehRunnLamp?.Daytime_Running_Lamp?.properties?.Make?.value || "";

  //         // Add 'M/s.' prefix if missing
  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         // Get the TAC Validity value
  //         const dtRunnLampTACValue = vehRunnLamp?.Daytime_Running_Lamp?.properties?.CoP_Cert_No_with_validity_date?.value;

  //         // Push TAC value
  //         dtRunnLampDataList.copCertList.push(dtRunnLampTACValue);

  //         // Push make instead of supplierName if TAC value present and not "NA"
  //         if (dtRunnLampTACValue && dtRunnLampTACValue.trim() !== "NA") {
  //             dtRunnLampDataList.suppNameList.push(make);
  //         }

  //         dtRunnLampDataList.MakeList.push(make);
  //         dtRunnLampDataList.possibleDateList.push(vehRunnLamp?.Daytime_Running_Lamp?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         dtRunnLampDataList.validityList.push(vehRunnLamp?.Daytime_Running_Lamp?.properties?.TAC_Validity?.value);
  //     }
  // });

  // const dtRunnLampList = form8Data?.Daytime_Running_Lamp?.DaytimeRunningLamp || [];
  // let dtRunnLampDataList = mainData();

  // dtRunnLampList.map(vehRunnLamp => {
  //     if (vehRunnLamp?.supplier?.active === true) {
  //         const props = vehRunnLamp?.Daytime_Running_Lamp?.properties || {};
  //         let make = props?.Make?.value || "";

  //         // Add 'M/s.' prefix if missing
  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         const validityStr = props?.TAC_Validity?.value || "";
  //         const validityResult = parseAndCheckTACValidity(validityStr);

  //         const copValue = props?.CoP_Cert_No_with_validity_date?.value || "NA";
  //         const possibleDateValue = props?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //         // Always push make & validity
  //         dtRunnLampDataList.MakeList.push(make);
  //         dtRunnLampDataList.validityList.push(validityStr);
  //         dtRunnLampDataList.suppNameList.push(make);

  //         // Push CoP and possible date as per expiry logic
  //         if (!validityResult.hasDate || validityResult.expired) {
  //             dtRunnLampDataList.copCertList.push(copValue);
  //             dtRunnLampDataList.possibleDateList.push(possibleDateValue);
  //         } else {
  //             dtRunnLampDataList.copCertList.push("NA");
  //             dtRunnLampDataList.possibleDateList.push("NA");
  //         }
  //     }
  // });

  //   const dtRunnLampList =
  //     form8Data?.Daytime_Running_Lamp?.DaytimeRunningLamp || [];
  //   let dtRunnLampDataList = mainData();

  //   dtRunnLampList.map((vehRunnLamp) => {
  //     if (vehRunnLamp?.supplier?.active === true) {
  //       let make =
  //         vehRunnLamp?.Daytime_Running_Lamp?.properties?.Make?.value || "";
  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       const tacValueRaw =
  //         vehRunnLamp?.Daytime_Running_Lamp?.properties?.TAC_Validity?.value ||
  //         "";
  //       const copCertRaw =
  //         vehRunnLamp?.Daytime_Running_Lamp?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw =
  //         vehRunnLamp?.Daytime_Running_Lamp?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";

  //       dtRunnLampDataList.validityList.push(tacValueRaw);
  //       dtRunnLampDataList.MakeList.push(make);
  //       dtRunnLampDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(
  //         tacValueRaw,
  //         copCertRaw,
  //         possibleDateRaw
  //       );
  //       dtRunnLampDataList.copCertList.push(cop);
  //       dtRunnLampDataList.possibleDateList.push(possible);
  //     }
  //   });

  const dtRunnLampList =
    form8Data?.Daytime_Running_Lamp?.DaytimeRunningLamp || [];
  let dtRunnLampDataList = mainData();

  dtRunnLampList.map((vehRunnLamp) => {
    if (vehRunnLamp?.supplier?.active === true) {
    //   let make =
    //     vehRunnLamp?.Daytime_Running_Lamp?.properties?.Make?.value || "";
    //   if (make && !make.startsWith("M/")) {
    //     make = `M/s. ${make}`;
    //   }
    let make = makePrefix(vehRunnLamp?.Daytime_Running_Lamp?.properties?.Make?.value);

      const tacValueRaw =
        vehRunnLamp?.Daytime_Running_Lamp?.properties?.TAC_Validity?.value ||
        "";
      const copCertRaw =
        vehRunnLamp?.Daytime_Running_Lamp?.properties
          ?.CoP_Cert_No_with_validity_date?.value || "";
      const possibleDateRaw =
        vehRunnLamp?.Daytime_Running_Lamp?.properties
          ?.Possible_date_of_submission_of_required_approval?.value || "";

      // Logic for TAC = "NA" when TAC missing and CoP present
      const isTacMissing = tacValueRaw.trim() === "";
      const isPossibleDatePresent = possibleDateRaw.trim() !== "";
      let finalTAC = tacValueRaw;
      if (isTacMissing && isPossibleDatePresent) {
        finalTAC = "NA";
      }

      dtRunnLampDataList.validityList.push(finalTAC);
      dtRunnLampDataList.MakeList.push(make);
      dtRunnLampDataList.suppNameList.push(make);

      const { cop, possible } = TACvalidationcheck(
        tacValueRaw,
        copCertRaw,
        possibleDateRaw
      );
      dtRunnLampDataList.copCertList.push(cop);
      dtRunnLampDataList.possibleDateList.push(possible);
    }
  });

  console.log("Current suppNameList:", dtRunnLampDataList.suppNameList);
  console.log("Current MakeList:", dtRunnLampDataList.MakeList);
  console.log("Possible Date List:", dtRunnLampDataList.possibleDateList);
  console.log("cop List:", dtRunnLampDataList.copCertList);
  console.log("Validity List:", dtRunnLampDataList.validityList);

  // const posLampsList = form8Data.Position_Lamps.PositionLamps;
  // let frontPosLampDataList = mainData();
  // let rearPosLampDataList = mainData();
  // let stopLampDataList = mainData();
  // posLampsList.map(vehPosLamp => {
  //     if (vehPosLamp.supplier.active === true) {
  //         let supplierName = vehPosLamp?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // frontPosLampDataList.suppNameList.push(supplierName);
  //         // frontPosLampDataList.suppNameList.push(vehPosLamp?.supplier.nameOfSupplier);
  //         // frontPosLampDataList.validityList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Validity?.value);
  //         // Get the validity value (TAC_Validity)
  //         const validityValue = vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Number?.value;

  //         // Push the validity value to validityList
  //         frontPosLampDataList.tacNumberList.push(validityValue);

  //         // Check if validity data is present
  //         // if (validityValue) {
  //         //     // If data is present, add supplier name
  //         //     frontPosLampDataList.suppNameList.push(supplierName);
  //         // } else {
  //         //     // If no data is present, add a blank space
  //         //     frontPosLampDataList.suppNameList.push("");
  //         // }
  //         // frontPosLampDataList.suppNameList.push(validityValue === "NA" ? "" : supplierName);
  //         if (validityValue && validityValue.trim() !== "NA") {
  //             frontPosLampDataList.suppNameList.push(supplierName);
  //         }
  //         frontPosLampDataList.MakeList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.Make?.value);

  //         frontPosLampDataList.possibleDateList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         frontPosLampDataList.copCertList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         frontPosLampDataList.validityList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Validity?.value);
  //         // frontPosLampDataList.tacNumberList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Number?.value);
  //         // rearPosLampDataList.suppNameList.push(vehPosLamp?.supplier?.nameOfSupplier);

  //         // rearPosLampDataList.suppNameList.push(supplierName);
  //         // rearPosLampDataList.validityList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Validity?.value);
  //         // Get the validity value for Parking_Lamp_Bulb_Rear (TAC_Validity)
  //         const rearValidityValue = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Number?.value;

  //         // Push the validity value to validityList for rearPosLampDataList
  //         rearPosLampDataList.tacNumberLampList.push(rearValidityValue);

  //         // // Check if validity data is present
  //         // if (rearValidityValue) {
  //         //     // If data is present, add supplier name
  //         //     rearPosLampDataList.suppNameList.push(supplierName);
  //         // } else {
  //         //     // If no data is present, add a blank space
  //         //     rearPosLampDataList.suppNameList.push("");
  //         // }
  //         // rearPosLampDataList.suppNameList.push(rearValidityValue === "NA" ? "" : supplierName);
  //         if (rearValidityValue && rearValidityValue.trim() !== "NA") {
  //             rearPosLampDataList.suppNameLampList.push(supplierName);
  //         }

  //         rearPosLampDataList.MakeList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.Make?.value);

  //         rearPosLampDataList.possibleDateLampList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rearPosLampDataList.copCertLampList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         rearPosLampDataList.validityLampList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Validity?.value);

  //         // rearPosLampDataList.tacNumberList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Number?.value);

  //         const rearValidityValueled = vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Number?.value;

  //         // Push the validity value to validityList for rearPosLampDataList
  //         rearPosLampDataList.tacNumberList.push(rearValidityValueled);

  //         if (rearValidityValueled && rearValidityValueled.trim() !== "NA") {
  //             rearPosLampDataList.suppNameList.push(supplierName);
  //         }

  //         rearPosLampDataList.MakeList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.Make_of_Parking_lamp_led_rear?.value);

  //         rearPosLampDataList.possibleDateList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rearPosLampDataList.copCertList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         rearPosLampDataList.validityList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Validity?.value);

  //         // stopLampDataList.suppNameList.push(vehPosLamp?.supplier?.nameOfSupplier);

  //         // stopLampDataList.suppNameList.push(supplierName);
  //         // stopLampDataList.validityList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Validity?.value);

  //         // Get the validity value for Stop Lamp
  //         const stopValidityValue = vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Number?.value;

  //         // Push the validity value to stopLampDataList and add the supplier name (or blank space)
  //         stopLampDataList.tacNumberList.push(stopValidityValue);
  //         // stopLampDataList.suppNameList.push(stopValidityValue ? supplierName : "");
  //         // stopLampDataList.suppNameList.push(stopValidityValue === "NA" ? "" : supplierName);
  //         if (stopValidityValue && stopValidityValue.trim() !== "NA") {
  //             stopLampDataList.suppNameList.push(supplierName);
  //         }

  //         stopLampDataList.MakeList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.Make?.value);

  //         stopLampDataList.possibleDateList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         stopLampDataList.copCertList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         stopLampDataList.validityList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Validity?.value);
  //         // stopLampDataList.tacNumberList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Number?.value);
  //         // stopLampDataList.suppNameLampList.push(supplierName);
  //         // stopLampDataList.validityLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Stop Lamp
  //         const stopLampTACValue = vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to stopLampDataList
  //         stopLampDataList.tacNumberLampList.push(stopLampTACValue);

  //         // Check if TAC value is present
  //         // stopLampDataList.suppNameLampList.push(stopLampTACValue ? supplierName : "");
  //         // stopLampDataList.suppNameLampList.push(stopLampTACValue === "NA" ? "" : supplierName);
  //         if (stopLampTACValue && stopLampTACValue.trim() !== "NA") {
  //             stopLampDataList.suppNameLampList.push(supplierName);
  //         }

  //         stopLampDataList.MakeList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.Make?.value);

  //         stopLampDataList.possibleDateLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         stopLampDataList.copCertLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         stopLampDataList.validityLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Validity?.value);
  //         // stopLampDataList.tacNumberLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Number?.value);

  //         // frontPosLampDataList.validityLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Front Position Lamp
  //         const frontPosLampTACValue = vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to frontPosLampDataList
  //         frontPosLampDataList.tacNumberLampList.push(frontPosLampTACValue);

  //         // Check if TAC value is present
  //         // frontPosLampDataList.suppNameLampList.push(frontPosLampTACValue ? supplierName : "");
  //         // frontPosLampDataList.suppNameLampList.push(frontPosLampTACValue === "NA" ? "" : supplierName);
  //         if (frontPosLampTACValue && frontPosLampTACValue.trim() !== "NA") {
  //             frontPosLampDataList.suppNameLampList.push(supplierName);
  //         }

  //         frontPosLampDataList.MakeList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.Make?.value);

  //         frontPosLampDataList.possibleDateLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         frontPosLampDataList.copCertLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         frontPosLampDataList.validityLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Validity?.value);
  //         // frontPosLampDataList.tacNumberLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Number?.value);

  //     }
  // });

  // const posLampsList = form8Data.Position_Lamps.PositionLamps;
  // let frontPosLampDataList = mainData();
  // let rearPosLampDataList = mainData();
  // let stopLampDataList = mainData();
  // const prefixMake = (make) => {
  //     if (make && !make.startsWith("M/s.")) {
  //         return `M/s. ${make}`;
  //     }
  //     return make || "";
  // };

  // posLampsList.map(vehPosLamp => {
  //     if (vehPosLamp.supplier.active === true) {
  //         // Get Make values for the different lamps with prefix applied
  //         const frontMake = prefixMake(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.Make?.value);
  //         const rearMake = prefixMake(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.Make?.value);
  //         const rearLedMake = prefixMake(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.Make_of_Parking_lamp_led_rear?.value);
  //         const stopMake = prefixMake(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.Make?.value);
  //         const stopFilamentMake = prefixMake(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.Make?.value);
  //         const frontBulbMake = prefixMake(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.Make?.value);

  //         // Front Position Lamp LED Type
  //         const validityValue = vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Number?.value;
  //         frontPosLampDataList.tacNumberList.push(validityValue);
  //         if (validityValue && validityValue.trim() !== "NA") {
  //             frontPosLampDataList.suppNameList.push(frontMake);
  //         }
  //         frontPosLampDataList.MakeList.push(frontMake);
  //         frontPosLampDataList.possibleDateList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         frontPosLampDataList.copCertList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         frontPosLampDataList.validityList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Validity?.value);

  //         // Rear Position Lamp Bulb Rear
  //         const rearValidityValue = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Number?.value;
  //         rearPosLampDataList.tacNumberLampList.push(rearValidityValue);
  //         if (rearValidityValue && rearValidityValue.trim() !== "NA") {
  //             rearPosLampDataList.suppNameLampList.push(rearMake);
  //         }
  //         rearPosLampDataList.MakeList.push(rearMake);
  //         rearPosLampDataList.possibleDateLampList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rearPosLampDataList.copCertLampList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         rearPosLampDataList.validityLampList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Validity?.value);

  //         // Rear Position Lamp LED Rear
  //         const rearValidityValueled = vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Number?.value;
  //         rearPosLampDataList.tacNumberList.push(rearValidityValueled);
  //         if (rearValidityValueled && rearValidityValueled.trim() !== "NA") {
  //             rearPosLampDataList.suppNameList.push(rearLedMake);
  //         }
  //         rearPosLampDataList.MakeList.push(rearLedMake);
  //         rearPosLampDataList.possibleDateList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rearPosLampDataList.copCertList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         rearPosLampDataList.validityList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Validity?.value);

  //         // Stop Lamp LED Type
  //         const stopValidityValue = vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Number?.value;
  //         stopLampDataList.tacNumberList.push(stopValidityValue);
  //         if (stopValidityValue && stopValidityValue.trim() !== "NA") {
  //             stopLampDataList.suppNameList.push(stopMake);
  //         }
  //         stopLampDataList.MakeList.push(stopMake);
  //         stopLampDataList.possibleDateList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         stopLampDataList.copCertList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         stopLampDataList.validityList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Validity?.value);

  //         // Stop Lamp Bulb Filament Type
  //         const stopLampTACValue = vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Number?.value;
  //         stopLampDataList.tacNumberLampList.push(stopLampTACValue);
  //         if (stopLampTACValue && stopLampTACValue.trim() !== "NA") {
  //             stopLampDataList.suppNameLampList.push(stopFilamentMake);
  //         }
  //         stopLampDataList.MakeList.push(stopFilamentMake);
  //         stopLampDataList.possibleDateLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         stopLampDataList.copCertLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         stopLampDataList.validityLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Validity?.value);

  //         // Front Position Lamp Bulb Type
  //         const frontPosLampTACValue = vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Number?.value;
  //         frontPosLampDataList.tacNumberLampList.push(frontPosLampTACValue);
  //         if (frontPosLampTACValue && frontPosLampTACValue.trim() !== "NA") {
  //             frontPosLampDataList.suppNameLampList.push(frontBulbMake);
  //         }
  //         frontPosLampDataList.MakeList.push(frontBulbMake);
  //         frontPosLampDataList.possibleDateLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         frontPosLampDataList.copCertLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         frontPosLampDataList.validityLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Validity?.value);
  //     }
  // });

  // const posLampsList = form8Data.Position_Lamps.PositionLamps;
  // let frontPosLampDataList = mainData();
  // let rearPosLampDataList = mainData();
  // let stopLampDataList = mainData();

  // const prefixMake = (make) => {
  //     if (make && !make.startsWith("M/s.")) {
  //         return `M/s. ${make}`;
  //     }
  //     return make || "";
  // };

  // posLampsList.map(vehPosLamp => {
  //     if (vehPosLamp.supplier.active === true) {
  //         // Get Make values for the different lamps with prefix applied
  //         const frontMake = prefixMake(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.Make?.value);
  //         const rearMake = prefixMake(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.Make?.value);
  //         const rearLedMake = prefixMake(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.Make_of_Parking_lamp_led_rear?.value);
  //         const stopMake = prefixMake(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.Make?.value);
  //         const stopFilamentMake = prefixMake(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.Make?.value);
  //         const frontBulbMake = prefixMake(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.Make?.value);

  //         // Front Position Lamp LED Type
  //         const validityCheckFront = parseAndCheckTACValidity(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Validity?.value);
  //         const validityValueFront = vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Number?.value;
  //         frontPosLampDataList.tacNumberList.push(validityValueFront);
  //         if (validityValueFront && validityValueFront.trim() !== "NA") {
  //             frontPosLampDataList.suppNameList.push(frontMake);
  //         }
  //         frontPosLampDataList.MakeList.push(frontMake);
  //         frontPosLampDataList.possibleDateList.push(
  //             !validityCheckFront.expired
  //                 ? vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         frontPosLampDataList.copCertList.push(
  //             !validityCheckFront.expired
  //                 ? vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );
  //         frontPosLampDataList.validityList.push(vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Validity?.value);

  //         // Rear Position Lamp Bulb Rear
  //         const validityCheckRearBulb = parseAndCheckTACValidity(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Validity?.value);
  //         const validityValueRearBulb = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Number?.value;
  //         rearPosLampDataList.tacNumberLampList.push(validityValueRearBulb);
  //         if (validityValueRearBulb && validityValueRearBulb.trim() !== "NA") {
  //             rearPosLampDataList.suppNameLampList.push(rearMake);
  //         }
  //         rearPosLampDataList.MakeList.push(rearMake);
  //         rearPosLampDataList.possibleDateLampList.push(
  //             !validityCheckRearBulb.expired
  //                 ? vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         rearPosLampDataList.copCertLampList.push(
  //             !validityCheckRearBulb.expired
  //                 ? vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );
  //         rearPosLampDataList.validityLampList.push(vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Validity?.value);

  //         // Rear Position Lamp LED Rear
  //         const validityCheckRearLed = parseAndCheckTACValidity(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Validity?.value);
  //         const validityValueRearLed = vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Number?.value;
  //         rearPosLampDataList.tacNumberList.push(validityValueRearLed);
  //         if (validityValueRearLed && validityValueRearLed.trim() !== "NA") {
  //             rearPosLampDataList.suppNameList.push(rearLedMake);
  //         }
  //         rearPosLampDataList.MakeList.push(rearLedMake);
  //         rearPosLampDataList.possibleDateList.push(
  //             !validityCheckRearLed.expired
  //                 ? vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         rearPosLampDataList.copCertList.push(
  //             !validityCheckRearLed.expired
  //                 ? vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );
  //         rearPosLampDataList.validityList.push(vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Validity?.value);

  //         // Stop Lamp LED Type
  //         const validityCheckStopLed = parseAndCheckTACValidity(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Validity?.value);
  //         const validityValueStopLed = vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Number?.value;
  //         stopLampDataList.tacNumberList.push(validityValueStopLed);
  //         if (validityValueStopLed && validityValueStopLed.trim() !== "NA") {
  //             stopLampDataList.suppNameList.push(stopMake);
  //         }
  //         stopLampDataList.MakeList.push(stopMake);
  //         stopLampDataList.possibleDateList.push(
  //             !validityCheckStopLed.expired
  //                 ? vehPosLamp?.Stop_Lamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         stopLampDataList.copCertList.push(
  //             !validityCheckStopLed.expired
  //                 ? vehPosLamp?.Stop_Lamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );
  //         stopLampDataList.validityList.push(vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Validity?.value);

  //         // Stop Lamp Bulb Filament Type
  //         const validityCheckStopFilament = parseAndCheckTACValidity(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Validity?.value);
  //         const validityValueStopFilament = vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Number?.value;
  //         stopLampDataList.tacNumberLampList.push(validityValueStopFilament);
  //         if (validityValueStopFilament && validityValueStopFilament.trim() !== "NA") {
  //             stopLampDataList.suppNameLampList.push(stopFilamentMake);
  //         }
  //         stopLampDataList.MakeList.push(stopFilamentMake);
  //         stopLampDataList.possibleDateLampList.push(
  //             !validityCheckStopFilament.expired
  //                 ? vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         stopLampDataList.copCertLampList.push(
  //             !validityCheckStopFilament.expired
  //                 ? vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );
  //         stopLampDataList.validityLampList.push(vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Validity?.value);

  //         // Front Position Lamp Bulb Type
  //         const validityCheckFrontBulb = parseAndCheckTACValidity(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Validity?.value);
  //         const validityValueFrontBulb = vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Number?.value;
  //         frontPosLampDataList.tacNumberLampList.push(validityValueFrontBulb);
  //         if (validityValueFrontBulb && validityValueFrontBulb.trim() !== "NA") {
  //             frontPosLampDataList.suppNameLampList.push(frontBulbMake);
  //         }
  //         frontPosLampDataList.MakeList.push(frontBulbMake);
  //         frontPosLampDataList.possibleDateLampList.push(
  //             !validityCheckFrontBulb.expired
  //                 ? vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         frontPosLampDataList.copCertLampList.push(
  //             !validityCheckFrontBulb.expired
  //                 ? vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );
  //         frontPosLampDataList.validityLampList.push(vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Validity?.value);
  //     }
  // });

  //   const posLampsList = form8Data?.Position_Lamps?.PositionLamps || [];
  //   let frontPosLampDataList = mainData();
  //   let rearPosLampDataList = mainData();
  //   let stopLampDataList = mainData();

  //   const prefixMake = (make) => {
  //     if (make && !make.startsWith("M/s.")) {
  //       return `M/s. ${make}`;
  //     }
  //     return make || "";
  //   };

  //   posLampsList.map((vehPosLamp) => {
  //     if (vehPosLamp?.supplier?.active !== true) return;

  //     // === FRONT LED ===
  //     {
  //       const tacVal =
  //         vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Validity
  //           ?.value || "";
  //       const tacNum =
  //         vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.TAC_Number
  //           ?.value || "";
  //       const cop =
  //         vehPosLamp?.Front_Position_Lamp_LED_Type?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const poss =
  //         vehPosLamp?.Front_Position_Lamp_LED_Type?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const make = prefixMake(
  //         vehPosLamp?.Front_Position_Lamp_LED_Type?.properties?.Make?.value
  //       );
  //       frontPosLampDataList.MakeList.push(make);
  //       frontPosLampDataList.suppNameList.push(make);
  //       if (tacVal && tacVal.trim() !== "NA" && tacNum) {
  //         frontPosLampDataList.validityList.push(tacVal);

  //         frontPosLampDataList.tacNumberList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         frontPosLampDataList.copCertList.push(c);
  //         frontPosLampDataList.possibleDateList.push(p);
  //       }
  //     }

  //     // === FRONT BULB ===
  //     {
  //       const tacVal =
  //         vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Validity
  //           ?.value || "";
  //       const tacNum =
  //         vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.TAC_Number
  //           ?.value || "";
  //       const cop =
  //         vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const poss =
  //         vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const make = prefixMake(
  //         vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties?.Make?.value
  //       );
  //       frontPosLampDataList.MakeList.push(make);
  //       frontPosLampDataList.suppNameLampList.push(make);
  //       if (tacVal && tacVal.trim() !== "NA" && tacNum) {
  //         frontPosLampDataList.validityLampList.push(tacVal);

  //         frontPosLampDataList.tacNumberLampList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         frontPosLampDataList.copCertLampList.push(c);
  //         frontPosLampDataList.possibleDateLampList.push(p);
  //       }
  //     }

  //     // === REAR BULB ===
  //     {
  //       const tacVal =
  //         vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Validity?.value ||
  //         "";
  //       const tacNum =
  //         vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.TAC_Number?.value || "";
  //       const cop =
  //         vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const poss =
  //         vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const make = prefixMake(
  //         vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties?.Make?.value
  //       );
  //       rearPosLampDataList.MakeList.push(make);
  //       rearPosLampDataList.suppNameLampList.push(make);
  //       if (tacVal && tacVal.trim() !== "NA" && tacNum) {
  //         rearPosLampDataList.validityLampList.push(tacVal);

  //         rearPosLampDataList.tacNumberLampList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         rearPosLampDataList.copCertLampList.push(c);
  //         rearPosLampDataList.possibleDateLampList.push(p);
  //       }
  //     }

  //     // === REAR LED ===
  //     {
  //       const tacVal =
  //         vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Validity?.value ||
  //         "";
  //       const tacNum =
  //         vehPosLamp?.Parking_Lamp_Led_Rear?.properties?.TAC_Number?.value || "";
  //       const cop =
  //         vehPosLamp?.Parking_Lamp_Led_Rear?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const poss =
  //         vehPosLamp?.Parking_Lamp_Led_Rear?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const make = prefixMake(
  //         vehPosLamp?.Parking_Lamp_Led_Rear?.properties
  //           ?.Make_of_Parking_lamp_led_rear?.value
  //       );
  //       rearPosLampDataList.MakeList.push(make);
  //       rearPosLampDataList.suppNameList.push(make);
  //       if (tacVal && tacVal.trim() !== "NA" && tacNum) {
  //         rearPosLampDataList.validityList.push(tacVal);

  //         rearPosLampDataList.tacNumberList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         rearPosLampDataList.copCertList.push(c);
  //         rearPosLampDataList.possibleDateList.push(p);
  //       }
  //     }

  //     // === STOP LED ===
  //     {
  //       const tacVal =
  //         vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Validity?.value || "";
  //       const tacNum =
  //         vehPosLamp?.Stop_Lamp_LED_Type?.properties?.TAC_Number?.value || "";
  //       const cop =
  //         vehPosLamp?.Stop_Lamp_LED_Type?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const poss =
  //         vehPosLamp?.Stop_Lamp_LED_Type?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const make = prefixMake(
  //         vehPosLamp?.Stop_Lamp_LED_Type?.properties?.Make?.value
  //       );
  //       stopLampDataList.MakeList.push(make);
  //       stopLampDataList.suppNameList.push(make);
  //       if (tacVal && tacVal.trim() !== "NA" && tacNum) {
  //         stopLampDataList.validityList.push(tacVal);

  //         stopLampDataList.tacNumberList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         stopLampDataList.copCertList.push(c);
  //         stopLampDataList.possibleDateList.push(p);
  //       }
  //     }

  //     // === STOP BULB ===
  //     {
  //       const tacVal =
  //         vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Validity
  //           ?.value || "";
  //       const tacNum =
  //         vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.TAC_Number
  //           ?.value || "";
  //       const cop =
  //         vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const poss =
  //         vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";
  //       const make = prefixMake(
  //         vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties?.Make?.value
  //       );
  //       stopLampDataList.MakeList.push(make);
  //       stopLampDataList.suppNameLampList.push(make);
  //       if (tacVal && tacVal.trim() !== "NA" && tacNum) {
  //         stopLampDataList.validityLampList.push(tacVal);

  //         stopLampDataList.tacNumberLampList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         stopLampDataList.copCertLampList.push(c);
  //         stopLampDataList.possibleDateLampList.push(p);
  //       }
  //     }
  //   });

  // const posLampsList = form8Data?.Position_Lamps?.PositionLamps || [];

  // let frontPosLampDataList = mainData();
  // let rearPosLampDataList = mainData();
  // let stopLampDataList = mainData();

  // posLampsList.forEach((vehPosLamp) => {
  //   if (vehPosLamp?.supplier?.active !== true) return;

  //   // FRONT POSITION LAMP LED
  //   {
  //     const props = vehPosLamp?.Front_Position_Lamp_LED_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";

  //     frontPosLampDataList.validityList.push(props?.TAC_Validity?.value || "");
  //     frontPosLampDataList.MakeList.push(make);
  //     frontPosLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     frontPosLampDataList.tacNumberList.push(tac);
  //     frontPosLampDataList.copCertList.push(copFinal);
  //     frontPosLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // FRONT POSITION LAMP BULB
  //   {
  //     const props = vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";

  //     frontPosLampDataList.validityLampList.push(props?.TAC_Validity?.value || "");
  //     frontPosLampDataList.MakeList.push(make);
  //     frontPosLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     frontPosLampDataList.tacNumberLampList.push(tac);
  //     frontPosLampDataList.copCertLampList.push(copFinal);
  //     frontPosLampDataList.possibleDateLampList.push(possibleFinal);
  //   }

  //   // REAR PARKING LAMP LED
  //   {
  //     const props = vehPosLamp?.Parking_Lamp_Led_Rear?.properties || {};
  //     let make = props?.Make_of_Parking_lamp_led_rear?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";

  //     rearPosLampDataList.validityList.push(props?.TAC_Validity?.value || "");
  //     rearPosLampDataList.MakeList.push(make);
  //     rearPosLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     rearPosLampDataList.tacNumberList.push(tac);
  //     rearPosLampDataList.copCertList.push(copFinal);
  //     rearPosLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // REAR PARKING LAMP BULB
  //   {
  //     const props = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";

  //     rearPosLampDataList.validityLampList.push(props?.TAC_Validity?.value || "");
  //     rearPosLampDataList.MakeList.push(make);
  //     rearPosLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     rearPosLampDataList.tacNumberLampList.push(tac);
  //     rearPosLampDataList.copCertLampList.push(copFinal);
  //     rearPosLampDataList.possibleDateLampList.push(possibleFinal);
  //   }

  //   // STOP LAMP LED
  //   {
  //     const props = vehPosLamp?.Stop_Lamp_LED_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";

  //     stopLampDataList.validityList.push(props?.TAC_Validity?.value || "");
  //     stopLampDataList.MakeList.push(make);
  //     stopLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     stopLampDataList.tacNumberList.push(tac);
  //     stopLampDataList.copCertList.push(copFinal);
  //     stopLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // STOP LAMP BULB FILAMENT TYPE
  //   {
  //     const props = vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";

  //     stopLampDataList.validityLampList.push(props?.TAC_Validity?.value || "");
  //     stopLampDataList.MakeList.push(make);
  //     stopLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     stopLampDataList.tacNumberLampList.push(tac);
  //     stopLampDataList.copCertLampList.push(copFinal);
  //     stopLampDataList.possibleDateLampList.push(possibleFinal);
  //   }
  // });

  // const posLampsList = form8Data?.Position_Lamps?.PositionLamps || [];

  // let frontPosLampDataList = mainData();
  // let rearPosLampDataList = mainData();
  // let stopLampDataList = mainData();

  // posLampsList.forEach((vehPosLamp) => {
  //   if (vehPosLamp?.supplier?.active !== true) return;

  //   // Helper function for TAC with condition
  //   const getFinalTAC = (tacRaw, copRaw) => {
  //     const isTacMissing = tacRaw.trim() === "";
  //     const isCopPresent = copRaw.trim() !== "";
  //     return isTacMissing && isCopPresent ? "NA" : tacRaw;
  //   };

  //   // FRONT POSITION LAMP LED
  //   {
  //     const props = vehPosLamp?.Front_Position_Lamp_LED_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     frontPosLampDataList.validityList.push(tacValidity);
  //     frontPosLampDataList.MakeList.push(make);
  //     frontPosLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     frontPosLampDataList.tacNumberList.push(tac);
  //     frontPosLampDataList.copCertList.push(copFinal);
  //     frontPosLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // FRONT POSITION LAMP BULB
  //   {
  //     const props = vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     frontPosLampDataList.validityLampList.push(tacValidity);
  //     frontPosLampDataList.MakeList.push(make);
  //     frontPosLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     frontPosLampDataList.tacNumberLampList.push(tac);
  //     frontPosLampDataList.copCertLampList.push(copFinal);
  //     frontPosLampDataList.possibleDateLampList.push(possibleFinal);
  //   }

  //   // REAR PARKING LAMP LED
  //   {
  //     const props = vehPosLamp?.Parking_Lamp_Led_Rear?.properties || {};
  //     let make = props?.Make_of_Parking_lamp_led_rear?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     rearPosLampDataList.validityList.push(tacValidity);
  //     rearPosLampDataList.MakeList.push(make);
  //     rearPosLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     rearPosLampDataList.tacNumberList.push(tac);
  //     rearPosLampDataList.copCertList.push(copFinal);
  //     rearPosLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // REAR PARKING LAMP BULB
  //   {
  //     const props = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     rearPosLampDataList.validityLampList.push(tacValidity);
  //     rearPosLampDataList.MakeList.push(make);
  //     rearPosLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     rearPosLampDataList.tacNumberLampList.push(tac);
  //     rearPosLampDataList.copCertLampList.push(copFinal);
  //     rearPosLampDataList.possibleDateLampList.push(possibleFinal);
  //   }

  //   // STOP LAMP LED
  //   {
  //     const props = vehPosLamp?.Stop_Lamp_LED_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     stopLampDataList.validityList.push(tacValidity);
  //     stopLampDataList.MakeList.push(make);
  //     stopLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     stopLampDataList.tacNumberList.push(tac);
  //     stopLampDataList.copCertList.push(copFinal);
  //     stopLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // STOP LAMP BULB FILAMENT TYPE
  //   {
  //     const props = vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     stopLampDataList.validityLampList.push(tacValidity);
  //     stopLampDataList.MakeList.push(make);
  //     stopLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     stopLampDataList.tacNumberLampList.push(tac);
  //     stopLampDataList.copCertLampList.push(copFinal);
  //     stopLampDataList.possibleDateLampList.push(possibleFinal);
  //   }
  // });

  // const posLampsList = form8Data?.Position_Lamps?.PositionLamps || [];

  // let frontPosLampDataList = mainData();
  // let rearPosLampDataList = mainData();
  // let stopLampDataList = mainData();

  // posLampsList.forEach((vehPosLamp) => {
  //   if (vehPosLamp?.supplier?.active !== true) return;

  //   const getFinalTAC = (tacRaw, copRaw) => {
  //     const isTacMissing = tacRaw.trim() === "";
  //     const isCopPresent = copRaw.trim() !== "";
  //     return isTacMissing && isCopPresent ? "NA" : tacRaw;
  //   };

  //   // FRONT POSITION LAMP LED
  //   {
  //     const props = vehPosLamp?.Front_Position_Lamp_LED_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     frontPosLampDataList.validityList.push(tacValidity);
  //     frontPosLampDataList.MakeList.push(make);
  //     frontPosLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     frontPosLampDataList.tacNumberList.push(tac);
  //     frontPosLampDataList.copCertList.push(copFinal);
  //     frontPosLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // FRONT POSITION LAMP BULB
  //   {
  //     const props = vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     frontPosLampDataList.validityLampList.push(tacValidity);
  //     frontPosLampDataList.MakeList.push(make);
  //     frontPosLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     frontPosLampDataList.tacNumberLampList.push(tac);
  //     frontPosLampDataList.copCertLampList.push(copFinal);
  //     frontPosLampDataList.possibleDateLampList.push(possibleFinal);
  //   }

  //   // REAR PARKING LAMP LED
  //   {
  //     const props = vehPosLamp?.Parking_Lamp_Led_Rear?.properties || {};
  //     let make = props?.Make_of_Parking_lamp_led_rear?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     rearPosLampDataList.validityList.push(tacValidity);
  //     rearPosLampDataList.MakeList.push(make);
  //     rearPosLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     rearPosLampDataList.tacNumberList.push(tac);
  //     rearPosLampDataList.copCertList.push(copFinal);
  //     rearPosLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // REAR PARKING LAMP BULB
  //   {
  //     const props = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     rearPosLampDataList.validityLampList.push(tacValidity);
  //     rearPosLampDataList.MakeList.push(make);
  //     rearPosLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     rearPosLampDataList.tacNumberLampList.push(tac);
  //     rearPosLampDataList.copCertLampList.push(copFinal);
  //     rearPosLampDataList.possibleDateLampList.push(possibleFinal);
  //   }

  //   // STOP LAMP LED
  //   {
  //     const props = vehPosLamp?.Stop_Lamp_LED_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     stopLampDataList.validityList.push(tacValidity);
  //     stopLampDataList.MakeList.push(make);
  //     stopLampDataList.suppNameList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     stopLampDataList.tacNumberList.push(tac);
  //     stopLampDataList.copCertList.push(copFinal);
  //     stopLampDataList.possibleDateList.push(possibleFinal);
  //   }

  //   // STOP LAMP BULB FILAMENT TYPE
  //   {
  //     const props = vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties || {};
  //     let make = props?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) make = `M/s. ${make}`;

  //     const tac = props?.TAC_Number?.value || "";
  //     const cop = props?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possible = props?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const tacValidityRaw = props?.TAC_Validity?.value || "";
  //     const tacValidity = getFinalTAC(tacValidityRaw, cop);

  //     stopLampDataList.validityLampList.push(tacValidity);
  //     stopLampDataList.MakeList.push(make);
  //     stopLampDataList.suppNameLampList.push(make);
  //     const { cop: copFinal, possible: possibleFinal } = TACvalidationcheck(tac, cop, possible);
  //     stopLampDataList.tacNumberLampList.push(tac);
  //     stopLampDataList.copCertLampList.push(copFinal);
  //     stopLampDataList.possibleDateLampList.push(possibleFinal);
  //   }
  // });






//   const posLampsList = form8Data?.Position_Lamps?.PositionLamps || [];

//   let frontPosLampDataList = mainData();
//   let rearPosLampDataList = mainData();
//   let stopLampDataList = mainData();

//   posLampsList.forEach((vehPosLamp) => {
//     if (vehPosLamp?.supplier?.active === true) {
//       // FRONT POSITION LAMP LED
//       {
//         const props =
//           vehPosLamp?.Front_Position_Lamp_LED_Type?.properties || {};
//         // let make = props?.Make?.value || "";
//         // if (make && !make.startsWith("M/")) {
//         //   make = `M/s. ${make}`;
//         // }
//         let make = makePrefix(props?.Make?.value);
//         const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
//         const copCertRaw =
//           props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
//         const possibleDateRaw =
//           props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
//           "";

//         const isTacMissing = tacValueRaw === "";
//         const isPossibleDatePresent = possibleDateRaw !== "";

//         let finalTAC = tacValueRaw;
//         if (isTacMissing && isPossibleDatePresent) {
//           finalTAC = "NA";
//         }

//         frontPosLampDataList.validityList.push(finalTAC);
//         frontPosLampDataList.MakeList.push(make);
//         frontPosLampDataList.suppNameList.push(make);

//         const { cop, possible } = TACvalidationcheck(
//           tacValueRaw,
//           copCertRaw,
//           possibleDateRaw
//         );
//         frontPosLampDataList.copCertList.push(cop);
//         frontPosLampDataList.possibleDateList.push(possible);
//       }

//       // FRONT POSITION LAMP BULB
//       {
//         const props =
//           vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties || {};
//         // let make = props?.Make?.value || "";
//         // if (make && !make.startsWith("M/")) {
//         //   make = `M/s. ${make}`;
//         // }
//         let make = makePrefix(props?.Make?.value);

//         const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
//         const copCertRaw =
//           props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
//         const possibleDateRaw =
//           props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
//           "";

//         const isTacMissing = tacValueRaw === "";
//         const isPossibleDatePresent = possibleDateRaw !== "";

//         let finalTAC = tacValueRaw;
//         if (isTacMissing && isPossibleDatePresent) {
//           finalTAC = "NA";
//         }

//         frontPosLampDataList.validityLampList.push(finalTAC);
//         frontPosLampDataList.MakeList.push(make);
//         frontPosLampDataList.suppNameLampList.push(make);

//         const { cop, possible } = TACvalidationcheck(
//           tacValueRaw,
//           copCertRaw,
//           possibleDateRaw
//         );
//         frontPosLampDataList.copCertLampList.push(cop);
//         frontPosLampDataList.possibleDateLampList.push(possible);
//       }

//       // REAR PARKING LAMP LED
//       {
//         const props = vehPosLamp?.Parking_Lamp_Led_Rear?.properties || {};
//         // let make = props?.Make_of_Parking_lamp_led_rear?.value || "";
//         // if (make && !make.startsWith("M/")) {
//         //   make = `M/s. ${make}`;
//         // }
//         let make = makePrefix(props?.Make_of_Parking_lamp_led_rear?.value);

//         const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
//         const copCertRaw =
//           props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
//         const possibleDateRaw =
//           props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
//           "";

//         const isTacMissing = tacValueRaw === "";
//         const isPossibleDatePresent = possibleDateRaw !== "";

//         let finalTAC = tacValueRaw;
//         if (isTacMissing && isPossibleDatePresent) {
//           finalTAC = "NA";
//         }

//         rearPosLampDataList.validityList.push(finalTAC);
//         rearPosLampDataList.MakeList.push(make);
//         rearPosLampDataList.suppNameList.push(make);

//         const { cop, possible } = TACvalidationcheck(
//           tacValueRaw,
//           copCertRaw,
//           possibleDateRaw
//         );
//         rearPosLampDataList.copCertList.push(cop);
//         rearPosLampDataList.possibleDateList.push(possible);
//       }

//       // REAR PARKING LAMP BULB
//       {
//         const props = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties || {};
//         // let make = props?.Make?.value || "";
//         // if (make && !make.startsWith("M/")) {
//         //   make = `M/s. ${make}`;
//         // }
//         let make = makePrefix(props?.Make?.value);

//         const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
//         const copCertRaw =
//           props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
//         const possibleDateRaw =
//           props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
//           "";

//         const isTacMissing = tacValueRaw === "";
//         const isPossibleDatePresent = possibleDateRaw !== "";

//         let finalTAC = tacValueRaw;
//         if (isTacMissing && isPossibleDatePresent) {
//           finalTAC = "NA";
//         }

//         rearPosLampDataList.validityLampList.push(finalTAC);
//         rearPosLampDataList.MakeList.push(make);
//         rearPosLampDataList.suppNameLampList.push(make);

//         const { cop, possible } = TACvalidationcheck(
//           tacValueRaw,
//           copCertRaw,
//           possibleDateRaw
//         );
//         rearPosLampDataList.copCertLampList.push(cop);
//         rearPosLampDataList.possibleDateLampList.push(possible);
//       }

//       // STOP LAMP LED
//       {
//         const props = vehPosLamp?.Stop_Lamp_LED_Type?.properties || {};
//         // let make = props?.Make?.value || "";
//         // if (make && !make.startsWith("M/")) {
//         //   make = `M/s. ${make}`;
//         // }
//         let make = makePrefix(props?.Make?.value);

//         const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
//         const copCertRaw =
//           props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
//         const possibleDateRaw =
//           props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
//           "";

//         const isTacMissing = tacValueRaw === "";
//         const isPossibleDatePresent = possibleDateRaw !== "";

//         let finalTAC = tacValueRaw;
//         if (isTacMissing && isPossibleDatePresent) {
//           finalTAC = "NA";
//         }

//         stopLampDataList.validityList.push(finalTAC);
//         stopLampDataList.MakeList.push(make);
//         stopLampDataList.suppNameList.push(make);

//         const { cop, possible } = TACvalidationcheck(
//           tacValueRaw,
//           copCertRaw,
//           possibleDateRaw
//         );
//         stopLampDataList.copCertList.push(cop);
//         stopLampDataList.possibleDateList.push(possible);
//       }

//       // STOP LAMP BULB FILAMENT TYPE
//       {
//         const props =
//           vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties || {};
//         // let make = props?.Make?.value || "";
//         // if (make && !make.startsWith("M/")) {
//         //   make = `M/s. ${make}`;
//         // }
//         let make = makePrefix(props?.Make?.value);

//         const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
//         const copCertRaw =
//           props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
//         const possibleDateRaw =
//           props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
//           "";

//         const isTacMissing = tacValueRaw === "";
//         const isPossibleDatePresent = possibleDateRaw !== "";

//         let finalTAC = tacValueRaw;
//         if (isTacMissing && isPossibleDatePresent) {
//           finalTAC = "NA";
//         }

//         stopLampDataList.validityLampList.push(finalTAC);
//         stopLampDataList.MakeList.push(make);
//         stopLampDataList.suppNameLampList.push(make);

//         const { cop, possible } = TACvalidationcheck(
//           tacValueRaw,
//           copCertRaw,
//           possibleDateRaw
//         );
//         stopLampDataList.copCertLampList.push(cop);
//         stopLampDataList.possibleDateLampList.push(possible);
//       }
//     }
//   });




const posLampsList = form8Data?.Position_Lamps?.PositionLamps || [];

let frontPosLampDataList = mainData();
let rearPosLampDataList = mainData();
let stopLampDataList = mainData();

posLampsList.forEach((vehPosLamp) => {
  if (vehPosLamp?.supplier?.active === true) {
    // FRONT POSITION LAMP LED
    {
      const props = vehPosLamp?.Front_Position_Lamp_LED_Type?.properties || {};
      let make = makePrefix(props?.Make?.value);
      const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
      const tacNumber = props?.TAC_Number?.value?.trim() || "";
      const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissingFrontLamp = tacValueRaw === "";
      const isPossibleDatePresentfrontLamp = possibleDateRaw !== "";

      let finalTACFrontLamp = tacValueRaw;
      if (isTacMissingFrontLamp && isPossibleDatePresentfrontLamp) {
        finalTACFrontLamp = "NA";
      }

      if (finalTACFrontLamp !== "NA") {
        frontPosLampDataList.validityList.push(finalTACFrontLamp);
        frontPosLampDataList.tacNumberList.push(tacNumber);
      } else {
        frontPosLampDataList.validityList.push("NA");
        frontPosLampDataList.tacNumberList.push("");
      }



    //   frontPosLampDataList.validityList.push(finalTAC);
    //   frontPosLampDataList.tacNumberList.push(tacNumber);
      frontPosLampDataList.MakeList.push(make);
      frontPosLampDataList.suppNameList.push(make);

      const { cop:copFrontLed, possible:possibleFrontLed } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
      frontPosLampDataList.copCertList.push(copFrontLed);
      frontPosLampDataList.possibleDateList.push(possibleFrontLed);
    }

    // FRONT POSITION LAMP BULB
    {
      const props = vehPosLamp?.Front_Position_Lamp_Bulb_Type?.properties || {};
      let make = makePrefix(props?.Make?.value);
      const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
      const tacNumber = props?.TAC_Number?.value?.trim() || "";
      const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissingFrontBulb = tacValueRaw === "";
      const isPossibleDatePresentFrontBulb = possibleDateRaw !== "";

      let finalTACFrontBulb = tacValueRaw;
      if (isTacMissingFrontBulb && isPossibleDatePresentFrontBulb) {
        finalTACFrontBulb = "NA";
      }


      if (finalTACFrontBulb !== "NA") {
        frontPosLampDataList.validityLampList.push(tacValueRaw);
        frontPosLampDataList.tacNumberLampList.push(tacNumber);
      } else {
        frontPosLampDataList.validityLampList.push("NA");
        frontPosLampDataList.tacNumberLampList.push("");
      }
      
    //   frontPosLampDataList.validityLampList.push(finalTAC);
    //   frontPosLampDataList.tacNumberLampList.push(tacNumber);
      frontPosLampDataList.MakeList.push(make);
      frontPosLampDataList.suppNameLampList.push(make);

      const { cop:copFrontBulb, possible:possibleFrontBulb } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
      frontPosLampDataList.copCertLampList.push(copFrontBulb);
      frontPosLampDataList.possibleDateLampList.push(possibleFrontBulb);
    }

    // REAR PARKING LAMP LED
    {
      const props = vehPosLamp?.Parking_Lamp_Led_Rear?.properties || {};
      let make = makePrefix(props?.Make_of_Parking_lamp_led_rear?.value);
      const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
      const tacNumber = props?.TAC_Number?.value?.trim() || "";
      const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissingRearLamp = tacValueRaw === "";
      const isPossibleDatePresentRearLamp = possibleDateRaw !== "";

      let finalTACRearLamp = tacValueRaw;
      if (isTacMissingRearLamp && isPossibleDatePresentRearLamp) {
        finalTACRearLamp = "NA";
      }


      if (finalTACRearLamp !== "NA") {
        rearPosLampDataList.validityList.push(tacValueRaw);
        rearPosLampDataList.tacNumberList.push(tacNumber);
      } else {
        rearPosLampDataList.validityList.push("NA");
        rearPosLampDataList.tacNumberList.push("");
      }

    //   rearPosLampDataList.validityList.push(finalTAC);
    //   rearPosLampDataList.tacNumberList.push(tacNumber);
      rearPosLampDataList.MakeList.push(make);
      rearPosLampDataList.suppNameList.push(make);

      const { cop:copRearParkLed, possible:possibleRearParkLed } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
      rearPosLampDataList.copCertList.push(copRearParkLed);
      rearPosLampDataList.possibleDateList.push(possibleRearParkLed);
    }

    // REAR PARKING LAMP BULB
    {
      const props = vehPosLamp?.Parking_Lamp_Bulb_Rear?.properties || {};
      let make = makePrefix(props?.Make?.value);
      const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
      const tacNumber = props?.TAC_Number?.value?.trim() || "";
      const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissing = tacValueRaw === "";
      const isPossibleDatePresent = possibleDateRaw !== "";

      let finalTAC = tacValueRaw;
      if (isTacMissing && isPossibleDatePresent) {
        finalTAC = "NA";
      }

      if (finalTAC !== "NA") {
        rearPosLampDataList.validityLampList.push(finalTAC);
        rearPosLampDataList.tacNumberLampList.push(tacNumber);
      } else {
        rearPosLampDataList.validityLampList.push("NA");
        rearPosLampDataList.tacNumberLampList.push("");
      }


    //   rearPosLampDataList.validityLampList.push(finalTAC);
    //   rearPosLampDataList.tacNumberLampList.push(tacNumber);
      rearPosLampDataList.MakeList.push(make);
      rearPosLampDataList.suppNameLampList.push(make);

      const { cop:copRearParkBulb, possible:possibleRearParkBulb } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
      rearPosLampDataList.copCertLampList.push(copRearParkBulb);
      rearPosLampDataList.possibleDateLampList.push(possibleRearParkBulb);
    }

    // STOP LAMP LED
    {
      const props = vehPosLamp?.Stop_Lamp_LED_Type?.properties || {};
      let make = makePrefix(props?.Make?.value);
      const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
      const tacNumber = props?.TAC_Number?.value?.trim() || "";
      const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissing = tacValueRaw === "";
      const isPossibleDatePresent = possibleDateRaw !== "";

      let finalTAC = tacValueRaw;
      if (isTacMissing && isPossibleDatePresent) {
        finalTAC = "NA";
      }

      if (finalTAC !== "NA") {
        stopLampDataList.validityList.push(finalTAC);
        stopLampDataList.tacNumberList.push(tacNumber);
      } else {
        stopLampDataList.validityList.push("NA");
        stopLampDataList.tacNumberList.push("");
      }


    //   stopLampDataList.validityList.push(finalTAC);
    //   stopLampDataList.tacNumberList.push(tacNumber);
      stopLampDataList.MakeList.push(make);
      stopLampDataList.suppNameList.push(make);

      const { cop:copStopLed, possible:possibleStopLed } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
      stopLampDataList.copCertList.push(copStopLed);
      stopLampDataList.possibleDateList.push(possibleStopLed);
    }

    // STOP LAMP BULB FILAMENT TYPE
    {
      const props = vehPosLamp?.Stop_lamp_bulb_Filament_Type?.properties || {};
      let make = makePrefix(props?.Make?.value);
      const tacValueRaw = props?.TAC_Validity?.value?.trim() || "";
      const tacNumber = props?.TAC_Number?.value?.trim() || "";
      const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissing = tacValueRaw === "";
      const isPossibleDatePresent = possibleDateRaw !== "";

      let finalTAC = tacValueRaw;
      if (isTacMissing && isPossibleDatePresent) {
        finalTAC = "NA";
      }

      if (finalTAC !== "NA") {
        stopLampDataList.validityLampList.push(finalTAC);
        stopLampDataList.tacNumberLampList.push(tacNumber);
      } else {
        stopLampDataList.validityLampList.push("NA");
        stopLampDataList.tacNumberLampList.push("");
      }

    //   stopLampDataList.validityLampList.push(finalTAC);
    //   stopLampDataList.tacNumberLampList.push(tacNumber);
      stopLampDataList.MakeList.push(make);
      stopLampDataList.suppNameLampList.push(make);

      const { cop:copStopFillament, possible:possibleStopFillament } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
      stopLampDataList.copCertLampList.push(copStopFillament);
      stopLampDataList.possibleDateLampList.push(possibleStopFillament);
    }
  }
});


  console.log("frontPosLampDataList.MakeList", frontPosLampDataList.MakeList);
  console.log(
    "frontPosLampDataList.possibleDateList",
    frontPosLampDataList.possibleDateList
  );
  console.log(
    "frontPosLampDataList.copCertList",
    frontPosLampDataList.copCertList
  );
  console.log(
    "frontPosLampDataList.validityList",
    frontPosLampDataList.validityList
  );
  console.log(
    "frontPosLampDataList.tacNumberLampList",
    frontPosLampDataList.tacNumberList
  );
  console.log(
    "frontPosLampDataList.tacNumberLampList",
    frontPosLampDataList.tacNumberLampList
  );
  console.log(
    "frontPosLampDataList.suppNameLampList",
    frontPosLampDataList.suppNameLampList
  );
  console.log(
    "frontPosLampDataList.possibleDateLampList",
    frontPosLampDataList.possibleDateLampList
  );
  console.log(
    "frontPosLampDataList.copCertLampList",
    frontPosLampDataList.copCertLampList
  );
  console.log(
    "frontPosLampDataList.validityLampList",
    frontPosLampDataList.validityLampList
  );

  console.log(
    "rearPosLampDataList.tacNumberLampList",
    rearPosLampDataList.tacNumberLampList
  );
  console.log(
    "rearPosLampDataList.suppNameLampList",
    rearPosLampDataList.suppNameLampList
  );
  console.log("rearPosLampDataList.MakeList", rearPosLampDataList.MakeList);
  console.log(
    "rearPosLampDataList.possibleDateLampList",
    rearPosLampDataList.possibleDateLampList
  );
  console.log(
    "rearPosLampDataList.copCertLampList",
    rearPosLampDataList.copCertLampList
  );
  console.log(
    "rearPosLampDataList.validityLampList",
    rearPosLampDataList.validityLampList
  );
  console.log(
    "rearPosLampDataList.tacNumberList",
    rearPosLampDataList.tacNumberList
  );
  console.log(
    "rearPosLampDataList.suppNameList",
    rearPosLampDataList.suppNameList
  );
  console.log(
    "rearPosLampDataList.possibleDateList",
    rearPosLampDataList.possibleDateList
  );
  console.log(
    "rearPosLampDataList.copCertList",
    rearPosLampDataList.copCertList
  );
  console.log(
    "rearPosLampDataList.validityList",
    rearPosLampDataList.validityList
  );

  console.log("stopLampDataList.tacNumberList", stopLampDataList.tacNumberList);
  console.log("stopLampDataList.suppNameList", stopLampDataList.suppNameList);
  console.log("stopLampDataList.MakeList", stopLampDataList.MakeList);
  console.log(
    "stopLampDataList.possibleDateList",
    stopLampDataList.possibleDateList
  );
  console.log("stopLampDataList.copCertList", stopLampDataList.copCertList);
  console.log("stopLampDataList.validityList", stopLampDataList.validityList);
  console.log(
    "stopLampDataList.tacNumberLampList",
    stopLampDataList.tacNumberLampList
  );
  console.log(
    "stopLampDataList.suppNameLampList",
    stopLampDataList.suppNameLampList
  );
  console.log(
    "stopLampDataList.possibleDateLampList",
    stopLampDataList.possibleDateLampList
  );
  console.log(
    "stopLampDataList.copCertLampList",
    stopLampDataList.copCertLampList
  );
  console.log(
    "stopLampDataList.validityLampList",
    stopLampDataList.validityLampList
  );

  // const dirIndLampList = form8Data?.Direction_Indicator_Lamp?.DirectionIndicatorLamp;
  // let fdIndLampDataList = mainData();
  // let sdIndLampDataList = mainData();
  // let rdIndLampDataList = mainData();
  // dirIndLampList.map(vehDirInd => {
  //     if (vehDirInd.supplier.active === true) {
  //         let supplierName = vehDirInd?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // fdIndLampDataList.suppNameList.push(supplierName);

  //         // fdIndLampDataList.validityList.push(vehDirInd?.Front_Direction_Indicator_LED_Type?.properties?.TAC_Validity?.value);
  //         // Get the validity value for Front Direction Indicator Lamp
  //         const fdIndValidityValue = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties?.TAC_Number?.value;

  //         // Push the validity value to fdIndLampDataList
  //         fdIndLampDataList.tacNumberList.push(fdIndValidityValue);

  //         // Check if validity data is present
  //         // fdIndLampDataList.suppNameList.push(fdIndValidityValue ? supplierName : "");
  //         // fdIndLampDataList.suppNameList.push(fdIndValidityValue === "NA" ? "" : supplierName);
  //         if (fdIndValidityValue && fdIndValidityValue.trim() !== "NA") {
  //             fdIndLampDataList.suppNameList.push(supplierName);
  //         }

  //         fdIndLampDataList.MakeList.push(vehDirInd?.Front_Direction_Indicator_LED_Type?.properties?.Make?.value);
  //         fdIndLampDataList.validityList.push(vehDirInd?.Front_Direction_Indicator_LED_Type?.properties?.TAC_Validity?.value);
  //         // fdIndLampDataList.tacNumberList.push(vehDirInd?.Front_Direction_Indicator_LED_Type?.properties?.TAC_Number?.value);
  //         fdIndLampDataList.possibleDateList.push(vehDirInd?.Front_Direction_Indicator_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         fdIndLampDataList.copCertList.push(vehDirInd?.Front_Direction_Indicator_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         // sdIndLampDataList.suppNameList.push(supplierName);
  //         // sdIndLampDataList.validityList.push(vehDirInd?.Side_Direction_Indicator?.properties?.TAC_Validity?.value);
  //         // Get the validity value for Side Direction Indicator Lamp
  //         const sdIndValidityValue = vehDirInd?.Side_Direction_Indicator?.properties?.TAC_Number?.value;

  //         // Push the validity value to sdIndLampDataList
  //         sdIndLampDataList.tacNumberList.push(sdIndValidityValue);

  //         // Check if validity data is present
  //         // sdIndLampDataList.suppNameList.push(sdIndValidityValue ? supplierName : "");
  //         // sdIndLampDataList.suppNameList.push(sdIndValidityValue === "NA" ? "" : supplierName);
  //         if (sdIndValidityValue && sdIndValidityValue.trim() !== "NA") {
  //             sdIndLampDataList.suppNameList.push(supplierName);
  //         }

  //         sdIndLampDataList.MakeList.push(vehDirInd?.Side_Direction_Indicator?.properties?.Make?.value);
  //         sdIndLampDataList.validityList.push(vehDirInd?.Side_Direction_Indicator?.properties?.TAC_Validity?.value);
  //         // sdIndLampDataList.tacNumberList.push(vehDirInd?.Side_Direction_Indicator?.properties?.TAC_Number?.value);
  //         sdIndLampDataList.possibleDateList.push(vehDirInd?.Side_Direction_Indicator?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         sdIndLampDataList.copCertList.push(vehDirInd?.Side_Direction_Indicator?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         // rdIndLampDataList.suppNameList.push(supplierName);
  //         // rdIndLampDataList.validityList.push(vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties?.TAC_Validity?.value);
  //         // Get the validity value for Rear Direction Indicator Lamp
  //         const rdIndValidityValue = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties?.TAC_Number?.value;

  //         // Push the validity value to rdIndLampDataList
  //         rdIndLampDataList.tacNumberList.push(rdIndValidityValue);

  //         // Check if validity data is present
  //         // rdIndLampDataList.suppNameList.push(rdIndValidityValue ? supplierName : "");
  //         // rdIndLampDataList.suppNameList.push(rdIndValidityValue === "NA" ? "" : supplierName);
  //         if (rdIndValidityValue && rdIndValidityValue.trim() !== "NA") {
  //             rdIndLampDataList.suppNameList.push(supplierName);
  //         }

  //         rdIndLampDataList.MakeList.push(vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties?.Make?.value);
  //         rdIndLampDataList.validityList.push(vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties?.TAC_Validity?.value);
  //         // rdIndLampDataList.tacNumberList.push(vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties?.TAC_Number?.value);
  //         rdIndLampDataList.possibleDateList.push(vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rdIndLampDataList.copCertList.push(vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         // fdIndLampDataList.validityLampList.push(vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Front Direction Indicator Lamp
  //         const fdIndLampTACValue = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to fdIndLampDataList
  //         fdIndLampDataList.tacNumberLampList.push(fdIndLampTACValue);

  //         // Check if TAC value is present
  //         // fdIndLampDataList.suppNameLampList.push(fdIndLampTACValue ? supplierName : "");
  //         // fdIndLampDataList.suppNameLampList.push(fdIndLampTACValue === "NA" ? "" : supplierName);
  //         if (fdIndLampTACValue && fdIndLampTACValue.trim() !== "NA") {
  //             fdIndLampDataList.suppNameLampList.push(supplierName);
  //         }

  //         fdIndLampDataList.MakeList.push(vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties?.Make?.value);
  //         fdIndLampDataList.validityLampList.push(vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties?.TAC_Validity?.value);
  //         // fdIndLampDataList.tacNumberLampList.push(vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties?.TAC_Number?.value);
  //         fdIndLampDataList.possibleDateLampList.push(vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         fdIndLampDataList.copCertLampList.push(vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         // rdIndLampDataList.validityLampList.push(vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Rear Direction Indicator Lamp
  //         const rdIndLampTACValue = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to rdIndLampDataList
  //         rdIndLampDataList.tacNumberLampList.push(rdIndLampTACValue);

  //         // Check if TAC value is present
  //         // rdIndLampDataList.suppNameLampList.push(rdIndLampTACValue ? supplierName : "");
  //         // rdIndLampDataList.suppNameLampList.push(rdIndLampTACValue === "NA" ? "" : supplierName);
  //         if (rdIndLampTACValue && rdIndLampTACValue.trim() !== "NA") {
  //             rdIndLampDataList.suppNameLampList.push(supplierName);
  //         }

  //         rdIndLampDataList.MakeList.push(vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties?.Make?.value);
  //         rdIndLampDataList.validityLampList.push(vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties?.TAC_Validity?.value);
  //         // rdIndLampDataList.tacNumberLampList.push(vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties?.TAC_Number?.value);
  //         rdIndLampDataList.possibleDateLampList.push(vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rdIndLampDataList.copCertLampList.push(vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const dirIndLampList = form8Data?.Direction_Indicator_Lamp?.DirectionIndicatorLamp;

  // let fdIndLampDataList = mainData();
  // let sdIndLampDataList = mainData();
  // let rdIndLampDataList = mainData();

  // dirIndLampList?.forEach(vehDirInd => {
  //     if (vehDirInd.supplier?.active) {

  //         // Front Direction Indicator LED
  //         const fdLED = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
  //         const fdTACNumber = fdLED?.TAC_Number?.value;
  //         const fdMake = fdLED?.Make?.value || "";
  //         if (fdTACNumber && fdTACNumber.trim() !== "NA") {
  //             // Push prefixed make instead of supplier name
  //             fdIndLampDataList.suppNameList.push(prefixMake(fdMake));
  //         }
  //         fdIndLampDataList.tacNumberList.push(fdTACNumber);
  //         fdIndLampDataList.MakeList.push(fdMake);  // Raw make here, no prefix
  //         fdIndLampDataList.validityList.push(fdLED?.TAC_Validity?.value);
  //         fdIndLampDataList.possibleDateList.push(fdLED?.Possible_date_of_submission_of_required_approval?.value);
  //         fdIndLampDataList.copCertList.push(fdLED?.CoP_Cert_No_with_validity_date?.value);

  //         // Side Direction Indicator LED
  //         const sdLED = vehDirInd?.Side_Direction_Indicator?.properties || {};
  //         console.log('sdlED:', sdLED);
  //         const sdTACNumber = sdLED?.TAC_Number?.value;
  //         const sdMake = sdLED?.Make?.value || "";
  //         if (sdTACNumber && sdTACNumber.trim() !== "NA") {
  //             sdIndLampDataList.suppNameList.push(prefixMake(sdMake));
  //         }
  //         sdIndLampDataList.tacNumberList.push(sdTACNumber);
  //         sdIndLampDataList.MakeList.push(sdMake);
  //         sdIndLampDataList.validityList.push(sdLED?.TAC_Validity?.value);
  //         sdIndLampDataList.possibleDateList.push(sdLED?.Possible_date_of_submission_of_required_approval?.value);
  //         sdIndLampDataList.copCertList.push(sdLED?.CoP_Cert_No_with_validity_date?.value);

  //         // Rear Direction Indicator LED
  //         const rdLED = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
  //         const rdTACNumber = rdLED?.TAC_Number?.value;
  //         const rdMake = rdLED?.Make?.value || "";
  //         if (rdTACNumber && rdTACNumber.trim() !== "NA") {
  //             rdIndLampDataList.suppNameList.push(prefixMake(rdMake));
  //         }
  //         rdIndLampDataList.tacNumberList.push(rdTACNumber);
  //         rdIndLampDataList.MakeList.push(rdMake);
  //         rdIndLampDataList.validityList.push(rdLED?.TAC_Validity?.value);
  //         rdIndLampDataList.possibleDateList.push(rdLED?.Possible_date_of_submission_of_required_approval?.value);
  //         rdIndLampDataList.copCertList.push(rdLED?.CoP_Cert_No_with_validity_date?.value);

  //         // Front Direction Indicator Bulb
  //         const fdBulb = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
  //         const fdBulbTAC = fdBulb?.TAC_Number?.value;
  //         const fdBulbMake = fdBulb?.Make?.value || "";
  //         if (fdBulbTAC && fdBulbTAC.trim() !== "NA") {
  //             fdIndLampDataList.suppNameLampList.push(prefixMake(fdBulbMake));
  //         }
  //         fdIndLampDataList.tacNumberLampList.push(fdBulbTAC);
  //         fdIndLampDataList.MakeList.push(fdBulbMake);
  //         fdIndLampDataList.validityLampList.push(fdBulb?.TAC_Validity?.value);
  //         fdIndLampDataList.possibleDateLampList.push(fdBulb?.Possible_date_of_submission_of_required_approval?.value);
  //         fdIndLampDataList.copCertLampList.push(fdBulb?.CoP_Cert_No_with_validity_date?.value);

  //         // Rear Direction Indicator Bulb
  //         const rdBulb = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
  //         const rdBulbTAC = rdBulb?.TAC_Number?.value;
  //         const rdBulbMake = rdBulb?.Make?.value || "";
  //         if (rdBulbTAC && rdBulbTAC.trim() !== "NA") {
  //             rdIndLampDataList.suppNameLampList.push(prefixMake(rdBulbMake));
  //         }
  //         rdIndLampDataList.tacNumberLampList.push(rdBulbTAC);
  //         rdIndLampDataList.MakeList.push(rdBulbMake);
  //         rdIndLampDataList.validityLampList.push(rdBulb?.TAC_Validity?.value);
  //         rdIndLampDataList.possibleDateLampList.push(rdBulb?.Possible_date_of_submission_of_required_approval?.value);
  //         rdIndLampDataList.copCertLampList.push(rdBulb?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const dirIndLampList = form8Data?.Direction_Indicator_Lamp?.DirectionIndicatorLamp;

  // let fdIndLampDataList = mainData();
  // let sdIndLampDataList = mainData();
  // let rdIndLampDataList = mainData();

  // dirIndLampList?.forEach(vehDirInd => {
  //     if (vehDirInd.supplier?.active) {

  //         // --- Front Direction Indicator LED ---
  //         const fdLED = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
  //         const fdTACNumber = fdLED?.TAC_Number?.value;
  //         const fdMake = fdLED?.Make?.value || "";
  //         const validityFD = parseAndCheckTACValidity(fdLED?.TAC_Validity?.value);

  //         if (fdTACNumber && fdTACNumber.trim() !== "NA") {
  //             fdIndLampDataList.suppNameList.push(prefixMake(fdMake));
  //         }
  //         fdIndLampDataList.tacNumberList.push(fdTACNumber);
  //         fdIndLampDataList.MakeList.push(fdMake);
  //         fdIndLampDataList.validityList.push(fdLED?.TAC_Validity?.value);
  //         fdIndLampDataList.possibleDateList.push(
  //             !validityFD.expired ? fdLED?.Possible_date_of_submission_of_required_approval?.value : "NA"
  //         );
  //         fdIndLampDataList.copCertList.push(
  //             !validityFD.expired ? fdLED?.CoP_Cert_No_with_validity_date?.value : "NA"
  //         );

  //         // --- Side Direction Indicator LED ---
  //         const sdLED = vehDirInd?.Side_Direction_Indicator?.properties || {};
  //         const sdTACNumber = sdLED?.TAC_Number?.value;
  //         const sdMake = sdLED?.Make?.value || "";
  //         const validitySD = parseAndCheckTACValidity(sdLED?.TAC_Validity?.value);

  //         if (sdTACNumber && sdTACNumber.trim() !== "NA") {
  //             sdIndLampDataList.suppNameList.push(prefixMake(sdMake));
  //         }
  //         sdIndLampDataList.tacNumberList.push(sdTACNumber);
  //         sdIndLampDataList.MakeList.push(sdMake);
  //         sdIndLampDataList.validityList.push(sdLED?.TAC_Validity?.value);
  //         sdIndLampDataList.possibleDateList.push(
  //             !validitySD.expired ? sdLED?.Possible_date_of_submission_of_required_approval?.value : "NA"
  //         );
  //         sdIndLampDataList.copCertList.push(
  //             !validitySD.expired ? sdLED?.CoP_Cert_No_with_validity_date?.value : "NA"
  //         );

  //         // --- Rear Direction Indicator LED ---
  //         const rdLED = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
  //         const rdTACNumber = rdLED?.TAC_Number?.value;
  //         const rdMake = rdLED?.Make?.value || "";
  //         const validityRD = parseAndCheckTACValidity(rdLED?.TAC_Validity?.value);

  //         if (rdTACNumber && rdTACNumber.trim() !== "NA") {
  //             rdIndLampDataList.suppNameList.push(prefixMake(rdMake));
  //         }
  //         rdIndLampDataList.tacNumberList.push(rdTACNumber);
  //         rdIndLampDataList.MakeList.push(rdMake);
  //         rdIndLampDataList.validityList.push(rdLED?.TAC_Validity?.value);
  //         rdIndLampDataList.possibleDateList.push(
  //             !validityRD.expired ? rdLED?.Possible_date_of_submission_of_required_approval?.value : "NA"
  //         );
  //         rdIndLampDataList.copCertList.push(
  //             !validityRD.expired ? rdLED?.CoP_Cert_No_with_validity_date?.value : "NA"
  //         );

  //         // --- Front Direction Indicator Bulb ---
  //         const fdBulb = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
  //         const fdBulbTAC = fdBulb?.TAC_Number?.value;
  //         const fdBulbMake = fdBulb?.Make?.value || "";
  //         const validityFDBulb = parseAndCheckTACValidity(fdBulb?.TAC_Validity?.value);

  //         if (fdBulbTAC && fdBulbTAC.trim() !== "NA") {
  //             fdIndLampDataList.suppNameLampList.push(prefixMake(fdBulbMake));
  //         }
  //         fdIndLampDataList.tacNumberLampList.push(fdBulbTAC);
  //         fdIndLampDataList.MakeList.push(fdBulbMake);
  //         fdIndLampDataList.validityLampList.push(fdBulb?.TAC_Validity?.value);
  //         fdIndLampDataList.possibleDateLampList.push(
  //             !validityFDBulb.expired ? fdBulb?.Possible_date_of_submission_of_required_approval?.value : "NA"
  //         );
  //         fdIndLampDataList.copCertLampList.push(
  //             !validityFDBulb.expired ? fdBulb?.CoP_Cert_No_with_validity_date?.value : "NA"
  //         );

  //         // --- Rear Direction Indicator Bulb ---
  //         const rdBulb = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
  //         const rdBulbTAC = rdBulb?.TAC_Number?.value;
  //         const rdBulbMake = rdBulb?.Make?.value || "";
  //         const validityRDBulb = parseAndCheckTACValidity(rdBulb?.TAC_Validity?.value);

  //         if (rdBulbTAC && rdBulbTAC.trim() !== "NA") {
  //             rdIndLampDataList.suppNameLampList.push(prefixMake(rdBulbMake));
  //         }
  //         rdIndLampDataList.tacNumberLampList.push(rdBulbTAC);
  //         rdIndLampDataList.MakeList.push(rdBulbMake);
  //         rdIndLampDataList.validityLampList.push(rdBulb?.TAC_Validity?.value);
  //         rdIndLampDataList.possibleDateLampList.push(
  //             !validityRDBulb.expired ? rdBulb?.Possible_date_of_submission_of_required_approval?.value : "NA"
  //         );
  //         rdIndLampDataList.copCertLampList.push(
  //             !validityRDBulb.expired ? rdBulb?.CoP_Cert_No_with_validity_date?.value : "NA"
  //         );
  //     }
  // });

  const dirIndLampList =
    form8Data?.Direction_Indicator_Lamp?.DirectionIndicatorLamp;

  let fdIndLampDataList = mainData();
  let sdIndLampDataList = mainData();
  let rdIndLampDataList = mainData();

  // const prefixMake = (make) => {
  //     if (make && !make.startsWith("M/s.")) {
  //         return `M/s. ${make}`;
  //     }
  //     return make || "";
  // };

  //   const extractAndPush = (component, dataList, isLamp = false) => {
  //     const tacVal = component?.TAC_Validity?.value || "";
  //     const tacNum = component?.TAC_Number?.value || "";
  //     const cop = component?.CoP_Cert_No_with_validity_date?.value || "";
  //     const poss =
  //       component?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const make = prefixMake(component?.Make?.value);
  //     dataList.MakeList.push(make);
  //     dataList.suppNameLampList.push(make);
  //     if (tacVal && tacVal.trim() !== "NA" && tacNum && tacNum.trim() !== "NA") {
  //       if (isLamp) {
  //         dataList.validityLampList.push(tacVal);
  //         dataList.tacNumberLampList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         dataList.copCertLampList.push(c);
  //         dataList.possibleDateLampList.push(p);
  //       } else {
  //         dataList.validityList.push(tacVal);
  //         dataList.tacNumberList.push(tacNum);

  //         const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //         dataList.copCertList.push(c);
  //         dataList.possibleDateList.push(p);
  //       }
  //     }
  //   };

  //   dirIndLampList?.forEach((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active) {
  //       // Front Direction Indicator LED
  //       extractAndPush(
  //         vehDirInd?.Front_Direction_Indicator_LED_Type?.properties,
  //         fdIndLampDataList
  //       );

  //       // Side Direction Indicator LED
  //       extractAndPush(
  //         vehDirInd?.Side_Direction_Indicator?.properties,
  //         sdIndLampDataList
  //       );

  //       // Rear Direction Indicator LED
  //       extractAndPush(
  //         vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties,
  //         rdIndLampDataList
  //       );

  //       // Front Direction Indicator Bulb
  //       extractAndPush(
  //         vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties,
  //         fdIndLampDataList,
  //         true
  //       );

  //       // Rear Direction Indicator Bulb
  //       extractAndPush(
  //         vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties,
  //         rdIndLampDataList,
  //         true
  //       );
  //     }
  //   });

  // const extractAndPush = (component, dataList, isLamp = false) => {
  //     const tacVal = component?.TAC_Validity?.value || "";
  //     const tacNum = component?.TAC_Number?.value || "";
  //     const cop = component?.CoP_Cert_No_with_validity_date?.value || "";
  //     const poss = component?.Possible_date_of_submission_of_required_approval?.value || "";
  //     const make = prefixMake(component?.Make?.value);

  //     dataList.MakeList.push(make);
  //     dataList.suppNameList.push(make); // unified list name

  //     dataList.validityList.push(tacVal);
  //     dataList.tacNumberList.push(tacNum);

  //     const { cop: c, possible: p } = TACvalidationcheck(tacVal, cop, poss);
  //     dataList.copCertList.push(c);
  //     dataList.possibleDateList.push(p);
  //   };

  //   dirIndLampList?.forEach((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active) {
  //       // Front Direction Indicator LED
  //       extractAndPush(
  //         vehDirInd?.Front_Direction_Indicator_LED_Type?.properties,
  //         fdIndLampDataList
  //       );

  //       // Side Direction Indicator LED
  //       extractAndPush(
  //         vehDirInd?.Side_Direction_Indicator?.properties,
  //         sdIndLampDataList
  //       );

  //       // Rear Direction Indicator LED
  //       extractAndPush(
  //         vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties,
  //         rdIndLampDataList
  //       );

  //       // Front Direction Indicator Bulb
  //       extractAndPush(
  //         vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties,
  //         fdIndLampDataList
  //       );

  //       // Rear Direction Indicator Bulb
  //       extractAndPush(
  //         vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties,
  //         rdIndLampDataList
  //       );
  //     }
  //   });

  // // Front Direction Indicator LED
  // dirIndLampList.map((vehDirInd) => {
  //   if (vehDirInd?.supplier?.active === true) {
  //     const fdLED = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
  //     let make = fdLED?.Make?.value || "";
  //     if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //     const tacValueRaw = fdLED?.TAC_Number?.value || "";
  //     const copCertRaw = fdLED?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possibleDateRaw = fdLED?.Possible_date_of_submission_of_required_approval?.value || "";

  //     fdIndLampDataList.validityList.push(tacValueRaw);
  //     fdIndLampDataList.MakeList.push(make);
  //     fdIndLampDataList.suppNameList.push(make);

  //     const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //     fdIndLampDataList.copCertList.push(cop);
  //     fdIndLampDataList.possibleDateList.push(possible);
  //   }
  // });

  // // Side Direction Indicator LED
  // dirIndLampList.map((vehDirInd) => {
  //   if (vehDirInd?.supplier?.active === true) {
  //     const sdLED = vehDirInd?.Side_Direction_Indicator?.properties || {};
  //     let make = sdLED?.Make?.value || "";
  //     if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //     const tacValueRaw = sdLED?.TAC_Number?.value || "";
  //     const copCertRaw = sdLED?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possibleDateRaw = sdLED?.Possible_date_of_submission_of_required_approval?.value || "";

  //     sdIndLampDataList.validityList.push(tacValueRaw);
  //     sdIndLampDataList.MakeList.push(make);
  //     sdIndLampDataList.suppNameList.push(make);

  //     const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //     sdIndLampDataList.copCertList.push(cop);
  //     sdIndLampDataList.possibleDateList.push(possible);
  //   }
  // });

  // // Rear Direction Indicator LED
  // dirIndLampList.map((vehDirInd) => {
  //   if (vehDirInd?.supplier?.active === true) {
  //     const rdLED = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
  //     let make = rdLED?.Make?.value || "";
  //     if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //     const tacValueRaw = rdLED?.TAC_Number?.value || "";
  //     const copCertRaw = rdLED?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possibleDateRaw = rdLED?.Possible_date_of_submission_of_required_approval?.value || "";

  //     rdIndLampDataList.validityList.push(tacValueRaw);
  //     rdIndLampDataList.MakeList.push(make);
  //     rdIndLampDataList.suppNameList.push(make);

  //     const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //     rdIndLampDataList.copCertList.push(cop);
  //     rdIndLampDataList.possibleDateList.push(possible);
  //   }
  // });

  // // Front Direction Indicator Bulb
  // dirIndLampList.map((vehDirInd) => {
  //   if (vehDirInd?.supplier?.active === true) {
  //     const fdBulb = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
  //     let make = fdBulb?.Make?.value || "";
  //     if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //     const tacValueRaw = fdBulb?.TAC_Number?.value || "";
  //     const copCertRaw = fdBulb?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possibleDateRaw = fdBulb?.Possible_date_of_submission_of_required_approval?.value || "";

  //     fdIndLampDataList.validityLampList.push(tacValueRaw);
  //     fdIndLampDataList.MakeList.push(make);
  //     fdIndLampDataList.suppNameLampList.push(make);

  //     const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //     fdIndLampDataList.copCertLampList.push(cop);
  //     fdIndLampDataList.possibleDateLampList.push(possible);
  //   }
  // });

  // // Rear Direction Indicator Bulb
  // dirIndLampList.map((vehDirInd) => {
  //   if (vehDirInd?.supplier?.active === true) {
  //     const rdBulb = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
  //     let make = rdBulb?.Make?.value || "";
  //     if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //     const tacValueRaw = rdBulb?.TAC_Number?.value || "";
  //     const copCertRaw = rdBulb?.CoP_Cert_No_with_validity_date?.value || "";
  //     const possibleDateRaw = rdBulb?.Possible_date_of_submission_of_required_approval?.value || "";

  //     rdIndLampDataList.validityLampList.push(tacValueRaw);
  //     rdIndLampDataList.MakeList.push(make);
  //     rdIndLampDataList.suppNameLampList.push(make);

  //     const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //     rdIndLampDataList.copCertLampList.push(cop);
  //     rdIndLampDataList.possibleDateLampList.push(possible);
  //   }
  // });

  // const getFinalTAC = (tacRaw, copRaw) => {
  //     const isTacMissing = tacRaw.trim() === "";
  //     const isCopPresent = copRaw.trim() !== "";
  //     return isTacMissing && isCopPresent ? "NA" : tacRaw;
  //   };

  //   // Front Direction Indicator LED
  //   dirIndLampList.map((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {
  //       const fdLED = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
  //       let make = fdLED?.Make?.value || "";
  //       if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //       const tacValueRaw = fdLED?.TAC_Number?.value || "";
  //       const copCertRaw = fdLED?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw = fdLED?.Possible_date_of_submission_of_required_approval?.value || "";

  //       const tacValidity = getFinalTAC(tacValueRaw, copCertRaw);

  //       fdIndLampDataList.validityList.push(tacValidity);
  //       fdIndLampDataList.MakeList.push(make);
  //       fdIndLampDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //       fdIndLampDataList.copCertList.push(cop);
  //       fdIndLampDataList.possibleDateList.push(possible);
  //     }
  //   });

  //   // Side Direction Indicator LED
  //   dirIndLampList.map((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {
  //       const sdLED = vehDirInd?.Side_Direction_Indicator?.properties || {};
  //       let make = sdLED?.Make?.value || "";
  //       if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //       const tacValueRaw = sdLED?.TAC_Number?.value || "";
  //       const copCertRaw = sdLED?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw = sdLED?.Possible_date_of_submission_of_required_approval?.value || "";

  //       const tacValidity = getFinalTAC(tacValueRaw, copCertRaw);

  //       sdIndLampDataList.validityList.push(tacValidity);
  //       sdIndLampDataList.MakeList.push(make);
  //       sdIndLampDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //       sdIndLampDataList.copCertList.push(cop);
  //       sdIndLampDataList.possibleDateList.push(possible);
  //     }
  //   });

  //   // Rear Direction Indicator LED
  //   dirIndLampList.map((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {
  //       const rdLED = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
  //       let make = rdLED?.Make?.value || "";
  //       if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //       const tacValueRaw = rdLED?.TAC_Number?.value || "";
  //       const copCertRaw = rdLED?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw = rdLED?.Possible_date_of_submission_of_required_approval?.value || "";

  //       const tacValidity = getFinalTAC(tacValueRaw, copCertRaw);

  //       rdIndLampDataList.validityList.push(tacValidity);
  //       rdIndLampDataList.MakeList.push(make);
  //       rdIndLampDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //       rdIndLampDataList.copCertList.push(cop);
  //       rdIndLampDataList.possibleDateList.push(possible);
  //     }
  //   });

  //   // Front Direction Indicator Bulb
  //   dirIndLampList.map((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {
  //       const fdBulb = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
  //       let make = fdBulb?.Make?.value || "";
  //       if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //       const tacValueRaw = fdBulb?.TAC_Number?.value || "";
  //       const copCertRaw = fdBulb?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw = fdBulb?.Possible_date_of_submission_of_required_approval?.value || "";

  //       const tacValidity = getFinalTAC(tacValueRaw, copCertRaw);

  //       fdIndLampDataList.validityLampList.push(tacValidity);
  //       fdIndLampDataList.MakeList.push(make);
  //       fdIndLampDataList.suppNameLampList.push(make);

  //       const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //       fdIndLampDataList.copCertLampList.push(cop);
  //       fdIndLampDataList.possibleDateLampList.push(possible);
  //     }
  //   });

  //   // Rear Direction Indicator Bulb
  //   dirIndLampList.map((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {
  //       const rdBulb = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
  //       let make = rdBulb?.Make?.value || "";
  //       if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //       const tacValueRaw = rdBulb?.TAC_Number?.value || "";
  //       const copCertRaw = rdBulb?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw = rdBulb?.Possible_date_of_submission_of_required_approval?.value || "";

  //       const tacValidity = getFinalTAC(tacValueRaw, copCertRaw);

  //       rdIndLampDataList.validityLampList.push(tacValidity);
  //       rdIndLampDataList.MakeList.push(make);
  //       rdIndLampDataList.suppNameLampList.push(make);

  //       const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //       rdIndLampDataList.copCertLampList.push(cop);
  //       rdIndLampDataList.possibleDateLampList.push(possible);
  //     }
  //   });

  // dirIndLampList.forEach((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {
  //       // FRONT DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacValueRaw = props?.TAC_Number?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         const isTacMissing = tacValueRaw === "";
  //         const isPossibleDatePresent = possibleDateRaw !== "";

  //         let finalTAC = tacValueRaw;
  //         if (isTacMissing && isPossibleDatePresent) {
  //           finalTAC = "NA";
  //         }

  //         fdIndLampDataList.validityList.push(finalTAC);
  //         fdIndLampDataList.MakeList.push(make);
  //         fdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //         fdIndLampDataList.copCertList.push(cop);
  //         fdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // SIDE DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Side_Direction_Indicator?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacValueRaw = props?.TAC_Number?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         const isTacMissing = tacValueRaw === "";
  //         const isPossibleDatePresent = possibleDateRaw !== "";

  //         let finalTAC = tacValueRaw;
  //         if (isTacMissing && isPossibleDatePresent) {
  //           finalTAC = "NA";
  //         }

  //         sdIndLampDataList.validityList.push(finalTAC);
  //         sdIndLampDataList.MakeList.push(make);
  //         sdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //         sdIndLampDataList.copCertList.push(cop);
  //         sdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // REAR DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacValueRaw = props?.TAC_Number?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         const isTacMissing = tacValueRaw === "";
  //         const isPossibleDatePresent = possibleDateRaw !== "";

  //         let finalTAC = tacValueRaw;
  //         if (isTacMissing && isPossibleDatePresent) {
  //           finalTAC = "NA";
  //         }

  //         rdIndLampDataList.validityList.push(finalTAC);
  //         rdIndLampDataList.MakeList.push(make);
  //         rdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //         rdIndLampDataList.copCertList.push(cop);
  //         rdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // FRONT DIRECTION INDICATOR BULB
  //       {
  //         const props = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacValueRaw = props?.TAC_Number?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         const isTacMissing = tacValueRaw === "";
  //         const isPossibleDatePresent = possibleDateRaw !== "";

  //         let finalTAC = tacValueRaw;
  //         if (isTacMissing && isPossibleDatePresent) {
  //           finalTAC = "NA";
  //         }

  //         fdIndLampDataList.validityLampList.push(finalTAC);
  //         fdIndLampDataList.MakeList.push(make);
  //         fdIndLampDataList.suppNameLampList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //         fdIndLampDataList.copCertLampList.push(cop);
  //         fdIndLampDataList.possibleDateLampList.push(possible);
  //       }

  //       // REAR DIRECTION INDICATOR BULB
  //       {
  //         const props = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacValueRaw = props?.TAC_Number?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         const isTacMissing = tacValueRaw === "";
  //         const isPossibleDatePresent = possibleDateRaw !== "";

  //         let finalTAC = tacValueRaw;
  //         if (isTacMissing && isPossibleDatePresent) {
  //           finalTAC = "NA";
  //         }

  //         rdIndLampDataList.validityLampList.push(finalTAC);
  //         rdIndLampDataList.MakeList.push(make);
  //         rdIndLampDataList.suppNameLampList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //         rdIndLampDataList.copCertLampList.push(cop);
  //         rdIndLampDataList.possibleDateLampList.push(possible);
  //       }
  //     }
  //   });

  // dirIndLampList.forEach((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {

  //       // FRONT DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumber = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         fdIndLampDataList.tacNumberList.push(tacNumber);
  //         fdIndLampDataList.validityList.push(tacValidity);
  //         fdIndLampDataList.MakeList.push(make);
  //         fdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         fdIndLampDataList.copCertList.push(cop);
  //         fdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // SIDE DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Side_Direction_Indicator?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumber = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         sdIndLampDataList.tacNumberList.push(tacNumber);
  //         sdIndLampDataList.validityList.push(tacValidity);
  //         sdIndLampDataList.MakeList.push(make);
  //         sdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         sdIndLampDataList.copCertList.push(cop);
  //         sdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // REAR DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumber = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         rdIndLampDataList.tacNumberList.push(tacNumber);
  //         rdIndLampDataList.validityList.push(tacValidity);
  //         rdIndLampDataList.MakeList.push(make);
  //         rdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         rdIndLampDataList.copCertList.push(cop);
  //         rdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // FRONT DIRECTION INDICATOR BULB
  //       {
  //         const props = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumber = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         fdIndLampDataList.tacNumberLampList.push(tacNumber);
  //         fdIndLampDataList.validityLampList.push(tacValidity);
  //         fdIndLampDataList.MakeList.push(make);
  //         fdIndLampDataList.suppNameLampList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         fdIndLampDataList.copCertLampList.push(cop);
  //         fdIndLampDataList.possibleDateLampList.push(possible);
  //       }

  //       // REAR DIRECTION INDICATOR BULB
  //       {
  //         const props = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumber = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         rdIndLampDataList.tacNumberLampList.push(tacNumber);
  //         rdIndLampDataList.validityLampList.push(tacValidity);
  //         rdIndLampDataList.MakeList.push(make);
  //         rdIndLampDataList.suppNameLampList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         rdIndLampDataList.copCertLampList.push(cop);
  //         rdIndLampDataList.possibleDateLampList.push(possible);
  //       }
  //     }
  //   });

  // dirIndLampList.forEach((vehDirInd) => {
  //     if (vehDirInd?.supplier?.active === true) {

  //       // FRONT DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumberRaw = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         let finalTAC = tacNumberRaw;
  //         if (!tacNumberRaw && copCertRaw) finalTAC = "NA";

  //         fdIndLampDataList.tacNumberList.push(finalTAC);
  //         fdIndLampDataList.validityList.push(finalTAC !== "NA" ? tacValidity : "");
  //         fdIndLampDataList.MakeList.push(make);
  //         fdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         fdIndLampDataList.copCertList.push(cop);
  //         fdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // SIDE DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Side_Direction_Indicator?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumberRaw = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         let finalTAC = tacNumberRaw;
  //         if (!tacNumberRaw && copCertRaw) finalTAC = "NA";

  //         sdIndLampDataList.tacNumberList.push(finalTAC);
  //         sdIndLampDataList.validityList.push(finalTAC !== "NA" ? tacValidity : "");
  //         sdIndLampDataList.MakeList.push(make);
  //         sdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         sdIndLampDataList.copCertList.push(cop);
  //         sdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // REAR DIRECTION INDICATOR LED
  //       {
  //         const props = vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumberRaw = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         let finalTAC = tacNumberRaw;
  //         if (!tacNumberRaw && copCertRaw) finalTAC = "NA";

  //         rdIndLampDataList.tacNumberList.push(finalTAC);
  //         rdIndLampDataList.validityList.push(finalTAC !== "NA" ? tacValidity : "");
  //         rdIndLampDataList.MakeList.push(make);
  //         rdIndLampDataList.suppNameList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         rdIndLampDataList.copCertList.push(cop);
  //         rdIndLampDataList.possibleDateList.push(possible);
  //       }

  //       // FRONT DIRECTION INDICATOR BULB
  //       {
  //         const props = vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumberRaw = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         let finalTAC = tacNumberRaw;
  //         if (!tacNumberRaw && copCertRaw) finalTAC = "NA";

  //         fdIndLampDataList.tacNumberLampList.push(finalTAC);
  //         fdIndLampDataList.validityLampList.push(finalTAC !== "NA" ? tacValidity : "");
  //         fdIndLampDataList.MakeList.push(make);
  //         fdIndLampDataList.suppNameLampList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         fdIndLampDataList.copCertLampList.push(cop);
  //         fdIndLampDataList.possibleDateLampList.push(possible);
  //       }

  //       // REAR DIRECTION INDICATOR BULB
  //       {
  //         const props = vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
  //         let make = props?.Make?.value || "";
  //         if (make && !make.startsWith("M/s.")) make = `M/s. ${make}`;

  //         const tacNumberRaw = props?.TAC_Number?.value?.trim() || "";
  //         const tacValidity = props?.TAC_Validity?.value?.trim() || "";
  //         const copCertRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //         const possibleDateRaw = props?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //         let finalTAC = tacNumberRaw;
  //         if (!tacNumberRaw && copCertRaw) finalTAC = "NA";

  //         rdIndLampDataList.tacNumberLampList.push(finalTAC);
  //         rdIndLampDataList.validityLampList.push(finalTAC !== "NA" ? tacValidity : "");
  //         rdIndLampDataList.MakeList.push(make);
  //         rdIndLampDataList.suppNameLampList.push(make);

  //         const { cop, possible } = TACvalidationcheck(tacValidity, copCertRaw, possibleDateRaw);
  //         rdIndLampDataList.copCertLampList.push(cop);
  //         rdIndLampDataList.possibleDateLampList.push(possible);
  //       }
  //     }
  //   });

  dirIndLampList.forEach((vehDirInd) => {
    if (vehDirInd?.supplier?.active === true) {
      // --- Front Direction Indicator ---
      const frontLed =
        vehDirInd?.Front_Direction_Indicator_LED_Type?.properties || {};
    //   let frontLedMake = frontLed?.Make?.value || "";
    //   if (frontLedMake && !frontLedMake.startsWith("M/")) {
    //     frontLedMake = `M/s. ${frontLedMake}`;
    //   }
    let frontLedMake = makePrefix(frontLed?.Make?.value);

      const frontLedValidityRaw = frontLed?.TAC_Validity?.value?.trim() || "";
      const frontLedTacNumber = frontLed?.TAC_Number?.value || "";     
      const frontLedCopCert =
        frontLed?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const frontLedPossibleDate =
        frontLed?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      let finalFrontLedValidity = frontLedValidityRaw;
      if (!frontLedValidityRaw && frontLedPossibleDate) {
        finalFrontLedValidity = "NA";
      }

    //   if (finalFrontLedValidity !== "NA") {
    //     fdIndLampDataList.validityList.push(frontLedValidityRaw);
    //   } else {
    //     fdIndLampDataList.validityList.push("");
    //   }

    if (finalFrontLedValidity !== "NA") {
        fdIndLampDataList.validityList.push(frontLedValidityRaw);
        fdIndLampDataList.tacNumberList.push(frontLedTacNumber);
      } else {
        fdIndLampDataList.validityList.push("NA");
        fdIndLampDataList.tacNumberList.push("");
      }

      // fdIndLampDataList.validityList.push(finalFrontLedValidity);
    //   fdIndLampDataList.tacNumberList.push(frontLedTacNumber);
      fdIndLampDataList.MakeList.push(frontLedMake);
      fdIndLampDataList.suppNameList.push(frontLedMake);

      const { cop: frontCop, possible: frontPossible } = TACvalidationcheck(
        frontLedValidityRaw,
        frontLedCopCert,
        frontLedPossibleDate
      );
      fdIndLampDataList.copCertList.push(frontCop);
      fdIndLampDataList.possibleDateList.push(frontPossible);

      // --- Front Direction Indicator Bulb ---
      const frontBulb =
        vehDirInd?.Front_Direction_indicator_Bulb_Type?.properties || {};
    //   let frontBulbMake = frontBulb?.Make?.value || "";
    //   if (frontBulbMake && !frontBulbMake.startsWith("M/")) {
    //     frontBulbMake = `M/s. ${frontBulbMake}`;
    //   }
    let frontBulbMake = makePrefix(frontBulb?.Make?.value);

      const frontBulbValidityRaw = frontBulb?.TAC_Validity?.value?.trim() || "";
      const frontBulbTacNumber = frontBulb?.TAC_Number?.value || "";
      const frontBulbCopCert =
        frontBulb?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const frontBulbPossibleDate =
        frontBulb?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      let finalFrontBulbValidity = frontBulbValidityRaw;
      if (!frontBulbValidityRaw && frontBulbPossibleDate) {
        finalFrontBulbValidity = "NA";
      }

    //   if (finalFrontBulbValidity !== "NA") {
    //     fdIndLampDataList.validityLampList.push(frontBulbValidityRaw);
    //   } else {
    //     fdIndLampDataList.validityLampList.push("");
    //   }

    if (finalFrontBulbValidity !== "NA") {
        fdIndLampDataList.validityLampList.push(frontBulbValidityRaw);
        fdIndLampDataList.tacNumberLampList.push(frontBulbTacNumber);
      } else {
        fdIndLampDataList.validityLampList.push("NA");
        fdIndLampDataList.tacNumberLampList.push("");
      }

      // fdIndLampDataList.validityLampList.push(finalFrontBulbValidity);
    //   fdIndLampDataList.tacNumberLampList.push(frontBulbTacNumber);
      fdIndLampDataList.MakeList.push(frontBulbMake);
      fdIndLampDataList.suppNameLampList.push(frontBulbMake);

      const { cop: frontBulbCop, possible: frontBulbPossible } =
        TACvalidationcheck(
          frontBulbValidityRaw,
          frontBulbCopCert,
          frontBulbPossibleDate
        );
      fdIndLampDataList.copCertLampList.push(frontBulbCop);
      fdIndLampDataList.possibleDateLampList.push(frontBulbPossible);

      // --- Side Direction Indicator ---
      const sideLed = vehDirInd?.Side_Direction_Indicator?.properties || {};
    //   let sideLedMake = sideLed?.Make?.value || "";
    //   if (sideLedMake && !sideLedMake.startsWith("M/")) {
    //     sideLedMake = `M/s. ${sideLedMake}`;
    //   }
    let sideLedMake = makePrefix(sideLed?.Make?.value);

      const sideLedValidityRaw = sideLed?.TAC_Validity?.value?.trim() || "";
      const sideLedTacNumber = sideLed?.TAC_Number?.value || "";
      const sideLedCopCert =
        sideLed?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const sideLedPossibleDate =
        sideLed?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      let finalSideLedValidity = sideLedValidityRaw;
      if (!sideLedValidityRaw && sideLedPossibleDate) {
        finalSideLedValidity = "NA";
      }

    //   if (finalSideLedValidity !== "NA") {
    //     sdIndLampDataList.validityList.push(sideLedValidityRaw);
    //   } else {
    //     sdIndLampDataList.validityList.push("");
    //   }

    if (finalSideLedValidity !== "NA") {
        sdIndLampDataList.validityList.push(sideLedValidityRaw);
        sdIndLampDataList.tacNumberList.push(sideLedTacNumber);
      } else {
        sdIndLampDataList.validityList.push("NA");
        sdIndLampDataList.tacNumberList.push("");
      }

      // sdIndLampDataList.validityList.push(finalSideLedValidity);
    //   sdIndLampDataList.tacNumberList.push(sideLedTacNumber);
      sdIndLampDataList.MakeList.push(sideLedMake);
      sdIndLampDataList.suppNameList.push(sideLedMake);

      const { cop: sideCop, possible: sidePossible } = TACvalidationcheck(
        sideLedValidityRaw,
        sideLedCopCert,
        sideLedPossibleDate
      );
      sdIndLampDataList.copCertList.push(sideCop);
      sdIndLampDataList.possibleDateList.push(sidePossible);

      // --- Rear Direction Indicator ---
      const rearLed =
        vehDirInd?.Rear_Direction_Indicator_LED_Type?.properties || {};
    //   let rearLedMake = rearLed?.Make?.value || "";
    //   if (rearLedMake && !rearLedMake.startsWith("M/")) {
    //     rearLedMake = `M/s. ${rearLedMake}`;
    //   }
    let rearLedMake = makePrefix(rearLed?.Make?.value);

      const rearLedValidityRaw = rearLed?.TAC_Validity?.value?.trim() || "";
      const rearLedTacNumber = rearLed?.TAC_Number?.value || "";
      const rearLedCopCert =
        rearLed?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const rearLedPossibleDate =
        rearLed?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      let finalRearLedValidity = rearLedValidityRaw;
      if (!rearLedValidityRaw && rearLedPossibleDate) {
        finalRearLedValidity = "NA";
      }


    //   if (finalRearLedValidity !== "NA") {
    //     rdIndLampDataList.validityList.push(rearLedValidityRaw);
    //   } else {
    //     rdIndLampDataList.validityList.push("");
    //   }

    if (finalRearLedValidity !== "NA") {
        rdIndLampDataList.validityList.push(rearLedValidityRaw);
        rdIndLampDataList.tacNumberList.push(rearLedTacNumber);
      } else {
        rdIndLampDataList.validityList.push("NA");
        rdIndLampDataList.tacNumberList.push("");
      }

      // rdIndLampDataList.validityList.push(finalRearLedValidity);
    //   rdIndLampDataList.tacNumberList.push(rearLedTacNumber);
      rdIndLampDataList.MakeList.push(rearLedMake);
      rdIndLampDataList.suppNameList.push(rearLedMake);

      const { cop: rearCop, possible: rearPossible } = TACvalidationcheck(
        rearLedValidityRaw,
        rearLedCopCert,
        rearLedPossibleDate
      );
      rdIndLampDataList.copCertList.push(rearCop);
      rdIndLampDataList.possibleDateList.push(rearPossible);

      // --- Rear Direction Indicator Bulb ---
      const rearBulb =
        vehDirInd?.Rear_Direction_Indicator_Bulb_Type?.properties || {};
    //   let rearBulbMake = rearBulb?.Make?.value || "";
    //   if (rearBulbMake && !rearBulbMake.startsWith("M/")) {
    //     rearBulbMake = `M/s. ${rearBulbMake}`;
    //   }
    let rearBulbMake = makePrefix(rearBulb?.Make?.value);

      const rearBulbValidityRaw = rearBulb?.TAC_Validity?.value?.trim() || "";
      const rearBulbTacNumber = rearBulb?.TAC_Number?.value || "";
      const rearBulbCopCert =
        rearBulb?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const rearBulbPossibleDate =
        rearBulb?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      let finalRearBulbValidity = rearBulbValidityRaw;
      if (!rearBulbValidityRaw && rearBulbPossibleDate) {
        finalRearBulbValidity = "NA";
      }
    //   if (finalRearBulbValidity !== "NA") {
    //     rdIndLampDataList.validityLampList.push(rearBulbValidityRaw);
    //   } else {
    //     rdIndLampDataList.validityLampList.push("");
    //   }

    if (finalRearBulbValidity !== "NA") {
        rdIndLampDataList.validityLampList.push(rearBulbValidityRaw);
        rdIndLampDataList.tacNumberLampList.push(rearBulbTacNumber);
      } else {
        rdIndLampDataList.validityLampList.push("NA");
        rdIndLampDataList.tacNumberLampList.push("");
      }

      // rdIndLampDataList.validityLampList.push(finalRearBulbValidity);
    //   rdIndLampDataList.tacNumberLampList.push(rearBulbTacNumber);
      rdIndLampDataList.MakeList.push(rearBulbMake);
      rdIndLampDataList.suppNameLampList.push(rearBulbMake);

      const { cop: rearBulbCop, possible: rearBulbPossible } =
        TACvalidationcheck(
          rearBulbValidityRaw,
          rearBulbCopCert,
          rearBulbPossibleDate
        );
      rdIndLampDataList.copCertLampList.push(rearBulbCop);
      rdIndLampDataList.possibleDateLampList.push(rearBulbPossible);
    }
  });

  console.log("fdIndLampDataList.suppNameList", fdIndLampDataList.suppNameList);
  console.log(
    "fdIndLampDataList.tacNumberList",
    fdIndLampDataList.tacNumberList
  );
  console.log("fdIndLampDataList.MakeList", fdIndLampDataList.MakeList);
  console.log("fdIndLampDataList.tacNumberList", fdIndLampDataList.tacNumberList);
  console.log("fdIndLampDataList.validityList", fdIndLampDataList.validityList);
  console.log(
    "fdIndLampDataList.possibleDateList",
    fdIndLampDataList.possibleDateList
  );
  console.log("fdIndLampDataList.copCertList", fdIndLampDataList.copCertList);

  console.log("sdIndLampDataList.suppNameList", sdIndLampDataList.suppNameList);
  console.log(
    "sdIndLampDataList.tacNumberList",
    sdIndLampDataList.tacNumberList
  );
  console.log("sdIndLampDataList.MakeList", sdIndLampDataList.MakeList);
  console.log("sdIndLampDataList.tacNumberList", sdIndLampDataList.tacNumberList);
  console.log("sdIndLampDataList.validityList", sdIndLampDataList.validityList);
  console.log(
    "sdIndLampDataList.possibleDateList",
    sdIndLampDataList.possibleDateList
  );
  console.log("sdIndLampDataList.copCertList", sdIndLampDataList.copCertList);

  console.log("rdIndLampDataList.suppNameList", rdIndLampDataList.suppNameList);
  console.log(
    "rdIndLampDataList.tacNumberList",
    rdIndLampDataList.tacNumberList
  );
  console.log("rdIndLampDataList.MakeList", rdIndLampDataList.MakeList);
  console.log("rdIndLampDataList.tacNumberList", rdIndLampDataList.tacNumberList);
  console.log("rdIndLampDataList.validityList", rdIndLampDataList.validityList);
  console.log(
    "rdIndLampDataList.possibleDateList",
    rdIndLampDataList.possibleDateList
  );
  console.log("rdIndLampDataList.copCertList", rdIndLampDataList.copCertList);

  console.log(
    "fdIndLampDataList.suppNameLampList",
    fdIndLampDataList.suppNameLampList
  );
  console.log(
    "fdIndLampDataList.tacNumberLampList",
    fdIndLampDataList.tacNumberLampList
  );
  console.log(
    "fdIndLampDataList.validityLampList",
    fdIndLampDataList.validityLampList
  );
  console.log(
    "fdIndLampDataList.possibleDateLampList",
    fdIndLampDataList.possibleDateLampList
  );
  console.log(
    "fdIndLampDataList.copCertLampList",
    fdIndLampDataList.copCertLampList
  );

  console.log(
    "rdIndLampDataList.suppNameLampList",
    rdIndLampDataList.suppNameLampList
  );
  console.log(
    "rdIndLampDataList.tacNumberLampList",
    rdIndLampDataList.tacNumberLampList
  );
  console.log(
    "rdIndLampDataList.validityLampList",
    rdIndLampDataList.validityLampList
  );
  console.log(
    "rdIndLampDataList.possibleDateLampList",
    rdIndLampDataList.possibleDateLampList
  );
  console.log(
    "rdIndLampDataList.copCertLampList",
    rdIndLampDataList.copCertLampList
  );

  // const revLampList = form8Data?.Reversing_Lamp?.ReversingLamp;

  // let revLampDataList = mainData();
  // //     revLampList.map(vehRevLamp => {
  // //         if (vehRevLamp.supplier.active === true) {
  // //             let supplierName = vehRevLamp?.supplier?.nameOfSupplier;

  // //             // Modify supplierName directly
  // //             if (!supplierName.startsWith("M/")) {
  // //                 supplierName = `M/s. ${supplierName}`;
  // //             }

  // //             // revLampDataList.suppNameList.push(supplierName);
  // //             // // revLampDataList.suppNameList.push(vehRevLamp?.supplier?.nameOfSupplier);
  // //             // revLampDataList.validityList.push(vehRevLamp?.Reversing_Lamp?.properties?.TAC_Validity?.value);
  // //             // Get the validity value for Reversing Lamp
  // //             const revLampValidityValue = vehRevLamp?.Reversing_Lamp?.properties?.CoP_Cert_No_with_validity_date?.value;

  // //             // Push the validity value to revLampDataList
  // //             revLampDataList.copCertList.push(revLampValidityValue);

  // //             // Check if validity data is present
  // //             // revLampDataList.suppNameList.push(revLampValidityValue ? supplierName : "");
  // //             // revLampDataList.suppNameList.push(revLampValidityValue === "NA" ? "" : supplierName);
  // //             if (revLampValidityValue && revLampValidityValue.trim() !== "NA") {
  // //                 revLampDataList.suppNameList.push(supplierName);
  // //             }

  // //             revLampDataList.possibleDateList.push(vehRevLamp?.Reversing_Lamp?.properties?.Possible_date_of_submission_of_required_approval?.value);
  // //             // revLampDataList.copCertList.push(vehRevLamp?.Reversing_Lamp?.properties?.CoP_Cert_No_with_validity_date?.value);
  // //             revLampDataList.validityList.push(vehRevLamp?.Reversing_Lamp?.properties?.TAC_Validity?.value);
  // //             // revLampDataList.tacNumberList.push(vehRevLamp?.Reversing_Lamp?.properties?.TAC_Number?.value);

  // //             // revLampDataList.validityLampList.push(vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.TAC_Validity?.value);
  // //             // Get the TAC Validity value for Reverse Lamp
  // // const revLampTACValue = vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value;

  // // // Push the TAC value to revLampDataList
  // // revLampDataList.copCertLampList.push(revLampTACValue);

  // // // Check if TAC value is present
  // // // revLampDataList.suppNameLampList.push(revLampTACValue ? supplierName : "");
  // // // revLampDataList.suppNameLampList.push(revLampTACValue === "NA" ? "" : supplierName);
  // // if (revLampTACValue && revLampTACValue.trim() !== "NA") {
  // //     revLampDataList.suppNameLampList.push(supplierName);
  // // }

  // //             revLampDataList.possibleDateLampList.push(vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  // //             // revLampDataList.copCertLampList.push(vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value);
  // //             revLampDataList.validityLampList.push(vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.TAC_Validity?.value);
  // //             // revLampDataList.tacNumberLampList.push(vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.TAC_Number?.value);
  // //         }
  // //     });

  // revLampList?.forEach(vehRevLamp => {
  //     if (vehRevLamp?.supplier?.active === true) {
  //         let supplierName = vehRevLamp?.supplier?.nameOfSupplier || "";

  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // ==== List (Reversing_Lamp) ====
  //         if (!twoWheeler) {
  //             const revLampValidityValue = vehRevLamp?.Reversing_Lamp?.properties?.CoP_Cert_No_with_validity_date?.value?.trim();
  //             if (revLampValidityValue && revLampValidityValue !== "NA") {
  //                 revLampDataList.suppNameList.push(supplierName);
  //             }

  //             revLampDataList.copCertList.push(revLampValidityValue || "NA");
  //             revLampDataList.MakeList.push(
  //                 vehRevLamp?.Reversing_Lamp?.properties?.Make?.value || "NA"
  //             );
  //             revLampDataList.possibleDateList.push(
  //                 vehRevLamp?.Reversing_Lamp?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //             );
  //             revLampDataList.validityList.push(
  //                 vehRevLamp?.Reversing_Lamp?.properties?.TAC_Validity?.value || "NA"
  //             );
  //         } else {
  //             // For twoWheeler: push "NA" only once
  //             if (revLampDataList.suppNameList.length === 0) {
  //                 revLampDataList.suppNameList.push("NA");
  //                 revLampDataList.copCertList.push("NA");
  //                 revLampDataList.possibleDateList.push("NA");
  //                 revLampDataList.validityList.push("NA");
  //             }
  //         }

  //         // ==== LampList (Reverse_Lamp_Bulb_Type) ====
  //         const revLampTACValue = vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.CoP_Cert_No_with_validity_date?.value?.trim();
  //         if (revLampTACValue && revLampTACValue !== "NA") {
  //             revLampDataList.suppNameLampList.push(supplierName);
  //         }

  //         revLampDataList.copCertLampList.push(revLampTACValue || "NA");
  //         revLampDataList.MakeList.push(
  //             vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.Make?.value || "NA"
  //         );
  //         revLampDataList.possibleDateLampList.push(
  //             vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //         );
  //         revLampDataList.validityLampList.push(
  //             vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties?.TAC_Validity?.value || "NA"
  //         );
  //     }
  // });

  // const revLampList = form8Data?.Reversing_Lamp?.ReversingLamp;
  // let revLampDataList = mainData();

  // revLampList?.forEach(vehRevLamp => {
  //     if (vehRevLamp?.supplier?.active === true) {
  //         const revLampProps = vehRevLamp?.Reversing_Lamp?.properties || {};
  //         let revLampMake = revLampProps?.Make?.value || "NA";
  //         const revLampCoP = revLampProps?.CoP_Cert_No_with_validity_date?.value?.trim();

  //         // Add "M/s." prefix if not starting with "M/"
  //         if (revLampMake && !revLampMake.startsWith("M/") && revLampMake !== "NA") {
  //             revLampMake = `M/s. ${revLampMake}`;
  //         }

  //         // ==== List (Reversing_Lamp) ====
  //         if (!twoWheeler) {
  //             if (revLampCoP && revLampCoP !== "NA") {
  //                 revLampDataList.suppNameList.push(revLampMake); // use Make with prefix
  //             }

  //             revLampDataList.copCertList.push(revLampCoP || "NA");
  //             revLampDataList.MakeList.push(revLampMake);
  //             revLampDataList.tacNumberList.push(
  //                 revLampProps?.TAC_Number?.value || "NA"
  //             );
  //             revLampDataList.possibleDateList.push(
  //                 revLampProps?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //             );
  //             revLampDataList.validityList.push(
  //                 revLampProps?.TAC_Validity?.value || "NA"
  //             );
  //         } else {
  //             if (revLampDataList.suppNameList.length === 0) {
  //                 revLampDataList.suppNameList.push("NA");
  //                 revLampDataList.copCertList.push("NA");
  //                 revLampDataList.MakeList.push("NA");
  //                 revLampDataList.possibleDateList.push("NA");
  //                 revLampDataList.validityList.push("NA");
  //             }
  //         }

  //         // ==== LampList (Reverse_Lamp_Bulb_Type) ====
  //         const bulbProps = vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties || {};
  //         let bulbMake = bulbProps?.Make?.value || "NA";
  //         const bulbCoP = bulbProps?.CoP_Cert_No_with_validity_date?.value?.trim();

  //         if (bulbMake && !bulbMake.startsWith("M/") && bulbMake !== "NA") {
  //             bulbMake = `M/s. ${bulbMake}`;
  //         }

  //         if (bulbCoP && bulbCoP !== "NA") {
  //             revLampDataList.suppNameLampList.push(bulbMake);
  //         }

  //         revLampDataList.copCertLampList.push(bulbCoP || "NA");
  //         revLampDataList.MakeList.push(bulbMake);
  //         revLampDataList.tacNumberLampList.push(
  //             bulbProps?.TAC_Number?.value || "NA"
  //         );
  //         revLampDataList.possibleDateLampList.push(
  //             bulbProps?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //         );
  //         revLampDataList.validityLampList.push(
  //             bulbProps?.TAC_Validity?.value || "NA"
  //         );
  //     }
  // });

  //   const revLampList = form8Data?.Reversing_Lamp?.ReversingLamp || [];
  //   let revLampDataList = mainData();

  //   revLampList.forEach((vehRevLamp) => {
  //     if (vehRevLamp?.supplier?.active === true) {
  //       // --- Reversing Lamp ---
  //       const revLamp = vehRevLamp?.Reversing_Lamp?.properties || {};
  //       let revLampMake = revLamp?.Make?.value || "";
  //       if (revLampMake && !revLampMake.startsWith("M/")) {
  //         revLampMake = `M/s. ${revLampMake}`;
  //       }

  //       const revLampValidity = revLamp?.TAC_Validity?.value || "";
  //       const revLampCopCert =
  //         revLamp?.CoP_Cert_No_with_validity_date?.value || "";
  //       const revLampPossibleDate =
  //         revLamp?.Possible_date_of_submission_of_required_approval?.value || "";

  //       revLampDataList.validityList.push(revLampValidity);
  //       revLampDataList.tacNumberList.push(revLamp?.TAC_Number?.value || "");
  //       revLampDataList.MakeList.push(revLampMake);
  //       revLampDataList.suppNameList.push(revLampMake);

  //       const { cop, possible } = TACvalidationcheck(
  //         revLampValidity,
  //         revLampCopCert,
  //         revLampPossibleDate
  //       );
  //       revLampDataList.copCertList.push(cop);
  //       revLampDataList.possibleDateList.push(possible);

  //       // --- Reverse Lamp Bulb ---
  //       const revBulb = vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties || {};
  //       let revBulbMake = revBulb?.Make?.value || "";
  //       if (revBulbMake && !revBulbMake.startsWith("M/")) {
  //         revBulbMake = `M/s. ${revBulbMake}`;
  //       }

  //       const revBulbValidity = revBulb?.TAC_Validity?.value || "";
  //       const revBulbCopCert =
  //         revBulb?.CoP_Cert_No_with_validity_date?.value || "";
  //       const revBulbPossibleDate =
  //         revBulb?.Possible_date_of_submission_of_required_approval?.value || "";

  //       revLampDataList.validityLampList.push(revBulbValidity);
  //       revLampDataList.MakeList.push(revBulbMake);
  //       revLampDataList.suppNameLampList.push(revBulbMake);
  //       revLampDataList.tacNumberLampList.push(revBulb?.TAC_Number?.value || "");
  //       const { cop: bulbCop, possible: bulbPossible } = TACvalidationcheck(
  //         revBulbValidity,
  //         revBulbCopCert,
  //         revBulbPossibleDate
  //       );
  //       revLampDataList.copCertLampList.push(bulbCop);
  //       revLampDataList.possibleDateLampList.push(bulbPossible);
  //     }
  //   });

  const revLampList = form8Data?.Reversing_Lamp?.ReversingLamp || [];
  let revLampDataList = mainData();

  revLampList.forEach((vehRevLamp) => {
    if (vehRevLamp?.supplier?.active === true) {
      // --- Reversing Lamp ---
      const revLamp = vehRevLamp?.Reversing_Lamp?.properties || {};
    //   let revLampMake = revLamp?.Make?.value || "";
    //   if (revLampMake && !revLampMake.startsWith("M/")) {
    //     revLampMake = `M/s. ${revLampMake}`;
    //   }
    let revLampMake = makePrefix(revLamp?.Make?.value);

      const revLampValidityRaw = revLamp?.TAC_Validity?.value?.trim() || "";
      const revLampTacNumber = revLamp?.TAC_Number?.value || "";
      const revLampCopCert =
        revLamp?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const revLampPossibleDate =
        revLamp?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      // Fallback logic for Reversing Lamp TAC
      let finalRevLampValidity = revLampValidityRaw;
      if (!revLampValidityRaw && revLampPossibleDate) {
        finalRevLampValidity = "NA";
      }

    //   if (finalRevLampValidity !== "NA") {
    //     revLampDataList.validityList.push(revLampValidityRaw);
    //   } else {
    //     revLampDataList.validityList.push("");
    //   }

    if (finalRevLampValidity !== "NA") {
        revLampDataList.validityList.push(finalRevLampValidity);
        revLampDataList.tacNumberList.push(revLampTacNumber);
      } else {
        revLampDataList.validityList.push("NA");
        revLampDataList.tacNumberList.push("");
      }

      // revLampDataList.validityList.push(finalRevLampValidity);
    //   revLampDataList.tacNumberList.push(revLampTacNumber);
      revLampDataList.MakeList.push(revLampMake);
      revLampDataList.suppNameList.push(revLampMake);

      const { cop, possible } = TACvalidationcheck(
        revLampValidityRaw,
        revLampCopCert,
        revLampPossibleDate
      );
      revLampDataList.copCertList.push(cop);
      revLampDataList.possibleDateList.push(possible);

      // --- Reverse Lamp Bulb ---
      const revBulb = vehRevLamp?.Reverse_Lamp_Bulb_Type?.properties || {};
    //   let revBulbMake = revBulb?.Make?.value || "";
    //   if (revBulbMake && !revBulbMake.startsWith("M/")) {
    //     revBulbMake = `M/s. ${revBulbMake}`;
    //   }
    let revBulbMake = makePrefix(revBulb?.Make?.value);

      const revBulbValidityRaw = revBulb?.TAC_Validity?.value?.trim() || "";
      const revBulbTacNumber = revBulb?.TAC_Number?.value || "";
      const revBulbCopCert =
        revBulb?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const revBulbPossibleDate =
        revBulb?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      // Fallback logic for Bulb TAC
      let finalRevBulbValidity = revBulbValidityRaw;
      if (!revBulbValidityRaw && revBulbPossibleDate) {
        finalRevBulbValidity = "NA";
      }


    //   if (finalRevBulbValidity !== "NA") {
    //     revLampDataList.validityLampList.push(revBulbValidityRaw);
    //   } else {
    //     revLampDataList.validityLampList.push("");
    //   }

 if (finalRevBulbValidity !== "NA") {
    revLampDataList.validityLampList.push(finalRevBulbValidity);
        revLampDataList.tacNumberLampList.push(revBulbTacNumber);
      } else {
        revLampDataList.validityLampList.push("NA");
        revLampDataList.tacNumberLampList.push("");
      }

      // revLampDataList.validityLampList.push(finalRevBulbValidity);
    //   revLampDataList.tacNumberLampList.push(revBulbTacNumber);
      revLampDataList.MakeList.push(revBulbMake);
      revLampDataList.suppNameLampList.push(revBulbMake);

      const { cop: bulbCop, possible: bulbPossible } = TACvalidationcheck(
        revBulbValidityRaw,
        revBulbCopCert,
        revBulbPossibleDate
      );
      revLampDataList.copCertLampList.push(bulbCop);
      revLampDataList.possibleDateLampList.push(bulbPossible);
    }
  });

  console.log("revlampdatalist.suppNameList", revLampDataList.suppNameList);
  console.log("revlampdatalist.copCertList", revLampDataList.copCertList);
  console.log("revlampdatalist.MakeList", revLampDataList.MakeList);
  console.log(
    "revlampdatalist.possibleDateList",
    revLampDataList.possibleDateList
  );
  console.log("revlampdatalist.validityList", revLampDataList.validityList);
  console.log("revlampdatalist.tacNumberList", revLampDataList.tacNumberList);

  // const rrpLampList = form8Data?.Rear_Registration_Plate_lamp?.RearRegistrationPlatelamp;
  // let rrpLampDataList = mainData();
  // rrpLampList.map(vehRRPLamp => {
  //     if (vehRRPLamp.supplier.active === true) {
  //         let supplierName = vehRRPLamp?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // rrpLampDataList.suppNameList.push(supplierName);
  //         // // rrpLampDataList.suppNameList.push(vehRRPLamp?.supplier?.nameOfSupplier);
  //         // rrpLampDataList.validityList.push(vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties?.TAC_Validity?.value);
  //         // Get the validity value for Registration Plate Lamp
  //         const rrpLampValidityValue = vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties?.TAC_Number?.value;

  //         // Push the validity value to rrpLampDataList
  //         rrpLampDataList.tacNumberList.push(rrpLampValidityValue);

  //         // Check if validity data is present
  //         // rrpLampDataList.suppNameList.push(rrpLampValidityValue ? supplierName : "");
  //         // rrpLampDataList.suppNameList.push(rrpLampValidityValue === "NA" ? "" : supplierName);
  //         if (rrpLampValidityValue && rrpLampValidityValue.trim() !== "NA") {
  //             rrpLampDataList.suppNameList.push(supplierName);
  //         }

  //         rrpLampDataList.MakeList.push(vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties?.Make?.value);
  //         rrpLampDataList.validityList.push(vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties?.TAC_Validity?.value);
  //         // rrpLampDataList.tacNumberList.push(vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties?.TAC_Number?.value);
  //         rrpLampDataList.possibleDateList.push(vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rrpLampDataList.copCertList.push(vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         // rrpLampDataList.validityLampList.push(vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties?.TAC_Validity?.value);
  //         // Get the TAC Validity value for Registration Plate Lamp
  //         const rrpLampTACValue = vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties?.TAC_Number?.value;

  //         // Push the TAC value to rrpLampDataList
  //         rrpLampDataList.tacNumberLampList.push(rrpLampTACValue);

  //         // Check if TAC value is present
  //         // rrpLampDataList.suppNameLampList.push(rrpLampTACValue ? supplierName : "");
  //         // rrpLampDataList.suppNameLampList.push(rrpLampTACValue === "NA" ? "" : supplierName);
  //         if (rrpLampTACValue && rrpLampTACValue.trim() !== "NA") {
  //             rrpLampDataList.suppNameLampList.push(supplierName);
  //         }

  //         rrpLampDataList.MakeList.push(vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties?.Make?.value);
  //         rrpLampDataList.validityLampList.push(vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties?.TAC_Validity?.value);
  //         // rrpLampDataList.tacNumberLampList.push(vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties?.TAC_Number?.value);
  //         rrpLampDataList.possibleDateLampList.push(vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rrpLampDataList.copCertLampList.push(vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const rrpLampList = form8Data?.Rear_Registration_Plate_lamp?.RearRegistrationPlatelamp || [];
  // let rrpLampDataList = mainData();

  // rrpLampList.forEach(vehRRPLamp => {
  //     if (vehRRPLamp.supplier?.active) {
  //         // For LED Type
  //         const ledType = vehRRPLamp.Registration_Plate_Lamp_LED_Type?.properties || {};
  //         let ledMake = ledType.Make?.value || "";

  //         if (ledMake && !ledMake.startsWith("M/")) {
  //             ledMake = `M/s. ${ledMake}`;
  //         }

  //         const rrpLampValidityValue = ledType.TAC_Number?.value;
  //         rrpLampDataList.tacNumberList.push(rrpLampValidityValue);

  //         if (rrpLampValidityValue && rrpLampValidityValue.trim() !== "NA") {
  //             rrpLampDataList.suppNameList.push(ledMake);
  //         }

  //         rrpLampDataList.MakeList.push(ledMake);
  //         rrpLampDataList.validityList.push(ledType.TAC_Validity?.value);
  //         rrpLampDataList.possibleDateList.push(ledType.Possible_date_of_submission_of_required_approval?.value);
  //         rrpLampDataList.copCertList.push(ledType.CoP_Cert_No_with_validity_date?.value);

  //         // For Bulb Type
  //         const bulbType = vehRRPLamp.Registration_Plate_Lamp_bulb_type?.properties || {};
  //         let bulbMake = bulbType.Make?.value || "";

  //         if (bulbMake && !bulbMake.startsWith("M/")) {
  //             bulbMake = `M/s. ${bulbMake}`;
  //         }

  //         const rrpLampTACValue = bulbType.TAC_Number?.value;
  //         rrpLampDataList.tacNumberLampList.push(rrpLampTACValue);

  //         if (rrpLampTACValue && rrpLampTACValue.trim() !== "NA") {
  //             rrpLampDataList.suppNameLampList.push(bulbMake);
  //         }

  //         rrpLampDataList.MakeList.push(bulbMake);
  //         rrpLampDataList.validityLampList.push(bulbType.TAC_Validity?.value);
  //         rrpLampDataList.possibleDateLampList.push(bulbType.Possible_date_of_submission_of_required_approval?.value);
  //         rrpLampDataList.copCertLampList.push(bulbType.CoP_Cert_No_with_validity_date?.value);

  //         console.log('rrpLampDataList.tacNumberList', rrpLampDataList.tacNumberList);
  //         console.log('rrpLampDataList.suppNameList', rrpLampDataList.suppNameList);
  //         console.log('rrpLampDataList.MakeList', rrpLampDataList.MakeList);
  //         console.log('rrpLampDataList.validityList', rrpLampDataList.validityList);
  //         console.log('rrpLampDataList.possibleDateList', rrpLampDataList.possibleDateList);
  //         console.log('rrpLampDataList.copCertList', rrpLampDataList.copCertList);

  //         console.log('rrpLampDataList.tacNumberLampList', rrpLampDataList.tacNumberLampList);
  //         console.log('rrpLampDataList.suppNameLampList', rrpLampDataList.suppNameLampList);
  //         console.log('rrpLampDataList.validityLampList', rrpLampDataList.validityLampList);
  //         console.log('rrpLampDataList.possibleDateLampList', rrpLampDataList.possibleDateLampList);
  //         console.log('rrpLampDataList.copCertLampList', rrpLampDataList.copCertLampList);
  //     }
  // });

  // const rrpLampList = form8Data?.Rear_Registration_Plate_lamp?.RearRegistrationPlatelamp || [];
  // let rrpLampDataList = mainData();

  // rrpLampList.forEach(vehRRPLamp => {
  //     if (vehRRPLamp.supplier?.active) {
  //         // For LED Type
  //         const ledType = vehRRPLamp.Registration_Plate_Lamp_LED_Type?.properties || {};
  //         let ledMake = ledType.Make?.value || "";

  //         if (ledMake && !ledMake.startsWith("M/")) {
  //             ledMake = `M/s. ${ledMake}`;
  //         }

  //         const validityLed = parseAndCheckTACValidity(ledType.TAC_Validity?.value);
  //         const rrpLampValidityValue = ledType.TAC_Number?.value;
  //         rrpLampDataList.tacNumberList.push(rrpLampValidityValue);

  //         if (rrpLampValidityValue && rrpLampValidityValue.trim() !== "NA") {
  //             rrpLampDataList.suppNameList.push(ledMake);
  //         }

  //         rrpLampDataList.MakeList.push(ledMake);
  //         rrpLampDataList.validityList.push(ledType.TAC_Validity?.value);
  //         rrpLampDataList.possibleDateList.push(
  //             !validityLed.expired
  //                 ? ledType.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         rrpLampDataList.copCertList.push(
  //             !validityLed.expired
  //                 ? ledType.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );

  //         // For Bulb Type
  //         const bulbType = vehRRPLamp.Registration_Plate_Lamp_bulb_type?.properties || {};
  //         let bulbMake = bulbType.Make?.value || "";

  //         if (bulbMake && !bulbMake.startsWith("M/")) {
  //             bulbMake = `M/s. ${bulbMake}`;
  //         }

  //         const validityBulb = parseAndCheckTACValidity(bulbType.TAC_Validity?.value);
  //         const rrpLampTACValue = bulbType.TAC_Number?.value;
  //         rrpLampDataList.tacNumberLampList.push(rrpLampTACValue);

  //         if (rrpLampTACValue && rrpLampTACValue.trim() !== "NA") {
  //             rrpLampDataList.suppNameLampList.push(bulbMake);
  //         }

  //         rrpLampDataList.MakeList.push(bulbMake);
  //         rrpLampDataList.validityLampList.push(bulbType.TAC_Validity?.value);
  //         rrpLampDataList.possibleDateLampList.push(
  //             !validityBulb.expired
  //                 ? bulbType.Possible_date_of_submission_of_required_approval?.value
  //                 : "NA"
  //         );
  //         rrpLampDataList.copCertLampList.push(
  //             !validityBulb.expired
  //                 ? bulbType.CoP_Cert_No_with_validity_date?.value
  //                 : "NA"
  //         );

  //         console.log('rrpLampDataList.tacNumberList', rrpLampDataList.tacNumberList);
  //         console.log('rrpLampDataList.suppNameList', rrpLampDataList.suppNameList);
  //         console.log('rrpLampDataList.MakeList', rrpLampDataList.MakeList);
  //         console.log('rrpLampDataList.validityList', rrpLampDataList.validityList);
  //         console.log('rrpLampDataList.possibleDateList', rrpLampDataList.possibleDateList);
  //         console.log('rrpLampDataList.copCertList', rrpLampDataList.copCertList);

  //         console.log('rrpLampDataList.tacNumberLampList', rrpLampDataList.tacNumberLampList);
  //         console.log('rrpLampDataList.suppNameLampList', rrpLampDataList.suppNameLampList);
  //         console.log('rrpLampDataList.validityLampList', rrpLampDataList.validityLampList);
  //         console.log('rrpLampDataList.possibleDateLampList', rrpLampDataList.possibleDateLampList);
  //         console.log('rrpLampDataList.copCertLampList', rrpLampDataList.copCertLampList);
  //     }
  // });

  //   const rrpLampList =
  //     form8Data?.Rear_Registration_Plate_lamp?.RearRegistrationPlatelamp || [];
  //   let rrpLampDataList = mainData();

  //   rrpLampList.forEach((vehRRPLamp) => {
  //     if (vehRRPLamp?.supplier?.active === true) {
  //       // --- LED Type ---
  //       const ledType =
  //         vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties || {};
  //       let ledMake = ledType?.Make?.value || "";
  //       if (ledMake && !ledMake.startsWith("M/")) {
  //         ledMake = `M/s. ${ledMake}`;
  //       }

  //       const tacValidityLed = ledType?.TAC_Validity?.value || "";
  //       const tacNumberLed = ledType?.TAC_Number?.value || "";
  //       const copCertLed = ledType?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateLed =
  //         ledType?.Possible_date_of_submission_of_required_approval?.value || "";

  //       rrpLampDataList.validityList.push(tacValidityLed);
  //       rrpLampDataList.tacNumberList.push(tacNumberLed);
  //       rrpLampDataList.MakeList.push(ledMake);
  //       rrpLampDataList.suppNameList.push(ledMake);

  //       const { cop, possible } = TACvalidationcheck(
  //         tacValidityLed,
  //         copCertLed,
  //         possibleDateLed
  //       );
  //       rrpLampDataList.copCertList.push(cop);
  //       rrpLampDataList.possibleDateList.push(possible);

  //       // --- Bulb Type ---
  //       const bulbType =
  //         vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties || {};
  //       let bulbMake = bulbType?.Make?.value || "";
  //       if (bulbMake && !bulbMake.startsWith("M/")) {
  //         bulbMake = `M/s. ${bulbMake}`;
  //       }

  //       const tacValidityBulb = bulbType?.TAC_Validity?.value || "";
  //       const tacNumberBulb = bulbType?.TAC_Number?.value || "";
  //       const copCertBulb = bulbType?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateBulb =
  //         bulbType?.Possible_date_of_submission_of_required_approval?.value || "";

  //       rrpLampDataList.validityLampList.push(tacValidityBulb);
  //       rrpLampDataList.tacNumberLampList.push(tacNumberBulb);
  //       rrpLampDataList.MakeList.push(bulbMake);
  //       rrpLampDataList.suppNameLampList.push(bulbMake);

  //       const { cop: bulbCop, possible: bulbPossible } = TACvalidationcheck(
  //         tacValidityBulb,
  //         copCertBulb,
  //         possibleDateBulb
  //       );
  //       rrpLampDataList.copCertLampList.push(bulbCop);
  //       rrpLampDataList.possibleDateLampList.push(bulbPossible);
  //     }
  //   });

  const rrpLampList =
    form8Data?.Rear_Registration_Plate_lamp?.RearRegistrationPlatelamp || [];
  let rrpLampDataList = mainData();

  rrpLampList.forEach((vehRRPLamp) => {
    if (vehRRPLamp?.supplier?.active === true) {
      // --- LED Type ---
      const ledType =
        vehRRPLamp?.Registration_Plate_Lamp_LED_Type?.properties || {};
    //   let ledMake = ledType?.Make?.value || "";
    //   if (ledMake && !ledMake.startsWith("M/")) {
    //     ledMake = `M/s. ${ledMake}`;
    //   }
    let ledMake = makePrefix(ledType?.Make?.value);

      const tacValidityLed = ledType?.TAC_Validity?.value || "";
      const tacNumberLed = ledType?.TAC_Number?.value || "";
      const copCertLed = ledType?.CoP_Cert_No_with_validity_date?.value || "";
      const possibleDateLed =
        ledType?.Possible_date_of_submission_of_required_approval?.value || "";

    //   const isTacLedMissing = tacNumberLed === "";
    //   const isPossibleDateLed = possibleDateLed !== "";

    //   let finalTACLed = tacNumberLed;
    //   if (isTacLedMissing && isPossibleDateLed) {
    //     finalTACLed = "NA";
    //   }

      let finalValidityLed=tacValidityLed;
      if(!tacValidityLed && possibleDateLed){
        finalValidityLed="NA";
      }

    //   if (finalTACLed !== "NA") {
    //     rrpLampDataList.validityList.push(tacValidityLed);
    //   } else {
    //     rrpLampDataList.validityList.push(""); // or skip pushing completely, your choice
    //   }

    if (finalValidityLed !== "NA") {
        rrpLampDataList.validityList.push(finalValidityLed);
        rrpLampDataList.tacNumberList.push(tacNumberLed);
      } else {
        rrpLampDataList.validityList.push("NA");
        rrpLampDataList.tacNumberList.push("");
      }


      // rrpLampDataList.validityList.push(tacValidityLed);
    //   rrpLampDataList.tacNumberList.push(finalTACLed);
      rrpLampDataList.MakeList.push(ledMake);
      rrpLampDataList.suppNameList.push(ledMake);

      const { cop: ledCop, possible: ledPossible } = TACvalidationcheck(
        tacValidityLed,
        copCertLed,
        possibleDateLed
      );
      rrpLampDataList.copCertList.push(ledCop);
      rrpLampDataList.possibleDateList.push(ledPossible);

      // --- Bulb Type ---
      const bulbType =
        vehRRPLamp?.Registration_Plate_Lamp_bulb_type?.properties || {};
    //   let bulbMake = bulbType?.Make?.value || "";
    //   if (bulbMake && !bulbMake.startsWith("M/")) {
    //     bulbMake = `M/s. ${bulbMake}`;
    //   }
    let bulbMake = makePrefix(bulbType?.Make?.value);

      const tacValidityBulb = bulbType?.TAC_Validity?.value || "";
      const tacNumberBulb = bulbType?.TAC_Number?.value || "";
      const copCertBulb = bulbType?.CoP_Cert_No_with_validity_date?.value || "";
      const possibleDateBulb =
        bulbType?.Possible_date_of_submission_of_required_approval?.value || "";

    //   const isTacBulbMissing = tacNumberBulb === "";
    //   const isPossibleDateBulb = possibleDateBulb !== "";

    //   let finalTACBulb = tacNumberBulb;
    //   if (isTacBulbMissing && isPossibleDateBulb) {
    //     finalTACBulb = "NA";
    //   }

    //   if (finalTACBulb !== "NA") {
    //     rrpLampDataList.validityLampList.push(tacValidityBulb);
    //   } else {
    //     rrpLampDataList.validityLampList.push(""); // or skip if you handle index mapping
    //   }


    let finalValiditybulb=tacValidityBulb;
    if(!tacValidityBulb && possibleDateBulb){
        finalValiditybulb="NA";
    }


    if (finalValiditybulb !== "NA") {
        rrpLampDataList.validityLampList.push(finalValiditybulb);
        rrpLampDataList.tacNumberLampList.push(tacNumberBulb);
      } else {
        rrpLampDataList.validityLampList.push("NA");
        rrpLampDataList.tacNumberLampList.push("");
      }


      // rrpLampDataList.validityLampList.push(tacValidityBulb);
    //   rrpLampDataList.tacNumberLampList.push(finalTACBulb);
      rrpLampDataList.MakeList.push(bulbMake);
      rrpLampDataList.suppNameLampList.push(bulbMake);

      const { cop: bulbCop, possible: bulbPossible } = TACvalidationcheck(
        tacValidityBulb,
        copCertBulb,
        possibleDateBulb
      );
      rrpLampDataList.copCertLampList.push(bulbCop);
      rrpLampDataList.possibleDateLampList.push(bulbPossible);
    }
  });

  console.log("rrpLampDataList.tacNumberList", rrpLampDataList.tacNumberList);
  console.log("rrpLampDataList.suppNameList", rrpLampDataList.suppNameList);
  console.log("rrpLampDataList.MakeList", rrpLampDataList.MakeList);
  console.log("rrpLampDataList.validityList", rrpLampDataList.validityList);
  console.log(
    "rrpLampDataList.possibleDateList",
    rrpLampDataList.possibleDateList
  );
  console.log("rrpLampDataList.copCertList", rrpLampDataList.copCertList);

  console.log(
    "rrpLampDataList.tacNumberLampList",
    rrpLampDataList.tacNumberLampList
  );
  console.log(
    "rrpLampDataList.suppNameLampList",
    rrpLampDataList.suppNameLampList
  );
  console.log(
    "rrpLampDataList.validityLampList",
    rrpLampDataList.validityLampList
  );
  console.log(
    "rrpLampDataList.possibleDateLampList",
    rrpLampDataList.possibleDateLampList
  );
  console.log(
    "rrpLampDataList.copCertLampList",
    rrpLampDataList.copCertLampList
  );

  // const hydrBrakeHoseList = form8Data?.Hydraulic_Brake_Hose?.HydraulicBrakeHose;
  // let hydrBrkHoseDataList = mainData();
  // hydrBrakeHoseList.map(vehHydr => {
  //     if (vehHydr.supplier.active === true) {
  //         let supplierName = vehHydr?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // hydrBrkHoseDataList.suppNameList.push(supplierName);
  //         // // hydrBrkHoseDataList.suppNameList.push(vehHydr?.supplier?.nameOfSupplier);
  //         // hydrBrkHoseDataList.validityList.push(vehHydr?.Hydraulic_Brake_Hose?.properties?.TAC_Number?.value);
  //         // Get the validity value for Hydraulic Brake Hose (using TAC_Number)
  //         const hydrBrkHoseTACValue = vehHydr?.Hydraulic_Brake_Hose?.properties?.TAC_Number?.value;

  //         // Push the validity value to hydrBrkHoseDataList
  //         hydrBrkHoseDataList.validityList.push(hydrBrkHoseTACValue);

  //         // Check if validity data is present
  //         // hydrBrkHoseDataList.suppNameList.push(hydrBrkHoseTACValue ? supplierName : "");
  //         // hydrBrkHoseDataList.suppNameList.push(hydrBrkHoseTACValue === "NA" ? "" : supplierName);

  //         if (hydrBrkHoseTACValue && hydrBrkHoseTACValue.trim() !== "") {
  //             hydrBrkHoseDataList.suppNameList.push(supplierName);
  //         }
  //         hydrBrkHoseDataList.MakeList.push(vehHydr?.Hydraulic_Brake_Hose?.properties?.Make?.value);

  //         hydrBrkHoseDataList.possibleDateList.push(vehHydr?.Hydraulic_Brake_Hose?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         hydrBrkHoseDataList.copCertList.push(vehHydr?.Hydraulic_Brake_Hose?.properties.CoP_Cert_No_with_validity_date?.value);

  //     }
  // });

  // const hydrBrakeHoseList = form8Data?.Hydraulic_Brake_Hose?.HydraulicBrakeHose;
  // let hydrBrkHoseDataList = mainData();

  // hydrBrakeHoseList?.map(vehHydr => {
  //     if (vehHydr?.supplier?.active === true) {
  //         const hoseProps = vehHydr?.Hydraulic_Brake_Hose?.properties || {};
  //         let make = hoseProps?.Make?.value || "";

  //         // Add M/s. prefix if not present and make is not empty
  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         const tacNumber = hoseProps?.TAC_Number?.value?.trim();

  //         // Push TAC Number into validity list
  //         hydrBrkHoseDataList.validityList.push(tacNumber || "NA");

  //         // If TAC Number is present and not NA, push make into suppNameList
  //         if (tacNumber && tacNumber !== "NA") {
  //             hydrBrkHoseDataList.suppNameList.push(make);
  //         }

  //         hydrBrkHoseDataList.MakeList.push(make);
  //         hydrBrkHoseDataList.possibleDateList.push(
  //             hoseProps?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //         );
  //         hydrBrkHoseDataList.copCertList.push(
  //             hoseProps?.CoP_Cert_No_with_validity_date?.value || "NA"
  //         );

  //         console.log('hydrBrkHoseDataList.validityList', hydrBrkHoseDataList.validityList);
  //         console.log('hydrBrkHoseDataList.suppNameList', hydrBrkHoseDataList.suppNameList);
  //         console.log('hydrBrkHoseDataList.MakeList', hydrBrkHoseDataList.MakeList);
  //         console.log('hydrBrkHoseDataList.possibleDateList', hydrBrkHoseDataList.possibleDateList);
  //         console.log('hydrBrkHoseDataList.copCertList', hydrBrkHoseDataList.copCertList);
  //     }
  // });

  // const hydrBrakeHoseList = form8Data?.Hydraulic_Brake_Hose?.HydraulicBrakeHose;
  // let hydrBrkHoseDataList = mainData();

  // hydrBrakeHoseList?.map((vehHydr) => {
  //     if (vehHydr?.supplier?.active === true) {
  //         const hoseProps = vehHydr?.Hydraulic_Brake_Hose?.properties || {};
  //         let make = hoseProps?.Make?.value || "";

  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         const tacRaw = hoseProps?.TAC_Number?.value || "";
  //         const tacCheck = parseAndCheckTACValidity(tacRaw);

  //         hydrBrkHoseDataList.validityList.push(tacRaw);
  //         hydrBrkHoseDataList.MakeList.push(make);

  //         const copCert = hoseProps?.CoP_Cert_No_with_validity_date?.value || "NA";
  //         const possibleDate = hoseProps?.Possible_date_of_submission_of_required_approval?.value || "NA";

  //         hydrBrkHoseDataList.suppNameList.push(make);

  //         if (tacCheck.hasDate) {
  //             if (tacCheck.expired) {
  //                 hydrBrkHoseDataList.copCertList.push(copCert);
  //                 hydrBrkHoseDataList.possibleDateList.push(possibleDate);
  //             } else {
  //                 hydrBrkHoseDataList.copCertList.push("NA");
  //                 hydrBrkHoseDataList.possibleDateList.push("NA");
  //             }
  //         } else {
  //             hydrBrkHoseDataList.copCertList.push(copCert);
  //             hydrBrkHoseDataList.possibleDateList.push(possibleDate);
  //         }
  //     }
  // });

  //   const hydrBrakeHoseList = form8Data?.Hydraulic_Brake_Hose?.HydraulicBrakeHose;
  //   let hydrBrkHoseDataList = mainData();

  //   hydrBrakeHoseList?.map((vehHydr) => {
  //     if (vehHydr?.supplier?.active === true) {
  //       const hoseProps = vehHydr?.Hydraulic_Brake_Hose?.properties || {};
  //       let make = hoseProps?.Make?.value || "";

  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       const tacValidity = hoseProps?.TAC_Number?.value || "";
  //       const copCert = hoseProps?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDate =
  //         hoseProps?.Possible_date_of_submission_of_required_approval?.value ||
  //         "";

  //       hydrBrkHoseDataList.validityList.push(tacValidity);
  //       hydrBrkHoseDataList.MakeList.push(make);
  //       hydrBrkHoseDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(
  //         tacValidity,
  //         copCert,
  //         possibleDate
  //       );
  //       hydrBrkHoseDataList.copCertList.push(cop);
  //       hydrBrkHoseDataList.possibleDateList.push(possible);
  //     }
  //   });

  // const hydrBrakeHoseList = form8Data?.Hydraulic_Brake_Hose?.HydraulicBrakeHose;
  // let hydrBrkHoseDataList = mainData();

  // hydrBrakeHoseList?.map((vehHydr) => {
  //   if (vehHydr?.supplier?.active === true) {
  //     const hoseProps = vehHydr?.Hydraulic_Brake_Hose?.properties || {};
  //     let make = hoseProps?.Make?.value?.trim() || "";

  //     if (make && !make.startsWith("M/")) {
  //       make = `M/s. ${make}`;
  //     }

  //     const tacRaw = hoseProps?.TAC_Number?.value?.trim() || "";
  //     const copCert = hoseProps?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //     const possibleDate = hoseProps?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //     let finalTac = tacRaw;
  //     if (!tacRaw && copCert) {
  //       finalTac = "NA";
  //     }

  //     hydrBrkHoseDataList.validityList.push(finalTac);
  //     hydrBrkHoseDataList.MakeList.push(make);
  //     hydrBrkHoseDataList.suppNameList.push(make);

  //     const { cop, possible } = TACvalidationcheck(finalTac, copCert, possibleDate);
  //     hydrBrkHoseDataList.copCertList.push(cop);
  //     hydrBrkHoseDataList.possibleDateList.push(possible);
  //   }
  // });

  const hydrBrakeHoseList =
    form8Data?.Hydraulic_Brake_Hose?.HydraulicBrakeHose || [];
  let hydrBrkHoseDataList = mainData();

  hydrBrakeHoseList.forEach((vehHydr) => {
    if (vehHydr?.supplier?.active === true) {
      const props = vehHydr?.Hydraulic_Brake_Hose?.properties || {};
    //   let make = props?.Make?.value?.trim() || "";
    //   if (make && !make.startsWith("M/")) {
    //     make = `M/s. ${make}`;
    //   }
    let make = makePrefix(props?.Make?.value?.trim());

      const tacRawHydralic = props?.TAC_Number?.value?.trim() || "";
      const tacValidityRaw = props?.TAC_Validity?.value?.trim() || "";
      const copRaw = props?.CoP_Cert_No_with_validity_date?.value || "";
      const possibleRaw =
        props?.Possible_date_of_submission_of_required_approval?.value ||
        "";

    //   const isTacMissing = tacRaw === "";
    //   const isPossibleDatePresent = possibleRaw !== "";
    //   let finalTAC = tacRaw;
    //   if (isTacMissing && isPossibleDatePresent) {
    //     finalTAC = "NA";
    //   }





      let finalValiditybulb=tacValidityRaw;
      if(!tacValidityRaw && possibleRaw){
          finalValiditybulb="NA";
      }
  
  
      if (finalValiditybulb !== "NA") {
        hydrBrkHoseDataList.validityList.push(tacValidityRaw);
        hydrBrkHoseDataList.tacNumberList.push(tacRawHydralic);
        } else {
            hydrBrkHoseDataList.validityList.push("NA");
            hydrBrkHoseDataList.tacNumberList.push("");
        }
  
  





    //   hydrBrkHoseDataList.validityList.push(finalTAC);
    //   hydrBrkHoseDataList.tacNumberList.push(finalTAC);      
      hydrBrkHoseDataList.MakeList.push(make);
      hydrBrkHoseDataList.suppNameList.push(make);

      const { cop:copHydrolic, possible:possibleHydrolic } = TACvalidationcheck(tacValidityRaw, copRaw, possibleRaw);
      hydrBrkHoseDataList.copCertList.push(copHydrolic);
      hydrBrkHoseDataList.possibleDateList.push(possibleHydrolic);
    }
  });

  console.log(
    "hydrBrkHoseDataList.tacNumberList",
    hydrBrkHoseDataList.tacNumberList
  );
  console.log(
    "hydrBrkHoseDataList.validityList",
    hydrBrkHoseDataList.validityList
  );
  console.log(
    "hydrBrkHoseDataList.suppNameList",
    hydrBrkHoseDataList.suppNameList
  );
  console.log(
    "hydrBrkHoseDataList.copCertList",
    hydrBrkHoseDataList.copCertList
  );
  console.log(
    "hydrBrkHoseDataList.possibleDateList",
    hydrBrkHoseDataList.possibleDateList
  );

  // const wheelRimList = form8Data?.Wheel_Rim?.WheelRim;
  // let wheelRimDataList = mainData();
  // wheelRimList.map(vehWheelRim => {
  //     if (vehWheelRim?.supplier?.active === true) {
  //         wheelRimDataList.suppNameList.push(vehWheelRim?.supplier?.nameOfSupplier);
  //         wheelRimDataList.tacNumberList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.BIS_License_TAC_Number_with_its_Validity?.value);
  //         wheelRimDataList.possibleDateList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         wheelRimDataList.copCertList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const mirrorsList = form8Data?.Rear_View_Mirror?.RearViewMirror;
  // let rearViewMirrorsDataList = mainData();
  // mirrorsList.map(vehMirror => {
  //     if (vehMirror.supplier.active === true) {
  //         let supplierName = vehMirror?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // rearViewMirrorsDataList.suppNameList.push(supplierName);
  //         // // rearViewMirrorsDataList.suppNameList.push(vehMirror?.supplier?.nameOfSupplier);
  //         // rearViewMirrorsDataList.tacNumberList.push(vehMirror?.Rear_View_Mirror?.properties?.TAC_Number_Its_Validity?.value);
  //         // Get the TAC Number value for Rear View Mirror
  //         const rearViewMirrorTACValue = vehMirror?.Rear_View_Mirror?.properties?.TAC_Number_Its_Validity?.value;

  //         // Push the TAC value to rearViewMirrorsDataList
  //         rearViewMirrorsDataList.tacNumberList.push(rearViewMirrorTACValue);

  //         // Check if TAC value is present
  //         // rearViewMirrorsDataList.suppNameList.push(rearViewMirrorTACValue ? supplierName : "");
  //         // rearViewMirrorsDataList.suppNameList.push(rearViewMirrorTACValue === "NA" ? "" : supplierName);
  //         if (rearViewMirrorTACValue && rearViewMirrorTACValue.trim() !== "") {
  //             rearViewMirrorsDataList.suppNameList.push(supplierName);
  //         }

  //         rearViewMirrorsDataList.MakeList.push(vehMirror?.Rear_View_Mirror?.properties?.Make?.value);

  //         rearViewMirrorsDataList.possibleDateList.push(vehMirror?.Rear_View_Mirror?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         rearViewMirrorsDataList.copCertList.push(vehMirror?.Rear_View_Mirror?.properties?.CoP_Cert_No_with_validity_date?.value);

  //     }
  // });

  // const mirrorsList = form8Data?.Rear_View_Mirror?.RearViewMirror;
  // let rearViewMirrorsDataList = mainData();

  // mirrorsList.map(vehMirror => {
  //     if (vehMirror?.supplier?.active === true) {
  //         // Extract and process Make
  //         let make = vehMirror?.Rear_View_Mirror?.properties?.Make?.value || "";

  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         // TAC Number
  //         const rearViewMirrorTACValue = vehMirror?.Rear_View_Mirror?.properties?.TAC_Number_Its_Validity?.value;
  //         rearViewMirrorsDataList.tacNumberList.push(rearViewMirrorTACValue);

  //         // Push Make to suppNameList only if TAC value is present
  //         if (rearViewMirrorTACValue && rearViewMirrorTACValue.trim() !== "") {
  //             rearViewMirrorsDataList.suppNameList.push(make);
  //         }

  //         rearViewMirrorsDataList.MakeList.push(make);

  //         const possibleDate = (make.includes("NA"))
  //             ? "NA"
  //             : vehMirror?.Rear_View_Mirror?.properties?.Possible_date_of_submission_of_required_approval?.value;
  //         rearViewMirrorsDataList.possibleDateList.push(possibleDate);

  //         rearViewMirrorsDataList.copCertList.push(vehMirror?.Rear_View_Mirror?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const mirrorsList = form8Data?.Rear_View_Mirror?.RearViewMirror;
  // let rearViewMirrorsDataList = mainData();

  // mirrorsList.map(vehMirror => {
  //     if (vehMirror?.supplier?.active === true) {
  //         // Extract and process Make
  //         let make = vehMirror?.Rear_View_Mirror?.properties?.Make?.value || "";
  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         // TAC Number
  //         const rearViewMirrorTACValue = vehMirror?.Rear_View_Mirror?.properties?.TAC_Number_Its_Validity?.value;
  //         rearViewMirrorsDataList.tacNumberList.push(rearViewMirrorTACValue);
  //         rearViewMirrorsDataList.MakeList.push(make);

  //         // Check TAC expiry
  //         const tacCheck = parseAndCheckTACValidity(rearViewMirrorTACValue);

  //         if (rearViewMirrorTACValue && rearViewMirrorTACValue.trim() !== "") {
  //             rearViewMirrorsDataList.suppNameList.push(make);

  //             if (tacCheck.hasDate) {
  //                 if (tacCheck.expired) {
  //                     // TAC expired — push actual CoP and submission date
  //                     rearViewMirrorsDataList.copCertList.push(
  //                         vehMirror?.Rear_View_Mirror?.properties?.CoP_Cert_No_with_validity_date?.value || "NA"
  //                     );
  //                     rearViewMirrorsDataList.possibleDateList.push(
  //                         vehMirror?.Rear_View_Mirror?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //                     );
  //                 } else {
  //                     // TAC valid — no need for CoP or submission date
  //                     rearViewMirrorsDataList.copCertList.push("NA");
  //                     rearViewMirrorsDataList.possibleDateList.push("NA");
  //                 }
  //             } else {
  //                 // TAC has no recognizable date — assume manual entry
  //                 rearViewMirrorsDataList.copCertList.push(
  //                     vehMirror?.Rear_View_Mirror?.properties?.CoP_Cert_No_with_validity_date?.value || "NA"
  //                 );
  //                 rearViewMirrorsDataList.possibleDateList.push(
  //                     vehMirror?.Rear_View_Mirror?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //                 );
  //             }
  //         } else {
  //             // No TAC value — skip CoP/possible date
  //             rearViewMirrorsDataList.copCertList.push("NA");
  //             rearViewMirrorsDataList.possibleDateList.push("NA");
  //         }
  //     }
  // });

  //   const mirrorsList = form8Data?.Rear_View_Mirror?.RearViewMirror;
  //   let rearViewMirrorsDataList = mainData();

  //   mirrorsList.map((vehMirror) => {
  //     if (vehMirror?.supplier?.active === true) {
  //       let make = vehMirror?.Rear_View_Mirror?.properties?.Make?.value || "";
  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       const tacValueRaw =
  //         vehMirror?.Rear_View_Mirror?.properties?.TAC_Number_Its_Validity
  //           ?.value || "";
  //       const copCertRaw =
  //         vehMirror?.Rear_View_Mirror?.properties?.CoP_Cert_No_with_validity_date
  //           ?.value || "";
  //       const possibleDateRaw =
  //         vehMirror?.Rear_View_Mirror?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";

  //       rearViewMirrorsDataList.tacNumberList.push(tacValueRaw);
  //       rearViewMirrorsDataList.MakeList.push(make);
  //       rearViewMirrorsDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(
  //         tacValueRaw,
  //         copCertRaw,
  //         possibleDateRaw
  //       );
  //       rearViewMirrorsDataList.copCertList.push(cop);
  //       rearViewMirrorsDataList.possibleDateList.push(possible);
  //     }
  //   });

  // const mirrorsList = form8Data?.Rear_View_Mirror?.RearViewMirror || [];
  // let rearViewMirrorsDataList = mainData();

  // mirrorsList.map((vehMirror) => {
  //   if (vehMirror?.supplier?.active === true) {
  //     let make = vehMirror?.Rear_View_Mirror?.properties?.Make?.value || "";
  //     if (make && !make.startsWith("M/")) {
  //       make = `M/s. ${make}`;
  //     }

  //     const tacValueRaw = vehMirror?.Rear_View_Mirror?.properties?.TAC_Number_Its_Validity?.value?.trim() || "";
  //     const copCertRaw = vehMirror?.Rear_View_Mirror?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //     const possibleDateRaw = vehMirror?.Rear_View_Mirror?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //     // Logic for handling TAC when only CoP is present
  //     const isTacMissing = tacValueRaw === "";
  //     const isPossibleDatePresent = possibleDateRaw !== "";

  //     let finalTAC = tacValueRaw;
  //     if (isTacMissing && isPossibleDatePresent) {
  //       finalTAC = "NA";
  //     }

  //     rearViewMirrorsDataList.validityList.push(finalTAC);
  //     rearViewMirrorsDataList.MakeList.push(make);
  //     rearViewMirrorsDataList.suppNameList.push(make);

  //     const { cop, possible } = TACvalidationcheck(tacValueRaw, copCertRaw, possibleDateRaw);
  //     rearViewMirrorsDataList.copCertList.push(cop);
  //     rearViewMirrorsDataList.possibleDateList.push(possible);
  //   }
  // });

  const mirrorsList = form8Data?.Rear_View_Mirror?.RearViewMirror || [];
  let rearViewMirrorsDataList = mainData();

  mirrorsList.forEach((vehMirror) => {
    if (vehMirror?.supplier?.active === true) {
      const props = vehMirror?.Rear_View_Mirror?.properties || {};
    //   let make = props?.Make?.value || "";
    //   if (make && !make.startsWith("M/")) {
    //     make = `M/s. ${make}`;
    //   }
    let make = makePrefix(props?.Make?.value);

      const tacRaw = props?.TAC_Number_Its_Validity?.value?.trim() || "";
      const copRaw = props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleRaw =
        props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      const isTacMissing = tacRaw === "";
      const isPossibleDatePresent = possibleRaw !== "";
      let finalTAC = tacRaw;
      if (isTacMissing && isPossibleDatePresent) {
        finalTAC = "NA";
      }

      rearViewMirrorsDataList.tacNumberList.push(finalTAC);
      rearViewMirrorsDataList.MakeList.push(make);
      rearViewMirrorsDataList.suppNameList.push(make);

      const { cop, possible } = TACvalidationcheck(tacRaw, copRaw, possibleRaw);
      rearViewMirrorsDataList.copCertList.push(cop);
      rearViewMirrorsDataList.possibleDateList.push(possible);
    }
  });

  console.log(
    "rearviewmirrorsdatalist.tacNumberList",
    rearViewMirrorsDataList.tacNumberList
  );
  console.log(
    "rearviewmirrorsdatalist.suppNameList",
    rearViewMirrorsDataList.suppNameList
  );
  console.log(
    "rearviewmirrorsdatalist.MakeList",
    rearViewMirrorsDataList.MakeList
  );
  console.log(
    "rearviewmirrorsdatalist.possibleDateList",
    rearViewMirrorsDataList.possibleDateList
  );
  console.log(
    "rearviewmirrorsdatalist.copCertList",
    rearViewMirrorsDataList.copCertList
  );

  // const TractionBatterypackList = form8Data?.Traction_Battery_Pack?.TractionBatterypack;
  // let TractionBatterypackDataList = mainData();
  // TractionBatterypackList.map(vehTractionBatterypack => {
  //     if (vehTractionBatterypack.supplier.active === true) {
  //         let supplierName = vehTractionBatterypack?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // TractionBatterypackDataList.suppNameList.push(supplierName);
  //         // // TractionBatterypackDataList.suppNameList.push(vehTractionBatterypack?.supplier?.nameOfSupplier);
  //         // TractionBatterypackDataList.tacNumberList.push(vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Type_approval_Certififcate_number?.value);
  //         // Get the TAC Number value for Traction Battery Pack
  //         const tractionBatteryTACValue = vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Type_approval_Certififcate_number?.value;

  //         // Push the TAC value to TractionBatterypackDataList
  //         TractionBatterypackDataList.tacNumberList.push(tractionBatteryTACValue);

  //         // Check if TAC value is present
  //         // TractionBatterypackDataList.suppNameList.push(tractionBatteryTACValue ? supplierName : "");
  //         // TractionBatterypackDataList.suppNameList.push(tractionBatteryTACValue === "NA" ? "" : supplierName);
  //         if (tractionBatteryTACValue && tractionBatteryTACValue.trim() !== "") {
  //             TractionBatterypackDataList.suppNameList.push(supplierName);
  //         }

  //         TractionBatterypackDataList.MakeList.push(vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Make?.value);
  //         TractionBatterypackDataList.possibleDateList.push(vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         TractionBatterypackDataList.copCertList.push(vehTractionBatterypack?.Traction_Battery_Pack?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const TractionBatterypackList = form8Data?.Traction_Battery_Pack?.TractionBatterypack;
  // let TractionBatterypackDataList = mainData();

  // TractionBatterypackList.map(vehTractionBatterypack => {
  //     if (vehTractionBatterypack?.supplier?.active === true) {
  //         // Extract and format Make
  //         let make = vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Make?.value || "";

  //         if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //         }

  //         // Get the TAC Number
  //         const tractionBatteryTACValue = vehTractionBatterypack?.Traction_Battery_Pack?.properties?.TAC_Number_Its_Validity?.value;
  //         TractionBatterypackDataList.tacNumberList.push(tractionBatteryTACValue);

  //         // Push Make to suppNameList if TAC value is present
  //         if (tractionBatteryTACValue && tractionBatteryTACValue.trim() !== "") {
  //             TractionBatterypackDataList.suppNameList.push(make);
  //         }

  //         TractionBatterypackDataList.MakeList.push(make);

  //         const possibleDate = (make.includes("NA"))
  //             ? "NA"
  //             : vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Possible_date_of_submission_of_required_approval?.value;
  //         TractionBatterypackDataList.possibleDateList.push(possibleDate);

  //         TractionBatterypackDataList.copCertList.push(vehTractionBatterypack?.Traction_Battery_Pack?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         console.log('TractionBatterypackDataList.tacNumberList', TractionBatterypackDataList.tacNumberList);
  //         console.log('TractionBatterypackDataList.suppNameList', TractionBatterypackDataList.suppNameList);
  //         console.log('TractionBatterypackDataList.MakeList', TractionBatterypackDataList.MakeList);
  //         console.log('TractionBatterypackDataList.possibleDateList', TractionBatterypackDataList.possibleDateList);
  //         console.log('TractionBatterypackDataList.copCertList', TractionBatterypackDataList.copCertList);

  //     }
  // });

  //   const TractionBatterypackList =
  //     form8Data?.Traction_Battery_Pack?.TractionBatterypack;
  //   let TractionBatterypackDataList = mainData();

  //   TractionBatterypackList.map((vehTractionBatterypack) => {
  //     if (vehTractionBatterypack?.supplier?.active === true) {
  //       let make =
  //         vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Make
  //           ?.value || "";

  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       const tacValueRaw =
  //         vehTractionBatterypack?.Traction_Battery_Pack?.properties
  //           ?.Type_approval_Certififcate_number?.value || "";
  //       const copCertRaw =
  //         vehTractionBatterypack?.Traction_Battery_Pack?.properties
  //           ?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDateRaw =
  //         vehTractionBatterypack?.Traction_Battery_Pack?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";

  //       TractionBatterypackDataList.tacNumberList.push(tacValueRaw);
  //       TractionBatterypackDataList.MakeList.push(make);
  //       TractionBatterypackDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(
  //         tacValueRaw,
  //         copCertRaw,
  //         possibleDateRaw
  //       );
  //       TractionBatterypackDataList.copCertList.push(cop);
  //       TractionBatterypackDataList.possibleDateList.push(possible);
  //     }
  //   });

  const TractionBatterypackList =
    form8Data?.Traction_Battery_Pack?.TractionBatterypack || [];
  let TractionBatterypackDataList = mainData();

  TractionBatterypackList.map((vehTractionBatterypack) => {
    if (vehTractionBatterypack?.supplier?.active === true) {
    //   let make =
    //     vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Make
    //       ?.value || "";

    //   if (make && !make.startsWith("M/")) {
    //     make = `M/s. ${make}`;
    //   }
    let make = makePrefix(
        vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Make?.value
      );
      
      const tacValueRaw =
        vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Type_approval_Certififcate_number?.value?.trim() ||
        "";
      const copCertRaw =
        vehTractionBatterypack?.Traction_Battery_Pack?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() ||
        "";
      const possibleDateRaw =
        vehTractionBatterypack?.Traction_Battery_Pack?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
        "";

      // Logic for handling TAC when only CoP is present
      const isTacMissing = tacValueRaw === "";
      const isPossibleDatePresent = possibleDateRaw !== "";

      let finalTAC = tacValueRaw;
      if (isTacMissing && isPossibleDatePresent) {
        finalTAC = "NA";
      }

      TractionBatterypackDataList.tacNumberList.push(finalTAC);
      TractionBatterypackDataList.MakeList.push(make);
      TractionBatterypackDataList.suppNameList.push(make);

      const { cop, possible } = TACvalidationcheck(
        tacValueRaw,
        copCertRaw,
        possibleDateRaw
      );
      TractionBatterypackDataList.copCertList.push(cop);
      TractionBatterypackDataList.possibleDateList.push(possible);
    }
  });

  console.log(
    "TractionBatterypackDataList.tacNumberList",
    TractionBatterypackDataList.tacNumberList
  );
  console.log(
    "TractionBatterypackDataList.suppNameList",
    TractionBatterypackDataList.suppNameList
  );
  console.log(
    "TractionBatterypackDataList.MakeList",
    TractionBatterypackDataList.MakeList
  );
  console.log(
    "TractionBatterypackDataList.possibleDateList",
    TractionBatterypackDataList.possibleDateList
  );
  console.log(
    "TractionBatterypackDataList.copCertList",
    TractionBatterypackDataList.copCertList
  );

  // const WheelRimList = form8Data?.Wheel_Rim?.WheelRim;

  // let FWheelRimDataList = mainData();
  // let RWheelRimDataList = mainData();

  // WheelRimList.map(vehWheelRim => {
  //     if (vehWheelRim.supplier.active === true) {
  //         let supplierName = vehWheelRim?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // FWheelRimDataList.suppNameList.push(supplierName);
  //         // // FWheelRimDataList.suppNameList.push(vehWheelRim?.supplier?.nameOfSupplier);
  //         // FWheelRimDataList.tacNumberList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.BIS_License_TAC_Number_with_its_Validity?.value);
  //         // Get the TAC Number value for Front Wheel Rim
  //         const fWheelRimTACValue = vehWheelRim?.Front_Wheel_Rim?.properties?.BIS_License_TAC_Number_with_its_Validity?.value;

  //         // Push the TAC value to FWheelRimDataList
  //         FWheelRimDataList.tacNumberList.push(fWheelRimTACValue);

  //         // Check if TAC value is present
  //         // FWheelRimDataList.suppNameList.push(fWheelRimTACValue ? supplierName : "");
  //         // FWheelRimDataList.suppNameList.push(fWheelRimTACValue === "NA" ? "" : supplierName);
  //         if (fWheelRimTACValue && fWheelRimTACValue.trim() !== "") {
  //             FWheelRimDataList.suppNameList.push(supplierName);
  //         }

  //         FWheelRimDataList.MakeList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.Make?.value);
  //         FWheelRimDataList.possibleDateList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         FWheelRimDataList.copCertList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         // RWheelRimDataList.suppNameList.push(vehWheelRim?.supplier?.nameOfSupplier);
  //         RWheelRimDataList.suppNameList.push(supplierName);
  //         RWheelRimDataList.MakeList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.Make?.value);
  //         RWheelRimDataList.tacNumberList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.BIS_License_TAC_Number_its_Validity?.value);
  //         RWheelRimDataList.possibleDateList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         RWheelRimDataList.copCertList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const WheelRimList = form8Data?.Wheel_Rim?.WheelRim;

  // let FWheelRimDataList = mainData();
  // let RWheelRimDataList = mainData();

  // WheelRimList.map(vehWheelRim => {
  //     if (vehWheelRim?.supplier?.active === true) {
  //         // FRONT
  //         let frontMake = vehWheelRim?.Front_Wheel_Rim?.properties?.Make?.value || "";
  //         if (frontMake && !frontMake.startsWith("M/")) {
  //             frontMake = `M/s. ${frontMake}`;
  //         }

  //         const fWheelRimTACValue = vehWheelRim?.Front_Wheel_Rim?.properties?.BIS_License_TAC_Number_with_its_Validity?.value;
  //         if (fWheelRimTACValue && fWheelRimTACValue.trim() !== "") {
  //             FWheelRimDataList.suppNameList.push(frontMake);
  //         }

  //         FWheelRimDataList.tacNumberList.push(fWheelRimTACValue);
  //         FWheelRimDataList.MakeList.push(frontMake);

  //         const frontPossibleDate = (frontMake.includes("NA"))
  //             ? "NA"
  //             : vehWheelRim?.Front_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value;
  //         FWheelRimDataList.possibleDateList.push(frontPossibleDate);

  //         FWheelRimDataList.copCertList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         // REAR
  //         let rearMake = vehWheelRim?.Rear_Wheel_Rim?.properties?.Make?.value || "";
  //         if (rearMake && !rearMake.startsWith("M/")) {
  //             rearMake = `M/s. ${rearMake}`;
  //         }

  //         RWheelRimDataList.suppNameList.push(rearMake);
  //         RWheelRimDataList.MakeList.push(rearMake);
  //         RWheelRimDataList.tacNumberList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.BIS_License_TAC_Number_its_Validity?.value);

  //         const rearPossibleDate = (rearMake.includes("NA"))
  //             ? "NA"
  //             : vehWheelRim?.Rear_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value;
  //         RWheelRimDataList.possibleDateList.push(rearPossibleDate);

  //         RWheelRimDataList.copCertList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value);

  //         console.log('FWheelRimDataList.suppNameList', FWheelRimDataList.suppNameList);
  //         console.log('FWheelRimDataList.tacNumberList', FWheelRimDataList.tacNumberList);
  //         console.log('FWheelRimDataList.MakeList', FWheelRimDataList.MakeList);
  //         console.log('FWheelRimDataList.possibleDateList', FWheelRimDataList.possibleDateList);
  //         console.log('FWheelRimDataList.copCertList', FWheelRimDataList.copCertList);

  //         console.log('RWheelRimDataList.suppNameList', RWheelRimDataList.suppNameList);
  //         console.log('RWheelRimDataList.tacNumberList', RWheelRimDataList.tacNumberList);
  //         console.log('RWheelRimDataList.MakeList', RWheelRimDataList.MakeList);
  //         console.log('RWheelRimDataList.possibleDateList', RWheelRimDataList.possibleDateList);
  //         console.log('RWheelRimDataList.copCertList', RWheelRimDataList.copCertList);

  //     }
  // });

  // const WheelRimList = form8Data?.Wheel_Rim?.WheelRim;

  // let FWheelRimDataList = mainData();
  // let RWheelRimDataList = mainData();

  // WheelRimList.map(vehWheelRim => {
  //     if (vehWheelRim?.supplier?.active === true) {
  //         // FRONT
  //         let frontMake = vehWheelRim?.Front_Wheel_Rim?.properties?.Make?.value || "";
  //         if (frontMake && !frontMake.startsWith("M/")) {
  //             frontMake = `M/s. ${frontMake}`;
  //         }

  //         const fWheelRimTACValue = vehWheelRim?.Front_Wheel_Rim?.properties?.BIS_License_TAC_Number_with_its_Validity?.value;
  //         const tacCheckFront = parseAndCheckTACValidity(fWheelRimTACValue);

  //         if (fWheelRimTACValue && fWheelRimTACValue.trim() !== "") {
  //             FWheelRimDataList.suppNameList.push(frontMake);
  //         }

  //         FWheelRimDataList.tacNumberList.push(fWheelRimTACValue);
  //         FWheelRimDataList.MakeList.push(frontMake);

  //         if (tacCheckFront.hasDate) {
  //             if (tacCheckFront.expired) {
  //                 FWheelRimDataList.copCertList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                 FWheelRimDataList.possibleDateList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //             } else {
  //                 FWheelRimDataList.copCertList.push("NA");
  //                 FWheelRimDataList.possibleDateList.push("NA");
  //             }
  //         } else {
  //             FWheelRimDataList.copCertList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //             FWheelRimDataList.possibleDateList.push(vehWheelRim?.Front_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //         }

  //         // REAR
  //         let rearMake = vehWheelRim?.Rear_Wheel_Rim?.properties?.Make?.value || "";
  //         if (rearMake && !rearMake.startsWith("M/")) {
  //             rearMake = `M/s. ${rearMake}`;
  //         }

  //         const rWheelRimTACValue = vehWheelRim?.Rear_Wheel_Rim?.properties?.BIS_License_TAC_Number_its_Validity?.value;
  //         const tacCheckRear = parseAndCheckTACValidity(rWheelRimTACValue);

  //         RWheelRimDataList.suppNameList.push(rearMake);
  //         RWheelRimDataList.MakeList.push(rearMake);
  //         RWheelRimDataList.tacNumberList.push(rWheelRimTACValue);

  //         if (tacCheckRear.hasDate) {
  //             if (tacCheckRear.expired) {
  //                 RWheelRimDataList.copCertList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //                 RWheelRimDataList.possibleDateList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //             } else {
  //                 RWheelRimDataList.copCertList.push("NA");
  //                 RWheelRimDataList.possibleDateList.push("NA");
  //             }
  //         } else {
  //             RWheelRimDataList.copCertList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date?.value || "NA");
  //             RWheelRimDataList.possibleDateList.push(vehWheelRim?.Rear_Wheel_Rim?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA");
  //         }
  //     }
  // });

  //   const WheelRimList = form8Data?.Wheel_Rim?.WheelRim;

  //   let FWheelRimDataList = mainData();
  //   let RWheelRimDataList = mainData();

  //   WheelRimList.map((vehWheelRim) => {
  //     if (vehWheelRim?.supplier?.active === true) {
  //       // FRONT Wheel Rim
  //       let frontMake =
  //         vehWheelRim?.Front_Wheel_Rim?.properties?.Make?.value || "";
  //       if (frontMake && !frontMake.startsWith("M/")) {
  //         frontMake = `M/s. ${frontMake}`;
  //       }

  //       const frontTAC =
  //         vehWheelRim?.Front_Wheel_Rim?.properties
  //           ?.BIS_License_TAC_Number_with_its_Validity?.value || "";
  //       const frontCoP =
  //         vehWheelRim?.Front_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date
  //           ?.value || "";
  //       const frontDate =
  //         vehWheelRim?.Front_Wheel_Rim?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";

  //       FWheelRimDataList.tacNumberList.push(frontTAC);
  //       FWheelRimDataList.MakeList.push(frontMake);
  //       FWheelRimDataList.suppNameList.push(frontMake);

  //       const { cop: fCop, possible: fDate } = TACvalidationcheck(
  //         frontTAC,
  //         frontCoP,
  //         frontDate
  //       );
  //       FWheelRimDataList.copCertList.push(fCop);
  //       FWheelRimDataList.possibleDateList.push(fDate);

  //       // REAR Wheel Rim
  //       let rearMake = vehWheelRim?.Rear_Wheel_Rim?.properties?.Make?.value || "";
  //       if (rearMake && !rearMake.startsWith("M/")) {
  //         rearMake = `M/s. ${rearMake}`;
  //       }

  //       const rearTAC =
  //         vehWheelRim?.Rear_Wheel_Rim?.properties
  //           ?.BIS_License_TAC_Number_its_Validity?.value || "";
  //       const rearCoP =
  //         vehWheelRim?.Rear_Wheel_Rim?.properties?.CoP_Cert_No_with_validity_date
  //           ?.value || "";
  //       const rearDate =
  //         vehWheelRim?.Rear_Wheel_Rim?.properties
  //           ?.Possible_date_of_submission_of_required_approval?.value || "";

  //       RWheelRimDataList.tacNumberList.push(rearTAC);
  //       RWheelRimDataList.MakeList.push(rearMake);
  //       RWheelRimDataList.suppNameList.push(rearMake);

  //       const { cop: rCop, possible: rDate } = TACvalidationcheck(
  //         rearTAC,
  //         rearCoP,
  //         rearDate
  //       );
  //       RWheelRimDataList.copCertList.push(rCop);
  //       RWheelRimDataList.possibleDateList.push(rDate);
  //     }
  //   });

  // const WheelRimList = form8Data?.Wheel_Rim?.WheelRim || [];

  // let FWheelRimDataList = mainData();
  // let RWheelRimDataList = mainData();

  // WheelRimList.map((vehWheelRim) => {
  //   if (vehWheelRim?.supplier?.active === true) {
  //     // FRONT Wheel Rim
  //     let frontMake = vehWheelRim?.Front_Wheel_Rim?.properties?.Make?.value || "";
  //     if (frontMake && !frontMake.startsWith("M/")) {
  //       frontMake = `M/s. ${frontMake}`;
  //     }

  //     const frontTAC = vehWheelRim?.Front_Wheel_Rim?.properties
  //       ?.BIS_License_TAC_Number_with_its_Validity?.value?.trim() || "";
  //     const frontCoP = vehWheelRim?.Front_Wheel_Rim?.properties
  //       ?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //     const frontDate = vehWheelRim?.Front_Wheel_Rim?.properties
  //       ?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //     const isFrontTacMissing = frontTAC === "";
  //     const isFrontCopPresent = frontCoP !== "";

  //     let finalFrontTAC = frontTAC;
  //     if (isFrontTacMissing && isFrontCopPresent) {
  //       finalFrontTAC = "NA";
  //     }

  //     FWheelRimDataList.tacNumberList.push(finalFrontTAC);
  //     FWheelRimDataList.MakeList.push(frontMake);
  //     FWheelRimDataList.suppNameList.push(frontMake);

  //     const { cop: fCop, possible: fDate } = TACvalidationcheck(
  //       frontTAC,
  //       frontCoP,
  //       frontDate
  //     );
  //     FWheelRimDataList.copCertList.push(fCop);
  //     FWheelRimDataList.possibleDateList.push(fDate);

  //     // REAR Wheel Rim
  //     let rearMake = vehWheelRim?.Rear_Wheel_Rim?.properties?.Make?.value || "";
  //     if (rearMake && !rearMake.startsWith("M/")) {
  //       rearMake = `M/s. ${rearMake}`;
  //     }

  //     const rearTAC = vehWheelRim?.Rear_Wheel_Rim?.properties
  //       ?.BIS_License_TAC_Number_its_Validity?.value?.trim() || "";
  //     const rearCoP = vehWheelRim?.Rear_Wheel_Rim?.properties
  //       ?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //     const rearDate = vehWheelRim?.Rear_Wheel_Rim?.properties
  //       ?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

  //     const isRearTacMissing = rearTAC === "";
  //     const isRearCopPresent = rearCoP !== "";

  //     let finalRearTAC = rearTAC;
  //     if (isRearTacMissing && isRearCopPresent) {
  //       finalRearTAC = "NA";
  //     }

  //     RWheelRimDataList.tacNumberList.push(finalRearTAC);
  //     RWheelRimDataList.MakeList.push(rearMake);
  //     RWheelRimDataList.suppNameList.push(rearMake);

  //     const { cop: rCop, possible: rDate } = TACvalidationcheck(
  //       rearTAC,
  //       rearCoP,
  //       rearDate
  //     );
  //     RWheelRimDataList.copCertList.push(rCop);
  //     RWheelRimDataList.possibleDateList.push(rDate);
  //   }
  // });

  // const WheelRimList = form8Data?.Wheel_Rim?.WheelRim || [];

  // let FWheelRimDataList = mainData();
  // let RWheelRimDataList = mainData();

  // WheelRimList.forEach((vehWheelRim) => {
  //   if (vehWheelRim?.supplier?.active === true) {
  //     // FRONT WHEEL RIM
  //     {
  //       const props = vehWheelRim?.Front_Wheel_Rim?.properties || {};
  //       // let make = props?.Make?.value || "";
  //       // if (make && !make.startsWith("M/")) {
  //       //   make = `M/s. ${make}`;
  //       // }
  //       let make = makePrefix(props?.Make?.value);

  //       const tacRaw =
  //         props?.BIS_License_TAC_Number_with_its_Validity?.value?.trim() || "";
  //       const copRaw =
  //         props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //       const possibleDateRaw =
  //         props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
  //         "";

  //       const isTacMissing = tacRaw === "";
  //       const isPossibleDatePresent = possibleDateRaw !== "";
  //       let finalTAC = tacRaw;
  //       if (isTacMissing && isPossibleDatePresent) {
  //         finalTAC = "NA";
  //       }

  //       FWheelRimDataList.tacNumberList.push(finalTAC);
  //       FWheelRimDataList.MakeList.push(make);
  //       FWheelRimDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(
  //         tacRaw,
  //         copRaw,
  //         possibleDateRaw
  //       );
  //       FWheelRimDataList.copCertList.push(cop);
  //       FWheelRimDataList.possibleDateList.push(possible);
  //     }

  //     // REAR WHEEL RIM
  //     {
  //       const props = vehWheelRim?.Rear_Wheel_Rim?.properties || {};
  //       // let make = props?.Make?.value || "";
  //       // if (make && !make.startsWith("M/")) {
  //       //   make = `M/s. ${make}`;
  //       // }
  //       let make = makePrefix(props?.Make?.value);

  //       const tacRaw =
  //         props?.BIS_License_TAC_Number_its_Validity?.value?.trim() || "";
  //       const copRaw =
  //         props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
  //       const possibleDateRaw =
  //         props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
  //         "";

  //       const isTacMissing = tacRaw === "";
  //       const isPossibleDatePresent = possibleDateRaw !== "";
  //       let finalTAC = tacRaw;
  //       if (isTacMissing && isPossibleDatePresent) {
  //         finalTAC = "NA";
  //       }

  //       RWheelRimDataList.tacNumberList.push(finalTAC);
  //       RWheelRimDataList.MakeList.push(make);
  //       RWheelRimDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(
  //         tacRaw,
  //         copRaw,
  //         possibleDateRaw
  //       );
  //       RWheelRimDataList.copCertList.push(cop);
  //       RWheelRimDataList.possibleDateList.push(possible);
  //     }
  //   }
  // });
  const WheelRimList = form8Data?.Wheel_Rim?.WheelRim || [];

  let FWheelRimDataList = mainData();
  let RWheelRimDataList = mainData();
  
  WheelRimList.forEach((vehWheelRim) => {
    if (vehWheelRim?.supplier?.active === true) {
      // ---------------- FRONT WHEEL RIM ----------------
      {
        const props = vehWheelRim?.Front_Wheel_Rim?.properties || {};
  
        let make = makePrefix(props?.Make?.value);
  
        const tacValueRaw =
          props?.BIS_License_TAC_Number_with_its_Validity?.value?.trim() || "";
        const copCertRaw =
          props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
        const possibleDateRaw =
          props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
          "";
  
        const isTacMissing = tacValueRaw === "";
        const isPossibleDatePresent = possibleDateRaw !== "";
  
        let finalTAC = tacValueRaw;
        if (isTacMissing && isPossibleDatePresent) {
          finalTAC = "NA"; // ✅ Condition same as Horn logic
        }
  
        FWheelRimDataList.tacNumberList.push(finalTAC);
        FWheelRimDataList.MakeList.push(make);
        FWheelRimDataList.suppNameList.push(make);
  
        const { cop:fWheelCop, possible:fWheelPossibleDate } = TACvalidationcheck(
          tacValueRaw,
          copCertRaw,
          possibleDateRaw
        );
        FWheelRimDataList.copCertList.push(fWheelCop);
        FWheelRimDataList.possibleDateList.push(fWheelPossibleDate);
      }
  
      // ---------------- REAR WHEEL RIM ----------------
      {
        const props = vehWheelRim?.Rear_Wheel_Rim?.properties || {};
  
        let make = makePrefix(props?.Make?.value);
  
        const tacValueRaw =
          props?.BIS_License_TAC_Number_its_Validity?.value?.trim() || "";
        const copCertRaw =
          props?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
        const possibleDateRaw =
          props?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
          "";
  
        const isTacMissing = tacValueRaw === "";
        const isPossibleDatePresent = possibleDateRaw !== "";
  
        let finalTAC = tacValueRaw;
        if (isTacMissing && isPossibleDatePresent) {
          finalTAC = "NA"; // ✅ Condition same as Horn logic
        }
  
        RWheelRimDataList.tacNumberList.push(finalTAC);
        RWheelRimDataList.MakeList.push(make);
        RWheelRimDataList.suppNameList.push(make);
  
        const { cop:rWheelCop, possible:rWheelPossibleDate } = TACvalidationcheck(
          tacValueRaw,
          copCertRaw,
          possibleDateRaw
        );
        RWheelRimDataList.copCertList.push(rWheelCop);
        RWheelRimDataList.possibleDateList.push(rWheelPossibleDate);
      }
    }
  });

  console.log("FWheelRimDataList.suppNameList", FWheelRimDataList.suppNameList);
  console.log(
    "FWheelRimDataList.tacNumberList",
    FWheelRimDataList.tacNumberList
  );
  console.log("FWheelRimDataList.MakeList", FWheelRimDataList.MakeList);
  console.log(
    "FWheelRimDataList.possibleDateList",
    FWheelRimDataList.possibleDateList
  );
  console.log("FWheelRimDataList.copCertList", FWheelRimDataList.copCertList);

  console.log("RWheelRimDataList.suppNameList", RWheelRimDataList.suppNameList);
  console.log(
    "RWheelRimDataList.tacNumberList",
    RWheelRimDataList.tacNumberList
  );
  console.log("RWheelRimDataList.MakeList", RWheelRimDataList.MakeList);
  console.log(
    "RWheelRimDataList.possibleDateList",
    RWheelRimDataList.possibleDateList
  );
  console.log("RWheelRimDataList.copCertList", RWheelRimDataList.copCertList);

  // const WindscreenList = form8Data?.Wind_screen?.Windscreen;
  // let WindscreenDataList = mainData();

  // WindscreenList.map(vehWindscreen => {
  //     if (vehWindscreen.supplier.active === true) {
  //         let supplierName = vehWindscreen?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // WindscreenDataList.suppNameList.push(supplierName);
  //         // // WindscreenDataList.suppNameList.push(vehWindscreen?.supplier?.nameOfSupplier);
  //         // WindscreenDataList.tacNumberList.push(vehWindscreen?.Windscreen?.properties?.BIS_License_Number_Validity?.value);
  //         // Get the TAC Number value for Windscreen
  //         const windscreenTACValue = vehWindscreen?.Windscreen?.properties?.BIS_License_Number_Validity?.value;

  //         // Push the TAC value to WindscreenDataList
  //         WindscreenDataList.tacNumberList.push(windscreenTACValue);

  //         // Check if TAC value is present
  //         // WindscreenDataList.suppNameList.push(windscreenTACValue ? supplierName : "");
  //         // WindscreenDataList.suppNameList.push(windscreenTACValue === "NA" ? "" : supplierName);
  //         if (windscreenTACValue && windscreenTACValue.trim() !== "") {
  //             WindscreenDataList.suppNameList.push(supplierName);
  //         }

  //         WindscreenDataList.possibleDateList.push(vehWindscreen?.Windscreen?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         WindscreenDataList.copCertList.push(vehWindscreen?.Windscreen?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });
  // if (twoWheeler) {
  //     WindscreenDataList.suppNameList = ["NA"];
  //     WindscreenDataList.tacNumberList = ["NA"];
  //     WindscreenDataList.possibleDateList = ["NA"];
  //     WindscreenDataList.copCertList = ["NA"];
  //     WindscreenDataList.MakeList = ["NA"];
  // } else {
  //     WindscreenList?.forEach(vehWindscreen => {
  //         if (vehWindscreen?.supplier?.active === true) {
  //             const tacValue = vehWindscreen?.Windscreen?.properties?.BIS_License_Number_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let supplierName = vehWindscreen?.supplier?.nameOfSupplier || "";

  //                 if (!supplierName.startsWith("M/")) {
  //                     supplierName = `M/s. ${supplierName}`;
  //                 }

  //                 WindscreenDataList.suppNameList.push(supplierName);
  //                 WindscreenDataList.tacNumberList.push(tacValue);
  //                 WindscreenDataList.possibleDateList.push(
  //                     vehWindscreen?.Windscreen?.properties?.Possible_date_of_submission_of_required_approval?.value || ""
  //                 );
  //                 WindscreenDataList.copCertList.push(
  //                     vehWindscreen?.Windscreen?.properties?.CoP_Cert_No_with_validity_date?.value || ""
  //                 );
  //                 WindscreenDataList.MakeList.push(
  //                     vehWindscreen?.Windscreen?.properties?.Make?.value || ""
  //                 );
  //             }
  //         }
  //     });
  // }

  // const WindscreenList = form8Data?.Wind_screen?.Windscreen;
  // let WindscreenDataList = mainData();

  // if (twoWheeler) {
  //     WindscreenDataList.suppNameList = ["NA"];
  //     WindscreenDataList.tacNumberList = ["NA"];
  //     WindscreenDataList.possibleDateList = ["NA"];
  //     WindscreenDataList.copCertList = ["NA"];
  // } else {
  //     WindscreenList?.forEach(vehWindscreen => {
  //         if (vehWindscreen?.supplier?.active === true) {
  //             const tacValue = vehWindscreen?.Windscreen?.properties?.BIS_License_Number_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let make = vehWindscreen?.Windscreen?.properties?.Make?.value || "";

  //                 if (make && !make.startsWith("M/")) {
  //                     make = `M/s. ${make}`;
  //                 }

  //                 WindscreenDataList.suppNameList.push(make);
  //                 WindscreenDataList.tacNumberList.push(tacValue);

  //                 const possibleDate = (make.includes("NA"))
  //                     ? "NA"
  //                     : vehWindscreen?.Windscreen?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //                 WindscreenDataList.possibleDateList.push(possibleDate);
  //                 WindscreenDataList.copCertList.push(
  //                     vehWindscreen?.Windscreen?.properties?.CoP_Cert_No_with_validity_date?.value || ""
  //                 );
  //                 WindscreenDataList.MakeList.push(make);
  //             }
  //         }
  //     });
  // }

  //   const WindscreenList = form8Data?.Wind_screen?.Windscreen;
  //   let WindscreenDataList = mainData();

  //   if (twoWheeler) {
  //     WindscreenDataList.suppNameList = ["NA"];
  //     WindscreenDataList.tacNumberList = ["NA"];
  //     WindscreenDataList.possibleDateList = ["NA"];
  //     WindscreenDataList.copCertList = ["NA"];
  //     WindscreenDataList.MakeList = ["NA"];
  //   } else {
  //     WindscreenList?.forEach((vehWindscreen) => {
  //       if (vehWindscreen?.supplier?.active === true) {
  //         const tacRaw =
  //           vehWindscreen?.Windscreen?.properties?.BIS_License_Number_Validity?.value?.trim() ||
  //           "";
  //         const copCert =
  //           vehWindscreen?.Windscreen?.properties?.CoP_Cert_No_with_validity_date
  //             ?.value || "";
  //         const possibleDate =
  //           vehWindscreen?.Windscreen?.properties
  //             ?.Possible_date_of_submission_of_required_approval?.value || "";

  //         if (tacRaw && tacRaw !== "NA") {
  //           let make = vehWindscreen?.Windscreen?.properties?.Make?.value || "";
  //           if (make && !make.startsWith("M/")) {
  //             make = `M/s. ${make}`;
  //           }

  //           WindscreenDataList.tacNumberList.push(tacRaw);
  //           WindscreenDataList.MakeList.push(make);
  //           WindscreenDataList.suppNameList.push(make);

  //           const { cop, possible } = TACvalidationcheck(
  //             tacRaw,
  //             copCert,
  //             possibleDate
  //           );
  //           WindscreenDataList.copCertList.push(cop);
  //           WindscreenDataList.possibleDateList.push(possible);
  //         }
  //       }
  //     });
  //   }

  // const WindscreenList = form8Data?.Wind_screen?.Windscreen || [];
  // let WindscreenDataList = mainData();

  // if (twoWheeler) {
  //   WindscreenDataList.suppNameList = ["NA"];
  //   WindscreenDataList.tacNumberList = ["NA"];
  //   WindscreenDataList.possibleDateList = ["NA"];
  //   WindscreenDataList.copCertList = ["NA"];
  //   WindscreenDataList.MakeList = ["NA"];
  // } else {
  //   WindscreenList.map((vehWindscreen) => {
  //     if (vehWindscreen?.supplier?.active === true) {
  //       let make = vehWindscreen?.Windscreen?.properties?.Make?.value || "";
  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       const tacRaw =
  //         vehWindscreen?.Windscreen?.properties?.BIS_License_Number_Validity?.value?.trim() || "";
  //       const copCert =
  //         vehWindscreen?.Windscreen?.properties?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDate =
  //         vehWindscreen?.Windscreen?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //       WindscreenDataList.tacNumberList.push(tacRaw);
  //       WindscreenDataList.MakeList.push(make);
  //       WindscreenDataList.suppNameList.push(make);

  //       const { cop, possible } = TACvalidationcheck(tacRaw, copCert, possibleDate);
  //       WindscreenDataList.copCertList.push(cop);
  //       WindscreenDataList.possibleDateList.push(possible);
  //     }
  //   });
  // }

  const WindscreenList = form8Data?.Wind_screen?.Windscreen || [];
  let WindscreenDataList = mainData();

  if (twoWheeler) {
    WindscreenDataList.suppNameList = ["NA"];
    WindscreenDataList.tacNumberList = ["NA"];
    WindscreenDataList.possibleDateList = ["NA"];
    WindscreenDataList.copCertList = ["NA"];
    WindscreenDataList.MakeList = ["NA"];
  } else {
    WindscreenList.map((vehWindscreen) => {
      if (vehWindscreen?.supplier?.active === true) {
        // let make = vehWindscreen?.Windscreen?.properties?.Make?.value || "";
        // if (make && !make.startsWith("M/")) {
        //   make = `M/s. ${make}`;
        // }
        let make = makePrefix(vehWindscreen?.Windscreen?.properties?.Make?.value);

        const tacRaw =
          vehWindscreen?.Windscreen?.properties?.BIS_License_Number_Validity?.value?.trim() ||
          "";
        const copCert =
          vehWindscreen?.Windscreen?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() ||
          "";
        const possibleDate =
          vehWindscreen?.Windscreen?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
          "";

        // TAC fallback logic
        const isTacMissing = tacRaw === "";
        const isPossibleDatePresent = possibleDate !== "";

        let finalTAC = tacRaw;
        if (isTacMissing && isPossibleDatePresent) {
          finalTAC = "NA";
        }

        WindscreenDataList.tacNumberList.push(finalTAC);
        WindscreenDataList.MakeList.push(make);
        WindscreenDataList.suppNameList.push(make);

        const { cop, possible } = TACvalidationcheck(
          tacRaw,
          copCert,
          possibleDate
        );
        WindscreenDataList.copCertList.push(cop);
        WindscreenDataList.possibleDateList.push(possible);
      }
    });
  }

  console.log(
    "windscreendatalist.suppNameList",
    WindscreenDataList.suppNameList
  );
  console.log(
    "windscreendatalist.tacNumberList",
    WindscreenDataList.tacNumberList
  );
  console.log(
    "windscreendatalist.possibleDateList",
    WindscreenDataList.possibleDateList
  );
  console.log("windscreendatalist.copCertList", WindscreenDataList.copCertList);
  console.log("windscreendatalist.MakeList", WindscreenDataList.MakeList);

  // const SideglassList = form8Data?.Side_glass?.Sideglass;
  // let SideglassDataList = mainData();
  // // SideglassList.map(vehSideglass => {
  // //     if (vehSideglass.supplier.active === true) {
  // //         let supplierName = vehSideglass?.supplier?.nameOfSupplier;

  // //         // Modify supplierName directly
  // //         if (!supplierName.startsWith("M/")) {
  // //             supplierName = `M/s. ${supplierName}`;
  // //         }

  // //         // SideglassDataList.suppNameList.push(supplierName);
  // //         // // SideglassDataList.suppNameList.push(vehSideglass?.supplier?.nameOfSupplier);
  // //         // SideglassDataList.tacNumberList.push(vehSideglass?.Side_Glass?.properties?.BIS_License_Number_Validity?.value);
  // //         // Get the TAC Number value for Side Glass
  // //         const sideglassTACValue = vehSideglass?.Side_Glass?.properties?.BIS_License_Number_Validity?.value;

  // //         // Push the TAC value to SideglassDataList
  // //         SideglassDataList.tacNumberList.push(sideglassTACValue);

  // //         // Check if TAC value is present
  // //         // SideglassDataList.suppNameList.push(sideglassTACValue ? supplierName : "");
  // //         // SideglassDataList.suppNameList.push(sideglassTACValue === "NA" ? "" : supplierName);
  // //         if (sideglassTACValue && sideglassTACValue.trim() !== "") {
  // //             SideglassDataList.suppNameList.push(supplierName);
  // //         }

  // //         SideglassDataList.possibleDateList.push(vehSideglass?.Side_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value);
  // //         SideglassDataList.copCertList.push(vehSideglass?.Side_Glass?.properties?.CoP_Cert_No_with_validity_date?.value);
  // //     }
  // // });

  // if (twoWheeler) {
  //     SideglassDataList.suppNameList = ["NA"];
  //     SideglassDataList.tacNumberList = ["NA"];
  //     SideglassDataList.possibleDateList = ["NA"];
  //     SideglassDataList.copCertList = ["NA"];
  // } else {
  //     SideglassList?.forEach(vehSideglass => {
  //         if (vehSideglass?.supplier?.active === true) {
  //             const tacValue = vehSideglass?.Side_Glass?.properties?.BIS_License_Number_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let supplierName = vehSideglass?.supplier?.nameOfSupplier || "";

  //                 if (!supplierName.startsWith("M/")) {
  //                     supplierName = `M/s. ${supplierName}`;
  //                 }

  //                 SideglassDataList.suppNameList.push(supplierName);
  //                 SideglassDataList.tacNumberList.push(tacValue);
  //                 SideglassDataList.possibleDateList.push(
  //                     vehSideglass?.Side_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || ""
  //                 );
  //                 SideglassDataList.copCertList.push(
  //                     vehSideglass?.Side_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || ""
  //                 );
  //             }
  //         }
  //     });
  // }

  // const SideglassList = form8Data?.Side_glass?.Sideglass;

  // let SideglassDataList = mainData();

  // if (twoWheeler) {
  //     SideglassDataList.suppNameList = ["NA"];
  //     SideglassDataList.tacNumberList = ["NA"];
  //     SideglassDataList.possibleDateList = ["NA"];
  //     SideglassDataList.copCertList = ["NA"];
  // } else {
  //     SideglassList?.forEach(vehSideglass => {
  //         if (vehSideglass?.supplier?.active === true) {
  //             const tacValue = vehSideglass?.Side_Glass?.properties?.BIS_License_Number_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let make = vehSideglass?.Side_Glass?.properties?.Make?.value || "";

  //                 if (make && !make.startsWith("M/")) {
  //                     make = `M/s. ${make}`;
  //                 }

  //                 SideglassDataList.suppNameList.push(make);
  //                 SideglassDataList.tacNumberList.push(tacValue);

  //                 const possibleDate = (make.includes("NA"))
  //                     ? "NA"
  //                     : vehSideglass?.Side_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //                 SideglassDataList.possibleDateList.push(possibleDate);
  //                 SideglassDataList.copCertList.push(
  //                     vehSideglass?.Side_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || ""
  //                 );
  //                 console.log("SuppNameList (Make):", SideglassDataList.suppNameList);
  //                 console.log("TAC Number List:", SideglassDataList.tacNumberList);
  //                 console.log("Possible Date List:", SideglassDataList.possibleDateList);
  //                 console.log("CoP Cert List:", SideglassDataList.copCertList);

  //             }
  //         }
  //     });
  // }

  //   const SideglassList = form8Data?.Side_glass?.Sideglass;
  //   let SideglassDataList = mainData();

  //   if (twoWheeler) {
  //     SideglassDataList.suppNameList = ["NA"];
  //     SideglassDataList.tacNumberList = ["NA"];
  //     SideglassDataList.possibleDateList = ["NA"];
  //     SideglassDataList.copCertList = ["NA"];
  //     SideglassDataList.MakeList = ["NA"];
  //   } else {
  //     SideglassList?.forEach((vehSideglass) => {
  //       if (vehSideglass?.supplier?.active === true) {
  //         const tacRaw =
  //           vehSideglass?.Side_Glass?.properties?.BIS_License_Number_Validity?.value?.trim() ||
  //           "";
  //         const copCert =
  //           vehSideglass?.Side_Glass?.properties?.CoP_Cert_No_with_validity_date
  //             ?.value || "";
  //         const possibleDate =
  //           vehSideglass?.Side_Glass?.properties
  //             ?.Possible_date_of_submission_of_required_approval?.value || "";
  //             let make = vehSideglass?.Side_Glass?.properties?.Make?.value || "";
  //             if (make && !make.startsWith("M/")) {
  //               make = `M/s. ${make}`;
  //             }
  //         SideglassDataList.MakeList.push(make);
  //         SideglassDataList.suppNameList.push(make);
  //         if (tacRaw && tacRaw !== "NA") {

  //           SideglassDataList.tacNumberList.push(tacRaw);

  //           const { cop, possible } = TACvalidationcheck(
  //             tacRaw,
  //             copCert,
  //             possibleDate
  //           );
  //           SideglassDataList.copCertList.push(cop);
  //           SideglassDataList.possibleDateList.push(possible);
  //         }
  //         console.log("SuppNameList (Make):", SideglassDataList.suppNameList);
  //         console.log("TAC Number List:", SideglassDataList.tacNumberList);
  //         console.log("Possible Date List:", SideglassDataList.possibleDateList);
  //         console.log("CoP Cert List:", SideglassDataList.copCertList);
  //       }
  //     });
  //   }

  // const SideglassList = form8Data?.Side_glass?.Sideglass || [];
  // let SideglassDataList = mainData();

  // if (twoWheeler) {
  //   SideglassDataList.suppNameList = ["NA"];
  //   SideglassDataList.tacNumberList = ["NA"];
  //   SideglassDataList.possibleDateList = ["NA"];
  //   SideglassDataList.copCertList = ["NA"];
  //   SideglassDataList.MakeList = ["NA"];
  // } else {
  //   SideglassList.map((vehSideglass) => {
  //     if (vehSideglass?.supplier?.active === true) {
  //       const tacRaw =
  //         vehSideglass?.Side_Glass?.properties?.BIS_License_Number_Validity?.value?.trim() || "";
  //       const copCert =
  //         vehSideglass?.Side_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDate =
  //         vehSideglass?.Side_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //       let make = vehSideglass?.Side_Glass?.properties?.Make?.value || "";
  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       SideglassDataList.MakeList.push(make);
  //       SideglassDataList.suppNameList.push(make);
  //       SideglassDataList.tacNumberList.push(tacRaw);

  //       const { cop, possible } = TACvalidationcheck(tacRaw, copCert, possibleDate);
  //       SideglassDataList.copCertList.push(cop);
  //       SideglassDataList.possibleDateList.push(possible);
  //     }
  //   });
  // }

  const SideglassList = form8Data?.Side_glass?.Sideglass || [];
  let SideglassDataList = mainData();

  if (twoWheeler) {
    SideglassDataList.suppNameList = ["NA"];
    SideglassDataList.tacNumberList = ["NA"];
    SideglassDataList.possibleDateList = ["NA"];
    SideglassDataList.copCertList = ["NA"];
    SideglassDataList.MakeList = ["NA"];
  } else {
    SideglassList.map((vehSideglass) => {
      if (vehSideglass?.supplier?.active === true) {
        const tacRaw =
          vehSideglass?.Side_Glass?.properties?.BIS_License_Number_Validity?.value?.trim() ||
          "";
        const copCert =
          vehSideglass?.Side_Glass?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() ||
          "";
        const possibleDate =
          vehSideglass?.Side_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
          "";

        // let make = vehSideglass?.Side_Glass?.properties?.Make?.value || "";
        // if (make && !make.startsWith("M/")) {
        //   make = `M/s. ${make}`;
        // }
        let make = makePrefix(vehSideglass?.Side_Glass?.properties?.Make?.value);

        // TAC fallback logic
        const isTacMissing = tacRaw === "";
        const isPossibleDatePresent = possibleDate !== "";

        let finalTAC = tacRaw;
        if (isTacMissing && isPossibleDatePresent) {
          finalTAC = "NA";
        }

        SideglassDataList.MakeList.push(make);
        SideglassDataList.suppNameList.push(make);
        SideglassDataList.tacNumberList.push(finalTAC);

        const { cop, possible } = TACvalidationcheck(
          tacRaw,
          copCert,
          possibleDate
        );
        SideglassDataList.copCertList.push(cop);
        SideglassDataList.possibleDateList.push(possible);
      }
    });
  }

  // const RearglassList = form8Data?.Rear_glass?.Rearglass;
  // let RearglassDataList = mainData();
  // // RearglassList.map(vehRearglass => {
  // //     if (vehRearglass.supplier.active === true) {
  // //         let supplierName = vehRearglass?.supplier?.nameOfSupplier;

  // //         // Modify supplierName directly
  // //         if (!supplierName.startsWith("M/")) {
  // //             supplierName = `M/s. ${supplierName}`;
  // //         }

  // //         // RearglassDataList.suppNameList.push(supplierName);
  // //         // // RearglassDataList.suppNameList.push(vehRearglass?.supplier?.nameOfSupplier);
  // //         // RearglassDataList.tacNumberList.push(vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value);
  // //         // Get the TAC Number value for Rear Glass
  // //         const rearglassTACValue = vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value;

  // //         // Push the TAC value to RearglassDataList
  // //         RearglassDataList.tacNumberList.push(rearglassTACValue);

  // //         // Check if TAC value is present
  // //         // RearglassDataList.suppNameList.push(rearglassTACValue ? supplierName : "");
  // //         // RearglassDataList.suppNameList.push(rearglassTACValue === "NA" ? "" : supplierName);
  // //         if (rearglassTACValue && rearglassTACValue.trim() !== "") {
  // //             RearglassDataList.suppNameList.push(supplierName);
  // //         }

  // //         RearglassDataList.possibleDateList.push(vehRearglass?.Rear_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value);
  // //         RearglassDataList.copCertList.push(vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date?.value);
  // //     }
  // // });
  // if (twoWheeler) {
  //     RearglassDataList.suppNameList = ["NA"];
  //     RearglassDataList.tacNumberList = ["NA"];
  //     RearglassDataList.possibleDateList = ["NA"];
  //     RearglassDataList.copCertList = ["NA"];
  // } else {
  //     RearglassList?.forEach(vehRearglass => {
  //         if (vehRearglass?.supplier?.active === true) {
  //             const tacValue = vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let supplierName = vehRearglass?.supplier?.nameOfSupplier || "";

  //                 if (!supplierName.startsWith("M/")) {
  //                     supplierName = `M/s. ${supplierName}`;
  //                 }

  //                 RearglassDataList.suppNameList.push(supplierName);
  //                 RearglassDataList.tacNumberList.push(tacValue);
  //                 RearglassDataList.possibleDateList.push(
  //                     vehRearglass?.Rear_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || ""
  //                 );
  //                 RearglassDataList.copCertList.push(
  //                     vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || ""
  //                 );
  //             }
  //         }
  //     });
  // }

  // const RearglassList = form8Data?.Rear_glass?.Rearglass;
  // let RearglassDataList = mainData();

  // if (twoWheeler) {
  //     RearglassDataList.suppNameList = ["NA"];
  //     RearglassDataList.tacNumberList = ["NA"];
  //     RearglassDataList.possibleDateList = ["NA"];
  //     RearglassDataList.copCertList = ["NA"];
  // } else {
  //     RearglassList?.forEach(vehRearglass => {
  //         if (vehRearglass?.supplier?.active === true) {
  //             const tacValue = vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let make = vehRearglass?.Rear_Glass?.properties?.Make?.value || "";

  //                 if (make && !make.startsWith("M/")) {
  //                     make = `M/s. ${make}`;
  //                 }

  //                 RearglassDataList.suppNameList.push(make);
  //                 RearglassDataList.tacNumberList.push(tacValue);

  //                 const possibleDate = (make.includes("NA"))
  //                     ? "NA"
  //                     : vehRearglass?.Rear_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //                 RearglassDataList.possibleDateList.push(possibleDate);
  //                 RearglassDataList.copCertList.push(
  //                     vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || ""
  //                 );
  //                 console.log("SuppNameList (Make):", RearglassDataList.suppNameList);
  //                 console.log("TAC Number List:", RearglassDataList.tacNumberList);
  //                 console.log("Possible Date List:", RearglassDataList.possibleDateList);
  //                 console.log("CoP Cert List:", RearglassDataList.copCertList);

  //             }
  //         }
  //     });
  // }

  // const RearglassList = form8Data?.Rear_glass?.Rearglass;
  // let RearglassDataList = mainData();

  // if (twoWheeler) {
  //     RearglassDataList.suppNameList = ["NA"];
  //     RearglassDataList.tacNumberList = ["NA"];
  //     RearglassDataList.possibleDateList = ["NA"];
  //     RearglassDataList.copCertList = ["NA"];
  // } else {
  //     RearglassList?.forEach(vehRearglass => {
  //         if (vehRearglass?.supplier?.active === true) {
  //             const tacValue = vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let make = vehRearglass?.Rear_Glass?.properties?.Make?.value || "";
  //                 if (make && !make.startsWith("M/")) {
  //                     make = `M/s. ${make}`;
  //                 }

  //                 RearglassDataList.tacNumberList.push(tacValue);
  //                 RearglassDataList.suppNameList.push(make);

  //                 const tacCheck = parseAndCheckTACValidity(tacValue);

  //                 if (tacCheck.hasDate) {
  //                     if (tacCheck.expired) {
  //                         RearglassDataList.possibleDateList.push(
  //                             vehRearglass?.Rear_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //                         );
  //                         RearglassDataList.copCertList.push(
  //                             vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || "NA"
  //                         );
  //                     } else {
  //                         RearglassDataList.possibleDateList.push("NA");
  //                         RearglassDataList.copCertList.push("NA");
  //                     }
  //                 } else {
  //                     RearglassDataList.possibleDateList.push(
  //                         vehRearglass?.Rear_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //                     );
  //                     RearglassDataList.copCertList.push(
  //                         vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || "NA"
  //                     );
  //                 }

  //                 console.log("SuppNameList (Make):", RearglassDataList.suppNameList);
  //                 console.log("TAC Number List:", RearglassDataList.tacNumberList);
  //                 console.log("Possible Date List:", RearglassDataList.possibleDateList);
  //                 console.log("CoP Cert List:", RearglassDataList.copCertList);
  //             }
  //         }
  //     });
  // }

  //   const RearglassList = form8Data?.Rear_glass?.Rearglass;
  //   let RearglassDataList = mainData();

  //   if (twoWheeler) {
  //     RearglassDataList.suppNameList = ["NA"];
  //     RearglassDataList.tacNumberList = ["NA"];
  //     RearglassDataList.possibleDateList = ["NA"];
  //     RearglassDataList.copCertList = ["NA"];
  //     RearglassDataList.MakeList = ["NA"];
  //   } else {
  //     RearglassList?.forEach((vehRearglass) => {
  //       if (vehRearglass?.supplier?.active === true) {
  //         const tacRaw =
  //           vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value?.trim() ||
  //           "";
  //         const copCert =
  //           vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date
  //             ?.value || "";
  //         const possibleDate =
  //           vehRearglass?.Rear_Glass?.properties
  //             ?.Possible_date_of_submission_of_required_approval?.value || "";
  //             let make = vehRearglass?.Rear_Glass?.properties?.Make?.value || "";
  //             if (make && !make.startsWith("M/")) {
  //               make = `M/s. ${make}`;
  //             }

  //         RearglassDataList.MakeList.push(make);
  //         RearglassDataList.suppNameList.push(make);
  //         if (tacRaw && tacRaw !== "NA") {

  //           RearglassDataList.tacNumberList.push(tacRaw);

  //           const { cop, possible } = TACvalidationcheck(
  //             tacRaw,
  //             copCert,
  //             possibleDate
  //           );
  //           RearglassDataList.copCertList.push(cop);
  //           RearglassDataList.possibleDateList.push(possible);
  //         }
  //         console.log("SuppNameList (Make):", RearglassDataList.suppNameList);
  //         console.log("TAC Number List:", RearglassDataList.tacNumberList);
  //         console.log("Possible Date List:", RearglassDataList.possibleDateList);
  //         console.log("CoP Cert List:", RearglassDataList.copCertList);
  //       }
  //     });
  //   }

  // const RearglassList = form8Data?.Rear_glass?.Rearglass || [];
  // let RearglassDataList = mainData();

  // if (twoWheeler) {
  //   RearglassDataList.suppNameList = ["NA"];
  //   RearglassDataList.tacNumberList = ["NA"];
  //   RearglassDataList.possibleDateList = ["NA"];
  //   RearglassDataList.copCertList = ["NA"];
  //   RearglassDataList.MakeList = ["NA"];
  // } else {
  //   RearglassList.map((vehRearglass) => {
  //     if (vehRearglass?.supplier?.active === true) {
  //       const tacRaw =
  //         vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value?.trim() || "";
  //       const copCert =
  //         vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDate =
  //         vehRearglass?.Rear_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //       let make = vehRearglass?.Rear_Glass?.properties?.Make?.value || "";
  //       if (make && !make.startsWith("M/")) {
  //         make = `M/s. ${make}`;
  //       }

  //       RearglassDataList.MakeList.push(make);
  //       RearglassDataList.suppNameList.push(make);
  //       RearglassDataList.tacNumberList.push(tacRaw);

  //       const { cop, possible } = TACvalidationcheck(tacRaw, copCert, possibleDate);
  //       RearglassDataList.copCertList.push(cop);
  //       RearglassDataList.possibleDateList.push(possible);
  //     }
  //   });
  // }

  const RearglassList = form8Data?.Rear_glass?.Rearglass || [];
  let RearglassDataList = mainData();

  if (twoWheeler) {
    RearglassDataList.suppNameList = ["NA"];
    RearglassDataList.tacNumberList = ["NA"];
    RearglassDataList.possibleDateList = ["NA"];
    RearglassDataList.copCertList = ["NA"];
    RearglassDataList.MakeList = ["NA"];
  } else {
    RearglassList.map((vehRearglass) => {
      if (vehRearglass?.supplier?.active === true) {
        const tacRaw =
          vehRearglass?.Rear_Glass?.properties?.BIS_License_Number_Validity?.value?.trim() ||
          "";
        const copCert =
          vehRearglass?.Rear_Glass?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() ||
          "";
        const possibleDate =
          vehRearglass?.Rear_Glass?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
          "";

        // let make = vehRearglass?.Rear_Glass?.properties?.Make?.value || "";
        // if (make && !make.startsWith("M/")) {
        //   make = `M/s. ${make}`;
        // }
        let make = makePrefix(vehRearglass?.Rear_Glass?.properties?.Make?.value);

        const isTacMissing = tacRaw === "";
        const isPossibleDatePresent = possibleDate !== "";

        let finalTAC = tacRaw;
        if (isTacMissing && isPossibleDatePresent) {
          finalTAC = "NA";
        }

        RearglassDataList.MakeList.push(make);
        RearglassDataList.suppNameList.push(make);
        RearglassDataList.tacNumberList.push(finalTAC);

        const { cop, possible } = TACvalidationcheck(
          tacRaw,
          copCert,
          possibleDate
        );
        RearglassDataList.copCertList.push(cop);
        RearglassDataList.possibleDateList.push(possible);
      }
    });
  }

  // const WindscreenwipingList = form8Data?.Windscreen_wiping?.Windscreenwiping;
  // let WindscreenwipingDataList = mainData();
  // WindscreenwipingList.map(vehWindscreenwiping => {
  //     if (vehWindscreenwiping.supplier.active === true) {
  //         let supplierName = vehWindscreenwiping?.supplier?.nameOfSupplier;

  //         // Modify supplierName directly
  //         if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // WindscreenwipingDataList.suppNameList.push(supplierName);
  //         // // WindscreenwipingDataList.suppNameList.push(vehWindscreenwiping?.supplier?.nameOfSupplier);
  //         // WindscreenwipingDataList.tacNumberList.push(vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value);
  //         // Get the TAC Number value for Wiping System
  //         const windscreenwipingTACValue = vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value;

  //         // Push the TAC value to WindscreenwipingDataList
  //         WindscreenwipingDataList.tacNumberList.push(windscreenwipingTACValue);

  //         // Check if TAC value is present
  //         // WindscreenwipingDataList.suppNameList.push(windscreenwipingTACValue ? supplierName : "");
  //         // WindscreenwipingDataList.suppNameList.push(windscreenwipingTACValue === "NA" ? "" : supplierName);

  //         if (windscreenwipingTACValue && windscreenwipingTACValue.trim() !== "") {
  //             WindscreenwipingDataList.suppNameList.push(supplierName);
  //         }

  //         WindscreenwipingDataList.possibleDateList.push(vehWindscreenwiping?.Wiping_System?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         WindscreenwipingDataList.copCertList.push(vehWindscreenwiping?.Wiping_System?.properties?.CoP_Cert_No_with_validity_date?.value);
  //     }
  // });

  // const WindscreenwipingList = form8Data?.Windscreen_wiping?.Windscreenwiping;
  // let WindscreenwipingDataList = mainData();
  // if (twoWheeler) {
  //     WindscreenwipingDataList.suppNameList = ["NA"];
  //     WindscreenwipingDataList.tacNumberList = ["NA"];
  //     WindscreenwipingDataList.possibleDateList = ["NA"];
  //     WindscreenwipingDataList.copCertList = ["NA"];
  // } else {
  //     WindscreenwipingList?.forEach(vehWindscreenwiping => {
  //         if (vehWindscreenwiping?.supplier?.active === true) {
  //             const tacValue = vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let supplierName = vehWindscreenwiping?.supplier?.nameOfSupplier || "";

  //                 if (!supplierName.startsWith("M/")) {
  //                     supplierName = `M/s. ${supplierName}`;
  //                 }

  //                 WindscreenwipingDataList.suppNameList.push(supplierName);
  //                 WindscreenwipingDataList.tacNumberList.push(tacValue);
  //                 WindscreenwipingDataList.possibleDateList.push(
  //                     vehWindscreenwiping?.Wiping_System?.properties?.Possible_date_of_submission_of_required_approval?.value || ""
  //                 );
  //                 WindscreenwipingDataList.copCertList.push(
  //                     vehWindscreenwiping?.Wiping_System?.properties?.CoP_Cert_No_with_validity_date?.value || ""
  //                 );
  //                 console.log("Windscreen SuppNameList:", WindscreenwipingDataList.suppNameList);
  //                 console.log("Windscreen TAC Number List:", WindscreenwipingDataList.tacNumberList);
  //                 console.log("Windscreen Possible Date List:", WindscreenwipingDataList.possibleDateList);
  //                 console.log("Windscreen CoP Cert List:", WindscreenwipingDataList.copCertList);

  //             }
  //         }
  //     });
  // }

  // const WindscreenwipingList = form8Data?.Windscreen_wiping?.Windscreenwiping;
  // let WindscreenwipingDataList = mainData();

  // if (twoWheeler) {
  //     WindscreenwipingDataList.suppNameList = ["NA"];
  //     WindscreenwipingDataList.tacNumberList = ["NA"];
  //     WindscreenwipingDataList.possibleDateList = ["NA"];
  //     WindscreenwipingDataList.copCertList = ["NA"];
  // } else {
  //     WindscreenwipingList?.forEach(vehWindscreenwiping => {
  //         if (vehWindscreenwiping?.supplier?.active === true) {
  //             const tacValue = vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value?.trim();

  //             if (tacValue && tacValue !== "NA") {
  //                 let supplierName = vehWindscreenwiping?.supplier?.nameOfSupplier || "";

  //                 if (!supplierName.startsWith("M/")) {
  //                     supplierName = `M/s. ${supplierName}`;
  //                 }

  //                 WindscreenwipingDataList.tacNumberList.push(tacValue);
  //                 WindscreenwipingDataList.suppNameList.push(supplierName);

  //                 const tacCheck = parseAndCheckTACValidity(tacValue);

  //                 if (tacCheck.hasDate) {
  //                     if (tacCheck.expired) {
  //                         WindscreenwipingDataList.possibleDateList.push(
  //                             vehWindscreenwiping?.Wiping_System?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //                         );
  //                         WindscreenwipingDataList.copCertList.push(
  //                             vehWindscreenwiping?.Wiping_System?.properties?.CoP_Cert_No_with_validity_date?.value || "NA"
  //                         );
  //                     } else {
  //                         WindscreenwipingDataList.possibleDateList.push("NA");
  //                         WindscreenwipingDataList.copCertList.push("NA");
  //                     }
  //                 } else {
  //                     WindscreenwipingDataList.possibleDateList.push(
  //                         vehWindscreenwiping?.Wiping_System?.properties?.Possible_date_of_submission_of_required_approval?.value || "NA"
  //                     );
  //                     WindscreenwipingDataList.copCertList.push(
  //                         vehWindscreenwiping?.Wiping_System?.properties?.CoP_Cert_No_with_validity_date?.value || "NA"
  //                     );
  //                 }

  //                 console.log("Windscreen SuppNameList:", WindscreenwipingDataList.suppNameList);
  //                 console.log("Windscreen TAC Number List:", WindscreenwipingDataList.tacNumberList);
  //                 console.log("Windscreen Possible Date List:", WindscreenwipingDataList.possibleDateList);
  //                 console.log("Windscreen CoP Cert List:", WindscreenwipingDataList.copCertList);
  //             }
  //         }
  //     });
  // }

  //   const WindscreenwipingList = form8Data?.Windscreen_wiping?.Windscreenwiping;
  //   let WindscreenwipingDataList = mainData();

  //   if (twoWheeler) {
  //     WindscreenwipingDataList.suppNameList = ["NA"];
  //     WindscreenwipingDataList.tacNumberList = ["NA"];
  //     WindscreenwipingDataList.possibleDateList = ["NA"];
  //     WindscreenwipingDataList.copCertList = ["NA"];
  //     WindscreenwipingDataList.MakeList = ["NA"];
  //   } else {
  //     WindscreenwipingList?.forEach((vehWindscreenwiping) => {
  //       if (vehWindscreenwiping?.supplier?.active === true) {
  //         const tacRaw =
  //           vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value?.trim() ||
  //           "";
  //         const copCert =
  //           vehWindscreenwiping?.Wiping_System?.properties
  //             ?.CoP_Cert_No_with_validity_date?.value || "";
  //         const possibleDate =
  //           vehWindscreenwiping?.Wiping_System?.properties
  //             ?.Possible_date_of_submission_of_required_approval?.value || "";
  //             let supplierName =
  //             vehWindscreenwiping?.supplier?.nameOfSupplier || "";
  //           if (!supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //           }

  //         WindscreenwipingDataList.suppNameList.push(supplierName);
  //         WindscreenwipingDataList.MakeList.push(supplierName); // Assuming MakeList should match supplier name
  //         if (tacRaw && tacRaw !== "NA") {

  //           WindscreenwipingDataList.tacNumberList.push(tacRaw);

  //           const { cop, possible } = TACvalidationcheck(
  //             tacRaw,
  //             copCert,
  //             possibleDate
  //           );
  //           WindscreenwipingDataList.copCertList.push(cop);
  //           WindscreenwipingDataList.possibleDateList.push(possible);
  //         }

  //         console.log(
  //           "Windscreenwiping SuppNameList:",
  //           WindscreenwipingDataList.suppNameList
  //         );
  //         console.log(
  //           "Windscreenwiping Validity List:",
  //           WindscreenwipingDataList.tacNumberList
  //         );
  //         console.log(
  //           "Windscreenwiping Possible Date List:",
  //           WindscreenwipingDataList.possibleDateList
  //         );
  //         console.log(
  //           "Windscreenwiping CoP Cert List:",
  //           WindscreenwipingDataList.copCertList
  //         );
  //       }
  //     });
  //   }

  // const WindscreenwipingList = form8Data?.Windscreen_wiping?.Windscreenwiping || [];
  // let WindscreenwipingDataList = mainData();

  // if (twoWheeler) {
  //   WindscreenwipingDataList.suppNameList = ["NA"];
  //   WindscreenwipingDataList.tacNumberList = ["NA"];
  //   WindscreenwipingDataList.possibleDateList = ["NA"];
  //   WindscreenwipingDataList.copCertList = ["NA"];
  //   WindscreenwipingDataList.MakeList = ["NA"];
  // } else {
  //   WindscreenwipingList.map((vehWindscreenwiping) => {
  //     if (vehWindscreenwiping?.supplier?.active === true) {
  //       const tacRaw =
  //         vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value?.trim() || "";
  //       const copCert =
  //         vehWindscreenwiping?.Wiping_System?.properties?.CoP_Cert_No_with_validity_date?.value || "";
  //       const possibleDate =
  //         vehWindscreenwiping?.Wiping_System?.properties?.Possible_date_of_submission_of_required_approval?.value || "";

  //       let supplierName = vehWindscreenwiping?.supplier?.nameOfSupplier || "";
  //       if (supplierName && !supplierName.startsWith("M/")) {
  //         supplierName = `M/s. ${supplierName}`;
  //       }

  //       WindscreenwipingDataList.suppNameList.push(supplierName);
  //       WindscreenwipingDataList.MakeList.push(supplierName); // Assuming MakeList = SupplierName

  //       WindscreenwipingDataList.tacNumberList.push(tacRaw);

  //       const { cop, possible } = TACvalidationcheck(tacRaw, copCert, possibleDate);
  //       WindscreenwipingDataList.copCertList.push(cop);
  //       WindscreenwipingDataList.possibleDateList.push(possible);
  //     }
  //   });
  // }

//   const WindscreenwipingList =
//     form8Data?.Windscreen_wiping?.Windscreenwiping || [];
    
//   let WindscreenwipingDataList = mainData();

//   if (twoWheeler) {
//     WindscreenwipingDataList.suppNameList = ["NA"];
//     WindscreenwipingDataList.tacNumberList = ["NA"];
//     WindscreenwipingDataList.possibleDateList = ["NA"];
//     WindscreenwipingDataList.copCertList = ["NA"];
//     WindscreenwipingDataList.MakeList = ["NA"];
//   } else {
//     WindscreenwipingList.map((vehWindscreenwiping) => {
//       if (vehWindscreenwiping?.supplier?.active === true) {
//         const tacRaw =
//           vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value?.trim() ||
//           "";
//         const copCert =
//           vehWindscreenwiping?.Wiping_System?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() ||
//           "";
//         const possibleDate =
//           vehWindscreenwiping?.Wiping_System?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() ||
//           "";

//         // let supplierName = vehWindscreenwiping?.supplier?.nameOfSupplier || "";
//         // if (supplierName && !supplierName.startsWith("M/")) {
//         //   supplierName = `M/s. ${supplierName}`;
//         // }
//         let supplierName = makePrefix(vehWindscreenwiping?.supplier?.nameOfSupplier);

//         const isTacMissing = tacRaw === "";
//         const isPossibleDatePresent = possibleDate !== "";

//         let finalTAC = tacRaw;
//         if (isTacMissing && isPossibleDatePresent) {
//           finalTAC = "NA";
//         }

//         WindscreenwipingDataList.suppNameList.push(supplierName);
//         WindscreenwipingDataList.MakeList.push(supplierName); // if Make = Supplier name
//         WindscreenwipingDataList.tacNumberList.push(finalTAC);

//         const { cop, possible } = TACvalidationcheck(
//           tacRaw,
//           copCert,
//           possibleDate
//         );
//         WindscreenwipingDataList.copCertList.push(cop);
//         WindscreenwipingDataList.possibleDateList.push(possible);
//       }
//     });
//   }


const WindscreenwipingList = form8Data?.Windscreen_wiping?.Windscreenwiping || [];

let WindscreenwipingDataList = mainData();
let WindscreenWashingDataList = mainData();
let WindscreenWiperDataList = mainData();

if (twoWheeler) {
  // Wiping
  WindscreenwipingDataList.suppNameList = ["NA"];
  WindscreenwipingDataList.tacNumberList = ["NA"];
  WindscreenwipingDataList.possibleDateList = ["NA"];
  WindscreenwipingDataList.copCertList = ["NA"];
  WindscreenwipingDataList.MakeList = ["NA"];

  // Washing
  WindscreenWashingDataList.suppNameList = ["NA"];
  WindscreenWashingDataList.tacNumberList = ["NA"];
  WindscreenWashingDataList.possibleDateList = ["NA"];
  WindscreenWashingDataList.copCertList = ["NA"];
  WindscreenWashingDataList.MakeList = ["NA"];

  // Wiper Blade
  WindscreenWiperDataList.suppNameList = ["NA"];
  WindscreenWiperDataList.tacNumberList = ["NA"];
  WindscreenWiperDataList.possibleDateList = ["NA"];
  WindscreenWiperDataList.copCertList = ["NA"];
  WindscreenWiperDataList.MakeList = ["NA"];
} else {
  WindscreenwipingList.forEach((vehWindscreenwiping) => {
    if (vehWindscreenwiping?.supplier?.active === true) {
      const supplierName = makePrefix(
        vehWindscreenwiping?.supplier?.nameOfSupplier
      );

      // Wiping System
      const tacRaw = vehWindscreenwiping?.Wiping_System?.properties?.TAC_Number_Its_Validity?.value?.trim() || "";
      const copCert = vehWindscreenwiping?.Wiping_System?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDate = vehWindscreenwiping?.Wiping_System?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissing = tacRaw === "";
      const isPossibleDatePresent = possibleDate !== "";
      let finalTAC = isTacMissing && isPossibleDatePresent ? "NA" : tacRaw;
      const WaipingMake = makePrefix(vehWindscreenwiping?.Wiping_System?.properties?.Make?.value);
      WindscreenwipingDataList.suppNameList.push(WaipingMake);
      WindscreenwipingDataList.MakeList.push(WaipingMake);
      WindscreenwipingDataList.tacNumberList.push(finalTAC);
      const { cop, possible } = TACvalidationcheck(tacRaw, copCert, possibleDate);
      WindscreenwipingDataList.copCertList.push(cop);
      WindscreenwipingDataList.possibleDateList.push(possible);

      // Washing System
      const tacRaw_Washing = vehWindscreenwiping?.Washing_System?.properties?.TAC_Number_Its_Validity?.value?.trim() || "";
      const copCert_Washing = vehWindscreenwiping?.Washing_System?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDate_Washing = vehWindscreenwiping?.Washing_System?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissing_Washing = tacRaw_Washing === "";
      const isPossibleDatePresent_Washing = possibleDate_Washing !== "";
      let finalTAC_Washing = isTacMissing_Washing && isPossibleDatePresent_Washing ? "NA" : tacRaw_Washing;


      const WashingMake = makePrefix(vehWindscreenwiping?.Washing_System?.properties?.Make?.value);
      WindscreenWashingDataList.suppNameList.push(WashingMake);
      WindscreenWashingDataList.MakeList.push(WashingMake);
      WindscreenWashingDataList.tacNumberList.push(finalTAC_Washing);
      const { cop: copWash, possible: possibleWash } = TACvalidationcheck(tacRaw_Washing, copCert_Washing, possibleDate_Washing);
      WindscreenWashingDataList.copCertList.push(copWash);
      WindscreenWashingDataList.possibleDateList.push(possibleWash);

      // Wiper Blade
      const tacRaw_Wiper = vehWindscreenwiping?.Wiper_Blade?.properties?.TAC_Number_Its_Validity?.value?.trim() || "";
      const copCert_Wiper = vehWindscreenwiping?.Wiper_Blade?.properties?.CoP_Cert_No_with_validity_date?.value?.trim() || "";
      const possibleDate_Wiper = vehWindscreenwiping?.Wiper_Blade?.properties?.Possible_date_of_submission_of_required_approval?.value?.trim() || "";

      const isTacMissing_Wiper = tacRaw_Wiper === "";
      const isPossibleDatePresent_Wiper = possibleDate_Wiper !== "";
      let finalTAC_Wiper = isTacMissing_Wiper && isPossibleDatePresent_Wiper ? "NA" : tacRaw_Wiper;
      const WiperMake = makePrefix(vehWindscreenwiping?.Wiper_Blade?.properties?.Make?.value);
      WindscreenWiperDataList.suppNameList.push(WiperMake);
      WindscreenWiperDataList.MakeList.push(WiperMake);
      WindscreenWiperDataList.tacNumberList.push(finalTAC_Wiper);
      const { cop: copWiper, possible: possibleWiper } = TACvalidationcheck(tacRaw_Wiper, copCert_Wiper, possibleDate_Wiper);
      WindscreenWiperDataList.copCertList.push(copWiper);
      WindscreenWiperDataList.possibleDateList.push(possibleWiper);
    }
  });
}


  // const SpraySuppressionList = form8Data?.Spray_Suppression?.SpraySuppression || [];
  // let SpraySuppressionDataList = mainData();

  // // Ensure suppNameList and MakeList are initialized as arrays
  // SpraySuppressionDataList.suppNameList = Array.isArray(SpraySuppressionDataList.suppNameList) ? SpraySuppressionDataList.suppNameList : [];
  // SpraySuppressionDataList.MakeList = Array.isArray(SpraySuppressionDataList.MakeList) ? SpraySuppressionDataList.MakeList : [];

  // SpraySuppressionList.map(vehSpraySuppression => {
  //     if (vehSpraySuppression?.supplier?.active === true) {
  //         // Push the supplier name and Make value to the respective lists
  //         SpraySuppressionDataList.suppNameList.push(vehSpraySuppression?.supplier?.nameOfSupplier || "NA");
  //         SpraySuppressionDataList.MakeList.push(vehSpraySuppression?.Spray_Suppression_System?.properties?.Make?.value || "NA");
  //     }
  // });

  // const SpraySuppressionList = form8Data?.Spray_Suppression?.SpraySuppression || [];
  // let SpraySuppressionDataList = mainData();

  // // Ensure suppNameList and MakeList are initialized as arrays
  // SpraySuppressionDataList.suppNameList = Array.isArray(SpraySuppressionDataList.suppNameList) ? SpraySuppressionDataList.suppNameList : [];
  // SpraySuppressionDataList.MakeList = Array.isArray(SpraySuppressionDataList.MakeList) ? SpraySuppressionDataList.MakeList : [];

  // SpraySuppressionList.map(vehSpraySuppression => {
  //     if (vehSpraySuppression?.supplier?.active === true) {
  //         let supplierName = vehSpraySuppression?.supplier?.nameOfSupplier || "NA";
  //         let makeValue = vehSpraySuppression?.Spray_Suppression_System?.properties?.Make?.value || "NA";

  //         // Modify supplierName if it does not start with "M/s."
  //         if (supplierName !== "NA" && !supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // Modify makeValue if it does not start with "M/s."
  //         if (makeValue !== "NA" && !makeValue.startsWith("M/")) {
  //             makeValue = `M/s. ${makeValue}`;
  //         }

  //         // SpraySuppressionDataList.suppNameList.push(supplierName);
  //         // SpraySuppressionDataList.MakeList.push(makeValue);
  //         if (twoWheeler) {
  //             SpraySuppressionDataList.suppNameList.push(supplierName);
  //             SpraySuppressionDataList.MakeList.push(makeValue);
  //             SpraySuppressionDataList.tacNumberList.push(vehSpraySuppression?.Spray_Suppression_System?.properties?.TAC_Number?.value);
  //             SpraySuppressionDataList.possibleDateList.push(vehSpraySuppression?.Spray_Suppression_System?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //             SpraySuppressionDataList.copCertList.push(vehSpraySuppression?.Spray_Suppression_System?.properties?.CoP_Cert_No_with_validity_date?.value);
  //         } else {
  //             SpraySuppressionDataList.suppNameList.push("NA");
  //             SpraySuppressionDataList.MakeList.push("NA");
  //             SpraySuppressionDataList.tacNumberList.push("NA");
  //             SpraySuppressionDataList.possibleDateList.push("NA");
  //             SpraySuppressionDataList.copCertList.push("NA");
  //         }
  //     }
  // });

  const SpraySuppressionList =
    form8Data?.Spray_Suppression?.SpraySuppression || [];
  let SpraySuppressionDataList = mainData();

  // Initialize all needed lists as arrays if not already
  SpraySuppressionDataList.suppNameList = Array.isArray(
    SpraySuppressionDataList.suppNameList
  )
    ? SpraySuppressionDataList.suppNameList
    : [];
  SpraySuppressionDataList.MakeList = Array.isArray(
    SpraySuppressionDataList.MakeList
  )
    ? SpraySuppressionDataList.MakeList
    : [];
  SpraySuppressionDataList.tacNumberList = Array.isArray(
    SpraySuppressionDataList.tacNumberList
  )
    ? SpraySuppressionDataList.tacNumberList
    : [];
  SpraySuppressionDataList.possibleDateList = Array.isArray(
    SpraySuppressionDataList.possibleDateList
  )
    ? SpraySuppressionDataList.possibleDateList
    : [];
  SpraySuppressionDataList.copCertList = Array.isArray(
    SpraySuppressionDataList.copCertList
  )
    ? SpraySuppressionDataList.copCertList
    : [];

  SpraySuppressionList.forEach((vehSpraySuppression) => {
    if (vehSpraySuppression?.supplier?.active === true) {
    //   let supplierName = vehSpraySuppression?.supplier?.nameOfSupplier || " ";
    //   let makeValue =
    //     vehSpraySuppression?.Spray_Suppression_System?.properties?.Make
    //       ?.value || " ";

    //   if (supplierName !== "NA" && !supplierName.startsWith("M/")) {
    //     supplierName = `M/s. ${supplierName}`;
    //   }

    //   if (makeValue !== "NA" && !makeValue.startsWith("M/")) {
    //     makeValue = `M/s. ${makeValue}`;
    //   }
    let supplierName = makePrefix(vehSpraySuppression?.supplier?.nameOfSupplier);
    let makeValue = makePrefix(
      vehSpraySuppression?.Spray_Suppression_System?.properties?.Make?.value
    );
    
      const tacRaw =
        vehSpraySuppression?.Spray_Suppression_System?.properties?.TAC_Number
          ?.value || "";
      const tacCheck = parseAndCheckTACValidity(tacRaw);

      SpraySuppressionDataList.tacNumberList.push(tacRaw || "NA");
      SpraySuppressionDataList.MakeList.push(makeValue);

      const copCert =
        vehSpraySuppression?.Spray_Suppression_System?.properties
          ?.CoP_Cert_No_with_validity_date?.value || "NA";
      const possibleDate =
        vehSpraySuppression?.Spray_Suppression_System?.properties
          ?.Possible_date_of_submission_of_required_approval?.value || "NA";

      if (tacCheck.hasDate) {
        if (tacCheck.expired) {
          SpraySuppressionDataList.suppNameList.push(supplierName);
          SpraySuppressionDataList.copCertList.push(copCert);
          SpraySuppressionDataList.possibleDateList.push(possibleDate);
        } else {
          SpraySuppressionDataList.suppNameList.push(supplierName);
          SpraySuppressionDataList.copCertList.push("NA");
          SpraySuppressionDataList.possibleDateList.push("NA");
        }
      } else {
        SpraySuppressionDataList.suppNameList.push(supplierName);
        SpraySuppressionDataList.copCertList.push(copCert);
        SpraySuppressionDataList.possibleDateList.push(possibleDate);
      }
    }
  });

  console.log(
    "spraysuppressiondatalist.suppNameList",
    SpraySuppressionDataList.suppNameList
  );
  console.log(
    "spraysuppressiondatalist.MakeList",
    SpraySuppressionDataList.MakeList
  );
  console.log(
    "spraysuppressiondatalist.tacNumberList",
    SpraySuppressionDataList.tacNumberList
  );
  console.log(
    "spraysuppressiondatalist.possibleDateList",
    SpraySuppressionDataList.possibleDateList
  );
  console.log(
    "spraysuppressiondatalist.copCertList",
    SpraySuppressionDataList.copCertList
  );

  // const HandleLockList = form8Data?.Handle_Lock?.HandleLock || [];
  // // console.log("SpraySuppressionList:", SpraySuppressionList);
  // let HandleLockDataList = mainData();
  // // Ensure suppNameList and MakeList are initialized
  // HandleLockDataList.suppNameList = HandleLockDataList.suppNameList || [];
  // HandleLockDataList.MakeList = HandleLockDataList.MakeList || [];
  // HandleLockList.map(vehHandleLock => {
  //     if (vehHandleLock?.supplier?.active === true) {
  //         HandleLockDataList.suppNameList.push(vehHandleLock?.supplier?.nameOfSupplier);
  //         HandleLockDataList.MakeList.push(vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Make?.value);
  //     }
  // });

  // const HandleLockList = form8Data?.Handle_Lock?.HandleLock || [];
  // let HandleLockDataList = mainData();

  // // Ensure suppNameList and MakeList are initialized
  // HandleLockDataList.suppNameList = HandleLockDataList.suppNameList || [];
  // HandleLockDataList.MakeList = HandleLockDataList.MakeList || [];

  // HandleLockList.map(vehHandleLock => {
  //     if (vehHandleLock?.supplier?.active === true) {
  //         let supplierName = vehHandleLock?.supplier?.nameOfSupplier || "NA";
  //         let makeValue = vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Make?.value || "NA";

  //         // Modify supplierName if it does not start with "M/s."
  //         if (supplierName !== "NA" && !supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         // Modify makeValue if it does not start with "M/s."
  //         if (makeValue !== "NA" && !makeValue.startsWith("M/")) {
  //             makeValue = `M/s. ${makeValue}`;
  //         }

  //         HandleLockDataList.suppNameList.push(supplierName);
  //         HandleLockDataList.MakeList.push(makeValue);
  //     }
  // });

  // HandleLockList.map(vehHandleLock => {
  //     if (twoWheeler && vehHandleLock?.supplier?.active === true) {
  //         let supplierName = vehHandleLock?.supplier?.nameOfSupplier || "NA";
  //         let makeValue = vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Make?.value || "NA";

  //         // Add "M/s." prefix if not already present
  //         if (supplierName !== "NA" && !supplierName.startsWith("M/")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         if (makeValue !== "NA" && !makeValue.startsWith("M/")) {
  //             makeValue = `M/s. ${makeValue}`;
  //         }

  //         HandleLockDataList.suppNameList.push(supplierName);
  //         HandleLockDataList.MakeList.push(makeValue);
  //         HandleLockDataList.tacNumberList.push(vehHandleLock?.Protective_Device_Handle_Lock?.properties?.TAC_Number?.value);
  //         HandleLockDataList.possibleDateList.push(vehHandleLock?.Protective_Device_Handle_Lock?.properties?.Possible_date_of_submission_of_required_approval?.value);
  //         HandleLockDataList.copCertList.push(vehHandleLock?.Protective_Device_Handle_Lock?.properties?.CoP_Cert_No_with_validity_date?.value);

  //     } else {
  //         // Push "NA" if not a two-wheeler or supplier not active
  //         HandleLockDataList.suppNameList.push("NA");
  //         HandleLockDataList.MakeList.push("NA");
  //         HandleLockDataList.tacNumberList.push("NA");
  //         HandleLockDataList.possibleDateList.push("NA");
  //         HandleLockDataList.copCertList.push("NA");
  //     }
  // });

  const GrabHandleList = form8Data?.Grab_handle?.Grabhandle || [];
  let GrabHandleDataList = mainData();

  // Ensure suppNameList and MakeList are initialized

  GrabHandleDataList.MakeList = GrabHandleDataList.MakeList || [];

  GrabHandleList.map((GrabHandle) => {
    if (GrabHandle?.supplier?.active === true) {
    //   let makeValue =
    //     GrabHandle?.Grab_handle_Straps?.properties?.Make?.value || "NA";

    //   // Modify makeValue if it does not start with "M/s."
    //   if (makeValue !== "NA" && !makeValue.startsWith("M/")) {
    //     makeValue = `M/s. ${makeValue}`;
    //   }
    let makeValue = makePrefix(
        GrabHandle?.Grab_handle_Straps?.properties?.Make?.value || "NA"
      );
      
      GrabHandleDataList.MakeList.push(makeValue);
    }
  });
  console.log(
    "grabhandle datallist.MakesList:",
    GrabHandleDataList.MakeLampList
  );
  // ///////////////

  // const BrakeFluidList = form8Data?.Brake_Fluid?.BrakeFluid || [];
  // let BrakeFluidDataList = mainData();
  // // Ensure suppNameList and MakeList are initialized
  // BrakeFluidDataList.suppNameList = BrakeFluidDataList.suppNameList || [];
  // BrakeFluidDataList.MakeList = BrakeFluidDataList.Brake_fluid_Test_Report_No || [];
  // BrakeFluidList.map(vehBrakeFluid => {
  //     if (vehBrakeFluid?.supplier?.active === true) {
  //         BrakeFluidDataList.suppNameList.push(vehBrakeFluid?.supplier?.nameOfSupplier);
  //         BrakeFluidDataList.tacNumberList.push(vehBrakeFluid?.Hydraulic_Brake_Fluid?.properties?.Brake_fluid_Test_Report_No?.value);
  //     }
  // });
  // const BrakeFluidList = form8Data?.Brake_Fluid?.BrakeFluid || [];
  // let BrakeFluidDataList = mainData();

  // // Ensure suppNameList is initialized
  // BrakeFluidDataList.suppNameList = BrakeFluidDataList.suppNameList || [];
  // BrakeFluidDataList.tacNumberList = BrakeFluidDataList.tacNumberList || [];

  // BrakeFluidList.map(vehBrakeFluid => {
  //     if (vehBrakeFluid?.supplier?.active === true) {
  //         let supplierName = vehBrakeFluid?.supplier?.nameOfSupplier || "NA";

  //         // Modify supplierName if it does not start with "M/s."
  //         if (supplierName !== "NA" && !supplierName.startsWith("M/s")) {
  //             supplierName = `M/s. ${supplierName}`;
  //         }

  //         BrakeFluidDataList.suppNameList.push(supplierName);
  //         BrakeFluidDataList.tacNumberList.push(
  //             vehBrakeFluid?.Hydraulic_Brake_Fluid?.properties?.Brake_fluid_Test_Report_No?.value
  //         );
  //         BrakeFluidDataList.MakeList.push(
  //             vehBrakeFluid?.Hydraulic_Brake_Fluid?.properties?.Make?.value
  //         );
  //     }
  // });

  // console.log('BrakeFluidDataList.suppNameList', BrakeFluidDataList.suppNameList);
  // console.log('BrakeFluidDataList.tacNumberList', BrakeFluidDataList.tacNumberList);

  const BrakeFluidList = form8Data?.Brake_Fluid?.BrakeFluid || [];
  let BrakeFluidDataList = mainData();

  // Ensure lists are initialized
  BrakeFluidDataList.suppNameList = BrakeFluidDataList.suppNameList || [];
  BrakeFluidDataList.tacNumberList = BrakeFluidDataList.tacNumberList || [];
  BrakeFluidDataList.MakeList = BrakeFluidDataList.MakeList || [];

  BrakeFluidList.map((vehBrakeFluid) => {
    if (vehBrakeFluid?.supplier?.active === true) {
      let supplierName = vehBrakeFluid?.supplier?.nameOfSupplier || "NA";

      // No M/s prefix for supplier name anymore
      BrakeFluidDataList.suppNameList.push(supplierName);

      BrakeFluidDataList.tacNumberList.push(
        vehBrakeFluid?.Hydraulic_Brake_Fluid?.properties
          ?.Brake_fluid_Test_Report_No?.value
      );

    //   let make =
    //     vehBrakeFluid?.Hydraulic_Brake_Fluid?.properties?.Make?.value || "";
    //   if (make !== "NA" && !make.startsWith("M/s")) {
    //     make = `M/s. ${make}`;
    //   }
    let make = makePrefix(
        vehBrakeFluid?.Hydraulic_Brake_Fluid?.properties?.Make?.value
      );
      
      BrakeFluidDataList.MakeList.push(make);
    }
  });

  console.log(
    "BrakeFluidDataList.suppNameList",
    BrakeFluidDataList.suppNameList
  );
  console.log(
    "BrakeFluidDataList.tacNumberList",
    BrakeFluidDataList.tacNumberList
  );
  console.log("BrakeFluidDataList.MakeList", BrakeFluidDataList.MakeList);
 const today = new Date();
const formattedDate = today.toLocaleDateString("en-GB");
  const form8Document = new Document({
    styles: {
      paragraphStyles: [
        {
          id: "table1Header",
          name: "table1Header",
          basedOn: "Normal",
          run: {
            size: "12pt",
          },
          paragraph: {
            size: "12pt",
            indent: {
              left: "0.2cm",
            },
          },
        },
        {
          id: "paragrapgBold",
          name: "paragrapgBold",
          basedOn: "Normal",
          run: {
            bold: true,
            size: "12pt",
          },
        },
        {
          id: "redColorText",
          name: "redColorText",
          basedOn: "Normal",
          run: {
            color: "#FF0000",
            size: "11pt",
            bold: true,
          },
        },
      ],
    },
    sections: [
      {
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Table 8 of AIS-007 (Revision 5)",
                    bold: true,
                    size: "18pt",
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
          }),
        },
        children: [
          new Table({
            // width: {
            //     size: 10000,
            //     type: WidthType.DXA
            // },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "Rule No.",
                            size: "12pt",
                          }),
                          new TextRun({
                            bold: true,
                            color: "#FF0000",
                            text: "C1",
                            size: "12pt",
                            break: 2,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Subject",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            bold: true,
                            color: "#FF0000",
                            size: "12pt",
                            break: 3,
                            text: "C2",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "Name of the Manufacturer",
                          }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            break: 2,
                            text: "( Please give information for every supplier / vendor under the same para, separate lines )",
                          }),
                          new TextRun({
                            bold: true,
                            color: "#FF0000",
                            size: "12pt",
                            break: 3,
                            text: "C3",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "TAC No. / BIS License No / Test Report No. as applicable.(indicate validity date)",
                          }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            break: 2,
                            text: "(Application Ref No. allotted by concerned Test Agency,  If approval is in the process )",
                          }),
                          new TextRun({
                            bold: true,
                            color: "#FF0000",
                            size: "12pt",
                            break: 3,
                            text: "C4",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "Possible date of submission of required approval, if the same is in process",
                          }),
                          new TextRun({
                            bold: true,
                            color: "#FF0000",
                            size: "12pt",
                            break: 3,
                            text: "C5",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "CoP Cert No. with validity date (where ever applicable)",
                          }),
                          new TextRun({
                            bold: true,
                            color: "#FF0000",
                            size: "12pt",
                            break: 3,
                            text: "C6",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "95",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Tyres",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            size: "12pt",
                            break: 2,
                            text: "(Compliance to IS 15633 / IS 15627/IS 15636)",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             children: [
                  //                                 new TextRun({
                  //                                     text: "Front",
                  //                                     size: "12pt",
                  //                                     bold: true
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             style: "paragrapgBold",
                  //                             children: [
                  //                                 new TextRun({
                  //                                     size: "12pt",
                  //                                     bold: true,
                  //                                     text: ""
                  //                                 }),
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             style: "table1Header",
                  //                             children: [
                  //                                 new TextRun({
                  //                                     size: "12pt",
                  //                                     bold: true,
                  //                                     text: ""
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             style: "table1Header",
                  //                             children: [
                  //                                 new TextRun({
                  //                                     size: "12pt",
                  //                                     bold: true,
                  //                                     text: ""
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             style: "table1Header",
                  //                             children: [
                  //                                 new TextRun({
                  //                                     size: "12pt",
                  //                                     bold: true,
                  //                                     text: ""
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         )
                  //     ]
                  // }),
                  // new TableRow({
                  //     children: [
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 1000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             children: [
                  //                                 new TextRun({
                  //                                     bold: true,
                  //                                     text: "",
                  //                                     size: "12pt"
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             children: [
                  //                                 new TextRun({
                  //                                     text: "Rear",
                  //                                     size: "12pt",
                  //                                     bold: true
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             style: "paragrapgBold",
                  //                             children: [
                  //                                 new TextRun({
                  //                                     size: "12pt",
                  //                                     bold: true,
                  //                                     text: ""
                  //                                 }),
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             style: "table1Header",
                  //                             children: [
                  //                                 new TextRun({
                  //                                     size: "12pt",
                  //                                     bold: true,
                  //                                     text: ""
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  //         new TableCell(
                  //             {
                  //                 width: {
                  //                     size: 3000,
                  //                     type: WidthType.DXA
                  //                 },
                  //                 children: [
                  //                     new Paragraph(
                  //                         {
                  //                             style: "table1Header",
                  //                             children: [
                  //                                 new TextRun({
                  //                                     size: "12pt",
                  //                                     bold: true,
                  //                                     text: ""
                  //                                 })
                  //                             ]
                  //                         }
                  //                     )
                  //                 ]
                  //             }
                  //         ),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front",
                            size: "12pt",
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: ftyreDataList.MakeList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    // children: [
                    //     new Paragraph(
                    //         {
                    //             style: "table1Header",
                    //             children: [
                    //               new TextRun({
                    //                     size: "12pt",
                    //                     bold: true,
                    //                     text: "TAC No and Validity"
                    //                 }),
                    //                 new TextRun({
                    //                     size: "12pt",
                    //                     bold: true,
                    //                     text: ftyreDataList.validityList.join(",")
                    //                 })
                    //             ]
                    //         }
                    //     )
                    // ]
                    children: [
                        ...(getTACorBISHeader(ftyreDataList.validityList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    ftyreDataList.validityList
                                  ),
                                }),
                              ],
                            }),
                          ]
                          : []),

                      // Always show the joined data, even if empty or "NA"
                      // new Paragraph({
                      //   style: "table1Header",
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       bold: true,
                      //       text: ftyreDataList.validityList.join(", "),
                      //     }),
                      //   ],
                      // }),

                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: (() => {
                              const label = getTACorBISHeader(ftyreDataList.validityList);
                              return label.startsWith("BIS")
                                ? ftyreDataList.validityList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : ftyreDataList.validityList.join(", ");
                            })(),
                          }),
                        ],
                      })
                      
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    // children: [
                    //     new Paragraph(
                    //         {
                    //             style: "table1Header",
                    //             children: [
                    //                 new TextRun({
                    //                     size: "12pt",
                    //                     bold: true,
                    //                     text: ftyreDataList.possibleDateList.join(",")
                    //                 })
                    //             ]
                    //         }
                    //     )
                    // ]
                    children: [
                        ...(getPossibleDateHeader(ftyreDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(
                                    ftyreDataList.possibleDateList
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: ftyreDataList.possibleDateList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    // children: [
                    //     new Paragraph(
                    //         {
                    //             style: "table1Header",
                    //             children: [
                    //                 new TextRun({
                    //                     size: "12pt",
                    //                     bold: true,
                    //                     text: ftyreDataList.copCertList.join(",")
                    //                 })
                    //             ]
                    //         }
                    //     )
                    // ]
                    children: [
                        ...(getCOPHeader(ftyreDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(ftyreDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: ftyreDataList.copCertList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear",
                            size: "12pt",
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: rtyreDataList.MakeList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    // children: [
                    //     new Paragraph(
                    //         {
                    //             style: "table1Header",
                    //             children: [
                    //                 new TextRun({
                    //                     size: "12pt",
                    //                     bold: true,
                    //                     text: rtyreDataList.validityList.join(",")
                    //                 })
                    //             ]
                    //         }
                    //     )
                    // ]

                    children: [
                      // Show heading only if there is valid data
                      ...(getTACorBISHeader(rtyreDataList.validityList)
                      ? [
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text: getTACorBISHeader(
                                    rtyreDataList.validityList
                                ),
                              }),
                            ],
                          }),
                        ]
                        : []),

                      // Always show the joined data, even if empty or "NA"
                      // new Paragraph({
                      //   style: "table1Header",
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       bold: true,
                      //       text: rtyreDataList.validityList.join(", "),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: (() => {
                              const label = getTACorBISHeader(rtyreDataList.validityList);
                              return label.startsWith("BIS")
                                ? rtyreDataList.validityList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match
                                        ? item.slice(match.index).trim()
                                        : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : rtyreDataList.validityList.join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    // children: [
                    //     new Paragraph(
                    //         {
                    //             style: "table1Header",
                    //             children: [
                    //                 new TextRun({
                    //                     size: "12pt",
                    //                     bold: true,
                    //                     text: rtyreDataList.possibleDateList.join(",")
                    //                 })
                    //             ]
                    //         }
                    //     )
                    // ]

                    children: [
                        ...(getPossibleDateHeader(rtyreDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(
                                    rtyreDataList.possibleDateList
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: rtyreDataList.possibleDateList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },               

                    children: [
                        ...(getCOPHeader(rtyreDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(rtyreDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: rtyreDataList.copCertList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
             
         
              // ✅ Building the TableRow
              new TableRow({
                children: [
                  new TableCell({
                    width: { size: 1000, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({ bold: true, text: "", size: "12pt" }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Spare wheel (as applicable)",
                            size: "12pt",
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: atyreDataList.MakeList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                  // ✅ TAC/BIS Column
                  new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getTACorBISHeader(atyreDataList.validityList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    atyreDataList.validityList
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   style: "table1Header",
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       bold: true,
                      //       text: atyreDataList.validityList.join(", "),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: (() => {
                              const label = getTACorBISHeader(atyreDataList.validityList);
                              return label.startsWith("BIS")
                                ? atyreDataList.validityList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match
                                        ? item.slice(match.index).trim()
                                        : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : atyreDataList.validityList.join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  // ✅ Possible Date Column
                  new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getPossibleDateHeader(atyreDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(
                                    atyreDataList.possibleDateList
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: atyreDataList.possibleDateList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                  // ✅ COP Column
                  new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getCOPHeader(atyreDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(atyreDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: atyreDataList.copCertList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "100",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Safety Glass",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "Windscreen",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Side",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Rear",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "(For  3 & 4 Wheeler)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: WindscreenDataList.suppNameList.join(","),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: SideglassDataList.suppNameList.join(","),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: RearglassDataList.suppNameList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: WindscreenDataList.tacNumberList.join(","),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: SideglassDataList.tacNumberList.join(","),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: RearglassDataList.tacNumberList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getTACorBISHeader(WindscreenDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(WindscreenDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : getTACorBISHeader(SideglassDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(SideglassDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : getTACorBISHeader(RearglassDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(RearglassDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   style: "table1Header",
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       bold: true,
                      //       text: WindscreenDataList.tacNumberList.join(","),
                      //     }),
                      //     new TextRun({
                      //       break: 1,
                      //       size: "12pt",
                      //       bold: true,
                      //       text: SideglassDataList.tacNumberList.join(","),
                      //     }),
                      //     new TextRun({
                      //       break: 1,
                      //       size: "12pt",
                      //       bold: true,
                      //       text: RearglassDataList.tacNumberList.join(","),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: (() => {
                              const label = getTACorBISHeader(WindscreenDataList.tacNumberList);
                              return label.startsWith("BIS")
                                ? WindscreenDataList.tacNumberList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : WindscreenDataList.tacNumberList.join(", ");
                            })(),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: (() => {
                              const label = getTACorBISHeader(SideglassDataList.tacNumberList);
                              return label.startsWith("BIS")
                                ? SideglassDataList.tacNumberList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : SideglassDataList.tacNumberList.join(", ");
                            })(),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: (() => {
                              const label = getTACorBISHeader(RearglassDataList.tacNumberList);
                              return label.startsWith("BIS")
                                ? RearglassDataList.tacNumberList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : RearglassDataList.tacNumberList.join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  

                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: WindscreenDataList.possibleDateList.join(","),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: SideglassDataList.possibleDateList.join(","),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: RearglassDataList.possibleDateList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getPossibleDateHeader(WindscreenDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(WindscreenDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : getPossibleDateHeader(SideglassDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(SideglassDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : getPossibleDateHeader(RearglassDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(RearglassDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: WindscreenDataList.possibleDateList.join(","),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: SideglassDataList.possibleDateList.join(","),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: RearglassDataList.possibleDateList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: WindscreenDataList.copCertList.join(","),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: SideglassDataList.copCertList.join(","),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: RearglassDataList.copCertList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getCOPHeader(WindscreenDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(WindscreenDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : getCOPHeader(SideglassDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(SideglassDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : getCOPHeader(RearglassDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(RearglassDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: WindscreenDataList.copCertList.join(","),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: SideglassDataList.copCertList.join(","),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: RearglassDataList.copCertList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "101",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Windscreen Wiping System",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "Wiping System",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Washing System",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Wiper Blade",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "(For 3 & 4 Wheelers)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: [
                //                 ...WindscreenwipingDataList.suppNameList,
                //                 ...WindscreenWashingDataList.suppNameList,
                //                 ...WindscreenWiperDataList.suppNameList,
                //               ].join("\n\r"),                           
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          ...[
                            ...WindscreenwipingDataList.suppNameList,
                            ...WindscreenWashingDataList.suppNameList,
                            ...WindscreenWiperDataList.suppNameList,
                          ].map(name => new TextRun({ text: name, break: 1, size: 24 })) // break:1 adds a line break
                        ],
                      }),
                    ],
                  }),
                  

                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             // text: WindscreenwipingDataList.tacNumberList.join(
                //             //   "\n\r"
                //             // ),
                //             text: [
                //                 ...WindscreenwipingDataList.tacNumberList,
                //                 ...WindscreenWashingDataList.tacNumberList,
                //                 ...WindscreenWiperDataList.tacNumberList,
                //               ].join("\n\r"),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getTACorBISHeader(WindscreenwipingDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(WindscreenwipingDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : getTACorBISHeader(WindscreenWashingDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(WindscreenWashingDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : getTACorBISHeader(WindscreenWiperDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(WindscreenWiperDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       text: WindscreenwipingDataList.tacNumberList.join(", "),
                      //     }),
                      //     new TextRun({
                      //       break: 1,
                      //       size: "12pt",
                      //       text: WindscreenWashingDataList.tacNumberList.join(", "),
                      //     }),
                      //     new TextRun({
                      //       break: 1,
                      //       size: "12pt",
                      //       text: WindscreenWiperDataList.tacNumberList.join(", "),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const label = getTACorBISHeader(WindscreenwipingDataList.tacNumberList);
                              return label.startsWith("BIS")
                                ? WindscreenwipingDataList.tacNumberList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : WindscreenwipingDataList.tacNumberList.join(", ");
                            })(),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const label = getTACorBISHeader(WindscreenWashingDataList.tacNumberList);
                              return label.startsWith("BIS")
                                ? WindscreenWashingDataList.tacNumberList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : WindscreenWashingDataList.tacNumberList.join(", ");
                            })(),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const label = getTACorBISHeader(WindscreenWiperDataList.tacNumberList);
                              return label.startsWith("BIS")
                                ? WindscreenWiperDataList.tacNumberList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : WindscreenWiperDataList.tacNumberList.join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             // text: WindscreenwipingDataList.possibleDateList.join(
                //             //   "\n\r"
                //             // ),
                //             text: [
                //                 ...WindscreenwipingDataList.possibleDateList,
                //                 ...WindscreenWashingDataList.possibleDateList,
                //                 ...WindscreenWiperDataList.possibleDateList,
                //               ].join("\n\r"),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getPossibleDateHeader(WindscreenwipingDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(WindscreenwipingDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : getPossibleDateHeader(WindscreenWashingDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(WindscreenWashingDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : getPossibleDateHeader(WindscreenWiperDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(WindscreenWiperDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: WindscreenwipingDataList.possibleDateList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            text: WindscreenWashingDataList.possibleDateList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            text: WindscreenWiperDataList.possibleDateList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),

                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             // text: WindscreenwipingDataList.copCertList.join(
                //             //   "\n\r"
                //             // ),
                //             text: [
                //                 ...WindscreenwipingDataList.copCertList,
                //                 ...WindscreenWashingDataList.copCertList,
                //                 ...WindscreenWiperDataList.copCertList,
                //               ].join("\n\r"),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      ...(getCOPHeader(WindscreenwipingDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(WindscreenwipingDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : getCOPHeader(WindscreenWashingDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(WindscreenWashingDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : getCOPHeader(WindscreenWiperDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(WindscreenWiperDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: WindscreenwipingDataList.copCertList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            text: WindscreenWashingDataList.copCertList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            text: WindscreenWiperDataList.copCertList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                  


                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "104",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Reflex Reflector",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "Front, White",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Rear, Red",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Side, Amber",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.frontWhiteList.MakeList.join(
                              ", "
                            ),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.rearRedList.MakeList.join(", "),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.sideAmberList.MakeList.join(
                              ", "
                            ),
                          }),
                        ],
                      }),
                    ],
                  }),
                  // new TableCell(
                  //     {
                  //         width:{
                  //             size: 3000,
                  //             type: WidthType.DXA
                  //         },
                  //         children:[
                  //             new Paragraph(
                  //                 {
                  //                     style: "table1Header",
                  //                     children: [
                  //                         new TextRun({
                  //                             size: "12pt",
                  //                             bold: true,
                  //                             text: reflDataList.frontWhiteList.tacNumberList.join(",")
                  //                         }),
                  //                         new TextRun({
                  //                             break: 1,
                  //                             size: "12pt",
                  //                             bold: true,
                  //                             text: reflDataList.rearRedList.tacNumberList.join(",")
                  //                         }),
                  //                         new TextRun({
                  //                             break: 1,
                  //                             size: "12pt",
                  //                             bold: true,
                  //                             text: reflDataList.frontWhiteList.tacNumberList.join(",")
                  //                         }),
                  //                     ]
                  //                 }
                  //             )
                  //         ]
                  //     }
                  // ),

                  // new TableCell({
                  //     width: {
                  //         size: 3000,
                  //         type: WidthType.DXA,
                  //     },
                  //     children: [
                  //         new Paragraph({
                  //             style: "table1Header",
                  //             children: [
                  //                 // Create an array of TextRun for each supplier
                  //                 ...[
                  //                     reflDataList.frontWhiteList,
                  //                     reflDataList.rearRedList,
                  //                     reflDataList.sideAmberList,
                  //                 ].map((supplier) => {
                  //                     // Generate a formatted string for the supplier
                  //                     const formattedData = supplier.tacNumberList.map((tacNumber, index) => {
                  //                         const validity = supplier.validityList[index] || '';
                  //                         return `${tacNumber} ${validity}  `; // Use backticks for string interpolation
                  //                     }).join(', ');

                  //                     return new TextRun({
                  //                         size: 24, // Adjust size to the correct point value if needed
                  //                         bold: true,
                  //                         text: formattedData,
                  //                     });
                  //                 }),
                  //             ],
                  //         }),
                  //     ],
                  // }),



                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           // Process frontWhiteList (first one)
                //           ...reflDataList.frontWhiteList.tacNumberList.map(
                //             (tacNumber, index) => {
                //               const validity =
                //                 reflDataList.frontWhiteList.validityList[
                //                   index
                //                 ] || "";
                //               return new TextRun({
                //                 size: 24,
                //                 bold: true,
                //                 text: `${tacNumber} ${validity} `,
                //               });
                //             }
                //           ),

                //           // Add a line break
                //           new TextRun({ break: 1 }),

                //           // Process rearRedList (second one in new line)
                //           ...reflDataList.rearRedList.tacNumberList.map(
                //             (tacNumber, index) => {
                //               const validity =
                //                 reflDataList.rearRedList.validityList[index] ||
                //                 "";
                //               return new TextRun({
                //                 size: 24,
                //                 bold: true,
                //                 text: `${tacNumber} ${validity} `,
                //               });
                //             }
                //           ),
                //           // Add a line break
                //           new TextRun({ break: 1 }),
                //           // Process sideAmberList (continues on the same line as rearRedList)
                //           ...reflDataList.sideAmberList.tacNumberList.map(
                //             (tacNumber, index) => {
                //               const validity =
                //                 reflDataList.sideAmberList.validityList[
                //                   index
                //                 ] || "";
                //               return new TextRun({
                //                 size: 24,
                //                 bold: true,
                //                 text: `${tacNumber} ${validity} `,
                //               });
                //             }
                //           ),
                //         ],
                //       }),
                //     ],
                //   }),
//////////
//                 new TableCell({
//   width: { size: 3000, type: WidthType.DXA },
//   children: [
//     // Add header if any list has a valid TAC/BIS header
//     ...(getTACorBISHeader(reflDataList.frontWhiteList.tacNumberList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getTACorBISHeader(reflDataList.frontWhiteList.tacNumberList),
//               }),
//             ],
//           }),
//         ]
//       : getTACorBISHeader(reflDataList.rearRedList.tacNumberList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getTACorBISHeader(reflDataList.rearRedList.tacNumberList),
//               }),
//             ],
//           }),
//         ]
//       : getTACorBISHeader(reflDataList.sideAmberList.tacNumberList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getTACorBISHeader(reflDataList.sideAmberList.tacNumberList),
//               }),
//             ],
//           }),
//         ]
//       : []),

//     // Main paragraph with TAC numbers and validities
//     new Paragraph({
//       style: "table1Header",
//       children: [
//         // Front White List
//         ...reflDataList.frontWhiteList.tacNumberList.map((tacNumber, index) => {
//           const validity = reflDataList.frontWhiteList.validityList[index] || "";
//           return new TextRun({
//             size: 24,
//             bold: true,
//             text: `${tacNumber} ${validity} `,
//           });
//         }),

//         // Line break before rearRedList
//         new TextRun({ break: 1 }),

//         // Rear Red List
//         ...reflDataList.rearRedList.tacNumberList.map((tacNumber, index) => {
//           const validity = reflDataList.rearRedList.validityList[index] || "";
//           return new TextRun({
//             size: 24,
//             bold: true,
//             text: `${tacNumber} ${validity} `,
//           });
//         }),

//         // Line break before sideAmberList
//         new TextRun({ break: 1 }),

//         // Side Amber List
//         ...reflDataList.sideAmberList.tacNumberList.map((tacNumber, index) => {
//           const validity = reflDataList.sideAmberList.validityList[index] || "";
//           return new TextRun({
//             size: 24,
//             bold: true,
//             text: `${tacNumber} ${validity} `,
//           });
//         }),
//       ],
//     }),
//   ],
// }),
/////////


// new TableCell({
//     width: { size: 3000, type: WidthType.DXA },
//     children: [
//       // ✅ Conditional header (only first valid one used)
//       ...(
//         (() => {
//           const headerSources = [
//             reflDataList.frontWhiteList.tacNumberList,
//             reflDataList.rearRedList.tacNumberList,
//             reflDataList.sideAmberList.tacNumberList,
//           ];
  
//           for (const source of headerSources) {
//             const header = getTACorBISHeader(source);
//             if (header) {
//               return [
//                 new Paragraph({
//                   style: "table1Header",
//                   children: [
//                     new TextRun({
//                       size: "12pt",
//                       bold: true,
//                       text: header,
//                     }),
//                   ],
//                 }),
//               ];
//             }
//           }
//           return [];
//         })()
//       ),
////////////////////////////
// new TableCell({
//     width: { size: 3000, type: WidthType.DXA },
//     children: [
//       // ✅ Conditional header from the first non-empty list only
//       ...(() => {
//         let selectedList = null;
  
//         if (reflDataList.frontWhiteList.tacNumberList.length > 0) {
//           selectedList = reflDataList.frontWhiteList;
//         } else if (reflDataList.rearRedList.tacNumberList.length > 0) {
//           selectedList = reflDataList.rearRedList;
//         } else if (reflDataList.sideAmberList.tacNumberList.length > 0) {
//           selectedList = reflDataList.sideAmberList;
//         }
  
//         if (!selectedList) return [];
  
//         const combined = selectedList.tacNumberList.map((tac, idx) =>
//           `${tac} ${selectedList.validityList[idx] || ""}`
//         );
  
//         const headerText = getTACorBISHeader(combined);
  
//         return headerText
//           ? [
//               new Paragraph({
//                 style: "table1Header",
//                 children: [
//                   new TextRun({
//                     size: "12pt",
//                     bold: true,
//                     text: headerText,
//                   }),
//                 ],
//               }),
//             ]
//           : [];
//       })(),
  
//       // ✅ Main TAC/Validity paragraph
//       new Paragraph({
//         style: "table1Header",
//         children: [
//           // Front White List
//           ...reflDataList.frontWhiteList.tacNumberList.map((tacNumber, index) => {
//             const validity = reflDataList.frontWhiteList.validityList[index] || "";
//             return new TextRun({
//               size: 24,
//               bold: true,
//               text: `${tacNumber} ${validity} `,
//             });
//           }),
  
//           // Line break before rearRedList
//           new TextRun({ break: 1 }),
  
//           // Rear Red List
//           ...reflDataList.rearRedList.tacNumberList.map((tacNumber, index) => {
//             const validity = reflDataList.rearRedList.validityList[index] || "";
//             return new TextRun({
//               size: 24,
//               bold: true,
//               text: `${tacNumber} ${validity} `,
//             });
//           }),
  
//           // Line break before sideAmberList
//           new TextRun({ break: 1 }),
  
//           // Side Amber List
//           ...reflDataList.sideAmberList.tacNumberList.map((tacNumber, index) => {
//             const validity = reflDataList.sideAmberList.validityList[index] || "";
//             return new TextRun({
//               size: 24,
//               bold: true,
//               text: `${tacNumber} ${validity} `,
//             });
//           }),
//         ],
//       }),
//     ],
//   }),
  
////////////////////////
new TableCell({
  width: { size: 3000, type: WidthType.DXA },
  children: [
    // ✅ Conditional header from first valid list
    ...(() => {
      let selectedList = null;

      if (reflDataList.frontWhiteList.tacNumberList.length > 0) {
        selectedList = reflDataList.frontWhiteList;
      } else if (reflDataList.rearRedList.tacNumberList.length > 0) {
        selectedList = reflDataList.rearRedList;
      } else if (reflDataList.sideAmberList.tacNumberList.length > 0) {
        selectedList = reflDataList.sideAmberList;
      }

      if (!selectedList) return [];

      const combined = selectedList.tacNumberList.map((tac, idx) =>
        `${tac} ${selectedList.validityList[idx] || ""}`
      );

      const headerText = getTACorBISHeader(combined);

      return headerText
        ? [
            new Paragraph({
              style: "table1Header",
              children: [
                new TextRun({
                  size: "12pt",
                  bold: true,
                  text: headerText,
                }),
              ],
            }),
          ]
        : [];
    })(),

    // ✅ Main TAC/validity content with conditional CM/L- and inline logic
    new Paragraph({
      style: "table1Header",
      children: [
        // Front White List
        ...(() => {
          const isBIS = getTACorBISHeader(reflDataList.frontWhiteList.tacNumberList).startsWith("BIS");
          return reflDataList.frontWhiteList.tacNumberList.map((tacNumber, index) => {
            const validity = reflDataList.frontWhiteList.validityList[index] || "";
            const prefix = isBIS ? "CM/L-" : "";
            return new TextRun({
              size: 24,
              bold: true,
              text: `${prefix}${tacNumber.trim()}${validity ? " " + validity.trim() : ""} `,
            });
          });
        })(),
    
        new TextRun({ break: 1 }),
    
        // Rear Red List
        ...(() => {
          const isBIS = getTACorBISHeader(reflDataList.rearRedList.tacNumberList).startsWith("BIS");
          return reflDataList.rearRedList.tacNumberList.map((tacNumber, index) => {
            const validity = reflDataList.rearRedList.validityList[index] || "";
            const prefix = isBIS ? "CM/L-" : "";
            return new TextRun({
              size: 24,
              bold: true,
              text: `${prefix}${tacNumber.trim()}${validity ? " " + validity.trim() : ""} `,
            });
          });
        })(),
    
        new TextRun({ break: 1 }),
    
        // Side Amber List
        ...(() => {
          const isBIS = getTACorBISHeader(reflDataList.sideAmberList.tacNumberList).startsWith("BIS");
          return reflDataList.sideAmberList.tacNumberList.map((tacNumber, index) => {
            const validity = reflDataList.sideAmberList.validityList[index] || "";
            const prefix = isBIS ? "CM/L-" : "";
            return new TextRun({
              size: 24,
              bold: true,
              text: `${prefix}${tacNumber.trim()}${validity ? " " + validity.trim() : ""} `,
            });
          });
        })(),
      ],
    }),
    
  ],
}),


                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.frontWhiteList.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.rearRedList.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.sideAmberList.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),



                ///////////
//                 new TableCell({
//   width: { size: 3000, type: WidthType.DXA },
//   children: [
//     ...(getPossibleDateHeader(reflDataList.frontWhiteList.possibleDateList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getPossibleDateHeader(reflDataList.frontWhiteList.possibleDateList),
//               }),
//             ],
//           }),
//         ]
//       : getPossibleDateHeader(reflDataList.rearRedList.possibleDateList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getPossibleDateHeader(reflDataList.rearRedList.possibleDateList),
//               }),
//             ],
//           }),
//         ]
//       : getPossibleDateHeader(reflDataList.sideAmberList.possibleDateList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getPossibleDateHeader(reflDataList.sideAmberList.possibleDateList),
//               }),
//             ],
//           }),
//         ]
//       : []),
//     new Paragraph({
//       style: "table1Header",
//       children: [
//         new TextRun({
//           size: "12pt",
//           bold: true,
//           text: reflDataList.frontWhiteList.possibleDateList.join(","),
//         }),
//         new TextRun({
//           break: 1,
//           size: "12pt",
//           bold: true,
//           text: reflDataList.rearRedList.possibleDateList.join(","),
//         }),
//         new TextRun({
//           break: 1,
//           size: "12pt",
//           bold: true,
//           text: reflDataList.sideAmberList.possibleDateList.join(","),
//         }),
//       ],
//     }),
//   ],
// }),
////////
new TableCell({
    width: { size: 3000, type: WidthType.DXA },
    children: [
      // ✅ Conditional header (first non-empty one only)
      ...(
        (() => {
          const headerSources = [
            reflDataList.frontWhiteList.possibleDateList,
            reflDataList.rearRedList.possibleDateList,
            reflDataList.sideAmberList.possibleDateList,
          ];
  
          for (const source of headerSources) {
            const header = getPossibleDateHeader(source);
            if (header) {
              return [
                new Paragraph({
                  style: "table1Header",
                  children: [
                    new TextRun({
                      size: "12pt",
                      bold: true,
                      text: header,
                    }),
                  ],
                }),
              ];
            }
          }
          return [];
        })()
      ),
  
      // ✅ Main content with line breaks
      new Paragraph({
        style: "table1Header",
        children: [
          new TextRun({
            size: "12pt",
            bold: true,
            text: reflDataList.frontWhiteList.possibleDateList.join(","),
          }),
          new TextRun({
            break: 1,
            size: "12pt",
            bold: true,
            text: reflDataList.rearRedList.possibleDateList.join(","),
          }),
          new TextRun({
            break: 1,
            size: "12pt",
            bold: true,
            text: reflDataList.sideAmberList.possibleDateList.join(","),
          }),
        ],
      }),
    ],
  }),
  

                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.frontWhiteList.copCertList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.rearRedList.copCertList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.sideAmberList.copCertList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
/////////
// new TableCell({
//   width: { size: 3000, type: WidthType.DXA },
//   children: [
//     ...(getCOPHeader(reflDataList.frontWhiteList.copCertList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getCOPHeader(reflDataList.frontWhiteList.copCertList),
//               }),
//             ],
//           }),
//         ]
//       : getCOPHeader(reflDataList.rearRedList.copCertList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getCOPHeader(reflDataList.rearRedList.copCertList),
//               }),
//             ],
//           }),
//         ]
//       : getCOPHeader(reflDataList.sideAmberList.copCertList)
//       ? [
//           new Paragraph({
//             style: "table1Header",
//             children: [
//               new TextRun({
//                 size: "12pt",
//                 bold: true,
//                 text: getCOPHeader(reflDataList.sideAmberList.copCertList),
//               }),
//             ],
//           }),
//         ]
//       : []),
//     new Paragraph({
//       style: "table1Header",
//       children: [
//         new TextRun({
//           size: "12pt",
//           bold: true,
//           text: reflDataList.frontWhiteList.copCertList.join(","),
//         }),
//         new TextRun({
//           break: 1,
//           size: "12pt",
//           bold: true,
//           text: reflDataList.rearRedList.copCertList.join(","),
//         }),
//         new TextRun({
//           break: 1,
//           size: "12pt",
//           bold: true,
//           text: reflDataList.sideAmberList.copCertList.join(","),
//         }),
//       ],
//     }),
//   ],
// }),
////////
new TableCell({
    width: { size: 3000, type: WidthType.DXA },
    children: [
      // ✅ Conditional header (first non-empty one only)
      ...(
        (() => {
          const headerSources = [
            reflDataList.frontWhiteList.copCertList,
            reflDataList.rearRedList.copCertList,
            reflDataList.sideAmberList.copCertList,
          ];
  
          for (const source of headerSources) {
            const header = getCOPHeader(source);
            if (header) {
              return [
                new Paragraph({
                  style: "table1Header",
                  children: [
                    new TextRun({
                      size: "12pt",
                      bold: true,
                      text: header,
                    }),
                  ],
                }),
              ];
            }
          }
          return [];
        })()
      ),
  
      // ✅ Main content with line breaks
      new Paragraph({
        style: "table1Header",
        children: [
          new TextRun({
            size: "12pt",
            bold: true,
            text: reflDataList.frontWhiteList.copCertList.join(","),
          }),
          new TextRun({
            break: 1,
            size: "12pt",
            bold: true,
            text: reflDataList.rearRedList.copCertList.join(","),
          }),
          new TextRun({
            break: 1,
            size: "12pt",
            bold: true,
            text: reflDataList.sideAmberList.copCertList.join(","),
          }),
        ],
      }),
    ],
  }),
  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "CNG / LPG Kit",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "Components",
                            size: "12pt",
                            break: 1,
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Cylinder (as per Gas Cylinder Rule, 2004)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Cylinder Valve / Multi-Function Valve (as per Gas Cylinder Rule, 2004)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "CNG / LPG Pressure Regulator",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "CNG / LPG Gas Solenoid  Valve",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "CNG / LPG Gas Air Mixer",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Petrol Solenoid valve",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "CNG/LPG Rigid Pipe",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "CNG/ LPG High Pressure Flexible Hose",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "CNG/ LPG Low Pressure Flexible Hose",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Electrical Fuses",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Ventilation Hose/ Conduit",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Electrical Wiring Harness",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Seat Upholstery, Roof, Side linings",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Non-moisture retaining Hard rubber for cylinder mounting (as applicable)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "104-1",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Reflective Tape For 3 & 4-Wheelers",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "Front, White",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Rear, Red",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Side, Yellow",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.frontWhiteListt.MakeList.join(
                              ", "
                            ),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.rearRedListt.MakeList.join(", "),
                          }),
                          new TextRun({ break: 1 }),
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.sideAmberListt.MakeList.join(
                              ", "
                            ),
                          }),
                        ],
                      }),
                    ],
                  }),

                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           // Process frontWhiteList (first one)
                //           ...reflDataList.frontWhiteListt.tacNumberList.map(
                //             (tacNumber, index) => {
                //               const validity =
                //                 reflDataList.frontWhiteListt.validityList[
                //                   index
                //                 ] || "";
                //               return new TextRun({
                //                 size: 24,
                //                 bold: true,
                //                 text: `${tacNumber} ${validity} `,
                //               });
                //             }
                //           ),

                //           // Add a line break
                //           new TextRun({ break: 1 }),

                //           // Process rearRedList (second one in new line)
                //           ...reflDataList.rearRedListt.tacNumberList.map(
                //             (tacNumber, index) => {
                //               const validity =
                //                 reflDataList.rearRedListt.validityList[index] ||
                //                 "";
                //               return new TextRun({
                //                 size: 24,
                //                 bold: true,
                //                 text: `${tacNumber} ${validity} `,
                //               });
                //             }
                //           ),
                //           // Add a line break
                //           new TextRun({ break: 1 }),
                //           // Process sideAmberList (continues on the same line as rearRedList)
                //           ...reflDataList.sideAmberListt.tacNumberList.map(
                //             (tacNumber, index) => {
                //               const validity =
                //                 reflDataList.sideAmberListt.validityList[
                //                   index
                //                 ] || "";
                //               return new TextRun({
                //                 size: 24,
                //                 bold: true,
                //                 text: `${tacNumber} ${validity} `,
                //               });
                //             }
                //           ),
                //         ],
                //       }),
                //     ],
                //   }),

                // new TableCell({
                //     width: { size: 3000, type: WidthType.DXA },
                //     children: [
                //       // Conditionally add the header for the first list that has one
                //       ...(getTACorBISHeader(reflDataList.frontWhiteList.tacNumberList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text: getTACorBISHeader(reflDataList.frontWhiteList.tacNumberList),
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : getTACorBISHeader(reflDataList.rearRedList.tacNumberList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text: getTACorBISHeader(reflDataList.rearRedList.tacNumberList),
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : getTACorBISHeader(reflDataList.sideAmberList.tacNumberList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text: getTACorBISHeader(reflDataList.sideAmberList.tacNumberList),
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                  
                //       // Paragraph with TAC numbers and validity from all three lists
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           // frontWhiteList TAC numbers + validity
                //           ...reflDataList.frontWhiteList.tacNumberList.map((tacNumber, index) => {
                //             const validity = reflDataList.frontWhiteList.validityList[index] || "";
                //             return new TextRun({
                //               size: 24,
                //               bold: true,
                //               text: `${tacNumber} ${validity} `,
                //             });
                //           }),
                  
                //           // Line break
                //           new TextRun({ break: 1 }),
                  
                //           // rearRedList TAC numbers + validity
                //           ...reflDataList.rearRedList.tacNumberList.map((tacNumber, index) => {
                //             const validity = reflDataList.rearRedList.validityList[index] || "";
                //             return new TextRun({
                //               size: 24,
                //               bold: true,
                //               text: `${tacNumber} ${validity} `,
                //             });
                //           }),
                  
                //           // Line break
                //           new TextRun({ break: 1 }),
                  
                //           // sideAmberList TAC numbers + validity
                //           ...reflDataList.sideAmberList.tacNumberList.map((tacNumber, index) => {
                //             const validity = reflDataList.sideAmberList.validityList[index] || "";
                //             return new TextRun({
                //               size: 24,
                //               bold: true,
                //               text: `${tacNumber} ${validity} `,
                //             });
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: { size: 3000, type: WidthType.DXA },
                    children: [
                      // ✅ Conditionally add the header from the first valid list only
                      ...(() => {
                        let selectedList = null;
                  
                        if (reflDataList.frontWhiteListt.tacNumberList.length > 0) {
                          selectedList = reflDataList.frontWhiteListt;
                        } else if (reflDataList.rearRedListt.tacNumberList.length > 0) {
                          selectedList = reflDataList.rearRedListt;
                        } else if (reflDataList.sideAmberListt.tacNumberList.length > 0) {
                          selectedList = reflDataList.sideAmberListt;
                        }
                  
                        if (!selectedList) return [];
                  
                        const combinedList = selectedList.tacNumberList.map((tac, idx) =>
                          `${tac} ${selectedList.validityList[idx] || ""}`
                        );
                  
                        const headerText = getTACorBISHeader(combinedList);
                  
                        return headerText
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: headerText,
                                  }),
                                ],
                              }),
                            ]
                          : [];
                      })(),
                  
                      // ✅ Paragraph with TAC numbers and validity from all three lists (unchanged)
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          // frontWhiteList
                          ...reflDataList.frontWhiteListt.tacNumberList.map((tacNumber, index) => {
                            const validity = reflDataList.frontWhiteListt.validityList[index] || "";
                            return new TextRun({
                              size: 24,
                              bold: true,
                              text: `${tacNumber} ${validity} `,
                            });
                          }),
                  
                          new TextRun({ break: 1 }),
                  
                          // rearRedList
                          ...reflDataList.rearRedListt.tacNumberList.map((tacNumber, index) => {
                            const validity = reflDataList.rearRedListt.validityList[index] || "";
                            return new TextRun({
                              size: 24,
                              bold: true,
                              text: `${tacNumber} ${validity} `,
                            });
                          }),
                  
                          new TextRun({ break: 1 }),
                  
                          // sideAmberList
                          ...reflDataList.sideAmberListt.tacNumberList.map((tacNumber, index) => {
                            const validity = reflDataList.sideAmberListt.validityList[index] || "";
                            return new TextRun({
                              size: 24,
                              bold: true,
                              text: `${tacNumber} ${validity} `,
                            });
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                  

                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.frontWhiteListt.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.rearRedListt.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.sideAmberListt.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      // Conditional header for possibleDateList (first non-empty header)
                      ...(getPossibleDateHeader(reflDataList.frontWhiteListt.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(reflDataList.frontWhiteListt.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : getPossibleDateHeader(reflDataList.rearRedListt.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(reflDataList.rearRedListt.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : getPossibleDateHeader(reflDataList.sideAmberListt.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(reflDataList.sideAmberListt.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                  
                      // Main paragraph showing joined possibleDateList with line breaks
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.frontWhiteListt.possibleDateList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: reflDataList.rearRedListt.possibleDateList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: reflDataList.sideAmberListt.possibleDateList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),

                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.frontWhiteListt.copCertList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.rearRedListt.copCertList.join(
                //               ","
                //             ),
                //           }),
                //           new TextRun({
                //             break: 1,
                //             size: "12pt",
                //             bold: true,
                //             text: reflDataList.sideAmberListt.copCertList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      // Conditional COP header (first valid header from any list)
                      ...(getCOPHeader(reflDataList.frontWhiteListt.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(reflDataList.frontWhiteListt.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : getCOPHeader(reflDataList.rearRedListt.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(reflDataList.rearRedListt.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : getCOPHeader(reflDataList.sideAmberListt.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(reflDataList.sideAmberListt.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                  
                      // Paragraph with COP certificates joined and line breaks
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: reflDataList.frontWhiteListt.copCertList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: reflDataList.rearRedListt.copCertList.join(", "),
                          }),
                          new TextRun({
                            break: 1,
                            size: "12pt",
                            bold: true,
                            text: reflDataList.sideAmberListt.copCertList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "104-D",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear marking Plates for Heavy and long vehicles",
                            size: "12pt",
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "118",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Speed Limiter Installation Test Report as per AIS-018 (SLD / SLF)",
                            size: "12pt",
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "119",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Horns(s)",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "Horn Installation (For all vehicles)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: hornDataList.suppNameList.join("\n\r"),
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: hornDataList.validityList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(hornDataList.validityList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(hornDataList.validityList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   style: "table1Header",
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       bold: true,
                      //       text: hornDataList.validityList.join(", "),
                      //     }),
                      //   ],
                      // }),

                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: (() => {
                              const label = getTACorBISHeader(hornDataList.validityList);
                              return label.startsWith("BIS")
                                ? hornDataList.validityList
                                    .map(item => {
                                      const match = item.match(validDateRegex);
                                      const numberPart = match
                                        ? item.slice(0, match.index).trim()
                                        : item.trim();
                                      const datePart = match ? item.slice(match.index).trim() : "";
                                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                    })
                                    .join(", ")
                                : hornDataList.validityList.join(", ");
                            })(),
                          }),
                        ],
                      }),                    
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: hornDataList.possibleDateList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(hornDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(hornDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: hornDataList.possibleDateList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: hornDataList.copCertList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(hornDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(hornDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: hornDataList.copCertList.join(", "),
                          }),
                        ],
                      }),
                    ],
                  }),

                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "123",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Pillion Hand Holds",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "(For all vehicles)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            text: GrabHandleDataList.MakeList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/1",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Automotive Bulbs",
                            size: "12pt",
                            bold: true,
                          }),
                          new TextRun({
                            text: "( Mention category of bulb/s as per AIS-034 )",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Main Beam head Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            // text: hlMainBeamDataList.suppNameList.join("\n\r"),
                            text: hlMainBeamDataList.suppNameLampList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlMainBeamDataList.tacNumberLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: hlMainBeamDataList.validityLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          hlMainBeamDataList.tacNumberLampList.map((tac, idx) => 
                            `${tac} ${hlMainBeamDataList.validityLampList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      hlMainBeamDataList.tacNumberLampList.map((tac, idx) => 
                                        `${tac} ${hlMainBeamDataList.validityLampList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: hlMainBeamDataList.tacNumberLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: hlMainBeamDataList.validityLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),

                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = hlMainBeamDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${hlMainBeamDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      })
                      
                    ],
                  }),
                  
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlMainBeamDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(hlMainBeamDataList.possibleDateLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(hlMainBeamDataList.possibleDateLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hlMainBeamDataList.possibleDateLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlMainBeamDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(hlMainBeamDataList.copCertLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(hlMainBeamDataList.copCertLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hlMainBeamDataList.copCertLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Dipped Beam Head Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            // text: hlDipBeamDataList.suppNameList.join("\n\r"),
                            text: hlDipBeamDataList.suppNameLampList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlDipBeamDataList.tacNumberLampList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: hlDipBeamDataList.validityLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          hlDipBeamDataList.tacNumberLampList.map((tac, idx) =>
                            `${tac} ${hlDipBeamDataList.validityLampList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      hlDipBeamDataList.tacNumberLampList.map((tac, idx) =>
                                        `${tac} ${hlDipBeamDataList.validityLampList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: hlDipBeamDataList.tacNumberLampList.join(","),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: hlDipBeamDataList.validityLampList.join(","),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = hlDipBeamDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${hlDipBeamDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlDipBeamDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getPossibleDateHeader(hlDipBeamDataList.possibleDateLampList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getPossibleDateHeader(hlDipBeamDataList.possibleDateLampList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hlDipBeamDataList.possibleDateLampList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlDipBeamDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getCOPHeader(hlDipBeamDataList.copCertLampList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getCOPHeader(hlDipBeamDataList.copCertLampList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hlDipBeamDataList.copCertLampList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Daytime Running Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: dtRunnLampDataList.suppNameList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: dtRunnLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: dtRunnLampDataList.possibleDateList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: dtRunnLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),



                // Validity Cell
new TableCell({
    width: {
      size: 3000,
      type: WidthType.DXA,
    },
    children: [
      ...(getTACorBISHeader(dtRunnLampDataList.validityList)
        ? [
            new Paragraph({
              style: "table1Header",
              children: [
                new TextRun({
                  size: "12pt",
                  bold: true,
                  text: getTACorBISHeader(dtRunnLampDataList.validityList),
                }),
              ],
            }),
          ]
        : []),
      // new Paragraph({
      //   children: [
      //     new TextRun({
      //       text: dtRunnLampDataList.validityList.join(","),
      //       size: "12pt",
      //     }),
      //   ],
      // }),



    //   new Paragraph({
    //     children: [
    //       new TextRun({
    //         size: "12pt",
    //         text: (() => {
    //           const combinedList = dtRunnLampDataList.tacNumberList.map((tac, idx) =>
    //             `${tac} ${dtRunnLampDataList.validityList[idx] || ""}`
    //           );
      
    //           const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
      
    //           return combinedList
    //             .map(item => {
    //               const match = item.match(validDateRegex);
    //               const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
    //               const datePart = match ? item.slice(match.index).trim() : "";
    //               return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
    //             })
    //             .join(", ");
    //         })(),
    //       }),
    //     ],
    //   }),



    new Paragraph({
        children: [
          new TextRun({
            size: "12pt",
            text: (() => {
              const label = getTACorBISHeader(dtRunnLampDataList.validityList);
              return label.startsWith("BIS")
                ? dtRunnLampDataList.validityList
                    .map(item => {
                      const match = item.match(validDateRegex);
                      const numberPart = match
                        ? item.slice(0, match.index).trim()
                        : item.trim();
                      const datePart = match ? item.slice(match.index).trim() : "";
                      return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                    })
                    .join(", ")
                : dtRunnLampDataList.validityList.join(", ");
            })(),
          }),
        ],
      }),
      
      
    ],
  }),
  
  // Possible Date Cell
  new TableCell({
    width: {
      size: 3000,
      type: WidthType.DXA,
    },
    children: [
      ...(getPossibleDateHeader(dtRunnLampDataList.possibleDateList)
        ? [
            new Paragraph({
              style: "table1Header",
              children: [
                new TextRun({
                  size: "12pt",
                  bold: true,
                  text: getPossibleDateHeader(dtRunnLampDataList.possibleDateList),
                }),
              ],
            }),
          ]
        : []),
      new Paragraph({
        children: [
          new TextRun({
            text: dtRunnLampDataList.possibleDateList.join(","),
            size: "12pt",
          }),
        ],
      }),
    ],
  }),
  
  // COP Certificate Cell
  new TableCell({
    width: {
      size: 3000,
      type: WidthType.DXA,
    },
    children: [
      ...(getCOPHeader(dtRunnLampDataList.copCertList)
        ? [
            new Paragraph({
              style: "table1Header",
              children: [
                new TextRun({
                  size: "12pt",
                  bold: true,
                  text: getCOPHeader(dtRunnLampDataList.copCertList),
                }),
              ],
            }),
          ]
        : []),
      new Paragraph({
        children: [
          new TextRun({
            text: dtRunnLampDataList.copCertList.join(","),
            size: "12pt",
          }),
        ],
      }),
    ],
  }),
  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 3,
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Cornering Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Position / parking lamp ",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: frontPosLampDataList.suppNameLampList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: frontPosLampDataList.tacNumberLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: frontPosLampDataList.validityLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          frontPosLampDataList.tacNumberLampList.map(
                            (tac, idx) => `${tac} ${frontPosLampDataList.validityLampList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      frontPosLampDataList.tacNumberLampList.map(
                                        (tac, idx) => `${tac} ${frontPosLampDataList.validityLampList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: frontPosLampDataList.tacNumberLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: frontPosLampDataList.validityLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),

                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = frontPosLampDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${frontPosLampDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      })
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: frontPosLampDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: frontPosLampDataList.copCertLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),




                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(frontPosLampDataList.possibleDateLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(frontPosLampDataList.possibleDateLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: frontPosLampDataList.possibleDateLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(frontPosLampDataList.copCertLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(frontPosLampDataList.copCertLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: frontPosLampDataList.copCertLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),

                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Fog Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Direction",
                            size: "12pt",
                          }),
                          new TextRun({
                            break: 1,
                            text: "Indicator Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: fdIndLampDataList.suppNameLampList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: fdIndLampDataList.tacNumberLampList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: fdIndLampDataList.validityLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        fdIndLampDataList.tacNumberLampList.map((tac, idx) =>
                          `${tac} ${fdIndLampDataList.validityLampList[idx] || ""}`
                        )
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    fdIndLampDataList.tacNumberLampList.map((tac, idx) =>
                                      `${tac} ${fdIndLampDataList.validityLampList[idx] || ""}`
                                    )
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: fdIndLampDataList.tacNumberLampList.join(","),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: fdIndLampDataList.validityLampList.join(","),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = fdIndLampDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${fdIndLampDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: fdIndLampDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(fdIndLampDataList.possibleDateLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(fdIndLampDataList.possibleDateLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: fdIndLampDataList.possibleDateLampList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),

                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: fdIndLampDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(fdIndLampDataList.copCertLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(fdIndLampDataList.copCertLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: fdIndLampDataList.copCertLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front End-out Marker Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Side Direction Indicator lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        // children: [
                        //     new TextRun({
                        //         text: sdIndLampDataList.suppNameList.join("\n\r"),
                        //         size: "12pt"
                        //     })
                        // ]
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        // children: [
                        //     new TextRun({
                        //         text: sdIndLampDataList.tacNumberList.join(","),
                        //         size: "12pt"
                        //     }),
                        //     new TextRun({
                        //         text: " ",
                        //         size: "12pt",
                        //     }),
                        //     new TextRun({
                        //         text: sdIndLampDataList.validityList.join(","),
                        //         size: "12pt"
                        //     }),
                        // ]
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        // children: [
                        //     new TextRun({
                        //         text: sdIndLampDataList.possibleDateList.join(","),
                        //         size: "12pt"
                        //     })
                        // ]
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        // children: [
                        //     new TextRun({
                        //         text: sdIndLampDataList.copCertList.join(","),
                        //         size: "12pt"
                        //     })
                        // ]
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Side Marker lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Stop Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: stopLampDataList.suppNameLampList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: stopLampDataList.tacNumberLampList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: stopLampDataList.validityLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          stopLampDataList.tacNumberLampList.map((tac, idx) =>
                            `${tac} ${stopLampDataList.validityLampList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      stopLampDataList.tacNumberLampList.map((tac, idx) =>
                                        `${tac} ${stopLampDataList.validityLampList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: stopLampDataList.tacNumberLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: stopLampDataList.validityLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = stopLampDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${stopLampDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: stopLampDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(stopLampDataList.possibleDateLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(stopLampDataList.possibleDateLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: stopLampDataList.possibleDateLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: stopLampDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(stopLampDataList.copCertLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(stopLampDataList.copCertLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: stopLampDataList.copCertLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Direction indicator Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rdIndLampDataList.suppNameLampList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rdIndLampDataList.tacNumberLampList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: rdIndLampDataList.validityLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          rdIndLampDataList.tacNumberLampList.map((tac, idx) =>
                            `${tac} ${rdIndLampDataList.validityLampList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      rdIndLampDataList.tacNumberLampList.map((tac, idx) =>
                                        `${tac} ${rdIndLampDataList.validityLampList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: rdIndLampDataList.tacNumberLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: rdIndLampDataList.validityLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),

                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = rdIndLampDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${rdIndLampDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rdIndLampDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(rdIndLampDataList.possibleDateLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(rdIndLampDataList.possibleDateLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rdIndLampDataList.possibleDateLampList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rdIndLampDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(rdIndLampDataList.copCertLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(rdIndLampDataList.copCertLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rdIndLampDataList.copCertLampList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Position / Parking Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rearPosLampDataList.suppNameLampList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rearPosLampDataList.tacNumberLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: rearPosLampDataList.validityLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        rearPosLampDataList.tacNumberLampList.map((tac, idx) =>
                          `${tac} ${rearPosLampDataList.validityLampList[idx] || ""}`
                        )
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    rearPosLampDataList.tacNumberLampList.map((tac, idx) =>
                                      `${tac} ${rearPosLampDataList.validityLampList[idx] || ""}`
                                    )
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: rearPosLampDataList.tacNumberLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: rearPosLampDataList.validityLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = rearPosLampDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${rearPosLampDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rearPosLampDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(rearPosLampDataList.possibleDateLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(rearPosLampDataList.possibleDateLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rearPosLampDataList.possibleDateLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rearPosLampDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(rearPosLampDataList.copCertLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(rearPosLampDataList.copCertLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rearPosLampDataList.copCertLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Reversing Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: revLampDataList.suppNameLampList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: revLampDataList.tacNumberLampList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: revLampDataList.validityLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        revLampDataList.tacNumberLampList.map((tac, idx) =>
                          `${tac} ${revLampDataList.validityLampList[idx] || ""}`
                        )
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    revLampDataList.tacNumberLampList.map((tac, idx) =>
                                      `${tac} ${revLampDataList.validityLampList[idx] || ""}`
                                    )
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: revLampDataList.tacNumberLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: revLampDataList.validityLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = revLampDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${revLampDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: revLampDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(revLampDataList.possibleDateLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(revLampDataList.possibleDateLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: revLampDataList.possibleDateLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: revLampDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(revLampDataList.copCertLampList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(revLampDataList.copCertLampList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: revLampDataList.copCertLampList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Fog Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Registration Plate Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rrpLampDataList.suppNameLampList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rrpLampDataList.tacNumberLampList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: rrpLampDataList.validityLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          rrpLampDataList.tacNumberLampList.map((tac, idx) =>
                            `${tac} ${rrpLampDataList.validityLampList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      rrpLampDataList.tacNumberLampList.map((tac, idx) =>
                                        `${tac} ${rrpLampDataList.validityLampList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: rrpLampDataList.tacNumberLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: rrpLampDataList.validityLampList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const combinedList = rrpLampDataList.tacNumberLampList.map((tac, idx) =>
                                `${tac} ${rrpLampDataList.validityLampList[idx] || ""}`
                              );
                      
                              const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                              return combinedList
                                .map(item => {
                                  const match = item.match(validDateRegex);
                                  const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                                  const datePart = match ? item.slice(match.index).trim() : "";
                                  return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                                })
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),

                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rrpLampDataList.possibleDateLampList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getPossibleDateHeader(rrpLampDataList.possibleDateLampList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getPossibleDateHeader(rrpLampDataList.possibleDateLampList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rrpLampDataList.possibleDateLampList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rrpLampDataList.copCertLampList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getCOPHeader(rrpLampDataList.copCertLampList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getCOPHeader(rrpLampDataList.copCertLampList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rrpLampDataList.copCertLampList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear End-out Marker Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "High Mounted Stop Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "NA",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124(1)-5(b)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Requirements for behavior of steering mechanism of a vehicle in a Head-on collision",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124(1)-5(c)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Protection of Occupants in the event of an Offset Frontal collision",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124(1)-6(b)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Approval of vehicles with regard to the Protection of Occupants in the event of a Lateral collision",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124(1)-6(c)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Approval of vehicles with regard to the Protection of Pedestrian and other Vulnerable Road User in the event of a collision with a Motor vehicle",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124(1)-51",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Protective devices against unauthorized use for M & N category vehicles",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124(1)-52",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Vehicle Alarm Systems and Immobilizers for M1 category, and N1 category (having GVW not more than 2 ton)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/2",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Hydraulic Brake Hose (For all vehicles – as applicable)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: hydrBrkHoseDataList.suppNameList.join("\n\r"),
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: hydrBrkHoseDataList.validityList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                // new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       ...(
                //         getTACorBISHeader(hydrBrkHoseDataList.validityList)
                //           ? [
                //               new Paragraph({
                //                 style: "table1Header",
                //                 children: [
                //                   new TextRun({
                //                     size: "12pt",
                //                     bold: true,
                //                     text: getTACorBISHeader(hydrBrkHoseDataList.validityList),
                //                   }),
                //                 ],
                //               }),
                //             ]
                //           : []
                //       ),
                //       // new Paragraph({
                //       //   children: [
                //       //     new TextRun({
                //       //       text: hydrBrkHoseDataList.validityList.join(","),
                //       //       size: "12pt",
                //       //     }),
                //       //   ],
                //       // }),

                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: (() => {
                //               const combinedList = hydrBrkHoseDataList.tacNumberList.map((tac, idx) =>
                //                 `${tac} ${hydrBrkHoseDataList.validityList[idx] || ""}`
                //               );
                      
                //               const isBIS = getTACorBISHeader(combinedList).startsWith("BIS");
                      
                //               return combinedList
                //                 .map(item => {
                //                   const match = item.match(validDateRegex);
                //                   const numberPart = match ? item.slice(0, match.index).trim() : item.trim();
                //                   const datePart = match ? item.slice(match.index).trim() : "";
                //                   return `${isBIS ? "CM/L-" : ""}${numberPart}${datePart ? " " + datePart : ""}`;
                //                 })
                //                 .join(", ");
                //             })(),
                //           }),
                //         ],
                //       }),
                      
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        hydrBrkHoseDataList.tacNumberList.map((tac, idx) =>
                          `${tac} ${hydrBrkHoseDataList.validityList[idx] || ""}`
                        )
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    hydrBrkHoseDataList.tacNumberList.map((tac, idx) =>
                                      `${tac} ${hydrBrkHoseDataList.validityList[idx] || ""}`
                                    )
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(hydrBrkHoseDataList.tacNumberList).startsWith("BIS");
                  
                              return hydrBrkHoseDataList.tacNumberList.map((tac, idx) => {
                                const validity = hydrBrkHoseDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: hydrBrkHoseDataList.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getPossibleDateHeader(hydrBrkHoseDataList.possibleDateList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getPossibleDateHeader(hydrBrkHoseDataList.possibleDateList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hydrBrkHoseDataList.possibleDateList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             bold: true,
                //             text: hydrBrkHoseDataList.copCertList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getCOPHeader(hydrBrkHoseDataList.copCertList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getCOPHeader(hydrBrkHoseDataList.copCertList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hydrBrkHoseDataList.copCertList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),

                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/3",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Hydraulic Brake Fluid (For all vehicles – as applicable)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: BrakeFluidDataList.MakeList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: BrakeFluidDataList.tacNumberList.join("\n\r"),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                // new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       ...(getTACorBISHeader(BrakeFluidDataList.tacNumberList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                 //   text: getTACorBISHeader(BrakeFluidDataList.tacNumberList),
                //                 text: "Test Report No",
                                  
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: BrakeFluidDataList.tacNumberList.join("\n\r"),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),



                new TableCell({
                  width: { size: 3000, type: WidthType.DXA },
                  children: [
                    // ---------------- Header ----------------
                    ...(getTACorBISHeader(BrakeFluidDataList.tacNumberList)
                      ? [
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text: getTACorBISHeader(BrakeFluidDataList.tacNumberList),
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    // ---------------- Values ----------------
                    new Paragraph({                      
                      children: [
                        new TextRun({
                          size: "12pt",
                          bold: true,
                          text: (() => {
                            const label = getTACorBISHeader(BrakeFluidDataList.tacNumberList);
                            return label.startsWith("BIS")
                              ? BrakeFluidDataList.tacNumberList
                                  .map((item) => {
                                    const match = item.match(validDateRegex);
                                    const numberPart = match
                                      ? item.slice(0, match.index).trim()
                                      : item.trim();
                                    const datePart = match ? item.slice(match.index).trim() : "";
                                    return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                  })
                                  .join(", ")
                              : BrakeFluidDataList.tacNumberList.join(", ");
                          })(),
                        }),
                      ],
                    }),
                  ],
                }),
                
                  
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/5",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Steering Impact",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "Head Form Test",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Body Block Test",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Crash Test",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "(For M1 category having GVW not more than 1500kg)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/6",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Side Door Impact Test",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(For passenger cars)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/7",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Fuel Tank (Provide details in case of multiple capacities / suppliers)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Fuel Tank (metallic) or ",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "Fuel Tank (plastic)",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "(For Four Wheelers)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/8",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Wheel Rims",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(For Four wheelers)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/9",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Control Cables  (For two wheelers below 50 CC)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/10",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Pneumatic Coupling (For N category of vehicles)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/12",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Bus Window Retention",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(Only for Buses)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/14",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Wheel Nuts /Bolts,",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "Wheel Caps / Hub Caps",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "(Only for Four Wheelers)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/15",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Accelerator Control Systems",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(Only for Four Wheelers)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 7,
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/16",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Door Locks & Hinges",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(Only for Four Wheelers)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 7,
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 7,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 7,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 7,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Door Hinges",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Door Hinges",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Door Hinges",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Door Locks",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Door Lock",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Door Lock",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/17",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Hood Latch",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(For passenger cars)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 5,
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/20",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "i)  Lighting Signaling & Indicating  Systems",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(For 4 Wheelers)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 5,
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 5,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 5,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 5,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Head Lamp (Main Beam)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Head Lamp (Dipped Beam)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Position / Parking Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Cornering Lamp (if provided)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 17,
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/20",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Direction Indicator",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 17,
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 17,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 17,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    rowSpan: 17,
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Fog lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Day-Time Running Lamp (if provided)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front end-out marker Lamp / Top Lights",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear end-out marker Lamp / Top Lights",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Stop Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Position / Parking Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Direction Indicator",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Reversing lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Fog lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "High mounted stop Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Registration Plate Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Side Direction Indicator Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Side Marker lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Head Lam Cleaning Device",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "ii) Lighting and Signaling Installation Requirements (for 4 wheelers)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Report No(s). for Base Model / Variants (if already issued)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/21",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Electromagnetic Radiation (EMI) (for all combinations of spark plug, ignition coil, HT cable, Ignition System, ECU and suppress cap)",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(For all vehicles)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/22",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Towing Devices  (For 4 wheelers) as applicable",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/24",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Lighting and Signaling installation requirements for 2 & 3wheelers, including Trailers, semi-Trailers",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Report No(s). for Base Model / Variants",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(if already issued)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/25",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Fuel Tank for 2 & 3wheelers",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "(metallic or Non-Metallic)   (Indicate Nominal capacity) ",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/32",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Lighting and light signaling devices for 2 wheelers, 3 wheelers and their trailers and semi-trailers.",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Head Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hlMainBeamDataList.suppNameList.join(","),
                            size: "12pt",
                          }),
                          new TextRun({
                            break: 1,
                            text: " ",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: hlDipBeamDataList.suppNameList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlMainBeamDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: hlMainBeamDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             break: 1,
                //             text: hlDipBeamDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: hlDipBeamDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                // new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       ...(() => {
                //         const mainBeamHeader = getTACorBISHeader(
                //           hlMainBeamDataList.tacNumberList.map(
                //             (tac, idx) => `${tac} ${hlMainBeamDataList.validityList[idx] || ""}`
                //           )
                //         );
                  
                //         const dipBeamHeader = getTACorBISHeader(
                //           hlDipBeamDataList.tacNumberList.map(
                //             (tac, idx) => `${tac} ${hlDipBeamDataList.validityList[idx] || ""}`
                //           )
                //         );
                  
                //         if (mainBeamHeader) {
                //           return [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text: mainBeamHeader,
                //                 }),
                //               ],
                //             }),
                //           ];
                //         } else if (dipBeamHeader) {
                //           return [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text: dipBeamHeader,
                //                 }),
                //               ],
                //             }),
                //           ];
                //         }
                //         return [];
                //       })(),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      // ✅ Conditionally render header from the first valid TAC list
                      ...(() => {
                        let selectedList = null;
                  
                        if (hlMainBeamDataList.tacNumberList.length > 0) {
                          selectedList = hlMainBeamDataList;
                        } else if (hlDipBeamDataList.tacNumberList.length > 0) {
                          selectedList = hlDipBeamDataList;
                        }
                  
                        if (!selectedList) return [];
                  
                        const combinedList = selectedList.tacNumberList.map((tac, idx) =>
                          `${tac} ${selectedList.validityList[idx] || ""}`
                        );
                  
                        const headerText = getTACorBISHeader(combinedList);
                  
                        return headerText
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: headerText,
                                  }),
                                ],
                              }),
                            ]
                          : [];
                      })(),
                  
                //       // ✅ Paragraph with TAC + validity from both hlMain and hlDip
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           // hlMainBeamDataList
                //           ...hlMainBeamDataList.tacNumberList.map((tacNumber, index) => {
                //             const validity = hlMainBeamDataList.validityList[index] || "";
                //             return new TextRun({
                //               size: 24,
                //               bold: true,
                //               text: `${tacNumber} ${validity} `,
                //             });
                //           }),
                  
                //           new TextRun({ break: 1 }),
                  
                //           // hlDipBeamDataList
                //           ...hlDipBeamDataList.tacNumberList.map((tacNumber, index) => {
                //             const validity = hlDipBeamDataList.validityList[index] || "";
                //             return new TextRun({
                //               size: 24,
                //               bold: true,
                //               text: `${tacNumber} ${validity} `,
                //             });
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                  
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: hlMainBeamDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: hlMainBeamDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       break: 1,
                      //       text: hlDipBeamDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: hlDipBeamDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          // Main Beam
                          new TextRun({
                            text: (() => {
                              const label = getTACorBISHeader(
                                hlMainBeamDataList.tacNumberList.map((tac, i) => `${tac} ${hlMainBeamDataList.validityList[i] || ""}`)
                              );
                              return label.startsWith("BIS")
                                ? hlMainBeamDataList.tacNumberList.map((tac, i) => {
                                    const validity = hlMainBeamDataList.validityList[i] || "";
                                    const combined = `${tac} ${validity}`.trim();
                                    const match = combined.match(validDateRegex);
                                    const numberPart = match ? combined.slice(0, match.index).trim() : combined;
                                    const datePart = match ? combined.slice(match.index).trim() : "";
                                    return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                  }).join(", ")
                                : hlMainBeamDataList.tacNumberList.map((tac, i) => `${tac} ${hlMainBeamDataList.validityList[i] || ""}`).join(", ");
                            })(),
                            size: "12pt",
                          }),
                      
                          new TextRun({ break: 1 }),
                      
                          // Dip Beam
                          new TextRun({
                            text: (() => {
                              const label = getTACorBISHeader(
                                hlDipBeamDataList.tacNumberList.map((tac, i) => `${tac} ${hlDipBeamDataList.validityList[i] || ""}`)
                              );
                              return label.startsWith("BIS")
                                ? hlDipBeamDataList.tacNumberList.map((tac, i) => {
                                    const validity = hlDipBeamDataList.validityList[i] || "";
                                    const combined = `${tac} ${validity}`.trim();
                                    const match = combined.match(validDateRegex);
                                    const numberPart = match ? combined.slice(0, match.index).trim() : combined;
                                    const datePart = match ? combined.slice(match.index).trim() : "";
                                    return `CM/L-${numberPart}${datePart ? " " + datePart : ""}`;
                                  }).join(", ")
                                : hlDipBeamDataList.tacNumberList.map((tac, i) => `${tac} ${hlDipBeamDataList.validityList[i] || ""}`).join(", ");
                            })(),
                            size: "12pt",
                          }),
                        ],
                      })
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlMainBeamDataList.possibleDateList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             break: 1,
                //             text: hlDipBeamDataList.possibleDateList.join(
                //               "\n\r"
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(() => {
                        const mainHeader = getPossibleDateHeader(hlMainBeamDataList.possibleDateList);
                        const dipHeader = getPossibleDateHeader(hlDipBeamDataList.possibleDateList);
                  
                        if (mainHeader) {
                          return [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: mainHeader,
                                }),
                              ],
                            }),
                          ];
                        } else if (dipHeader) {
                          return [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: dipHeader,
                                }),
                              ],
                            }),
                          ];
                        }
                        return [];
                      })(),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hlMainBeamDataList.possibleDateList.join(","),
                            size: "12pt",
                          }),
                          new TextRun({
                            break: 1,
                            text: hlDipBeamDataList.possibleDateList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),

                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: hlMainBeamDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             break: 1,
                //             text: hlDipBeamDataList.copCertList.join("\n\r"),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(() => {
                        const mainHeader = getCOPHeader(hlMainBeamDataList.copCertList);
                        const dipHeader = getCOPHeader(hlDipBeamDataList.copCertList);
                  
                        if (mainHeader) {
                          return [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: mainHeader,
                                }),
                              ],
                            }),
                          ];
                        } else if (dipHeader) {
                          return [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: dipHeader,
                                }),
                              ],
                            }),
                          ];
                        }
                        return [];
                      })(),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: hlMainBeamDataList.copCertList.join(","),
                            size: "12pt",
                          }),
                          new TextRun({
                            break: 1,
                            text: hlDipBeamDataList.copCertList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Position / Parking Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: frontPosLampDataList.suppNameList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: frontPosLampDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: frontPosLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          frontPosLampDataList.tacNumberList.map((tac, idx) => `${tac} ${frontPosLampDataList.validityList[idx] || ""}`)
                        )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    frontPosLampDataList.tacNumberList.map((tac, idx) => `${tac} ${frontPosLampDataList.validityList[idx] || ""}`)
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: frontPosLampDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: frontPosLampDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(frontPosLampDataList.tacNumberList).startsWith("BIS");
                      
                              return frontPosLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = frontPosLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: frontPosLampDataList.possibleDateList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getPossibleDateHeader(frontPosLampDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(frontPosLampDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: frontPosLampDataList.possibleDateList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: frontPosLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getCOPHeader(frontPosLampDataList.copCertList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getCOPHeader(frontPosLampDataList.copCertList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: frontPosLampDataList.copCertList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Direction Indicator",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: fdIndLampDataList.suppNameList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: fdIndLampDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: fdIndLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          fdIndLampDataList.tacNumberList.map((tac, idx) => `${tac} ${fdIndLampDataList.validityList[idx] || ""}`)
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      fdIndLampDataList.tacNumberList.map((tac, idx) => `${tac} ${fdIndLampDataList.validityList[idx] || ""}`)
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: fdIndLampDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: fdIndLampDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),

                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(fdIndLampDataList.tacNumberList).startsWith("BIS");
                      
                              return fdIndLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = fdIndLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: fdIndLampDataList.possibleDateList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getPossibleDateHeader(fdIndLampDataList.possibleDateList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getPossibleDateHeader(fdIndLampDataList.possibleDateList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: fdIndLampDataList.possibleDateList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: fdIndLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getCOPHeader(fdIndLampDataList.copCertList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getCOPHeader(fdIndLampDataList.copCertList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: fdIndLampDataList.copCertList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Stop Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: stopLampDataList.suppNameList.join("\n\r"),
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: stopLampDataList.tacNumberList.join(","),
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             size: "12pt",
                //             text: stopLampDataList.validityList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          stopLampDataList.tacNumberList.map((tac, idx) => 
                            `${tac} ${stopLampDataList.validityList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      stopLampDataList.tacNumberList.map((tac, idx) => 
                                        `${tac} ${stopLampDataList.validityList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   style: "table1Header",
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       text: stopLampDataList.tacNumberList.join(","),
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       size: "12pt",
                      //       text: stopLampDataList.validityList.join(","),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(stopLampDataList.tacNumberList).startsWith("BIS");
                      
                              return stopLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = stopLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: stopLampDataList.possibleDateList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getPossibleDateHeader(stopLampDataList.possibleDateList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getPossibleDateHeader(stopLampDataList.possibleDateList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: stopLampDataList.possibleDateList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: stopLampDataList.copCertList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getCOPHeader(stopLampDataList.copCertList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getCOPHeader(stopLampDataList.copCertList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: stopLampDataList.copCertList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  


                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Position / Parking Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rearPosLampDataList.suppNameList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                        // children: [
                        //     new TextRun({
                        //         text: "",
                        //         size: "12pt"
                        //     })
                        // ]
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rearPosLampDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: rearPosLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //         // children: [
                //         //     new TextRun({
                //         //         text: "",
                //         //         size: "12pt"
                //         //     })
                //         // ]
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getTACorBISHeader(
                          rearPosLampDataList.tacNumberList.map((tac, idx) => 
                            `${tac} ${rearPosLampDataList.validityList[idx] || ""}`
                          )
                        )
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getTACorBISHeader(
                                      rearPosLampDataList.tacNumberList.map((tac, idx) => 
                                        `${tac} ${rearPosLampDataList.validityList[idx] || ""}`
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: rearPosLampDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: rearPosLampDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(rearPosLampDataList.tacNumberList).startsWith("BIS");
                      
                              return rearPosLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = rearPosLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rearPosLampDataList.possibleDateList.join(
                //               ","
                //             ),
                //             size: "12pt",
                //           }),
                //         ],
                //         // children: [
                //         //     new TextRun({
                //         //         text: "",
                //         //         size: "12pt"
                //         //     })
                //         // ]
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getPossibleDateHeader(rearPosLampDataList.possibleDateList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getPossibleDateHeader(rearPosLampDataList.possibleDateList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rearPosLampDataList.possibleDateList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rearPosLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //         // children: [
                //         //     new TextRun({
                //         //         text: "",
                //         //         size: "12pt"
                //         //     })
                //         // ]
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(
                        getCOPHeader(rearPosLampDataList.copCertList)
                          ? [
                              new Paragraph({
                                style: "table1Header",
                                children: [
                                  new TextRun({
                                    size: "12pt",
                                    bold: true,
                                    text: getCOPHeader(rearPosLampDataList.copCertList),
                                  }),
                                ],
                              }),
                            ]
                          : []
                      ),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rearPosLampDataList.copCertList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Direction Indicator",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rdIndLampDataList.suppNameList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rdIndLampDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: rdIndLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        rdIndLampDataList.tacNumberList.map((tac, idx) => `${tac} ${rdIndLampDataList.validityList[idx] || ""}`)
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    rdIndLampDataList.tacNumberList.map((tac, idx) => `${tac} ${rdIndLampDataList.validityList[idx] || ""}`)
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: rdIndLampDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: rdIndLampDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(rdIndLampDataList.tacNumberList).startsWith("BIS");
                      
                              return rdIndLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = rdIndLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rdIndLampDataList.possibleDateList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(
                        rdIndLampDataList.possibleDateList
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(
                                    rdIndLampDataList.possibleDateList
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rdIndLampDataList.possibleDateList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rdIndLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(rdIndLampDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(rdIndLampDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rdIndLampDataList.copCertList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Reversing Lamp for 3 Wheeler",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: " ",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: revLampDataList.suppNameList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: revLampDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: revLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        revLampDataList.tacNumberList.map((tac, idx) => 
                          `${tac} ${revLampDataList.validityList[idx] || ""}`
                        )
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    revLampDataList.tacNumberList.map((tac, idx) => 
                                      `${tac} ${revLampDataList.validityList[idx] || ""}`
                                    )
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: revLampDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: revLampDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(revLampDataList.tacNumberList).startsWith("BIS");
                      
                              return revLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = revLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: revLampDataList.possibleDateList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(revLampDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(revLampDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: revLampDataList.possibleDateList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: revLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(revLampDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(revLampDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: revLampDataList.copCertList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear Registration Plate Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rrpLampDataList.suppNameList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rrpLampDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: rrpLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        rrpLampDataList.tacNumberList.map((tac, idx) =>
                          `${tac} ${rrpLampDataList.validityList[idx] || ""}`
                        )
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    rrpLampDataList.tacNumberList.map((tac, idx) =>
                                      `${tac} ${rrpLampDataList.validityList[idx] || ""}`
                                    )
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: rrpLampDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: rrpLampDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(rrpLampDataList.tacNumberList).startsWith("BIS");
                      
                              return rrpLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = rrpLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rrpLampDataList.possibleDateList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(rrpLampDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(rrpLampDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rrpLampDataList.possibleDateList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: rrpLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(rrpLampDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(rrpLampDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: rrpLampDataList.copCertList.join(","),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Side Direction Indicator Lamp",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: sdIndLampDataList.suppNameList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: sdIndLampDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: " ",
                //             size: "12pt",
                //           }),
                //           new TextRun({
                //             text: sdIndLampDataList.validityList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(
                        sdIndLampDataList.tacNumberList.map(
                          (tac, idx) => `${tac} ${sdIndLampDataList.validityList[idx] || ""}`
                        )
                      )
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(
                                    sdIndLampDataList.tacNumberList.map(
                                      (tac, idx) => `${tac} ${sdIndLampDataList.validityList[idx] || ""}`
                                    )
                                  ),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: sdIndLampDataList.tacNumberList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: " ",
                      //       size: "12pt",
                      //     }),
                      //     new TextRun({
                      //       text: sdIndLampDataList.validityList.join(", "),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(sdIndLampDataList.tacNumberList).startsWith("BIS");
                      
                              return sdIndLampDataList.tacNumberList.map((tac, idx) => {
                                const validity = sdIndLampDataList.validityList[idx] || "";
                                const prefix = isBIS ? "CM/L-" : "";
                                return `${prefix}${tac}${validity ? " " + validity : ""}`;
                              }).join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: sdIndLampDataList.possibleDateList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(sdIndLampDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(sdIndLampDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: sdIndLampDataList.possibleDateList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             text: sdIndLampDataList.copCertList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(sdIndLampDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(sdIndLampDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: sdIndLampDataList.copCertList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  

                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/33",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Spray Suppression System Installation test report as per AIS-013",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            // text: SpraySuppressionDataList.suppNameList.join("\n\r"),
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            // text: SpraySuppressionDataList.MakeList.join("\n\r"),
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/34",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Drivers field of vision for M1 category of vehicles. ",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/35",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Survival space for protection of occupants in a cab.",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/36",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Strength of superstructure of passenger vehicles.",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/37",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Flammability requirements for M3 category vehicles with more than 22 passengers.",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/38",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Interior fittings for M1 category",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/39",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Windscreen wiping system requirements for 3 wheelers",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/42",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Handholds for L5, M & N category vehicles",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/43",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Wheel Rims for L category vehicles",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        // children: [
                        //     new TextRun({
                        //         text: FWheelRimDataList.MakeList.join(","),

                        //         size: "12pt"
                        //     }),
                        //     new TextRun({
                        //         break: 1,
                        //         text: RWheelRimDataList.MakeList.join("\n\r"),
                        //         size: "12pt"
                        //     })

                        // ]

                        // children: [
                        //     new TextRun({
                        //         text: "Front Wheel Rim",
                        //         bold: true,
                        //         size: "12pt",
                        //     }),
                        //     new TextRun({
                        //         break: 1,
                        //         text: FWheelRimDataList.MakeList.join(", "),
                        //         size: "12pt",
                        //     }),
                        //     new TextRun({
                        //         break: 1,
                        //         text: "Rear Wheel Rim",
                        //         bold: true,
                        //         size: "12pt",
                        //     }),
                        //     new TextRun({
                        //         break: 1,
                        //         text: RWheelRimDataList.MakeList.join(", "),
                        //         size: "12pt",
                        //     }),
                        // ]

                        children: [
                          // Front Wheel Rim
                          ...(FWheelRimDataList.MakeList.some(
                            (val) => val && val.trim() !== ""
                          )
                            ? [
                                new TextRun({
                                  text: "Front Wheel Rim",
                                  bold: true,
                                  size: "12pt",
                                }),
                              ]
                            : []),
                          new TextRun({
                            break: 1,
                            text: FWheelRimDataList.MakeList.join(", "),
                            size: "12pt",
                          }),

                          // Rear Wheel Rim (separate paragraph)
                          new TextRun({ break: 2 }),
                          ...(RWheelRimDataList.MakeList.some(
                            (val) => val && val.trim() !== ""
                          )
                            ? [
                                new TextRun({
                                  text: "Rear Wheel Rim",
                                  bold: true,
                                  size: "12pt",
                                }),
                              ]
                            : []),
                          new TextRun({
                            break: 1,
                            text: RWheelRimDataList.MakeList.join(", "),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         // children: [
                //         //     new TextRun({
                //         //         text: FWheelRimDataList.tacNumberList.join(","),
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: RWheelRimDataList.tacNumberList.join("\n\r"),
                //         //         size: "12pt"
                //         //     })
                //         // ]

                //         // children: [
                //         //     new TextRun({
                //         //         text: "Front Wheel Rim TAC Number:",
                //         //         bold: true,
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: FWheelRimDataList.tacNumberList.join(", "),
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: "Rear Wheel Rim TAC Number:",
                //         //         bold: true,
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: RWheelRimDataList.tacNumberList.join(", "),
                //         //         size: "12pt"
                //         //     })
                //         // ]

                //         children: [
                //           // Front Wheel Rim TAC Number
                //           ...(FWheelRimDataList.tacNumberList.some(
                //             (val) => val && val.trim() !== ""
                //           )
                //             ? [
                //                 new TextRun({
                //                   text: "Front Wheel Rim TAC Number:",
                //                   bold: true,
                //                   size: "12pt",
                //                 }),
                //               ]
                //             : []),
                //           new TextRun({
                //             break: 1,
                //             text: FWheelRimDataList.tacNumberList.join(", "),
                //             size: "12pt",
                //           }),

                //           // Rear Wheel Rim TAC Number (separate paragraph)
                //           new TextRun({ break: 2 }),
                //           ...(RWheelRimDataList.tacNumberList.some(
                //             (val) => val && val.trim() !== ""
                //           )
                //             ? [
                //                 new TextRun({
                //                   text: "Rear Wheel Rim TAC Number:",
                //                   bold: true,
                //                   size: "12pt",
                //                 }),
                //               ]
                //             : []),
                //           new TextRun({
                //             break: 1,
                //             text: RWheelRimDataList.tacNumberList.join(", "),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),



                // new TableCell({
                //     width: { size: 3000, type: WidthType.DXA },
                //     children: [
                //       // Front Wheel Rim section
                //       ...(getTACorBISHeader(
                //         FWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                //       )
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text:
                //                     "Front Wheel Rim " +
                //                     getTACorBISHeader(
                //                       FWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                //                     ),
                //                 }),
                //               ],
                //             }),
                //             new Paragraph({
                //               children: [
                //                 ...FWheelRimDataList.tacNumberList.map((tac, idx) => {
                //                   const isBIS = getTACorBISHeader(
                //                     FWheelRimDataList.tacNumberList
                //                   ).startsWith("BIS");
                //                   return new TextRun({
                //                     text: `${isBIS ? "CM/L-" : ""}${tac}`,
                //                     break: idx < FWheelRimDataList.tacNumberList.length - 1 ? 1 : 0,
                //                     size: 24,
                //                   });
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                  
                //       // Rear Wheel Rim section
                //       ...(getTACorBISHeader(
                //         RWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                //       )
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text:
                //                     "Rear Wheel Rim " +
                //                     getTACorBISHeader(
                //                       RWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                //                     ),
                //                 }),
                //               ],
                //             }),
                //             new Paragraph({
                //               children: [
                //                 ...RWheelRimDataList.tacNumberList.map((tac, idx) => {
                //                   const isBIS = getTACorBISHeader(
                //                     RWheelRimDataList.tacNumberList
                //                   ).startsWith("BIS");
                //                   return new TextRun({
                //                     text: `${isBIS ? "CM/L-" : ""}${tac}`,
                //                     break: idx < RWheelRimDataList.tacNumberList.length - 1 ? 1 : 0,
                //                     size: 24,
                //                   });
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                //     ],
                //   }),


                new TableCell({
                  width: { size: 3000, type: WidthType.DXA },
                  children: [
                    // ---------------- Front Wheel Rim ----------------
                    ...(getTACorBISHeader(
                      FWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                    )
                      ? [
                          // Header (upper)
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text:
                                  "Front Wheel Rim " +
                                  getTACorBISHeader(
                                    FWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                                  ),
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    ...(FWheelRimDataList.tacNumberList.length > 0
                      ? [
                          // Values (downer)
                          new Paragraph({
                            children: [
                              ...FWheelRimDataList.tacNumberList.map((tac, idx) => {
                                const isBIS = getTACorBISHeader(
                                  FWheelRimDataList.tacNumberList
                                ).startsWith("BIS");
                                return new TextRun({
                                  text: `${isBIS ? "CM/L-" : ""}${tac}`,
                                  break:
                                    idx < FWheelRimDataList.tacNumberList.length - 1 ? 1 : 0,
                                  size: 24,
                                });
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    // ---------------- Rear Wheel Rim ----------------
                    ...(getTACorBISHeader(
                      RWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                    )
                      ? [
                          // Header (upper)
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text:
                                  "Rear Wheel Rim " +
                                  getTACorBISHeader(
                                    RWheelRimDataList.tacNumberList.map((tac) => `${tac}`)
                                  ),
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    ...(RWheelRimDataList.tacNumberList.length > 0
                      ? [
                          // Values (downer)
                          new Paragraph({
                            children: [
                              ...RWheelRimDataList.tacNumberList.map((tac, idx) => {
                                const isBIS = getTACorBISHeader(
                                  RWheelRimDataList.tacNumberList
                                ).startsWith("BIS");
                                return new TextRun({
                                  text: `${isBIS ? "CM/L-" : ""}${tac}`,
                                  break:
                                    idx < RWheelRimDataList.tacNumberList.length - 1 ? 1 : 0,
                                  size: 24,
                                });
                              }),
                            ],
                          }),
                        ]
                      : []),
                  ],
                }),

                
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         // children: [
                //         //     new TextRun({
                //         //         text: FWheelRimDataList.possibleDateList.join(","),
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: RWheelRimDataList.possibleDateList.join("\n\r"),
                //         //         size: "12pt"
                //         //     })
                //         // ]

                //         // children: [
                //         //     new TextRun({
                //         //         text: "Front Wheel Rim Possible Date:",
                //         //         bold: true,
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: FWheelRimDataList.possibleDateList.join(", "),
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: "Rear Wheel Rim Possible Date:",
                //         //         bold: true,
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: RWheelRimDataList.possibleDateList.join(", "),
                //         //         size: "12pt"
                //         //     })
                //         // ]

                //         children: [
                //           // Front Wheel Rim Possible Date
                //           ...(FWheelRimDataList.possibleDateList.some(
                //             (val) => val && val.trim() !== ""
                //           )
                //             ? [
                //                 new TextRun({
                //                   text: "Front Wheel Rim Possible Date:",
                //                   bold: true,
                //                   size: "12pt",
                //                 }),
                //               ]
                //             : []),
                //           new TextRun({
                //             break: 1,
                //             text: FWheelRimDataList.possibleDateList.join(", "),
                //             size: "12pt",
                //           }),

                //           // Rear Wheel Rim Possible Date (separate paragraph)
                //           new TextRun({ break: 2 }),
                //           ...(RWheelRimDataList.possibleDateList.some(
                //             (val) => val && val.trim() !== ""
                //           )
                //             ? [
                //                 new TextRun({
                //                   text: "Rear Wheel Rim Possible Date:",
                //                   bold: true,
                //                   size: "12pt",
                //                 }),
                //               ]
                //             : []),
                //           new TextRun({
                //             break: 1,
                //             text: RWheelRimDataList.possibleDateList.join(", "),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                // new TableCell({
                //     width: { size: 3000, type: WidthType.DXA },
                //     children: [
                //       // Front Wheel Rim section
                //       ...(getPossibleDateHeader(FWheelRimDataList.possibleDateList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text:
                //                     "Front Wheel Rim " +
                //                     getPossibleDateHeader(FWheelRimDataList.possibleDateList),
                //                 }),
                //               ],
                //             }),
                //             new Paragraph({
                //               children: [
                //                 new TextRun({
                //                   text: FWheelRimDataList.possibleDateList.join(", "),
                //                   size: "12pt",
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                  
                //       // Rear Wheel Rim section
                //       ...(getPossibleDateHeader(RWheelRimDataList.possibleDateList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text:
                //                     "Rear Wheel Rim " +
                //                     getPossibleDateHeader(RWheelRimDataList.possibleDateList),
                //                 }),
                //               ],
                //             }),
                //             new Paragraph({
                //               children: [
                //                 new TextRun({
                //                   text: RWheelRimDataList.possibleDateList.join(", "),
                //                   size: "12pt",
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                //     ],
                //   }),


                new TableCell({
                  width: { size: 3000, type: WidthType.DXA },
                  children: [
                    // ---------------- Front Wheel Rim ----------------
                    ...(getPossibleDateHeader(FWheelRimDataList.possibleDateList)
                      ? [
                          // Header (upper)
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text:
                                  "Front Wheel Rim " +
                                  getPossibleDateHeader(FWheelRimDataList.possibleDateList),
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    ...(FWheelRimDataList.possibleDateList.length > 0
                      ? [
                          // Values (downer)
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: FWheelRimDataList.possibleDateList.join(", "),
                                size: "12pt",
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    // ---------------- Rear Wheel Rim ----------------
                    ...(getPossibleDateHeader(RWheelRimDataList.possibleDateList)
                      ? [
                          // Header (upper)
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text:
                                  "Rear Wheel Rim " +
                                  getPossibleDateHeader(RWheelRimDataList.possibleDateList),
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    ...(RWheelRimDataList.possibleDateList.length > 0
                      ? [
                          // Values (downer)
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: RWheelRimDataList.possibleDateList.join(", "),
                                size: "12pt",
                              }),
                            ],
                          }),
                        ]
                      : []),
                  ],
                }),
                

                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         // children: [
                //         //     new TextRun({
                //         //         text: FWheelRimDataList.copCertList.join(","),
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: RWheelRimDataList.copCertList.join("\n\r"),
                //         //         size: "12pt"
                //         //     })
                //         // ]

                //         // children: [
                //         //     new TextRun({
                //         //         text: "Front Wheel Rim CoP Certificate:",
                //         //         bold: true,
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: FWheelRimDataList.copCertList.join(", "),
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: "Rear Wheel Rim CoP Certificate:",
                //         //         bold: true,
                //         //         size: "12pt"
                //         //     }),
                //         //     new TextRun({
                //         //         break: 1,
                //         //         text: RWheelRimDataList.copCertList.join(", "),
                //         //         size: "12pt"
                //         //     })
                //         // ]

                //         children: [
                //           // Front Wheel Rim CoP Certificate
                //           ...(FWheelRimDataList.copCertList.some(
                //             (val) => val && val.trim() !== ""
                //           )
                //             ? [
                //                 new TextRun({
                //                   text: "Front Wheel Rim CoP Certificate:",
                //                   bold: true,
                //                   size: "12pt",
                //                 }),
                //               ]
                //             : []),
                //           new TextRun({
                //             break: 1,
                //             text: FWheelRimDataList.copCertList.join(", "),
                //             size: "12pt",
                //           }),

                //           // Rear Wheel Rim CoP Certificate (separate paragraph)
                //           new TextRun({ break: 2 }),
                //           ...(RWheelRimDataList.copCertList.some(
                //             (val) => val && val.trim() !== ""
                //           )
                //             ? [
                //                 new TextRun({
                //                   text: "Rear Wheel Rim CoP Certificate:",
                //                   bold: true,
                //                   size: "12pt",
                //                 }),
                //               ]
                //             : []),
                //           new TextRun({
                //             break: 1,
                //             text: RWheelRimDataList.copCertList.join(", "),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                // new TableCell({
                //     width: { size: 3000, type: WidthType.DXA },
                //     children: [
                //       // Front Wheel Rim CoP Certificates
                //       ...(getCOPHeader(FWheelRimDataList.copCertList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text: "Front Wheel Rim " + getCOPHeader(FWheelRimDataList.copCertList),
                //                 }),
                //               ],
                //             }),
                //             new Paragraph({
                //               children: [
                //                 new TextRun({
                //                   text: FWheelRimDataList.copCertList.join(", "),
                //                   size: "12pt",
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                  
                //       // Rear Wheel Rim CoP Certificates
                //       ...(getCOPHeader(RWheelRimDataList.copCertList)
                //         ? [
                //             new Paragraph({
                //               style: "table1Header",
                //               children: [
                //                 new TextRun({
                //                   size: "12pt",
                //                   bold: true,
                //                   text: "Rear Wheel Rim " + getCOPHeader(RWheelRimDataList.copCertList),
                //                 }),
                //               ],
                //             }),
                //             new Paragraph({
                //               children: [
                //                 new TextRun({
                //                   text: RWheelRimDataList.copCertList.join(", "),
                //                   size: "12pt",
                //                 }),
                //               ],
                //             }),
                //           ]
                //         : []),
                //     ],
                //   }),
                  



                new TableCell({
                  width: { size: 3000, type: WidthType.DXA },
                  children: [
                    // ---------------- Front Wheel Rim ----------------
                    ...(getCOPHeader(FWheelRimDataList.copCertList)
                      ? [
                          // Header (upper)
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text:
                                  "Front Wheel Rim " +
                                  getCOPHeader(FWheelRimDataList.copCertList),
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    ...(FWheelRimDataList.copCertList.length > 0
                      ? [
                          // Values (downer)
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: FWheelRimDataList.copCertList.join(", "),
                                size: "12pt",
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    // ---------------- Rear Wheel Rim ----------------
                    ...(getCOPHeader(RWheelRimDataList.copCertList)
                      ? [
                          // Header (upper)
                          new Paragraph({
                            style: "table1Header",
                            children: [
                              new TextRun({
                                size: "12pt",
                                bold: true,
                                text:
                                  "Rear Wheel Rim " +
                                  getCOPHeader(RWheelRimDataList.copCertList),
                              }),
                            ],
                          }),
                        ]
                      : []),
                
                    ...(RWheelRimDataList.copCertList.length > 0
                      ? [
                          // Values (downer)
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: RWheelRimDataList.copCertList.join(", "),
                                size: "12pt",
                              }),
                            ],
                          }),
                        ]
                      : []),
                  ],
                }),
                
                ],

              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/44",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Protective Devices for L category vehicles",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: HandleLockDataList.MakeList.join("\n\r"),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         children: [
                //           new TextRun({
                //             // text: HandleLockDataList.suppNameList.length > 0
                //             //     ? "NA"
                //             //     : " ",
                //             text: HandleLockDataList.tacNumberList.join(","),
                //             size: "12pt",
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(HandleLockDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(HandleLockDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       text: HandleLockDataList.tacNumberList.join("\n\r"),
                      //       size: "12pt",
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(HandleLockDataList.tacNumberList).startsWith("BIS");
                              return HandleLockDataList.tacNumberList
                                .map(tac => `${isBIS ? "CM/L-" : ""}${tac}`)
                                .join("\n\r");
                            })(),
                          }),
                        ],
                      }),
                      
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         // style: "paragrapgBold",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             // bold: true,
                //             // text: ""
                //             text: HandleLockDataList.possibleDateList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(HandleLockDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(HandleLockDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: HandleLockDataList.possibleDateList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         // style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             // bold: true,
                //             // text: ""
                //             text: HandleLockDataList.copCertList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(HandleLockDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(HandleLockDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: HandleLockDataList.copCertList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/46",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Defrost & Demist Systems for M1 category vehicles",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/48",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Spray Suppression test for 2-Wheelers",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: SpraySuppressionDataList.MakeList.join(
                              "\n\r"
                            ),
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             // bold: true,
                //             text: SpraySuppressionDataList.tacNumberList.join(
                //               "\n\r"
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(SpraySuppressionDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(SpraySuppressionDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       text: SpraySuppressionDataList.tacNumberList.join("\n\r"),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(SpraySuppressionDataList.tacNumberList).startsWith("BIS");
                              return SpraySuppressionDataList.tacNumberList
                                .map(tac => `${isBIS ? "CM/L-" : ""}${tac}`)
                                .join("\n\r");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             // bold: true,
                //             text: SpraySuppressionDataList.possibleDateList.join(
                //               "\n\r"
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(SpraySuppressionDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(SpraySuppressionDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: SpraySuppressionDataList.possibleDateList.join("\n\r"),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             // bold: true,
                //             text: SpraySuppressionDataList.copCertList.join(
                //               "\n\r"
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),


                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(SpraySuppressionDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(SpraySuppressionDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: SpraySuppressionDataList.copCertList.join("\n\r"),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/49",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Traction Battery used in Battery Operated Vehicles",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: TractionBatterypackDataList.suppNameList.join(
                              "\n\r"
                            ),
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: TractionBatterypackDataList.tacNumberList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(TractionBatterypackDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(TractionBatterypackDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       text: TractionBatterypackDataList.tacNumberList.join(","),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(TractionBatterypackDataList.tacNumberList).startsWith("BIS");
                              return TractionBatterypackDataList.tacNumberList
                                .map(tac => `${isBIS ? "CM/L-" : ""}${tac}`)
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: TractionBatterypackDataList.possibleDateList.join(
                //               "\n\r"
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(TractionBatterypackDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(TractionBatterypackDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: TractionBatterypackDataList.possibleDateList.join("\n\r"),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: TractionBatterypackDataList.copCertList.join(
                //               "\n\r"
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(TractionBatterypackDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(TractionBatterypackDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: TractionBatterypackDataList.copCertList.join("\n\r"),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "124/1A",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Vehicle Rear Under run Protection And Lateral Protection (For four wheelers)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "125/1A",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Safety Belt and Safety Belt Anchorages (For four wheelers)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "125/C (7)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "FDAS/FDSS,FAS/FPS for Buses.",
                            size: "12pt",
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            bold: true,
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "125/(2)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Rear View Mirror and Rear View Mirror Installation Requirements as per AIS-002",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "( For all vehicles as referred in AIS-001 )",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: rearViewMirrorsDataList.suppNameList.join(
                              "\n\r"
                            ),
                          }),
                        ],
                      }),
                    ],
                  }),
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: rearViewMirrorsDataList.tacNumberList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),
                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getTACorBISHeader(rearViewMirrorsDataList.tacNumberList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getTACorBISHeader(rearViewMirrorsDataList.tacNumberList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      // new Paragraph({
                      //   style: "table1Header",
                      //   children: [
                      //     new TextRun({
                      //       size: "12pt",
                      //       text: rearViewMirrorsDataList.tacNumberList.join(","),
                      //     }),
                      //   ],
                      // }),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: (() => {
                              const isBIS = getTACorBISHeader(rearViewMirrorsDataList.tacNumberList).startsWith("BIS");
                              return rearViewMirrorsDataList.tacNumberList
                                .map(tac => `${isBIS ? "CM/L-" : ""}${tac}`)
                                .join(", ");
                            })(),
                          }),
                        ],
                      }),
                      
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: rearViewMirrorsDataList.possibleDateList.join(
                //               ","
                //             ),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getPossibleDateHeader(rearViewMirrorsDataList.possibleDateList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getPossibleDateHeader(rearViewMirrorsDataList.possibleDateList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: rearViewMirrorsDataList.possibleDateList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                //   new TableCell({
                //     width: {
                //       size: 3000,
                //       type: WidthType.DXA,
                //     },
                //     children: [
                //       new Paragraph({
                //         style: "table1Header",
                //         children: [
                //           new TextRun({
                //             size: "12pt",
                //             text: rearViewMirrorsDataList.copCertList.join(","),
                //           }),
                //         ],
                //       }),
                //     ],
                //   }),

                new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      ...(getCOPHeader(rearViewMirrorsDataList.copCertList)
                        ? [
                            new Paragraph({
                              style: "table1Header",
                              children: [
                                new TextRun({
                                  size: "12pt",
                                  bold: true,
                                  text: getCOPHeader(rearViewMirrorsDataList.copCertList),
                                }),
                              ],
                            }),
                          ]
                        : []),
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: rearViewMirrorsDataList.copCertList.join(","),
                          }),
                        ],
                      }),
                    ],
                  }),
                  
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Interior Mirror (Class-I )",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Main Mirror large ( Class-II)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Main Mirror small ( Class-III)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Wide Angle Mirror ( Class-IV)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Close proximity Mirror (Class-V)",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Front Mirror ( Class-VI )",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Mirrors for L category vehicle with bodywork  (Class-VII )",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "125/1C",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Seat Size, Anchorages and Head Restraints",
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "( For four wheelers )",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 1000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            bold: true,
                            text: "138",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Warning Triangles",
                            size: "12pt",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "paragrapgBold",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    children: [
                      new Paragraph({
                        style: "table1Header",
                        children: [
                          new TextRun({
                            size: "12pt",
                            text: "NA",
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    width: {
                      size: 3000,
                      type: WidthType.DXA,
                    },
                    columnSpan: 6,
                    children: [
                      new Paragraph({
                        spacing: {
                          before: 240,
                          after: 240,
                        },
                        children: [
                          new TextRun({
                            text: "Note:",
                            bold: true,
                            size: "12pt",
                          }),
                          new TextRun({
                            text: "Please enclose copies for TAC / CoP / BIS License / ECE Certificate / Test Reports wherever required by the testing agency.",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "Fill all the columns. If any clause is not applicable, mention “NA” in corresponding column.  Do not keep it blank.",
                            size: "12pt",
                            break: 1,
                          }),
                          new TextRun({
                            text: "In case samples are submitted to testing agency, please provide Reference No. if the approval is in process.)",
                            size: "12pt",
                            break: 1,
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
            ],
            size: "12pt",
          }),
        ],
        footers: {
          default: new Footer({
            children: [
              new Table({
                width: {
                  size: 9025,
                  type: WidthType.DXA,
                },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        width: {
                          size: 3000,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                                text: "Manufacturer :" + manufacturer_Name,
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                              }),
                            ],
                          }),
                        ],
                      }),

                      new TableCell({
                        width: {
                          size: 3025,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                                text: "Sheet No : ",
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                              }),
                            ],
                          }),
                        ],
                      }),
                      new TableCell({
                        width: {
                          size: 3000,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                                text: "Test Agency : ",
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        width: {
                          size: 3000,
                          type: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [docSealImage],

                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                      }),
                      new TableCell({
                        width: {
                          size: 3025,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                                text:
                                  "Document No: " +
                                  dataOfFooter.Document_No.value,
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                              }),
                            ],
                          }),
                        ],
                      }),
                      new TableCell({
                        width: {
                          size: 3000,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                                text: "",
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        width: {
                          size: 3000,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                                // text: "Name: " + dataOfFooter.Homologation_Engineer_Name.value,
                                text: "Name: " + homologation_Engg_Name,
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                              }),
                              new TextRun({
                                text: "Designation:",
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                                break: 1,
                              }),
                            ],
                          }),
                        ],
                      }),
                      new TableCell({
                        width: {
                          size: 3025,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                               text: `Date : ${formattedDate}`,
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                              }),
                            ],
                          }),
                        ],
                      }),
                      new TableCell({
                        width: {
                          size: 3000,
                          WidthType: WidthType.DXA,
                        },
                        children: [
                          new Paragraph({
                            style: "redColorText",
                            children: [
                              new TextRun({
                                text: "Name: ",
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                              }),
                              new TextRun({
                                text: "Designation: ",
                                font: "Times New Roman",
                                color: "#B22222", // Light Red color
                                break: 1,
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    children: ["Page | ", PageNumber.CURRENT],
                    font: "Times New Roman",
                    style: {
                      color: "#B22222", // Firebrick red
                    },
                  }),
                ],
                alignment: AlignmentType.RIGHT,
              }),
            ],
          }),
        },
      },
    ],
  });
  exportDoc(form8Document, "form8Document.docx");
}

export default generateForm8;